!(function (e) {
    "function" == typeof define && define.amd ? define("index", e) : e();
})(function () {
    "use strict";
    function e(t) {
        return (
            (e =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (e) {
                          return typeof e;
                      }
                    : function (e) {
                          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                      }),
            e(t)
        );
    }
    function t(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
        for (var i = 0; i < t.length; i++) {
            var n = t[i];
            (n.enumerable = n.enumerable || !1), (n.configurable = !0), "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
    }
    function n(e, t, n) {
        return t && i(e.prototype, t), n && i(e, n), e;
    }
    function o(e) {
        return (
            (o = Object.setPrototypeOf
                ? Object.getPrototypeOf
                : function (e) {
                      return e.__proto__ || Object.getPrototypeOf(e);
                  }),
            o(e)
        );
    }
    function a(e, t) {
        return (
            (a =
                Object.setPrototypeOf ||
                function (e, t) {
                    return (e.__proto__ = t), e;
                }),
            a(e, t)
        );
    }
    function s() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
            return !1;
        }
    }
    function r(e, t, i) {
        return (
            (r = s()
                ? Reflect.construct
                : function (e, t, i) {
                      var n = [null];
                      n.push.apply(n, t);
                      var o = new (Function.bind.apply(e, n))();
                      return i && a(o, i.prototype), o;
                  }),
            r.apply(null, arguments)
        );
    }
    function l(e) {
        var t = "function" == typeof Map ? new Map() : void 0;
        return (
            (l = function (e) {
                if (null === e || ((i = e), -1 === Function.toString.call(i).indexOf("[native code]"))) return e;
                var i;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return r(e, arguments, o(this).constructor);
                }
                return (n.prototype = Object.create(e.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), a(n, e);
            }),
            l(e)
        );
    }
    function c(e, t) {
        return !t || ("object" != typeof t && "function" != typeof t)
            ? (function (e) {
                  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return e;
              })(e)
            : t;
    }
    function d(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var i = 0, n = new Array(t); i < t; i++) n[i] = e[i];
        return n;
    }
    function u(e, t) {
        var i;
        if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
            if (
                Array.isArray(e) ||
                (i = (function (e, t) {
                    if (e) {
                        if ("string" == typeof e) return d(e, t);
                        var i = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === i && e.constructor && (i = e.constructor.name), "Map" === i || "Set" === i ? Array.from(e) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? d(e, t) : void 0;
                    }
                })(e)) ||
                (t && e && "number" == typeof e.length)
            ) {
                i && (e = i);
                var n = 0,
                    o = function () {};
                return {
                    s: o,
                    n: function () {
                        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
                    },
                    e: function (e) {
                        throw e;
                    },
                    f: o,
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var a,
            s = !0,
            r = !1;
        return {
            s: function () {
                i = e[Symbol.iterator]();
            },
            n: function () {
                var e = i.next();
                return (s = e.done), e;
            },
            e: function (e) {
                (r = !0), (a = e);
            },
            f: function () {
                try {
                    s || null == i.return || i.return();
                } finally {
                    if (r) throw a;
                }
            },
        };
    }
    function h() {
        const e = document.querySelectorAll(".collection__filter-group-list");
        if (e.length) {
            e.forEach((e) => {
                if (!e.querySelector(".filter-group-loading")) {
                    const t = '<span class="filter-group-loader"></span>',
                        i = document.createElement("div");
                    i.classList.add("filter-group-loading"), (i.innerHTML = t), e.appendChild(i);
                }
            });
            const t = document.querySelectorAll('.collection__active-filters button[data-action="toggle-tag"]');
            if (t.length) {
                const e = document.querySelectorAll(".filter-group-loading");
                e.forEach((e) => e.classList.add("visible"));
                let i = Array.from(t)
                    .map((e) => e.dataset.tag)
                    .join(",");
                const n = document.querySelectorAll(".layout__section .collection__filter-group-list .collection__filter-checkbox-list input[data-tag]");
                n.forEach(async (t, o) => {
                    if (!t.checked) {
                        const e = i + "," + t.dataset.tag;
                        await fetch(window.Shopify.routes.root + "search/suggest.json?q=" + e + "&resources[limit]=1&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=tag")
                            .then((e) => e.json())
                            .then((e) => {
                                const i = e.resources.results.products;
                                document.querySelectorAll(`input[data-tag="${t.dataset.tag}"]`).forEach((e) => {
                                    i.length ? (e.removeAttribute("disabled"), e.closest("li").classList.remove("disabled")) : ((e.disabled = "disabled"), e.closest("li").classList.add("disabled"));
                                    const t = e.closest(".collection__filter-group");
                                    e.closest("ul").querySelectorAll("li:not(.disabled)").length ? t.classList.remove("group-hidden") : t.classList.add("group-hidden");
                                });
                            });
                    }
                    n.length - 1 === o && e.forEach((e) => e.classList.remove("visible"));
                });
            } else
                document.querySelectorAll(".collection__filter-group").forEach((e) => e.classList.remove("group-hidden")),
                    document.querySelectorAll("input[data-tag]").forEach((e) => {
                        e.removeAttribute("disabled"), e.closest("li").classList.remove("disabled");
                    });
        }
    }
    window.addEventListener("DOMContentLoaded", h);
    var p = {},
        m = (function () {
            function e() {
                t(this, e);
            }
            return (
                n(e, null, [
                    {
                        key: "slideUp",
                        value: function (e, t) {
                            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "height";
                            (e.style[i] = "".concat(e.scrollHeight, "px")), e.offsetHeight, (e.style[i] = 0), p[e.id] && (e.removeEventListener("transitionend", p[e.id]), delete p[e.id]);
                            e.addEventListener("transitionend", function i(n) {
                                "height" === n.propertyName && (e.removeEventListener("transitionend", i), (t || function () {})());
                            });
                        },
                    },
                    {
                        key: "slideDown",
                        value: function (e, t) {
                            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "height";
                            e.style[i] = "".concat(e.scrollHeight, "px");
                            var n = function n(o) {
                                if (o.propertyName === i) {
                                    var a = "auto";
                                    "max-height" === i && (a = "none"), (e.style[i] = a), e.removeEventListener("transitionend", n), delete p[e.id], (t || function () {})();
                                }
                            };
                            e.addEventListener("transitionend", n), (p[e.id] = n);
                        },
                    },
                ]),
                e
            );
        })(),
        f = (function () {
            function e() {
                t(this, e);
            }
            return (
                n(e, null, [
                    {
                        key: "getSiblings",
                        value: function (e, t) {
                            for (var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = [], o = e; (o = o.previousElementSibling); ) (t && !o.matches(t)) || n.push(o);
                            for (i && n.push(e), o = e; (o = o.nextElementSibling); ) (t && !o.matches(t)) || n.push(o);
                            return n;
                        },
                    },
                ]),
                e
            );
        })(),
        v = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
    function g(e) {
        return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
    }
    function y(e, t, i) {
        return (
            e(
                (i = {
                    path: t,
                    exports: {},
                    require: function (e, t) {
                        return (function () {
                            throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
                        })(null == t && i.path);
                    },
                }),
                i.exports
            ),
            i.exports
        );
    }
    var w = y(function (e, t) {
            function i(e) {
                (this.listenerMap = [{}, {}]), e && this.root(e), (this.handle = i.prototype.handle.bind(this)), (this._removedListeners = []);
            }
            function n(e, t) {
                return e.toLowerCase() === t.tagName.toLowerCase();
            }
            function o(e, t) {
                return this.rootElement === window ? t === document || t === document.documentElement || t === window : this.rootElement === t;
            }
            function a(e, t) {
                return e === t.id;
            }
            Object.defineProperty(t, "__esModule", { value: !0 }),
                (t.default = void 0),
                (i.prototype.root = function (e) {
                    var t,
                        i = this.listenerMap;
                    if (this.rootElement) {
                        for (t in i[1]) i[1].hasOwnProperty(t) && this.rootElement.removeEventListener(t, this.handle, !0);
                        for (t in i[0]) i[0].hasOwnProperty(t) && this.rootElement.removeEventListener(t, this.handle, !1);
                    }
                    if (!e || !e.addEventListener) return this.rootElement && delete this.rootElement, this;
                    for (t in ((this.rootElement = e), i[1])) i[1].hasOwnProperty(t) && this.rootElement.addEventListener(t, this.handle, !0);
                    for (t in i[0]) i[0].hasOwnProperty(t) && this.rootElement.addEventListener(t, this.handle, !1);
                    return this;
                }),
                (i.prototype.captureForType = function (e) {
                    return -1 !== ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(e);
                }),
                (i.prototype.on = function (e, t, i, s) {
                    var r, l, c, d;
                    if (!e) throw new TypeError("Invalid event type: " + e);
                    if (("function" == typeof t && ((s = i), (i = t), (t = null)), void 0 === s && (s = this.captureForType(e)), "function" != typeof i)) throw new TypeError("Handler must be a type of Function");
                    return (
                        (r = this.rootElement),
                        (l = this.listenerMap[s ? 1 : 0])[e] || (r && r.addEventListener(e, this.handle, s), (l[e] = [])),
                        t ? (/^[a-z]+$/i.test(t) ? ((d = t), (c = n)) : /^#[a-z0-9\-_]+$/i.test(t) ? ((d = t.slice(1)), (c = a)) : ((d = t), (c = Element.prototype.matches))) : ((d = null), (c = o.bind(this))),
                        l[e].push({ selector: t, handler: i, matcher: c, matcherParam: d }),
                        this
                    );
                }),
                (i.prototype.off = function (e, t, i, n) {
                    var o, a, s, r, l;
                    if (("function" == typeof t && ((n = i), (i = t), (t = null)), void 0 === n)) return this.off(e, t, i, !0), this.off(e, t, i, !1), this;
                    if (((s = this.listenerMap[n ? 1 : 0]), !e)) {
                        for (l in s) s.hasOwnProperty(l) && this.off(l, t, i);
                        return this;
                    }
                    if (!(r = s[e]) || !r.length) return this;
                    for (o = r.length - 1; o >= 0; o--) (a = r[o]), (t && t !== a.selector) || (i && i !== a.handler) || (this._removedListeners.push(a), r.splice(o, 1));
                    return r.length || (delete s[e], this.rootElement && this.rootElement.removeEventListener(e, this.handle, n)), this;
                }),
                (i.prototype.handle = function (e) {
                    var t,
                        i,
                        n,
                        o,
                        a,
                        s = e.type,
                        r = [],
                        l = "ftLabsDelegateIgnore";
                    if (!0 !== e[l]) {
                        switch ((3 === (a = e.target).nodeType && (a = a.parentNode), a.correspondingUseElement && (a = a.correspondingUseElement), (n = this.rootElement), e.eventPhase || (e.target !== e.currentTarget ? 3 : 2))) {
                            case 1:
                                r = this.listenerMap[1][s];
                                break;
                            case 2:
                                this.listenerMap[0] && this.listenerMap[0][s] && (r = r.concat(this.listenerMap[0][s])), this.listenerMap[1] && this.listenerMap[1][s] && (r = r.concat(this.listenerMap[1][s]));
                                break;
                            case 3:
                                r = this.listenerMap[0][s];
                        }
                        var c,
                            d = [];
                        for (i = r.length; a && i; ) {
                            for (t = 0; t < i && (o = r[t]); t++)
                                a.tagName && ["button", "input", "select", "textarea"].indexOf(a.tagName.toLowerCase()) > -1 && a.hasAttribute("disabled") ? (d = []) : o.matcher.call(a, o.matcherParam, a) && d.push([e, a, o]);
                            if (a === n) break;
                            if (((i = r.length), (a = a.parentElement || a.parentNode) instanceof HTMLDocument)) break;
                        }
                        for (t = 0; t < d.length; t++)
                            if (!(this._removedListeners.indexOf(d[t][2]) > -1) && !1 === this.fire.apply(this, d[t])) {
                                (d[t][0][l] = !0), d[t][0].preventDefault(), (c = !1);
                                break;
                            }
                        return c;
                    }
                }),
                (i.prototype.fire = function (e, t, i) {
                    return i.handler.call(t, e, t);
                }),
                (i.prototype.destroy = function () {
                    this.off(), this.root();
                });
            var s = i;
            (t.default = s), (e.exports = t.default);
        }),
        b = g(w),
        _ = (function () {
            function e() {
                t(this, e), (this.domDelegate = new b(document.body)), this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.domDelegate.on("click", '[data-action="toggle-collapsible"]:not([disabled])', this._toggleCollapsible.bind(this)), document.addEventListener("collapsible:toggle", this._toggleCollapsible.bind(this));
                        },
                    },
                    {
                        key: "_toggleCollapsible",
                        value: function (e, t) {
                            var i = this;
                            !t && e.detail && (t = document.querySelector('[aria-controls="'.concat(e.detail.id, '"]')));
                            var n = "true" === t.getAttribute("aria-expanded"),
                                o = t.parentNode;
                            n ? this._close(o) : this._open(o),
                                "false" !== t.getAttribute("data-close-siblings") &&
                                    f.getSiblings(o).forEach(function (e) {
                                        return i._close(e);
                                    });
                        },
                    },
                    {
                        key: "_open",
                        value: function (e) {
                            var t = e.querySelector("[aria-controls]");
                            if (t && "true" !== t.getAttribute("aria-expanded")) {
                                var i = e.querySelector("#".concat(t.getAttribute("aria-controls")));
                                t.setAttribute("aria-expanded", "true"),
                                    i.hasAttribute("aria-hidden") && i.setAttribute("aria-hidden", "false"),
                                    m.slideDown(i, function () {
                                        t.hasAttribute("data-collapsible-force-overflow") && (i.style.overflow = "visible");
                                        var e = i.querySelector("[autofocus]");
                                        e && e.focus();
                                    });
                            }
                        },
                    },
                    {
                        key: "_close",
                        value: function (e) {
                            var t = e.querySelector("[aria-controls]");
                            if (t && "false" !== t.getAttribute("aria-expanded")) {
                                var i = e.querySelector("#".concat(t.getAttribute("aria-controls")));
                                t.hasAttribute("data-collapsible-force-overflow") && (i.style.overflow = "hidden"),
                                    i.hasAttribute("aria-hidden") && i.setAttribute("aria-hidden", "true"),
                                    t.setAttribute("aria-expanded", "false"),
                                    m.slideUp(i);
                            }
                        },
                    },
                ]),
                e
            );
        })(),
        E = (function () {
            function e(i, n) {
                t(this, e), (this.countrySelect = i), (this.provinceSelect = n), this.countrySelect && this.provinceSelect && (this._attachListeners(), this._initSelectors());
            }
            return (
                n(e, [
                    {
                        key: "destroy",
                        value: function () {
                            this.countrySelect && this.countrySelect.removeEventListener("change", this._onCountryChangedListener);
                        },
                    },
                    {
                        key: "_initSelectors",
                        value: function () {
                            var e = this.countrySelect.getAttribute("data-default");
                            if (e) {
                                for (var t = 0; t !== this.countrySelect.options.length; ++t)
                                    if (this.countrySelect.options[t].text === e) {
                                        this.countrySelect.selectedIndex = t;
                                        break;
                                    }
                            } else this.countrySelect.selectedIndex = 0;
                            var i = new Event("change", { bubbles: !0 });
                            this.countrySelect.dispatchEvent(i);
                            var n = this.provinceSelect.getAttribute("data-default");
                            if (n)
                                for (var o = 0; o !== this.provinceSelect.options.length; ++o)
                                    if (this.provinceSelect.options[o].text === n) {
                                        this.provinceSelect.selectedIndex = o;
                                        break;
                                    }
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._onCountryChangedListener = this._onCountryChanged.bind(this)), this.countrySelect.addEventListener("change", this._onCountryChangedListener);
                        },
                    },
                    {
                        key: "_onCountryChanged",
                        value: function () {
                            var e = this,
                                t = this.countrySelect.options[this.countrySelect.selectedIndex];
                            if (t) {
                                var i = JSON.parse(t.getAttribute("data-provinces") || "[]");
                                (this.provinceSelect.innerHTML = ""),
                                    0 !== i.length
                                        ? (i.forEach(function (t) {
                                              e.provinceSelect.options.add(new Option(t[1], t[0]));
                                          }),
                                          (this.provinceSelect.closest(".form__input-wrapper").style.display = "block"))
                                        : (this.provinceSelect.closest(".form__input-wrapper").style.display = "none");
                            }
                        },
                    },
                ]),
                e
            );
        })(),
        S = (function () {
            function e() {
                t(this, e);
            }
            return (
                n(e, null, [
                    {
                        key: "matchesBreakpoint",
                        value: function (e) {
                            switch (e) {
                                case "phone":
                                    return window.matchMedia("screen and (max-width: 640px)").matches;
                                case "tablet":
                                    return window.matchMedia("screen and (min-width: 641px) and (max-width: 1023px)").matches;
                                case "tablet-and-up":
                                    return window.matchMedia("screen and (min-width: 641px)").matches;
                                case "pocket":
                                    return window.matchMedia("screen and (max-width: 1023px)").matches;
                                case "lap":
                                    return window.matchMedia("screen and (min-width: 1024px) and (max-width: 1279px)").matches;
                                case "lap-and-up":
                                    return window.matchMedia("screen and (min-width: 1024px)").matches;
                                case "desk":
                                    return window.matchMedia("screen and (min-width: 1280px)").matches;
                                case "widescreen":
                                    return window.matchMedia("screen and (min-width: 1440px)").matches;
                                case "supports-hover":
                                    return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
                            }
                        },
                    },
                    {
                        key: "getCurrentBreakpoint",
                        value: function () {
                            return window.matchMedia("screen and (max-width: 640px)").matches
                                ? "phone"
                                : window.matchMedia("screen and (min-width: 641px) and (max-width: 1023px)").matches
                                ? "tablet"
                                : window.matchMedia("screen and (min-width: 1024px) and (max-width: 1279px)").matches
                                ? "lap"
                                : window.matchMedia("screen and (min-width: 1280px)").matches
                                ? "desk"
                                : void 0;
                        },
                    },
                ]),
                e
            );
        })(),
        k = (function () {
            function e(i, n, o) {
                t(this, e),
                    (this.element = i),
                    (this.delegateElement = new b(this.element)),
                    (this.delegateRoot = new b(document.documentElement)),
                    (this.useInlineNavigation = "inline" === n),
                    (this.isNavigationVisible = this.useInlineNavigation),
                    (this.openTrigger = o),
                    S.matchesBreakpoint("supports-hover") || (this.openTrigger = "click"),
                    (this.openItems = []),
                    (this.dropdownActivationTimeouts = {}),
                    (this.dropdownDeactivationTimeouts = {}),
                    (this.DROPDOWN_TIMEOUT = 100),
                    this._attachListeners(),
                    this.useInlineNavigation && this._setupInlineNavigation();
            }
            return (
                n(e, [
                    {
                        key: "destroy",
                        value: function () {
                            this.delegateElement.off(), this.delegateRoot.off();
                        },
                    },
                    {
                        key: "onBlockSelect",
                        value: function (e) {
                            var t = this;
                            this.useInlineNavigation || this._openNavigation(),
                                f.getSiblings(e.target.parentNode, ".is-dropdown-open").forEach(function (i) {
                                    t._deactivateDropdown(e, i.querySelector('[data-type="menuitem"][aria-haspopup]'));
                                }),
                                this._activateDropdown(e, e.target.previousElementSibling);
                        },
                    },
                    {
                        key: "onBlockDeselect",
                        value: function (e) {
                            this.useInlineNavigation || this._closeNavigation(), this._deactivateDropdown(e, e.target.parentNode);
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateElement.on("focusout", this._onFocusOut.bind(this)),
                                this.delegateRoot.on("click", this._onClick.bind(this)),
                                this.delegateElement.on("click", '[data-action="toggle-menu"]', this._toggleNavigation.bind(this)),
                                "hover" === this.openTrigger
                                    ? (this.delegateElement.on("focusin", '[data-type="menuitem"][aria-haspopup]', this._activateDropdown.bind(this)),
                                      this.delegateElement.on("mouseover", '[data-type="menuitem"][aria-haspopup]', this._activateDropdown.bind(this)),
                                      this.delegateElement.on("mouseover", '[data-type="menu"][aria-hidden="false"]', this._blockDropdownDeactivation.bind(this)),
                                      this.delegateElement.on("focusout", ".is-dropdown-open", this._deactivateDropdown.bind(this)),
                                      this.delegateElement.on("mouseout", ".is-dropdown-open", this._deactivateDropdown.bind(this)))
                                    : this.delegateElement.on("click", '[data-type="menuitem"][aria-haspopup]', this._toggleDropdown.bind(this));
                        },
                    },
                    {
                        key: "_onFocusOut",
                        value: function (e) {
                            null === e.relatedTarget || this.element.contains(e.relatedTarget) || this._closeNavigation();
                        },
                    },
                    {
                        key: "_onClick",
                        value: function (e) {
                            this.element.contains(e.target) || this._closeNavigation();
                        },
                    },
                    {
                        key: "_openNavigation",
                        value: function () {
                            this.useInlineNavigation ||
                                (this.element.querySelector('[data-action="toggle-menu"]').setAttribute("aria-expanded", "true"),
                                this.element.querySelector('[data-type="menu"]').setAttribute("aria-hidden", "false"),
                                (this.isNavigationVisible = !0));
                        },
                    },
                    {
                        key: "_closeNavigation",
                        value: function () {
                            var e = this;
                            (this.useInlineNavigation ||
                                (this.element.querySelector('[data-action="toggle-menu"]').setAttribute("aria-expanded", "false"), this.element.querySelector('[data-type="menu"]').setAttribute("aria-hidden", "true")),
                            (this.isNavigationVisible = !1),
                            "click" === this.openTrigger) &&
                                this.openItems.slice(0).forEach(function (t) {
                                    e._deactivateDropdown(event, t);
                                });
                        },
                    },
                    {
                        key: "_toggleNavigation",
                        value: function (e) {
                            this.isNavigationVisible ? this._closeNavigation() : this._openNavigation();
                        },
                    },
                    {
                        key: "_toggleDropdown",
                        value: function (e, t) {
                            "false" === t.getAttribute("aria-expanded") && e.preventDefault(),
                                "true" === t.getAttribute("aria-expanded") ? "#" === t.getAttribute("href") && (e.preventDefault(), this._deactivateDropdown(e, t.closest(".is-dropdown-open"))) : this._activateDropdown(e, t);
                        },
                    },
                    {
                        key: "_activateDropdown",
                        value: function (e, t) {
                            var i = this;
                            "click" === this.openTrigger &&
                                this.openItems.slice(0).forEach(function (n) {
                                    n.contains(t) || i._deactivateDropdown(e, n);
                                });
                            var n = f.getSiblings(t, "[aria-hidden]")[0],
                                o = function () {
                                    if (
                                        (t.setAttribute("aria-expanded", "true"),
                                        t.parentNode.classList.add("is-dropdown-open"),
                                        n.setAttribute("aria-hidden", "false"),
                                        "hover" === i.openTrigger && i.dropdownDeactivationTimeouts[n.id] && (clearTimeout(i.dropdownDeactivationTimeouts[n.id]), delete i.dropdownDeactivationTimeouts[n.id]),
                                        i.useInlineNavigation)
                                    ) {
                                        var e = window.innerWidth,
                                            o = !1;
                                        n.querySelectorAll(".nav-dropdown").forEach(function (t) {
                                            t.getBoundingClientRect().right > e && (o = !0);
                                        }),
                                            o && n.classList.add("nav-dropdown--inverse");
                                    }
                                    t.closest('[data-type="menu"]').classList.add("nav-dropdown--glued"), n.classList.contains("mega-menu") && i._setupMegaMenu(n), "click" === i.openTrigger && i.openItems.push(t.parentNode);
                                };
                            if ("click" === this.openTrigger) o();
                            else {
                                for (var a in this.dropdownActivationTimeouts) this.dropdownActivationTimeouts.hasOwnProperty(a) && (clearTimeout(this.dropdownActivationTimeouts[a]), delete this.dropdownActivationTimeouts[a]);
                                o();
                            }
                        },
                    },
                    {
                        key: "_deactivateDropdown",
                        value: function (e, t) {
                            var i = this;
                            if ("hover" !== this.openTrigger || !t.contains(e.relatedTarget)) {
                                var n = t.querySelector("[aria-hidden]"),
                                    o = function () {
                                        if (
                                            (t.classList.remove("is-dropdown-open"),
                                            t.querySelector('[data-type="menuitem"]').setAttribute("aria-expanded", "false"),
                                            t.querySelector("[aria-hidden]").setAttribute("aria-hidden", "true"),
                                            t.closest('[data-type="menu"]').classList.remove("nav-dropdown--glued"),
                                            "click" === i.openTrigger)
                                        ) {
                                            t.querySelectorAll(".is-dropdown-open").forEach(function (t) {
                                                i._deactivateDropdown(e, t);
                                                var n = i.openItems.indexOf(t);
                                                n > -1 && i.openItems.splice(n, 1);
                                            });
                                            var n = i.openItems.indexOf(t);
                                            n > -1 && i.openItems.splice(n, 1);
                                        }
                                    };
                                "click" === this.openTrigger
                                    ? o()
                                    : (this.dropdownDeactivationTimeouts[n.id] = setTimeout(function () {
                                          o(), delete i.dropdownDeactivationTimeouts[n.id];
                                      }, this.DROPDOWN_TIMEOUT));
                            }
                        },
                    },
                    {
                        key: "_blockDropdownDeactivation",
                        value: function (e, t) {
                            if (void 0 !== this.dropdownDeactivationTimeouts[t.id])
                                for (var i in (clearTimeout(this.dropdownDeactivationTimeouts[t.id]), delete this.dropdownDeactivationTimeouts[t.id], this.dropdownActivationTimeouts))
                                    this.dropdownActivationTimeouts.hasOwnProperty(i) && (clearTimeout(this.dropdownActivationTimeouts[i]), delete this.dropdownActivationTimeouts[i]);
                        },
                    },
                    {
                        key: "_setupMegaMenu",
                        value: function (e) {
                            if (!this.useInlineNavigation) {
                                var t = e.closest(".nav-dropdown").clientWidth;
                                e.style.maxWidth = Math.min(1400 - t, parseInt(window.innerWidth - t - 80)) + "px";
                            }
                        },
                    },
                    {
                        key: "_setupInlineNavigation",
                        value: function () {
                            var e = this;
                            this.element.querySelectorAll(".mega-menu").forEach(function (e) {
                                e.closest(".nav-bar__item").classList.add("nav-bar__item--static");
                            }),
                                "MutationObserver" in window &&
                                    ((this.dropdownMenuObserver = new MutationObserver(function (e) {
                                        e.forEach(function (e) {
                                            "false" === e.target.getAttribute("aria-hidden") && e.target.style.setProperty("--distance-to-top", "".concat(e.target.getBoundingClientRect().top, "px"));
                                        });
                                    })),
                                    this.element.querySelectorAll(".nav-dropdown .nav-dropdown").forEach(function (t) {
                                        e.dropdownMenuObserver.observe(t, { attributes: !0, attributeFilter: ["aria-hidden"] });
                                    }));
                        },
                    },
                ]),
                e
            );
        })(),
        x = (function () {
            function e(i) {
                t(this, e), (this.element = document.getElementById("mobile-collection-filters")), (this.delegateRoot = new b(document.documentElement)), (this.options = i), (this.isOpen = !1), this.element && this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "destroy",
                        value: function () {
                            this.delegateRoot.off();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateRoot.on("click", '[aria-controls="mobile-collection-filters"][data-action="open-drawer"]', this.open.bind(this)),
                                this.delegateRoot.on("click", '#mobile-collection-filters [data-action="close-drawer"]', this.close.bind(this)),
                                document.addEventListener("collection-filter:close", this.close.bind(this)),
                                document.addEventListener("click", this._detectOutsideClick.bind(this)),
                                window.addEventListener("resize", this._computeDrawerHeight.bind(this));
                        },
                    },
                    {
                        key: "open",
                        value: function (e) {
                            e && e.stopPropagation(),
                                this._computeDrawerHeight(),
                                (this.isOpen = !0),
                                document.querySelector('[aria-controls="mobile-collection-filters"]').setAttribute("aria-expanded", "true"),
                                document.getElementById("mobile-collection-filters").setAttribute("aria-hidden", "false"),
                                document.body.classList.add("no-mobile-scroll");
                        },
                    },
                    {
                        key: "close",
                        value: function (e) {
                            e && e.stopPropagation(),
                                (this.isOpen = !1),
                                document.querySelector('[aria-controls="mobile-collection-filters"]').setAttribute("aria-expanded", "false"),
                                document.getElementById("mobile-collection-filters").setAttribute("aria-hidden", "true"),
                                document.body.classList.remove("no-mobile-scroll");
                        },
                    },
                    {
                        key: "_computeDrawerHeight",
                        value: function () {
                            document.getElementById("mobile-collection-filters").querySelector(".collection-drawer").style.maxHeight = "".concat(window.innerHeight, "px");
                        },
                    },
                    {
                        key: "_filtersHaveChanged",
                        value: function (e) {
                            var t = this;
                            this.element &&
                                M.mutate(function () {
                                    var i = t.element.querySelector(".collection-drawer__filter-count");
                                    (i.innerText = "(".concat(e.length, ")")),
                                        (i.style.display = 0 === e.length ? "none" : "inline"),
                                        (t.element.querySelector('[data-action="clear-tags"]').style.display = 0 === e.length ? "none" : "block"),
                                        "group" === t.options.filterType &&
                                            t.element.querySelectorAll(".collection__filter-item-active").forEach(function (e) {
                                                var t = e.closest(".collection__filter-group").querySelector(".is-selected[data-tag]");
                                                t ? ((e.style.display = "block"), (e.innerText = t.getAttribute("data-tag-user"))) : (e.style.display = "none");
                                            });
                                });
                        },
                    },
                    {
                        key: "_detectOutsideClick",
                        value: function (e) {
                            this.isOpen && !e.target.closest(".collection-drawer__inner") && this.close();
                        },
                    },
                ]),
                e
            );
        })(),
        C = (function () {
            function e(i) {
                t(this, e),
                    (this.element = i),
                    (this.delegateElement = new b(this.element)),
                    (this.rootDelegateElement = new b(document.body)),
                    (this.options = JSON.parse(i.getAttribute("data-popup-settings"))),
                    (this.hasOpenOnceInCurrentPage = !1);
                try {
                    "#exit-popup" === window.location.hash && "captcha" !== window.theme.pageType && this._openPopup();
                } catch (e) {}
                this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "destroy",
                        value: function () {
                            this.delegateElement.off();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            var e = this;
                            (this._onKeyPressedListener = this._onKeyPressed.bind(this)),
                                S.matchesBreakpoint("supports-hover") &&
                                    (this.delegateElement.on("click", '[data-action="close-popup"]', this._closePopup.bind(this)),
                                    document.body.addEventListener("mouseleave", function () {
                                        e.hasOpenOnceInCurrentPage || ((!e.options.showOnlyOnce || (e.options.showOnlyOnce && null === localStorage.getItem("themeExitPopup"))) && e._openPopup());
                                    }),
                                    (this._clickOutsideListener = this._checkClickOutside.bind(this)));
                        },
                    },
                    {
                        key: "_openPopup",
                        value: function () {
                            window.theme.isNewsletterPopupOpen ||
                                (this.element.setAttribute("aria-hidden", "false"),
                                localStorage.setItem("themeExitPopup", "true"),
                                (this.hasOpenOnceInCurrentPage = !0),
                                (window.theme.isExitPopupOpen = !0),
                                this.delegateElement.on("click", this._clickOutsideListener),
                                this.rootDelegateElement.on("keyup", this._onKeyPressedListener));
                        },
                    },
                    {
                        key: "_closePopup",
                        value: function () {
                            this.element.setAttribute("aria-hidden", "true"),
                                (window.theme.isExitPopupOpen = !1),
                                this.delegateElement.off("click", this._clickOutsideListener),
                                this.rootDelegateElement.off("keyup", this._onKeyPressedListener);
                        },
                    },
                    {
                        key: "_checkClickOutside",
                        value: function (e) {
                            (this.element.contains(e.target) && this.element !== e.target) || this._closePopup();
                        },
                    },
                    {
                        key: "_onKeyPressed",
                        value: function (e) {
                            "Escape" === e.key && this._closePopup();
                        },
                    },
                ]),
                e
            );
        })(),
        L = (function () {
            function e() {
                t(this, e),
                    (this.element = document.querySelector(".loading-bar")),
                    this.element &&
                        (document.addEventListener("theme:loading:start", this._onLoadingStart.bind(this)),
                        document.addEventListener("theme:loading:end", this._onLoadingEnd.bind(this)),
                        this.element.addEventListener("transitionend", this._onTransitionEnd.bind(this)));
            }
            return (
                n(e, [
                    {
                        key: "_onLoadingStart",
                        value: function () {
                            this.element.classList.add("is-visible"), (this.element.style.transform = "scaleX(0.4)");
                        },
                    },
                    {
                        key: "_onLoadingEnd",
                        value: function () {
                            (this.element.style.transform = "scaleX(1)"), this.element.classList.add("is-finished");
                        },
                    },
                    {
                        key: "_onTransitionEnd",
                        value: function (e) {
                            "transform" === e.propertyName &&
                                this.element.classList.contains("is-finished") &&
                                (this.element.classList.remove("is-visible"), this.element.classList.remove("is-finished"), (this.element.style.transform = "scaleX(0)"));
                        },
                    },
                ]),
                e
            );
        })(),
        A = (function () {
            function e() {
                t(this, e);
            }
            return (
                n(e, null, [
                    {
                        key: "trapFocus",
                        value: function (e, t) {
                            this.listeners = this.listeners || {};
                            var i = e.querySelector("[autofocus]") || e;
                            e.setAttribute("tabindex", "-1"),
                                i.focus(),
                                (this.listeners[t] = function (t) {
                                    e === t.target || e.contains(t.target) || i.focus();
                                }),
                                document.addEventListener("focusin", this.listeners[t]);
                        },
                    },
                    {
                        key: "removeTrapFocus",
                        value: function (e, t) {
                            e && e.removeAttribute("tabindex"), document.removeEventListener("focusin", this.listeners[t]);
                        },
                    },
                    {
                        key: "clearTrapFocus",
                        value: function () {
                            for (var e in this.listeners) this.listeners.hasOwnProperty(e) && document.removeEventListener("focusin", this.listeners[e]);
                            this.listeners = {};
                        },
                    },
                ]),
                e
            );
        })(),
        T = (function () {
            function e(i, n) {
                t(this, e),
                    (this.element = i),
                    (this.delegateElement = new b(this.element)),
                    (this.delegateRoot = new b(document.documentElement)),
                    (this.options = n),
                    this.element &&
                        ((this.miniCartElement = this.element.querySelector(".mini-cart")),
                        (this.isMiniCartOpen = !1),
                        "cart" !== window.theme.pageType && this.miniCartElement && ((this.miniCartToggleElement = this.element.querySelector('[aria-controls="'.concat(this.miniCartElement.id, '"]'))), this._checkMiniCartScrollability()),
                        (this.itemCount = window.theme.cartCount),
                        this._attachListeners());
            }
            return (
                n(e, [
                    {
                        key: "destroy",
                        value: function () {
                            this.delegateElement.off(), this.delegateRoot.off(), window.removeEventListener("resize", this._calculateMiniCartHeightListener);
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._calculateMiniCartHeightListener = this._calculateMiniCartHeight.bind(this)),
                                "cart" !== window.theme.pageType &&
                                    "page" !== window.theme.cartType &&
                                    (this.delegateElement.on("click", '[data-action="toggle-mini-cart"]', this._toggleMiniCart.bind(this)),
                                    this.delegateElement.on("keyup", this._checkMiniCartClose.bind(this)),
                                    this.delegateRoot.on("click", this._onWindowClick.bind(this)),
                                    window.addEventListener("resize", this._calculateMiniCartHeightListener)),
                                this.delegateRoot.on("click", '[data-action="decrease-quantity"]', this._updateQuantity.bind(this)),
                                this.delegateRoot.on("click", '[data-action="increase-quantity"]', this._updateQuantity.bind(this)),
                                this.delegateRoot.on("change", ".quantity-selector:not(.quantity-selector--product) .quantity-selector__value", this._updateQuantity.bind(this)),
                                this.delegateRoot.on("keyup", ".quantity-selector:not(.quantity-selector--product) .quantity-selector__value", this._updateQuantitySize.bind(this)),
                                this.delegateRoot.on("keydown", ".quantity-selector__value", this._blockEnterKey.bind(this)),
                                this.delegateRoot.on("product:added", this._onProductAdded.bind(this)),
                                this.delegateRoot.on("cart:refresh", this._onCartRefresh.bind(this));
                        },
                    },
                    {
                        key: "_toggleMiniCart",
                        value: function (e) {
                            e && e.preventDefault(), this.isMiniCartOpen ? this._closeMiniCart() : this._openMiniCart();
                        },
                    },
                    {
                        key: "_openMiniCart",
                        value: function () {
                            if (
                                (this.miniCartToggleElement.setAttribute("aria-expanded", "true"),
                                "phone" === S.getCurrentBreakpoint() && this.miniCartToggleElement.querySelector(".header__cart-icon").setAttribute("aria-expanded", "true"),
                                this.miniCartElement.setAttribute("aria-hidden", "false"),
                                (this.isMiniCartOpen = !0),
                                this._calculateMiniCartHeight(),
                                A.trapFocus(this.miniCartElement, "mini-cart"),
                                document.body.classList.add("no-mobile-scroll"),
                                $(document).find("[null-faster-product]").length)
                            ) {
                                var e = $(document).find("[data-item-total]").data("item-total"),
                                    t = 0;
                                $(document)
                                    .find("[null-faster-product]")
                                    .each(function () {
                                        var e = $(this).data("item-variant"),
                                           // i = $.cookie("itg-faster-addprice_" + e);
                                            i = getCookie("itg-faster-addprice_" + e)

                                        t += parseInt(i);
                                    });
                                var i = 100 * t + e;
                                $(document)
                                    .find("[data-item-total]")
                                    .text(B.formatMoney(i) + " USD");
                            }
                        },
                    },
                    {
                        key: "_closeMiniCart",
                        value: function () {
                            this.miniCartToggleElement.setAttribute("aria-expanded", "false"),
                                "phone" === S.getCurrentBreakpoint() && (this.miniCartToggleElement.querySelector(".header__cart-icon").setAttribute("aria-expanded", "false"), (this.miniCartElement.style.maxHeight = "")),
                                this.miniCartElement.setAttribute("aria-hidden", "true"),
                                (this.isMiniCartOpen = !1),
                                document.body.classList.remove("no-mobile-scroll");
                        },
                    },
                    {
                        key: "_checkMiniCartClose",
                        value: function (e) {
                            this.isMiniCartOpen && "Escape" === e.key && this._closeMiniCart();
                        },
                    },
                    {
                        key: "_calculateMiniCartHeight",
                        value: function () {
                            if ("phone" === S.getCurrentBreakpoint())
                                if (this.isMiniCartOpen) {
                                    var e = window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom;
                                    this.miniCartElement.style.maxHeight = "".concat(e, "px");
                                    var t = this.miniCartElement.querySelector(".mini-cart__content"),
                                        i = this.miniCartElement.querySelector(".mini-cart__recap");
                                    i && (t.style.maxHeight = "".concat(e - i.clientHeight, "px"));
                                } else (this.miniCartElement.style.maxHeight = ""), (this.miniCartElement.querySelector(".mini-cart__content").style.maxHeight = "");
                            else (this.miniCartElement.style.maxHeight = ""), (this.miniCartElement.querySelector(".mini-cart__content").style.maxHeight = "");
                        },
                    },
                    {
                        key: "_updateQuantity",
                        value: function (e, t) {
                            var i = this,
                                n = 1;
                            if (((n = "INPUT" === t.tagName ? parseInt(t.value) : parseInt(t.getAttribute("data-quantity"))), "page" !== window.theme.cartType)) {
                                document.dispatchEvent(new CustomEvent("theme:loading:start"));
                                var o = $(t).data("quantity"),
                                    a = $(t).parents("[cart-line-items]").attr("data-faster-id");
                                a
                                    ? $(document)
                                          .find("[hidden-faster-product]")
                                          .each(function () {
                                              var e = $(this).data("item-variant"),
                                                  s = $(this).attr("cart-item-key");
                                              e == a &&
                                                  $.ajax({
                                                      type: "POST",
                                                      url: "/cart/change.js",
                                                      data: { quantity: o, id: s },
                                                      dataType: "json",
                                                      success: function (e) {
                                                          fetch("".concat(window.routes.cartChangeUrl, ".js"), {
                                                              body: JSON.stringify({ line: t.getAttribute("data-line"), quantity: n }),
                                                              credentials: "same-origin",
                                                              method: "POST",
                                                              headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                                                          }).then(function (e) {
                                                              $.getJSON("/cart.js", function (t) {
                                                                  var n = t.total_price,
                                                                      o = t.items,
                                                                      a = $(document).find("#minimum-order-fee").data("price"),
                                                                      s = $(document).find("#minimum-order-fee").data("required-price"),
                                                                      r = $(document).find("#minimum-order-fee").data("variant-id"),
                                                                      l = !1;
                                                                  $.each(o, function (e, t) {
                                                                      t.id === r && (l = !0);
                                                                  }),
                                                                      s > n
                                                                          ? 1 != l && o.length > 0
                                                                              ? $.ajax({
                                                                                    type: "POST",
                                                                                    url: "/cart/add.js",
                                                                                    data: { quantity: 1, id: r },
                                                                                    dataType: "json",
                                                                                    success: function (t) {
                                                                                        e.json().then(function (e) {
                                                                                            (i.itemCount = e.item_count + 1),
                                                                                                i._rerender(!1).then(function () {
                                                                                                    document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                                                                                });
                                                                                        });
                                                                                    },
                                                                                })
                                                                              : 1 == l && 1 == o.length
                                                                              ? $.ajax({
                                                                                    type: "POST",
                                                                                    url: "/cart/change.js",
                                                                                    data: { quantity: 0, id: r },
                                                                                    dataType: "json",
                                                                                    success: function (t) {
                                                                                        e.json().then(function (e) {
                                                                                            (i.itemCount = e.item_count - 1),
                                                                                                i._rerender(!1).then(function () {
                                                                                                    document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                                                                                });
                                                                                        });
                                                                                    },
                                                                                })
                                                                              : e.json().then(function (e) {
                                                                                    (i.itemCount = e.item_count),
                                                                                        i._rerender(!1).then(function () {
                                                                                            document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                                                                        });
                                                                                })
                                                                          : l && n - a > s
                                                                          ? $.ajax({
                                                                                type: "POST",
                                                                                url: "/cart/change.js",
                                                                                data: { quantity: 0, id: r },
                                                                                dataType: "json",
                                                                                success: function (t) {
                                                                                    e.json().then(function (e) {
                                                                                        (i.itemCount = e.item_count - 1),
                                                                                            i._rerender(!1).then(function () {
                                                                                                document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                                                                            });
                                                                                    });
                                                                                },
                                                                            })
                                                                          : e.json().then(function (e) {
                                                                                (i.itemCount = e.item_count),
                                                                                    i._rerender(!1).then(function () {
                                                                                        document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                                                                    });
                                                                            });
                                                              });
                                                          });
                                                      },
                                                  });
                                          })
                                    : fetch("".concat(window.routes.cartChangeUrl, ".js"), {
                                          body: JSON.stringify({ line: t.getAttribute("data-line"), quantity: n }),
                                          credentials: "same-origin",
                                          method: "POST",
                                          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                                      }).then(function (e) {
                                          $.getJSON("/cart.js", function (t) {
                                              var n = t.total_price,
                                                  o = t.items,
                                                  a = $(document).find("#minimum-order-fee").data("price"),
                                                  s = $(document).find("#minimum-order-fee").data("required-price"),
                                                  r = $(document).find("#minimum-order-fee").data("variant-id"),
                                                  l = !1;
                                              $.each(o, function (e, t) {
                                                  t.id === r && (l = !0);
                                              }),
                                                  s > n
                                                      ? 1 != l && o.length > 0
                                                          ? $.ajax({
                                                                type: "POST",
                                                                url: "/cart/add.js",
                                                                data: { quantity: 1, id: r },
                                                                dataType: "json",
                                                                success: function (t) {
                                                                    e.json().then(function (e) {
                                                                        (i.itemCount = e.item_count + 1),
                                                                            i._rerender(!1).then(function () {
                                                                                document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                                                            });
                                                                    });
                                                                },
                                                            })
                                                          : 1 == l && 1 == o.length
                                                          ? $.ajax({
                                                                type: "POST",
                                                                url: "/cart/change.js",
                                                                data: { quantity: 0, id: r },
                                                                dataType: "json",
                                                                success: function (t) {
                                                                    e.json().then(function (e) {
                                                                        (i.itemCount = e.item_count - 1),
                                                                            i._rerender(!1).then(function () {
                                                                                document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                                                            });
                                                                    });
                                                                },
                                                            })
                                                          : e.json().then(function (e) {
                                                                (i.itemCount = e.item_count),
                                                                    i._rerender(!1).then(function () {
                                                                        document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                                                    });
                                                            })
                                                      : l && n - a > s
                                                      ? $.ajax({
                                                            type: "POST",
                                                            url: "/cart/change.js",
                                                            data: { quantity: 0, id: r },
                                                            dataType: "json",
                                                            success: function (t) {
                                                                e.json().then(function (e) {
                                                                    (i.itemCount = e.item_count - 1),
                                                                        i._rerender(!1).then(function () {
                                                                            document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                                                        });
                                                                });
                                                            },
                                                        })
                                                      : e.json().then(function (e) {
                                                            (i.itemCount = e.item_count),
                                                                i._rerender(!1).then(function () {
                                                                    document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                                                });
                                                        });
                                          });
                                      }),
                                    e.preventDefault();
                            } else
                                t.hasAttribute("data-href")
                                    ? (window.location.href = t.getAttribute("data-href"))
                                    : (window.location.href = "".concat(window.routes.cartChangeUrl, "?line=").concat(t.getAttribute("data-line"), "&quantity=").concat(n));
                        },
                    },
                    {
                        key: "_updateQuantitySize",
                        value: function (e, t) {
                            t.setAttribute("size", Math.max(t.value.length, 2));
                        },
                    },
                    {
                        key: "_blockEnterKey",
                        value: function (e) {
                            if ("Enter" === e.key) return !1;
                        },
                    },
                    {
                        key: "_rerender",
                        value: function () {
                            var e = this,
                                t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
                                i = "";
                            if ("cart" !== window.theme.pageType) i = "".concat(window.routes.cartUrl, "?section_id=mini-cart");
                            else {
                                var n = document.querySelector('[data-section-type="cart"]');
                                i = "".concat(window.routes.cartUrl, "?section_id=").concat(n.getAttribute("data-section-id"));
                            }
                            return fetch(i, { credentials: "same-origin", method: "GET", headers: { "Cache-Control": "no-cache" } }).then(function (i) {
                                i.text().then(function (i) {
                                    var n = document.createElement("div");
                                    if (
                                        ((n.innerHTML = i),
                                        (n = n.firstElementChild).firstElementChild && n.firstElementChild.hasAttribute("data-item-count") && (e.itemCount = parseInt(n.firstElementChild.getAttribute("data-item-count"))),
                                        (e.element.querySelector(".header__cart-count").textContent = e.itemCount),
                                        "page" !== window.theme.cartType)
                                    )
                                        if ("cart" !== window.theme.pageType) {
                                            var o = document.createElement("div");
                                            o.innerHTML = i;
                                            var a = e.miniCartElement.querySelector(".mini-cart__line-item-list"),
                                                s = null;
                                            a && (s = a.scrollTop), (e.miniCartElement.innerHTML = o.querySelector(".mini-cart").innerHTML);
                                            var r = e.miniCartElement.querySelector(".mini-cart__line-item-list");
                                            r && null !== s && (r.scrollTop = s), e._checkMiniCartScrollability(), e._calculateMiniCartHeight(), e.element.dispatchEvent(new CustomEvent("cart:rerendered"));
                                        } else {
                                            var l = document.createElement("div");
                                            (l.innerHTML = i),
                                                (document.querySelector('[data-section-type="cart"]').innerHTML = l.querySelector('[data-section-type="cart"]').innerHTML),
                                                t && window.scrollTo({ top: 0, behavior: "smooth" }),
                                                e.element.dispatchEvent(new CustomEvent("cart:rerendered", { bubbles: !0 }));
                                        }
                                });
                            });
                        },
                    },
                    {
                        key: "_checkMiniCartScrollability",
                        value: function () {
                            var e = this.miniCartElement.querySelector(".mini-cart__line-item-list");
                            e && e.scrollHeight > e.clientHeight && e.classList.add("is-scrollable");
                        },
                    },
                    {
                        key: "_onProductAdded",
                        value: function (e) {
                            var t = this;
                            (this.itemCount += e.detail.quantity),
                                this._onCartRefresh().then(function () {
                                    "cart" !== window.theme.pageType &&
                                        ("drawer" !== window.theme.cartType || t.options.useStickyHeader || window.scrollTo({ top: 0, behavior: "smooth" }),
                                        "message" === window.theme.cartType &&
                                            e.detail.button &&
                                            ((e.detail.button.innerHTML = window.languages.productAddedShort),
                                            setTimeout(function () {
                                                e.detail.button.innerHTML = window.languages.productFormAddToCart;
                                            }, 1500)),
                                        "cart" !== window.theme.pageType &&
                                            "drawer" === window.theme.cartType &&
                                            (t._openMiniCart(),
                                            setTimeout(function () {
                                                if ($(document).find("[null-faster-product]").length) {
                                                    var e = $(document).find("[data-item-total]").data("item-total"),
                                                        t = 0;
                                                    $(document)
                                                        .find("[null-faster-product]")
                                                        .each(function () {
                                                            var e = $(this).data("item-variant"),
                                                                // i = $.cookie("itg-faster-addprice_" + e);
                                                                 i = getCookie("itg-faster-addprice_" + e);
                                                            t += parseInt(i);
                                                        });
                                                    var i = 100 * t + e;
                                                    $(document)
                                                        .find("[data-item-total]")
                                                        .text(B.formatMoney(i) + " USD");
                                                }
                                            }, 100)));
                                });
                        },
                    },
                    {
                        key: "_onCartRefresh",
                        value: function (e) {
                            var t = !0;
                            return (
                                e && e.detail && (t = e.detail.scrollToTop),
                                this._rerender(t).then(function () {
                                    document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                })
                            );
                        },
                    },
                    {
                        key: "_onWindowClick",
                        value: function (e) {
                            this.miniCartElement && this.isMiniCartOpen && !this.element.contains(e.target) && this._closeMiniCart();
                        },
                    },
                ]),
                e
            );
        })(),
        I = (function () {
            function e(i) {
                t(this, e),
                    (this.element = i),
                    (this.delegateElement = new b(this.element)),
                    (this.delegateRoot = new b(document.documentElement)),
                    (this.mobileMenuElement = this.element.querySelector(".mobile-menu")),
                    (this.mobileMenuToggleElement = this.element.querySelector('[aria-controls="'.concat(this.mobileMenuElement.id, '"]'))),
                    (this.isOpen = !1),
                    this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "destroy",
                        value: function () {
                            this.delegateElement.off(), this.delegateRoot.off(), window.removeEventListener("resize", this._calculatMaxHeightListener);
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._calculatMaxHeightListener = this._calculateMaxHeight.bind(this)),
                                this.delegateElement.on("click", '[data-action="toggle-menu"]', this._toggleMenu.bind(this)),
                                this.delegateElement.on("click", '[data-action="open-panel"]', this._openPanel.bind(this)),
                                this.delegateElement.on("click", '[data-action="close-panel"]', this._closePanel.bind(this)),
                                this.delegateRoot.on("click", this._onWindowClick.bind(this)),
                                window.addEventListener("resize", this._calculatMaxHeightListener);
                        },
                    },
                    {
                        key: "_toggleMenu",
                        value: function () {
                            (this.isOpen = !this.isOpen),
                                this.mobileMenuToggleElement.setAttribute("aria-expanded", this.isOpen ? "true" : "false"),
                                this.mobileMenuElement.setAttribute("aria-hidden", this.isOpen ? "false" : "true"),
                                this.isOpen
                                    ? (this._calculateMaxHeight(), document.body.classList.add("no-mobile-scroll"))
                                    : ((this.mobileMenuElement.style.maxHeight = ""),
                                      this.element.querySelectorAll(".mobile-menu__panel.is-open").forEach(function (e) {
                                          e.classList.remove("is-open");
                                      }),
                                      document.body.classList.remove("no-mobile-scroll"));
                        },
                    },
                    {
                        key: "_openPanel",
                        value: function (e, t) {
                            t.setAttribute("aria-expanded", "true"), this.element.querySelector("#".concat(t.getAttribute("aria-controls"))).classList.add("is-open");
                        },
                    },
                    {
                        key: "_closePanel",
                        value: function (e, t) {
                            var i = t.closest(".mobile-menu__panel.is-open");
                            i.classList.remove("is-open"), this.element.querySelector('[aria-controls="'.concat(i.id, '"]')).setAttribute("aria-expanded", "false");
                        },
                    },
                    {
                        key: "_calculateMaxHeight",
                        value: function () {
                            this.isOpen && (this.mobileMenuElement.style.maxHeight = "".concat(window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom, "px"));
                        },
                    },
                    {
                        key: "_onWindowClick",
                        value: function (e) {
                            this.isOpen && !this.element.contains(e.target) && this._toggleMenu();
                        },
                    },
                ]),
                e
            );
        })(),
        q = (function () {
            function e() {
                t(this, e), (this.domDelegate = new b(document.body)), (this.activeModalsQueue = []);
                var i = document.querySelector('.modal[aria-hidden="false"]');
                i && this.activeModalsQueue.push(i), this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._onKeyPressedListener = this._onKeyPressed.bind(this)),
                                this.domDelegate.on("click", '[data-action="open-modal"]', this._openModal.bind(this)),
                                this.domDelegate.on("click", '[data-action="close-modal"]', this._closeModal.bind(this)),
                                document.addEventListener("modal:close", this._closeModal.bind(this)),
                                (this._clickOutsideListener = this._checkClickOutside.bind(this)),
                                this.activeModalsQueue.length > 0 && (document.documentElement.classList.add("is-locked"), this.domDelegate.on("click", this._clickOutsideListener));
                        },
                    },
                    {
                        key: "_openModal",
                        value: function (e, t) {
                            var i = this,
                                n = document.querySelector("#".concat(t.getAttribute("aria-controls")));
                            if (n) {
                                return (
                                    n.addEventListener("transitionend", function e(t) {
                                        "visibility" === t.propertyName && (n.removeEventListener("transitionend", e), A.trapFocus(n, "modal" + n.id), i.activeModalsQueue.push(n));
                                    }),
                                    n.setAttribute("aria-hidden", "false"),
                                    document.documentElement.classList.add("is-locked"),
                                    this.domDelegate.on("click", this._clickOutsideListener),
                                    this.domDelegate.on("keyup", this._onKeyPressedListener),
                                    !1
                                );
                            }
                        },
                    },
                    {
                        key: "_closeModal",
                        value: function () {
                            if (this.activeModalsQueue.length > 0) {
                                var e = this.activeModalsQueue.pop();
                                e.addEventListener("transitionend", function t(i) {
                                    "visibility" === i.propertyName && (e.removeEventListener("transitionend", t), A.removeTrapFocus(e, "modal" + e.id), e.dispatchEvent(new CustomEvent("modal:closed")));
                                }),
                                    e.setAttribute("aria-hidden", "true"),
                                    document.documentElement.classList.remove("is-locked"),
                                    this.domDelegate.off("click", this._clickOutsideListener),
                                    this.domDelegate.off("keyup", this._onKeyPressedListener);
                            }
                        },
                    },
                    {
                        key: "_checkClickOutside",
                        value: function (e) {
                            if (0 !== this.activeModalsQueue.length) {
                                var t = this.activeModalsQueue[this.activeModalsQueue.length - 1];
                                !t || (t.contains(e.target) && t !== e.target) || this._closeModal();
                            }
                        },
                    },
                    {
                        key: "_onKeyPressed",
                        value: function (e) {
                            "Escape" === e.key && this._closeModal();
                        },
                    },
                ]),
                e
            );
        })(),
        P = (function () {
            function e(i) {
                t(this, e), (this.element = i), (this.delegateElement = new b(this.element)), (this.rootDelegateElement = new b(document.body)), (this.options = JSON.parse(i.getAttribute("data-popup-settings")));
                try {
                    "#newsletter-popup" === window.location.hash && "captcha" !== window.theme.pageType
                        ? this._openPopup()
                        : (!this.options.showOnlyOnce || (this.options.showOnlyOnce && null === localStorage.getItem("themePopup"))) && setTimeout(this._openPopup.bind(this), 1e3 * this.options.apparitionDelay);
                } catch (e) {}
                this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "destroy",
                        value: function () {
                            this.delegateElement.off();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._onKeyPressedListener = this._onKeyPressed.bind(this)),
                                this.delegateElement.on("click", '[data-action="close-popup"]', this._closePopup.bind(this)),
                                (this._clickOutsideListener = this._checkClickOutside.bind(this));
                        },
                    },
                    {
                        key: "_openPopup",
                        value: function () {
                            window.theme.isExitPopupOpen ||
                                (this.element.setAttribute("aria-hidden", "false"),
                                localStorage.setItem("themePopup", "true"),
                                (window.theme.isNewsletterPopupOpen = !0),
                                this.delegateElement.on("click", this._clickOutsideListener),
                                this.rootDelegateElement.on("keyup", this._onKeyPressedListener));
                        },
                    },
                    {
                        key: "_closePopup",
                        value: function () {
                            this.element.setAttribute("aria-hidden", "true"), (window.theme.isNewsletterPopupOpen = !1), this.delegateElement.off("click"), this.rootDelegateElement.off("keyup", this._onKeyPressedListener);
                        },
                    },
                    {
                        key: "_checkClickOutside",
                        value: function (e) {
                            (this.element.contains(e.target) && this.element !== e.target) || this._closePopup();
                        },
                    },
                    {
                        key: "_onKeyPressed",
                        value: function (e) {
                            "Escape" === e.key && this._closePopup();
                        },
                    },
                ]),
                e
            );
        })(),
        M = y(function (t) {
            !(function (i) {
                var n = function () {},
                    o =
                        i.requestAnimationFrame ||
                        i.webkitRequestAnimationFrame ||
                        i.mozRequestAnimationFrame ||
                        i.msRequestAnimationFrame ||
                        function (e) {
                            return setTimeout(e, 16);
                        };
                function a() {
                    var e = this;
                    (e.reads = []), (e.writes = []), (e.raf = o.bind(i));
                }
                function s(e) {
                    e.scheduled || ((e.scheduled = !0), e.raf(r.bind(null, e)));
                }
                function r(e) {
                    var t,
                        i = e.writes,
                        o = e.reads;
                    try {
                        n("flushing reads", o.length), l(o), n("flushing writes", i.length), l(i);
                    } catch (e) {
                        t = e;
                    }
                    if (((e.scheduled = !1), (o.length || i.length) && s(e), t)) {
                        if ((n("task errored", t.message), !e.catch)) throw t;
                        e.catch(t);
                    }
                }
                function l(e) {
                    for (var t; (t = e.shift()); ) t();
                }
                function c(e, t) {
                    var i = e.indexOf(t);
                    return !!~i && !!e.splice(i, 1);
                }
                a.prototype = {
                    constructor: a,
                    measure: function (e, t) {
                        var i = t ? e.bind(t) : e;
                        return this.reads.push(i), s(this), i;
                    },
                    mutate: function (e, t) {
                        var i = t ? e.bind(t) : e;
                        return this.writes.push(i), s(this), i;
                    },
                    clear: function (e) {
                        return c(this.reads, e) || c(this.writes, e);
                    },
                    extend: function (t) {
                        if ("object" != e(t)) throw new Error("expected object");
                        var i = Object.create(this);
                        return (
                            (function (e, t) {
                                for (var i in t) t.hasOwnProperty(i) && (e[i] = t[i]);
                            })(i, t),
                            (i.fastdom = this),
                            i.initialize && i.initialize(),
                            i
                        );
                    },
                    catch: null,
                };
                var d = (i.fastdom = i.fastdom || new a());
                t.exports = d;
            })("undefined" != typeof window ? window : v);
        }),
        z = (function () {
            function e(i, n) {
                t(this, e),
                    i &&
                        ((this.element = i),
                        (this.options = n),
                        (this.lastKnownY = window.scrollY),
                        (this.currentTop = 0),
                        (this.initialTopOffset = n.offsetTop || parseInt(window.getComputedStyle(this.element).top)),
                        this._attachListeners());
            }
            return (
                n(e, [
                    {
                        key: "destroy",
                        value: function () {
                            window.removeEventListener("scroll", this._checkPositionListener);
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._checkPositionListener = this._checkPosition.bind(this)), window.addEventListener("scroll", this._checkPositionListener);
                        },
                    },
                    {
                        key: "_checkPosition",
                        value: function () {
                            var e = this;
                            M.measure(function () {
                                var t = e.element.getBoundingClientRect().top + window.scrollY - e.element.offsetTop + e.initialTopOffset,
                                    i = e.element.clientHeight - window.innerHeight + (e.options.offsetBottom || 0);
                                window.scrollY < e.lastKnownY ? (e.currentTop -= window.scrollY - e.lastKnownY) : (e.currentTop += e.lastKnownY - window.scrollY),
                                    (e.currentTop = Math.min(Math.max(e.currentTop, -i), t, e.initialTopOffset)),
                                    (e.lastKnownY = window.scrollY);
                            }),
                                M.mutate(function () {
                                    e.element.style.top = "".concat(e.currentTop, "px");
                                });
                        },
                    },
                ]),
                e
            );
        })(),
        D = (function () {
            function e() {
                t(this, e), (this.delegateElement = new b(document.body)), (this.delegateRoot = new b(document.documentElement)), (this.activePopover = null), this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._onLooseFocusListener = this._onLooseFocus.bind(this)),
                                this.delegateElement.on("click", '[data-action="toggle-popover"]', this._togglePopover.bind(this)),
                                this.delegateElement.on("click", '[data-action="show-popover-panel"]', this._showPanel.bind(this)),
                                this.delegateRoot.on("click", this._onWindowClick.bind(this)),
                                document.addEventListener("popover:close", this._closeActivePopover.bind(this)),
                                window.addEventListener("resize", this._windowResized.bind(this));
                        },
                    },
                    {
                        key: "_togglePopover",
                        value: function (e, t) {
                            var i = null !== this.activePopover,
                                n = this.activePopover ? this.activePopover.id : null;
                            (t.hasAttribute("data-follow-link") && S.matchesBreakpoint(t.getAttribute("data-follow-link"))) ||
                                (i && this._closeActivePopover(), (!i || (i && t.getAttribute("aria-controls") !== n)) && this._openPopover(t), e.preventDefault());
                        },
                    },
                    {
                        key: "_closeActivePopover",
                        value: function () {
                            this.activePopover.setAttribute("aria-hidden", "true"),
                                document.querySelector('[aria-controls="'.concat(this.activePopover.id, '"]')).setAttribute("aria-expanded", "false"),
                                this.activePopover.removeEventListener("focusout", this._onLooseFocusListener),
                                (this.activePopover = null);
                        },
                    },
                    {
                        key: "_openPopover",
                        value: function (e) {
                            var t = document.getElementById(e.getAttribute("aria-controls"));
                            if ((e.setAttribute("aria-expanded", "true"), t.setAttribute("aria-hidden", "false"), "phone" === S.getCurrentBreakpoint()))
                                t.style.height = "".concat(window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom, "px");
                            else {
                                t.style.height = "";
                                var i = t.querySelector(".popover__panel-list");
                                i && (i.style.height = "".concat(i.clientHeight, "px"));
                            }
                            (this.activePopover = t), this.activePopover.addEventListener("focusout", this._onLooseFocusListener);
                        },
                    },
                    {
                        key: "_showPanel",
                        value: function (e, t) {
                            this.activePopover &&
                                this.activePopover.querySelectorAll(".popover__panel").forEach(function (e) {
                                    e.id === t.getAttribute("aria-controls") ? (e.classList.add("is-selected"), (e.closest(".popover__panel-list").style.height = "".concat(e.clientHeight, "px"))) : e.classList.remove("is-selected");
                                });
                        },
                    },
                    {
                        key: "_onWindowClick",
                        value: function (e) {
                            "toggle-popover" === e.target.getAttribute("data-action") || e.target.closest('[data-action="toggle-popover"]') || (this.activePopover && !this.activePopover.contains(e.target) && this._closeActivePopover());
                        },
                    },
                    {
                        key: "_onLooseFocus",
                        value: function (e) {
                            this.activePopover && null !== e.relatedTarget && !this.activePopover.contains(e.relatedTarget) && this._closeActivePopover();
                        },
                    },
                    {
                        key: "_windowResized",
                        value: function () {
                            "phone" === S.getCurrentBreakpoint() && this.activePopover && (this.activePopover.style.height = "".concat(window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom, "px"));
                        },
                    },
                ]),
                e
            );
        })(),
        O = (function () {
            function e(i) {
                t(this, e), (this.element = i), (this.delegateElement = new b(this.element)), this._attachListeners(), this.recalculateSwatches();
            }
            return (
                n(e, [
                    {
                        key: "destroy",
                        value: function () {
                            this.delegateElement.off(), window.removeEventListener("resize", this._recalculateSwatchesListener);
                        },
                    },
                    {
                        key: "recalculateSwatches",
                        value: function () {
                            var e = this;
                            M.measure(function () {
                                e.element.querySelectorAll(".product-item__swatch-list").forEach(function (e) {
                                    var t = e.clientWidth,
                                        i = parseInt(Math.min(t, 200)),
                                        n = Math.floor(i / 30);
                                    M.mutate(function () {
                                        var t = e.querySelectorAll(".color-swatch");
                                        t.forEach(function (e, i) {
                                            e.classList.remove("color-swatch--view-more"), n === i + 1 && n !== t.length && e.classList.add("color-swatch--view-more");
                                        });
                                    });
                                });
                            });
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._recalculateSwatchesListener = this.recalculateSwatches.bind(this)),
                                this.delegateElement.on("change", ".product-item__swatch-list .color-swatch__radio", this._colorChanged.bind(this)),
                                window.addEventListener("resize", this._recalculateSwatchesListener);
                        },
                    },
                    {
                        key: "_colorChanged",
                        value: function (e, t) {
                            console.log(t);
                            var i = t.closest(".product-item"),
                                n = t.getAttribute("data-variant-url");
                            i.querySelector(".product-item__image-wrapper").setAttribute("href", n), i.querySelector(".product-item__title").setAttribute("href", n);
                            var o = i.querySelector(".product-item__primary-image");
                            if (t.hasAttribute("data-image-url") && t.getAttribute("data-media-id") !== o.getAttribute("data-media-id")) {
                                var a = document.createElement("img");
                                (a.className = "product-item__primary-image lazyload image--fade-in"),
                                    a.setAttribute("data-media-id", t.getAttribute("data-media-id")),
                                    a.setAttribute("data-src", t.getAttribute("data-image-url")),
                                    a.setAttribute("data-widths", t.getAttribute("data-image-widths")),
                                    a.setAttribute("data-sizes", "auto"),
                                    (o.parentNode.style.paddingBottom = "".concat(100 / a.getAttribute("data-image-aspect-ratio"), "%")),
                                    o.parentNode.replaceChild(a, o);
                            }
                        },
                    },
                ]),
                e
            );
        })(),
        B = (function () {
            function e() {
                t(this, e);
            }
            return (
                n(e, null, [
                    {
                        key: "formatMoney",
                        value: function (e, t) {
                            "string" == typeof e && (e = e.replace(".", ""));
                            var i = /\{\{\s*(\w+)\s*\}\}/,
                                n = t || "${{amount}}";
                            function o(e, t) {
                                return null == e || e != e ? t : e;
                            }
                            function a(e, t, i, n) {
                                if (((t = o(t, 2)), (i = o(i, ",")), (n = o(n, ".")), isNaN(e) || null == e)) return 0;
                                var a = (e = (e / 100).toFixed(t)).split(".");
                                return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (a[1] ? n + a[1] : "");
                            }
                            var s = "";
                            switch (n.match(i)[1]) {
                                case "amount":
                                    s = a(e, 2);
                                    break;
                                case "amount_no_decimals":
                                    s = a(e, 0);
                                    break;
                                case "amount_with_space_separator":
                                    s = a(e, 2, " ", ".");
                                    break;
                                case "amount_no_decimals_with_comma_separator":
                                    s = a(e, 0, ",", ".");
                                    break;
                                case "amount_no_decimals_with_space_separator":
                                    s = a(e, 0, " ");
                                    break;
                                case "amount_with_comma_separator":
                                    s = a(e, 2, ".", ",");
                            }
                            return n.indexOf("with_comma_separator"), n.replace(i, s);
                        },
                    },
                ]),
                e
            );
        })();
    if (window.location.href.indexOf("cart") > -1 && $(document).find("[null-faster-product]").length) {
        var H = $(document).find("[data-item-total]").data("item-total"),
            N = 0;
        $(document)
            .find("[null-faster-product]")
            .each(function () {
                var e = $(this).data("item-variant"),
                   // t = $.cookie("itg-faster-addprice_" + e);
                    t = getCookie("itg-faster-addprice_" + e);
                N += parseInt(t);
            });
        var R = 100 * N + H;
        $(document)
            .find("[data-item-total]")
            .text(B.formatMoney(R) + " USD");
    }
    var F = (function () {
            function e() {
                t(this, e);
            }
            return (
                n(e, null, [
                    {
                        key: "serialize",
                        value: function (t) {
                            function i(e, t) {
                                var n = e.lastIndexOf("[");
                                if (-1 === n) {
                                    var o = {};
                                    return (o[e] = t), o;
                                }
                                var a = e.substr(0, n),
                                    s = {};
                                return (s[e.substring(n + 1, e.length - 1)] = t), i(a, s);
                            }
                            for (var n = {}, o = 0, a = t.elements.length; o < a; o++) {
                                var s = t.elements[o];
                                if (
                                    "" !== s.name &&
                                    !s.disabled &&
                                    s.name &&
                                    !s.disabled &&
                                    (s.checked || /select|textarea/i.test(s.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(s.type))
                                ) {
                                    var r = i(s.name, s.value);
                                    n = e.extend(n, r);
                                }
                            }
                            return n;
                        },
                    },
                    {
                        key: "extend",
                        value: function () {
                            for (
                                var t = {},
                                    i = 0,
                                    n = function (i) {
                                        for (var n in i) i.hasOwnProperty(n) && ("[object Object]" === Object.prototype.toString.call(i[n]) ? (t[n] = e.extend(t[n], i[n])) : (t[n] = i[n]));
                                    };
                                i < arguments.length;
                                i++
                            )
                                n(arguments[i]);
                            return t;
                        },
                    },
                ]),
                e
            );
        })(),
        U = (function () {
            function e(i) {
                if ((t(this, e), (this.element = i), this.element)) {
                    var n = this.element.querySelector(".store-availabilities-modal");
                    n && document.body.appendChild(n);
                }
            }
            return (
                n(e, [
                    {
                        key: "updateWithVariant",
                        value: function (e) {
                            this.element && (e ? this._renderAvailabilitySection(e.id) : (this.element.textContent = ""));
                        },
                    },
                    {
                        key: "_renderAvailabilitySection",
                        value: function (e) {
                            var t = this;
                            this.element.innerHTML = "";
                            var i = document.getElementById("StoreAvailabilityModal-".concat(e));
                            return (
                                i && i.remove(),
                                fetch("".concat(window.routes.rootUrlWithoutSlash, "/variants/").concat(e, "?section_id=store-availability")).then(function (i) {
                                    return i.text().then(function (i) {
                                        var n = document.createElement("div");
                                        if (((n.innerHTML = i), (n.innerHTML = n.firstElementChild.innerHTML), "0" !== n.firstElementChild.getAttribute("data-count"))) {
                                            t.element.innerHTML = n.innerHTML;
                                            var o = document.getElementById("StoreAvailabilityModal-".concat(e));
                                            document.body.appendChild(o);
                                        }
                                    });
                                })
                            );
                        },
                    },
                ]),
                e
            );
        })(),
        j = (function () {
            function e(i, n) {
                var o = this;
                t(this, e), (this.element = i), (this.delegateElement = new b(this.element)), (this.options = n);
                var a = this.element.querySelector("[data-product-json]");
                if (a) {
                    var s = JSON.parse(a.innerHTML);
                    (this.productData = s.product),
                        (this.productOptionsWithValues = s.options_with_values),
                        (this.variantsInventories = s.inventories || {}),
                        (this.variantSelectors = this.element.querySelectorAll(".product-form__option[data-selector-type]")),
                        (this.masterSelector = this.element.querySelector("#product-select-".concat(this.productData.id))),
                        this.productData.variants.forEach(function (e) {
                            e.id === s.selected_variant_id && ((o.currentVariant = e), (o.option1 = e.option1), (o.option2 = e.option2), (o.option3 = e.option3));
                        }),
                        (this.storeAvailability = new U(this.element.querySelector(".product-meta__store-availability-container")));
                }
                this._updateSelectors(this.currentVariant), this._setupStockCountdown(), this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "destroy",
                        value: function () {
                            this.delegateElement.off("click");
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateElement.on("change", ".product-form__single-selector", this._onOptionChanged.bind(this)),
                                this.delegateElement.on("click", '[data-action="add-to-cart"],[data-related-action="add-to-cart"]', this._addToCart.bind(this));
                        },
                    },
                    {
                        key: "_onVariantChanged",
                        value: function (e, t) {
                            this._updateProductPrices(t, e),
                                this._updateInventory(t, e),
                                this._updateSku(t, e),
                                this._updateDiscountLabel(t, e),
                                this._updateUnitPrice(t, e),
                                this._updateSelectors(t, e),
                                this._updateAddToCartButton(t, e),
                                this.storeAvailability.updateWithVariant(t),
                                this.element.dispatchEvent(new CustomEvent("variant:changed", { bubbles: !0, detail: { variant: t, previousVariant: e } })),
                                this.masterSelector.dispatchEvent(new Event("change", { bubbles: !0 }));
                        },
                    },
                    {
                        key: "_updateProductPrices",
                        value: function (e, t) {
                            var i = this.element.querySelector(".price-list"),
                                n = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
                            if (i)
                                if (e) {
                                    if (t && t.price === e.price && t.compare_at_price === e.compare_at_price) return;
                                    (i.innerHTML = ""),
                                        e.compare_at_price > e.price
                                            ? ((i.innerHTML += '<span class="price price--highlight"><span class="visually-hidden">'.concat(window.languages.productSalePrice, "</span>").concat(B.formatMoney(e.price, n), "</span>")),
                                              (i.innerHTML += '<span class="price price--compare"><span class="visually-hidden">'
                                                  .concat(window.languages.productRegularPrice, "</span>")
                                                  .concat(B.formatMoney(e.compare_at_price, n), "</span>")))
                                            : (i.innerHTML += '<span class="price"><span class="visually-hidden">'.concat(window.languages.productSalePrice, "</span>").concat(B.formatMoney(e.price, n), "</span>")),
                                        (i.style.display = "");
                                } else i.style.display = "none";
                        },
                    },
                    {
                        key: "_updateInventory",
                        value: function (e) {
                            if (this.options.showInventoryQuantity && e) {
                                var t = this.element.querySelector(".product-form__inventory"),
                                    i = this.variantsInventories[e.id].inventory_management,
                                    n = this.variantsInventories[e.id].inventory_policy,
                                    o = this.variantsInventories[e.id].inventory_quantity,
                                    a = this.variantsInventories[e.id].inventory_message;
                                if (t) {
                                    t.classList.remove("inventory--high"),
                                        t.classList.remove("inventory--low"),
                                        e.available &&
                                            (null !== i && "deny" === n && this.options.lowInventoryThreshold > 0 && o <= this.options.lowInventoryThreshold ? t.classList.add("inventory--low") : t.classList.add("inventory--high"));
                                    var s = this.element.querySelector(".inventory-bar");
                                    if (s) {
                                        var r = Math.min(Math.max((o / parseInt(s.getAttribute("data-stock-countdown-max"))) * 100, 0), 100);
                                        s.classList.toggle("inventory-bar--hidden", 0 === r), (s.firstElementChild.style.width = "".concat(r, "%"));
                                    }
                                    t.innerHTML = a;
                                }
                            }
                        },
                    },
                    {
                        key: "_updateSku",
                        value: function (e, t) {
                            var i = this.element.querySelector(".product-meta__sku"),
                                n = this.element.querySelector(".product-meta__sku_resp");
                            if (n && i) {
                                var o = n.querySelector(".product-meta__sku-number");
                                if (e && "" !== e.sku) {
                                    if (t && t.sku === e.sku) return;
                                    (o.innerHTML = e.sku), (n.style.display = "");
                                } else n.style.display = "none";
                                var a = i.querySelector(".product-meta__sku-number");
                                if (e && "" !== e.sku) {
                                    if (t && t.sku === e.sku) return;
                                    (a.innerHTML = e.sku), (i.style.display = "");
                                } else i.style.display = "none";
                            }
                        },
                    },
                    {
                        key: "_updateDiscountLabel",
                        value: function (e, t) {
                            if (window.theme.showDiscount) {
                                var i = this.element.querySelector(".product-meta .product-label--on-sale");
                                if (i)
                                    if (e && e.price < e.compare_at_price) {
                                        var n = null;
                                        (n =
                                            "percentage" === window.theme.discountMode
                                                ? "".concat(Math.round((100 * (e.compare_at_price - e.price)) / e.compare_at_price), "%")
                                                : "<span>".concat(B.formatMoney(e.compare_at_price - e.price, window.theme.moneyFormat), "</span>")),
                                            (i.innerHTML = "".concat(window.languages.collectionOnSaleLabel.replace("{{savings}}", n))),
                                            (i.style.display = "inline-block");
                                    } else i.style.display = "none";
                            }
                        },
                    },
                    {
                        key: "_updateUnitPrice",
                        value: function (e, t) {
                            var i = this.element.querySelector(".unit-price-measurement");
                            if (i)
                                if (e && e.unit_price_measurement) {
                                    (i.parentNode.style.display = "block"),
                                        (i.querySelector(".unit-price-measurement__price").innerHTML = B.formatMoney(e.unit_price, window.theme.moneyFormat)),
                                        (i.querySelector(".unit-price-measurement__reference-unit").innerHTML = e.unit_price_measurement.reference_unit);
                                    var n = i.querySelector(".unit-price-measurement__reference-value");
                                    (n.innerHTML = e.unit_price_measurement.reference_value), (n.style.display = 1 === e.unit_price_measurement.reference_value ? "none" : "inline");
                                } else i.parentNode.style.display = "none";
                        },
                    },
                    {
                        key: "_updateSelectors",
                        value: function (e) {
                            var t = this,
                                i = function (e, t, i) {
                                    switch (e.getAttribute("data-selector-type")) {
                                        case "color":
                                            e.querySelector(".color-swatch:nth-child(".concat(t + 1, ")")).classList.toggle("color-swatch--disabled", !i);
                                            break;
                                        case "variant":
                                            e.querySelector(".variant-swatch:nth-child(".concat(t + 1, ")")).classList.toggle("variant-swatch--disabled", !i);
                                            break;
                                        case "block":
                                            e.querySelector(".block-swatch:nth-child(".concat(t + 1, ")")).classList.toggle("block-swatch--disabled", !i);
                                    }
                                };
                            this.variantSelectors &&
                                this.variantSelectors[0] &&
                                this.productOptionsWithValues[0].values.forEach(function (e, n) {
                                    i(
                                        t.variantSelectors[0],
                                        n,
                                        t.productData.variants.some(function (t) {
                                            return t.option1 === e && t.available;
                                        })
                                    ),
                                        t.variantSelectors[1] &&
                                            void 0 !== t.productOptionsWithValues[1] &&
                                            t.productOptionsWithValues[1].values.forEach(function (e, n) {
                                                i(
                                                    t.variantSelectors[1],
                                                    n,
                                                    t.productData.variants.some(function (i) {
                                                        return i.option2 === e && i.option1 === t.option1 && i.available;
                                                    })
                                                ),
                                                    t.variantSelectors[2] &&
                                                        void 0 !== t.productOptionsWithValues[2] &&
                                                        t.productOptionsWithValues[2].values.forEach(function (e, n) {
                                                            i(
                                                                t.variantSelectors[2],
                                                                n,
                                                                t.productData.variants.some(function (i) {
                                                                    return i.option3 === e && i.option1 === t.option1 && i.option2 === t.option2 && i.available;
                                                                })
                                                            );
                                                        });
                                            });
                                });
                        },
                    },
                    {
                        key: "_updateAddToCartButton",
                        value: function (e) {
                            var t = this.element.querySelector(".product-form__add-button"),
                                i = this.element.querySelector(".product-form__info-list");
                            if (
                                t &&
                                (e
                                    ? ((i.style.display = "block"),
                                      e.available
                                          ? (t.removeAttribute("disabled"),
                                            t.classList.remove("button--disabled"),
                                            t.classList.add("button--primary"),
                                            t.setAttribute("data-action", "add-to-cart"),
                                            (t.innerHTML = window.languages.productFormAddToCart))
                                          : (t.setAttribute("disabled", "disabled"),
                                            t.classList.add("button--disabled"),
                                            t.classList.remove("button--primary"),
                                            t.removeAttribute("data-action"),
                                            (t.innerHTML = window.languages.productFormSoldOut)))
                                    : (t.setAttribute("disabled", "disabled"),
                                      t.classList.add("button--disabled"),
                                      t.classList.remove("button--primary"),
                                      t.removeAttribute("data-action"),
                                      (t.innerHTML = window.languages.productFormUnavailable),
                                      (i.style.display = "none")),
                                this.options.showPaymentButton)
                            ) {
                                var n = this.element.querySelector(".shopify-payment-button");
                                if (!n) return;
                                e && e.available ? (n.style.display = "block") : (n.style.display = "none");
                            }
                        },
                    },
                    {
                        key: "_onOptionChanged",
                        value: function (e, t) {
                            this["option" + t.getAttribute("data-option-position")] = t.value;
                            var i = t.closest(".product-form__option").querySelector(".product-form__selected-value");
                            i && (i.innerHTML = t.value);
                            var n = this.currentVariant;
                            if (((this.currentVariant = this._getCurrentVariantFromOptions()), this._onVariantChanged(n, this.currentVariant), this.currentVariant)) {
                                if (this.options.enableHistoryState && history.replaceState) {
                                    var o = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?variant=").concat(this.currentVariant.id);
                                    window.history.replaceState({ path: o }, "", o);
                                } else {
                                    const e = window.location.search,
                                        t = new URLSearchParams(e);
                                    t.delete("variant");
                                    o = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, t.toString());
                                    window.history.replaceState({ path: o }, "", o);
                                }
                                this.masterSelector.querySelector("[selected]").removeAttribute("selected"), this.masterSelector.querySelector('[value="'.concat(this.currentVariant.id, '"]')).setAttribute("selected", "selected");
                            }
                        },
                    },
                    {
                        key: "_getCurrentVariantFromOptions",
                        value: function () {
                            var e = this,
                                t = !1;
                            return (
                                this.productData.variants.forEach(function (i) {
                                    i.option1 === e.option1 && i.option2 === e.option2 && i.option3 === e.option3 && (t = i);
                                }),
                                t || null
                            );
                        },
                    },
                    {
                        key: "_addToCart",
                        value: function _addToCart(event, target) {
                                var _this4 = this;
                                if (window.theme.cartType === 'page') {
                                  return; // When using a cart type of page, we just simply redirect to the cart page
                                }
                                event.preventDefault(); // Prevent form to be submitted
                                event.stopPropagation(); // First, we switch the status of the button
                                const validateObjectData = validate_options(window.hulkapps.product_id);
                                const validateObjectValue = async () => {
                                  const v = await validateObjectData;
                                  if (v == true) {
                                    target.setAttribute('disabled', 'disabled');
                                    document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax
                                    var formElement = this.element.querySelector('form[action*="/cart/add"]');
                                    var variantInput = formElement.querySelector('*[name="id"]')
                                    var quantityInput = formElement.querySelector('input[name="quantity"]')
                                    var itemQuantity = quantityInput.size > 0 ? quantityInput.value : 1
                                    window.dataLayer.push({
                                      event: 'ee_add_to_cart',
                                      name: formElement.querySelector('.ptitle').value,
                                      id: formElement.querySelector('.pid').value,
                                      price: formElement.querySelector('.pprice').value,
                                      brand: formElement.querySelector('.pbrand').value,
                                      product_type: formElement.querySelector('.ptype').value,
                                      category: formElement.querySelector('.pcollection').value,
                                      quantity: itemQuantity,
                                      variant: variantInput.value,
                                      g_product_id: "shopify_US_" + formElement.querySelector('.pid').value + "_" + variantInput.value
                                    });
                                    $(formElement).find('#faster-properties').removeAttr("name").val('');
                                    $(formElement).find('#faster-addon-price').removeAttr("name").val('');
                                    if ($(formElement).find('#faster-checkbox:checked').length) {
                                      event.preventDefault();
                                      var itemQuantity = parseInt(formElement.querySelector('[name="quantity"]').value)
                                      var getFasterPrice = $(formElement).find('#faster-checkbox').val();
                                      var getFasterProductId = $(formElement).find('#faster-checkbox').data("product-id");
                                      var getProductVariantId = $(formElement).find('#faster-checkbox').data("variant-id");
                                      var _data = [];
                                      _data["product-id"] = getFasterProductId;
                                      _data["product-price"] = getFasterPrice * itemQuantity;
                                      $.ajax({
                                        type: 'POST',
                                        url: 'https://need-it-faster.qualitydoor.com/product_variant_create.php',
                                        data: {
                                          price: getFasterPrice
                                        },
                                        success: function (id) {
                                          $(formElement).find('#faster-properties').attr("name", "properties[Faster checkout]").val(id);
                                          $(formElement).find('#faster-addon-price').attr("name", "properties[Additional price for need it faster]").val(B.formatMoney(100 * getFasterPrice));
                                          $.ajax({
                                            type: 'POST',
                                            url: '/cart/add.js',
                                            data: {
                                              quantity: itemQuantity,
                                              id: id
                                            },
                                            dataType: 'json',
                                            success: function (event) {
                                              fetch("".concat(window.routes.cartAddUrl, ".js"), {
                                                body: JSON.stringify(F.serialize(formElement)),
                                                credentials: 'same-origin',
                                                method: 'POST',
                                                headers: {
                                                  'Content-Type': 'application/json',
                                                  'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                                                }
                                              }).then(function (response) {
                                                if (response.ok) {
                                                //   $.cookie('itg-faster-price_' + id + '', getFasterPrice, {
                                                //     expires: 1,
                                                //     path: '/'
                                                //   });
                                                const setCookie = (cName, cValue, expDays)=> {
                                                    let date = new Date();
                                                    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
                                                    const expires = "expires=" + date.toUTCString();
                                                    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
                                                  }
                                                  setCookie('itg-faster-price_' + id + '', getFasterPrice, 1)
                                                //   $.cookie('itg-faster-addprice_' + id + '', _data["product-price"], {
                                                //     expires: 1,
                                                //     path: '/'
                                                //   });
                                                  setCookie('itg-faster-addprice_' + id + '', _data["product-price"], 1)
                                                  $.getJSON('/cart.js', function (cart) {
                                                    var totalPrice = cart.total_price;
                                                    var cartItems = cart.items;
                                                    var feeProductPrice = $(document).find('#minimum-order-fee').data('price');
                                                    var requiredPrice = $(document).find('#minimum-order-fee').data('required-price');
                                                    var variantId = $(document).find('#minimum-order-fee').data('variant-id');
                                                    var checkFreeProduct = false;
                                                    $.each(cartItems, function (index, value) {
                                                      var cartItemId = value['id'];
                                                      if (cartItemId === variantId) {
                                                        checkFreeProduct = true;
                                                      }
                                                    });
                                                    if (requiredPrice > totalPrice) {
                                                      if (checkFreeProduct != true && cartItems.length > 0) {
                                                        $.ajax({
                                                          type: 'POST',
                                                          url: '/cart/add.js',
                                                          data: {
                                                            quantity: 1,
                                                            id: variantId
                                                          },
                                                          dataType: 'json',
                                                          success: function (data) {
                                                            document.dispatchEvent(new CustomEvent('theme:loading:end'));
                                                            target.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
                                                            var plusQuanityfaster = itemQuantity + itemQuantity + 1;
                                                            _this4.element.dispatchEvent(new CustomEvent('product:added', {
                                                              bubbles: true,
                                                              detail: {
                                                                variant: _this4.currentVariant,
                                                                quantity: plusQuanityfaster
                                                              }
                                                            })); // If we are in the context of quick view, we also force closing the modal
                                                            if (_this4.options['isQuickView'] && window.theme.cartType === 'drawer') {
                                                              document.dispatchEvent(new CustomEvent('modal:close'));
                                                            }
                                                            if (window.theme.cartType === 'message') {
                                                              _this4._showAlert(window.languages.productAdded, 'success', target);
                                                            }
                                                          }
                                                        });
                                                      } else {
                                                        if (cartItems.length == 1 && requiredPrice > totalPrice) {
                                                          $.ajax({
                                                            type: 'POST',
                                                            url: '/cart/change.js',
                                                            data: {
                                                              quantity: 0,
                                                              id: variantId
                                                            },
                                                            dataType: 'json',
                                                            success: function (data) {
                                                              document.dispatchEvent(new CustomEvent('theme:loading:end'));
                                                              target.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
                                                              var plusQuanityfaster = itemQuantity + itemQuantity;
                                                              _this4.element.dispatchEvent(new CustomEvent('product:added', {
                                                                bubbles: true,
                                                                detail: {
                                                                  variant: _this4.currentVariant,
                                                                  quantity: plusQuanityfaster - 1
                                                                }
                                                              })); // If we are in the context of quick view, we also force closing the modal
                                                              if (_this4.options['isQuickView'] && window.theme.cartType === 'drawer') {
                                                                document.dispatchEvent(new CustomEvent('modal:close'));
                                                              }
                                                              if (window.theme.cartType === 'message') {
                                                                _this4._showAlert(window.languages.productAdded, 'success', target);
                                                              }
                                                            }
                                                          });
                                                        } else {
                                                          document.dispatchEvent(new CustomEvent('theme:loading:end'));
                                                          target.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
                                                          var plusQuanityfaster = itemQuantity + itemQuantity;
                                                          _this4.element.dispatchEvent(new CustomEvent('product:added', {
                                                            bubbles: true,
                                                            detail: {
                                                              variant: _this4.currentVariant,
                                                              quantity: plusQuanityfaster
                                                            }
                                                          })); // If we are in the context of quick view, we also force closing the modal
                                                          if (_this4.options['isQuickView'] && window.theme.cartType === 'drawer') {
                                                            document.dispatchEvent(new CustomEvent('modal:close'));
                                                          }
                                                          if (window.theme.cartType === 'message') {
                                                            _this4._showAlert(window.languages.productAdded, 'success', target);
                                                          }
                                                        }
                                                      }
                                                    } else {
                                                      if (checkFreeProduct) {
                                                        if (totalPrice - feeProductPrice > requiredPrice) {
                                                          $.ajax({
                                                            type: 'POST',
                                                            url: '/cart/change.js',
                                                            data: {
                                                              quantity: 0,
                                                              id: variantId
                                                            },
                                                            dataType: 'json',
                                                            success: function (data) {
                                                              document.dispatchEvent(new CustomEvent('theme:loading:end'));
                                                              target.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
                                                              var plusQuanityfaster = itemQuantity + itemQuantity;
                                                              _this4.element.dispatchEvent(new CustomEvent('product:added', {
                                                                bubbles: true,
                                                                detail: {
                                                                  variant: _this4.currentVariant,
                                                                  quantity: plusQuanityfaster - 1
                                                                }
                                                              })); // If we are in the context of quick view, we also force closing the modal
                                                              if (_this4.options['isQuickView'] && window.theme.cartType === 'drawer') {
                                                                document.dispatchEvent(new CustomEvent('modal:close'));
                                                              }
                                                              if (window.theme.cartType === 'message') {
                                                                _this4._showAlert(window.languages.productAdded, 'success', target);
                                                              }
                                                            }
                                                          });
                                                        } else {
                                                          document.dispatchEvent(new CustomEvent('theme:loading:end'));
                                                          target.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
                                                          var plusQuanityfaster = itemQuantity + itemQuantity;
                                                          _this4.element.dispatchEvent(new CustomEvent('product:added', {
                                                            bubbles: true,
                                                            detail: {
                                                              variant: _this4.currentVariant,
                                                              quantity: plusQuanityfaster
                                                            }
                                                          })); // If we are in the context of quick view, we also force closing the modal
                                                          if (_this4.options['isQuickView'] && window.theme.cartType === 'drawer') {
                                                            document.dispatchEvent(new CustomEvent('modal:close'));
                                                          }
                                                          if (window.theme.cartType === 'message') {
                                                            _this4._showAlert(window.languages.productAdded, 'success', target);
                                                          }
                                                        }
                                                      } else {
                                                        document.dispatchEvent(new CustomEvent('theme:loading:end'));
                                                        target.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
                                                        var plusQuanityfaster = itemQuantity + itemQuantity;
                                                        _this4.element.dispatchEvent(new CustomEvent('product:added', {
                                                          bubbles: true,
                                                          detail: {
                                                            variant: _this4.currentVariant,
                                                            quantity: plusQuanityfaster
                                                          }
                                                        })); // If we are in the context of quick view, we also force closing the modal
                                                        if (_this4.options['isQuickView'] && window.theme.cartType === 'drawer') {
                                                          document.dispatchEvent(new CustomEvent('modal:close'));
                                                        }
                                                        if (window.theme.cartType === 'message') {
                                                          _this4._showAlert(window.languages.productAdded, 'success', target);
                                                        }
                                                      }
                                                    }
                                                  });
                                                } else {
                                                  document.dispatchEvent(new CustomEvent('theme:loading:end'));
                                                  response.json().then(function (content) {
                                                    _this4._showAlert(content['description'], 'error', target);
                                                  });
                                                }
                                              });
                                            }
                                          });
                                        }
                                      });
                                    } else {
                        
                        
                                      fetch("".concat(window.routes.cartAddUrl, ".js"), {
                                        body: JSON.stringify(F.serialize(formElement)),
                                        credentials: 'same-origin',
                                        method: 'POST',
                                        headers: {
                                          'Content-Type': 'application/json',
                                          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                        
                                        }
                                      }).then(function (response) {
                                        if (response.ok) {
                                          $.getJSON('/cart.js', function (cart) {
                                            var totalPrice = cart.total_price;
                                            var cartItems = cart.items;
                                            var feeProductPrice = $(document).find('#minimum-order-fee').data('price');
                                            var requiredPrice = $(document).find('#minimum-order-fee').data('required-price');
                                            var variantId = $(document).find('#minimum-order-fee').data('variant-id');
                                            var checkFreeProduct = false;
                                            $.each(cartItems, function (index, value) {
                                              var cartItemId = value['id'];
                                              if (cartItemId === variantId) {
                                                checkFreeProduct = true;
                                              }
                                            });
                                            if (requiredPrice > totalPrice) {
                                              if (checkFreeProduct != true && cartItems.length > 0) {
                                                $.ajax({
                                                  type: 'POST',
                                                  url: '/cart/add.js',
                                                  data: {
                                                    quantity: 1,
                                                    id: variantId
                                                  },
                                                  dataType: 'json',
                                                  success: function (data) {
                                                    document.dispatchEvent(new CustomEvent('theme:loading:end'));
                                                    target.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
                                                    _this4.element.dispatchEvent(new CustomEvent('product:added', {
                                                      bubbles: true,
                                                      detail: {
                                                        variant: _this4.currentVariant,
                                                        quantity: parseInt(formElement.querySelector('[name="quantity"]').value) + 1
                                                      }
                                                    })); // If we are in the context of quick view, we also force closing the modal
                                                    if (_this4.options['isQuickView'] && window.theme.cartType === 'drawer') {
                                                      document.dispatchEvent(new CustomEvent('modal:close'));
                                                    }
                                                    if (window.theme.cartType === 'message') {
                                                      _this4._showAlert(window.languages.productAdded, 'success', target);
                                                    }
                                                  }
                                                });
                                              } else {
                                                if (cartItems.length == 1 && requiredPrice > totalPrice) {
                                                  $.ajax({
                                                    type: 'POST',
                                                    url: '/cart/change.js',
                                                    data: {
                                                      quantity: 0,
                                                      id: variantId
                                                    },
                                                    dataType: 'json',
                                                    success: function (data) {
                                                      document.dispatchEvent(new CustomEvent('theme:loading:end'));
                                                      target.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
                                                      _this4.element.dispatchEvent(new CustomEvent('product:added', {
                                                        bubbles: true,
                                                        detail: {
                                                          variant: _this4.currentVariant,
                                                          quantity: parseInt(formElement.querySelector('[name="quantity"]').value) - 1
                                                        }
                                                      })); // If we are in the context of quick view, we also force closing the modal
                                                      if (_this4.options['isQuickView'] && window.theme.cartType === 'drawer') {
                                                        document.dispatchEvent(new CustomEvent('modal:close'));
                                                      }
                                                      if (window.theme.cartType === 'message') {
                                                        _this4._showAlert(window.languages.productAdded, 'success', target);
                                                      }
                                                    }
                                                  });
                                                } else {
                                                  document.dispatchEvent(new CustomEvent('theme:loading:end'));
                                                  target.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
                                                  _this4.element.dispatchEvent(new CustomEvent('product:added', {
                                                    bubbles: true,
                                                    detail: {
                                                      variant: _this4.currentVariant,
                                                      quantity: parseInt(formElement.querySelector('[name="quantity"]').value)
                                                    }
                                                  })); // If we are in the context of quick view, we also force closing the modal
                                                  if (_this4.options['isQuickView'] && window.theme.cartType === 'drawer') {
                                                    document.dispatchEvent(new CustomEvent('modal:close'));
                                                  }
                                                  if (window.theme.cartType === 'message') {
                                                    _this4._showAlert(window.languages.productAdded, 'success', target);
                                                  }
                                                }
                                              }
                                            } else {
                                              if (checkFreeProduct) {
                                                if (totalPrice - feeProductPrice > requiredPrice) {
                                                  $.ajax({
                                                    type: 'POST',
                                                    url: '/cart/change.js',
                                                    data: {
                                                      quantity: 0,
                                                      id: variantId
                                                    },
                                                    dataType: 'json',
                                                    success: function (data) {
                                                      document.dispatchEvent(new CustomEvent('theme:loading:end'));
                                                      target.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
                                                      _this4.element.dispatchEvent(new CustomEvent('product:added', {
                                                        bubbles: true,
                                                        detail: {
                                                          variant: _this4.currentVariant,
                                                          quantity: parseInt(formElement.querySelector('[name="quantity"]').value) - 1
                                                        }
                                                      })); // If we are in the context of quick view, we also force closing the modal
                                                      if (_this4.options['isQuickView'] && window.theme.cartType === 'drawer') {
                                                        document.dispatchEvent(new CustomEvent('modal:close'));
                                                      }
                                                      if (window.theme.cartType === 'message') {
                                                        _this4._showAlert(window.languages.productAdded, 'success', target);
                                                      }
                                                    }
                                                  });
                                                } else {
                                                  document.dispatchEvent(new CustomEvent('theme:loading:end'));
                                                  target.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
                                                  _this4.element.dispatchEvent(new CustomEvent('product:added', {
                                                    bubbles: true,
                                                    detail: {
                                                      variant: _this4.currentVariant,
                                                      quantity: parseInt(formElement.querySelector('[name="quantity"]').value)
                                                    }
                                                  })); // If we are in the context of quick view, we also force closing the modal
                                                  if (_this4.options['isQuickView'] && window.theme.cartType === 'drawer') {
                                                    document.dispatchEvent(new CustomEvent('modal:close'));
                                                  }
                                                  if (window.theme.cartType === 'message') {
                                                    _this4._showAlert(window.languages.productAdded, 'success', target);
                                                  }
                                                }
                                              } else {
                                                document.dispatchEvent(new CustomEvent('theme:loading:end'));
                                                target.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
                                                _this4.element.dispatchEvent(new CustomEvent('product:added', {
                                                  bubbles: true,
                                                  detail: {
                                                    variant: _this4.currentVariant,
                                                    quantity: parseInt(formElement.querySelector('[name="quantity"]').value)
                                                  }
                                                })); // If we are in the context of quick view, we also force closing the modal
                                                if (_this4.options['isQuickView'] && window.theme.cartType === 'drawer') {
                                                  document.dispatchEvent(new CustomEvent('modal:close'));
                                                }
                                                if (window.theme.cartType === 'message') {
                                                  _this4._showAlert(window.languages.productAdded, 'success', target);
                                                }
                                              }
                                            }
                                          });
                                        } else {
                                          document.dispatchEvent(new CustomEvent('theme:loading:end'));
                                          response.json().then(function (content) {
                                            _this4._showAlert(content['description'], 'error', target);
                                          });
                                        }
                                      });
                                    }
                                    event.preventDefault();
                                  }
                                };
                                validateObjectValue();
                        }
                    },
                    {
                        key: "_setupStockCountdown",
                        value: function () {
                            var e = this,
                                t = this.element.querySelector(".inventory-bar");
                            if (t) {
                                var i = function () {
                                    var i = e.variantsInventories[e.currentVariant.id].inventory_quantity,
                                        n = Math.min(Math.max((i / parseInt(t.getAttribute("data-stock-countdown-max"))) * 100, 0), 100);
                                    t.classList.toggle("inventory-bar--hidden", 0 === n), (t.firstElementChild.style.width = "".concat(n, "%"));
                                };
                                if (window.IntersectionObserver) {
                                    var n = new IntersectionObserver(function (e) {
                                        e.forEach(function (e) {
                                            e.isIntersecting && (i(), n.disconnect());
                                        });
                                    });
                                    n.observe(t);
                                } else i();
                            }
                        },
                    },
                    {
                        key: "_showAlert",
                        value: function (e, t, i) {
                            var n = document.createElement("div");
                            (n.className = "product-form__status-message"),
                                (n.innerHTML = '<p class="alert '.concat("success" === t ? "alert--success" : "alert--error", '">').concat(e, "</p>")),
                                i.removeAttribute("disabled"),
                                i.parentNode.insertAdjacentElement("afterend", n),
                                m.slideDown(n),
                                setTimeout(function () {
                                    m.slideUp(n, function () {
                                        n.remove();
                                    });
                                }, 5500);
                        },
                    },
                ]),
                e
            );
        })(),
        W = (function () {
            function e(i) {
                t(this, e), (this.element = i), (this.delegateElement = new b(this.element)), (this.delegateRoot = new b(document.documentElement)), this._attachListeners();
                var n = document.createElement("link");
                (n.rel = "stylesheet"),
                    (n.href = "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"),
                    document.head.appendChild(n),
                    window.Shopify.loadFeatures([
                        { name: "model-viewer-ui", version: "1.0", onLoad: this._setupModelViewerUI.bind(this) },
                        { name: "shopify-xr", version: "1.0" },
                    ]);
            }
            return (
                n(e, [
                    { key: "destroy", value: function () {} },
                    {
                        key: "_attachListeners",
                        value: function () {
                            var e = this;
                            this.element.querySelector("model-viewer").addEventListener("shopify_model_viewer_ui_toggle_play", function () {
                                e.element.dispatchEvent(new CustomEvent("model:played", { bubbles: !0 }));
                            }),
                                this.element.querySelector("model-viewer").addEventListener("shopify_model_viewer_ui_toggle_pause", function () {
                                    e.element.dispatchEvent(new CustomEvent("model:paused", { bubbles: !0 }));
                                });
                        },
                    },
                    {
                        key: "hasBeenSelected",
                        value: function (e) {
                            S.matchesBreakpoint("supports-hover") && !e && this.modelUi.play();
                        },
                    },
                    {
                        key: "hasBeenDeselected",
                        value: function () {
                            this.modelUi.pause();
                        },
                    },
                    {
                        key: "_setupModelViewerUI",
                        value: function () {
                            (this.modelElement = this.element.querySelector("model-viewer")), (this.modelUi = new window.Shopify.ModelViewerUI(this.modelElement));
                        },
                    },
                ]),
                e
            );
        })(),
        V = (function () {
            function e(i, n) {
                switch ((t(this, e), (this.element = i), (this.delegateElement = new b(this.element)), (this.enableVideoLooping = n), (this.player = null), this.element.getAttribute("data-media-type"))) {
                    case "video":
                        var o = document.createElement("link");
                        (o.rel = "stylesheet"),
                            (o.href = "https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css"),
                            document.head.appendChild(o),
                            window.Shopify.loadFeatures([{ name: "video-ui", version: "1.0", onLoad: this._setupHtml5Video.bind(this) }]);
                        break;
                    case "external_video":
                        this._setupExternalVideo();
                }
            }
            return (
                n(e, [
                    {
                        key: "destroy",
                        value: function () {
                            this.player && this.player.destroy();
                        },
                    },
                    {
                        key: "hasBeenSelected",
                        value: function (e) {
                            S.matchesBreakpoint("supports-hover") && !e && this.play();
                        },
                    },
                    {
                        key: "hasBeenDeselected",
                        value: function () {
                            this.pause();
                        },
                    },
                    {
                        key: "play",
                        value: function () {
                            switch (this.element.getAttribute("data-media-type")) {
                                case "video":
                                    this.player.play();
                                    break;
                                case "external_video":
                                    "youtube" === this.element.getAttribute("data-media-host") ? this.player.playVideo() : this.player.player(), this.element.focus();
                            }
                        },
                    },
                    {
                        key: "pause",
                        value: function () {
                            switch (this.element.getAttribute("data-media-type")) {
                                case "video":
                                    this.player.pause();
                                    break;
                                case "external_video":
                                    "youtube" === this.element.getAttribute("data-media-host") ? this.player.pauseVideo() : this.player.pause();
                            }
                        },
                    },
                    {
                        key: "_setupHtml5Video",
                        value: function () {
                            var e = this;
                            (this.player = new Shopify.Plyr(this.element.querySelector("video"), {
                                controls: ["play", "progress", "mute", "volume", "play-large", "fullscreen"],
                                loop: { active: this.enableVideoLooping },
                                hideControlsOnPause: !0,
                                clickToPlay: !0,
                                iconUrl: "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg",
                                tooltips: { controls: !1, seek: !0 },
                            })),
                                this.player.on("play", function () {
                                    e.element.dispatchEvent(new CustomEvent("video:played", { bubbles: !0 }));
                                }),
                                this.player.on("pause", function () {
                                    e.element.dispatchEvent(new CustomEvent("video:paused", { bubbles: !0 }));
                                });
                        },
                    },
                    {
                        key: "_setupExternalVideo",
                        value: function () {
                            "youtube" === this.element.getAttribute("data-media-host")
                                ? this._loadYouTubeScript().then(this._setupYouTubePlayer.bind(this))
                                : "vimeo" === this.element.getAttribute("data-media-host") && this._loadVimeoScript().then(this._setupVimeoPlayer.bind(this));
                        },
                    },
                    {
                        key: "_setupYouTubePlayer",
                        value: function () {
                            var e = this,
                                t = setInterval(function () {
                                    void 0 !== window.YT &&
                                        void 0 !== window.YT.Player &&
                                        ((e.player = new YT.Player(e.element.querySelector("iframe"), {
                                            videoId: e.element.getAttribute("data-video-id"),
                                            events: {
                                                onStateChange: function (t) {
                                                    0 === t.data && e.enableVideoLooping && t.target.seekTo(0);
                                                },
                                            },
                                        })),
                                        clearInterval(t));
                                }, 50);
                        },
                    },
                    {
                        key: "_loadYouTubeScript",
                        value: function () {
                            return new Promise(function (e, t) {
                                var i = document.createElement("script");
                                document.body.appendChild(i), (i.onload = e), (i.onerror = t), (i.async = !0), (i.src = "//www.youtube.com/iframe_api");
                            });
                        },
                    },
                    {
                        key: "_setupVimeoPlayer",
                        value: function () {
                            var e = this,
                                t = setInterval(function () {
                                    void 0 !== window.Vimeo && void 0 !== window.Vimeo.Player && ((e.player = new Vimeo.Player(e.element.querySelector("iframe"))), clearInterval(t));
                                }, 50);
                        },
                    },
                    {
                        key: "_loadVimeoScript",
                        value: function () {
                            return new Promise(function (e, t) {
                                var i = document.createElement("script");
                                document.body.appendChild(i), (i.onload = e), (i.onerror = t), (i.async = !0), (i.src = "//player.vimeo.com/api/player.js");
                            });
                        },
                    },
                ]),
                e
            );
        })(),
        X = y(function (e) {
            !(function (t, i) {
                e.exports ? (e.exports = i()) : (t.EvEmitter = i());
            })("undefined" != typeof window ? window : v, function () {
                function e() {}
                var t = e.prototype;
                return (
                    (t.on = function (e, t) {
                        if (e && t) {
                            var i = (this._events = this._events || {}),
                                n = (i[e] = i[e] || []);
                            return -1 == n.indexOf(t) && n.push(t), this;
                        }
                    }),
                    (t.once = function (e, t) {
                        if (e && t) {
                            this.on(e, t);
                            var i = (this._onceEvents = this._onceEvents || {});
                            return ((i[e] = i[e] || {})[t] = !0), this;
                        }
                    }),
                    (t.off = function (e, t) {
                        var i = this._events && this._events[e];
                        if (i && i.length) {
                            var n = i.indexOf(t);
                            return -1 != n && i.splice(n, 1), this;
                        }
                    }),
                    (t.emitEvent = function (e, t) {
                        var i = this._events && this._events[e];
                        if (i && i.length) {
                            (i = i.slice(0)), (t = t || []);
                            for (var n = this._onceEvents && this._onceEvents[e], o = 0; o < i.length; o++) {
                                var a = i[o];
                                n && n[a] && (this.off(e, a), delete n[a]), a.apply(this, t);
                            }
                            return this;
                        }
                    }),
                    (t.allOff = function () {
                        delete this._events, delete this._onceEvents;
                    }),
                    e
                );
            });
        }),
        G = y(function (t) {
            /*!
             * getSize v2.0.3
             * measure size of elements
             * MIT license
             */
            !(function (e, i) {
                t.exports ? (t.exports = i()) : (e.getSize = i());
            })(window, function () {
                function t(e) {
                    var t = parseFloat(e);
                    return -1 == e.indexOf("%") && !isNaN(t) && t;
                }
                var i =
                        "undefined" == typeof console
                            ? function () {}
                            : function (e) {
                                  console.error(e);
                              },
                    n = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
                    o = n.length;
                function a(e) {
                    var t = getComputedStyle(e);
                    return t || i("Style returned " + t + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), t;
                }
                var s,
                    r = !1;
                function l(i) {
                    if (
                        ((function () {
                            if (!r) {
                                r = !0;
                                var e = document.createElement("div");
                                (e.style.width = "200px"), (e.style.padding = "1px 2px 3px 4px"), (e.style.borderStyle = "solid"), (e.style.borderWidth = "1px 2px 3px 4px"), (e.style.boxSizing = "border-box");
                                var i = document.body || document.documentElement;
                                i.appendChild(e);
                                var n = a(e);
                                (s = 200 == Math.round(t(n.width))), (l.isBoxSizeOuter = s), i.removeChild(e);
                            }
                        })(),
                        "string" == typeof i && (i = document.querySelector(i)),
                        i && "object" == e(i) && i.nodeType)
                    ) {
                        var c = a(i);
                        if ("none" == c.display)
                            return (function () {
                                for (var e = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, t = 0; t < o; t++) e[n[t]] = 0;
                                return e;
                            })();
                        var d = {};
                        (d.width = i.offsetWidth), (d.height = i.offsetHeight);
                        for (var u = (d.isBorderBox = "border-box" == c.boxSizing), h = 0; h < o; h++) {
                            var p = n[h],
                                m = c[p],
                                f = parseFloat(m);
                            d[p] = isNaN(f) ? 0 : f;
                        }
                        var v = d.paddingLeft + d.paddingRight,
                            g = d.paddingTop + d.paddingBottom,
                            y = d.marginLeft + d.marginRight,
                            w = d.marginTop + d.marginBottom,
                            b = d.borderLeftWidth + d.borderRightWidth,
                            _ = d.borderTopWidth + d.borderBottomWidth,
                            E = u && s,
                            S = t(c.width);
                        !1 !== S && (d.width = S + (E ? 0 : v + b));
                        var k = t(c.height);
                        return !1 !== k && (d.height = k + (E ? 0 : g + _)), (d.innerWidth = d.width - (v + b)), (d.innerHeight = d.height - (g + _)), (d.outerWidth = d.width + y), (d.outerHeight = d.height + w), d;
                    }
                }
                return l;
            });
        }),
        Y = y(function (e) {
            !(function (t, i) {
                e.exports ? (e.exports = i()) : (t.matchesSelector = i());
            })(window, function () {
                var e = (function () {
                    var e = window.Element.prototype;
                    if (e.matches) return "matches";
                    if (e.matchesSelector) return "matchesSelector";
                    for (var t = ["webkit", "moz", "ms", "o"], i = 0; i < t.length; i++) {
                        var n = t[i] + "MatchesSelector";
                        if (e[n]) return n;
                    }
                })();
                return function (t, i) {
                    return t[e](i);
                };
            });
        }),
        Z = y(function (t) {
            !(function (e, i) {
                t.exports ? (t.exports = i(e, Y)) : (e.fizzyUIUtils = i(e, e.matchesSelector));
            })(window, function (t, i) {
                var n = {
                        extend: function (e, t) {
                            for (var i in t) e[i] = t[i];
                            return e;
                        },
                        modulo: function (e, t) {
                            return ((e % t) + t) % t;
                        },
                    },
                    o = Array.prototype.slice;
                (n.makeArray = function (t) {
                    return Array.isArray(t) ? t : null == t ? [] : "object" == e(t) && "number" == typeof t.length ? o.call(t) : [t];
                }),
                    (n.removeFrom = function (e, t) {
                        var i = e.indexOf(t);
                        -1 != i && e.splice(i, 1);
                    }),
                    (n.getParent = function (e, t) {
                        for (; e.parentNode && e != document.body; ) if (((e = e.parentNode), i(e, t))) return e;
                    }),
                    (n.getQueryElement = function (e) {
                        return "string" == typeof e ? document.querySelector(e) : e;
                    }),
                    (n.handleEvent = function (e) {
                        var t = "on" + e.type;
                        this[t] && this[t](e);
                    }),
                    (n.filterFindElements = function (e, t) {
                        e = n.makeArray(e);
                        var o = [];
                        return (
                            e.forEach(function (e) {
                                if (e instanceof HTMLElement)
                                    if (t) {
                                        i(e, t) && o.push(e);
                                        for (var n = e.querySelectorAll(t), a = 0; a < n.length; a++) o.push(n[a]);
                                    } else o.push(e);
                            }),
                            o
                        );
                    }),
                    (n.debounceMethod = function (e, t, i) {
                        i = i || 100;
                        var n = e.prototype[t],
                            o = t + "Timeout";
                        e.prototype[t] = function () {
                            var e = this[o];
                            clearTimeout(e);
                            var t = arguments,
                                a = this;
                            this[o] = setTimeout(function () {
                                n.apply(a, t), delete a[o];
                            }, i);
                        };
                    }),
                    (n.docReady = function (e) {
                        var t = document.readyState;
                        "complete" == t || "interactive" == t ? setTimeout(e) : document.addEventListener("DOMContentLoaded", e);
                    }),
                    (n.toDashed = function (e) {
                        return e
                            .replace(/(.)([A-Z])/g, function (e, t, i) {
                                return t + "-" + i;
                            })
                            .toLowerCase();
                    });
                var a = t.console;
                return (
                    (n.htmlInit = function (e, i) {
                        n.docReady(function () {
                            var o = n.toDashed(i),
                                s = "data-" + o,
                                r = document.querySelectorAll("[" + s + "]"),
                                l = document.querySelectorAll(".js-" + o),
                                c = n.makeArray(r).concat(n.makeArray(l)),
                                d = s + "-options",
                                u = t.jQuery;
                            c.forEach(function (t) {
                                var n,
                                    o = t.getAttribute(s) || t.getAttribute(d);
                                try {
                                    n = o && JSON.parse(o);
                                } catch (e) {
                                    return void (a && a.error("Error parsing " + s + " on " + t.className + ": " + e));
                                }
                                var r = new e(t, n);
                                u && u.data(t, i, r);
                            });
                        });
                    }),
                    n
                );
            });
        }),
        Q = y(function (e) {
            !(function (t, i) {
                e.exports ? (e.exports = i(t, G)) : ((t.Flickity = t.Flickity || {}), (t.Flickity.Cell = i(t, t.getSize)));
            })(window, function (e, t) {
                function i(e, t) {
                    (this.element = e), (this.parent = t), this.create();
                }
                var n = i.prototype;
                return (
                    (n.create = function () {
                        (this.element.style.position = "absolute"), this.element.setAttribute("aria-hidden", "true"), (this.x = 0), (this.shift = 0);
                    }),
                    (n.destroy = function () {
                        this.unselect(), (this.element.style.position = "");
                        var e = this.parent.originSide;
                        this.element.style[e] = "";
                    }),
                    (n.getSize = function () {
                        this.size = t(this.element);
                    }),
                    (n.setPosition = function (e) {
                        (this.x = e), this.updateTarget(), this.renderPosition(e);
                    }),
                    (n.updateTarget = n.setDefaultTarget = function () {
                        var e = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
                        this.target = this.x + this.size[e] + this.size.width * this.parent.cellAlign;
                    }),
                    (n.renderPosition = function (e) {
                        var t = this.parent.originSide;
                        this.element.style[t] = this.parent.getPositionValue(e);
                    }),
                    (n.select = function () {
                        this.element.classList.add("is-selected"), this.element.removeAttribute("aria-hidden");
                    }),
                    (n.unselect = function () {
                        this.element.classList.remove("is-selected"), this.element.setAttribute("aria-hidden", "true");
                    }),
                    (n.wrapShift = function (e) {
                        (this.shift = e), this.renderPosition(this.x + this.parent.slideableWidth * e);
                    }),
                    (n.remove = function () {
                        this.element.parentNode.removeChild(this.element);
                    }),
                    i
                );
            });
        }),
        J = y(function (e) {
            !(function (t, i) {
                e.exports ? (e.exports = i()) : ((t.Flickity = t.Flickity || {}), (t.Flickity.Slide = i()));
            })(window, function () {
                function e(e) {
                    (this.parent = e), (this.isOriginLeft = "left" == e.originSide), (this.cells = []), (this.outerWidth = 0), (this.height = 0);
                }
                var t = e.prototype;
                return (
                    (t.addCell = function (e) {
                        if ((this.cells.push(e), (this.outerWidth += e.size.outerWidth), (this.height = Math.max(e.size.outerHeight, this.height)), 1 == this.cells.length)) {
                            this.x = e.x;
                            var t = this.isOriginLeft ? "marginLeft" : "marginRight";
                            this.firstMargin = e.size[t];
                        }
                    }),
                    (t.updateTarget = function () {
                        var e = this.isOriginLeft ? "marginRight" : "marginLeft",
                            t = this.getLastCell(),
                            i = t ? t.size[e] : 0,
                            n = this.outerWidth - (this.firstMargin + i);
                        this.target = this.x + this.firstMargin + n * this.parent.cellAlign;
                    }),
                    (t.getLastCell = function () {
                        return this.cells[this.cells.length - 1];
                    }),
                    (t.select = function () {
                        this.cells.forEach(function (e) {
                            e.select();
                        });
                    }),
                    (t.unselect = function () {
                        this.cells.forEach(function (e) {
                            e.unselect();
                        });
                    }),
                    (t.getCellElements = function () {
                        return this.cells.map(function (e) {
                            return e.element;
                        });
                    }),
                    e
                );
            });
        }),
        K = y(function (e) {
            !(function (t, i) {
                e.exports ? (e.exports = i(t, Z)) : ((t.Flickity = t.Flickity || {}), (t.Flickity.animatePrototype = i(t, t.fizzyUIUtils)));
            })(window, function (e, t) {
                var i = {
                    startAnimation: function () {
                        this.isAnimating || ((this.isAnimating = !0), (this.restingFrames = 0), this.animate());
                    },
                    animate: function () {
                        this.applyDragForce(), this.applySelectedAttraction();
                        var e = this.x;
                        if ((this.integratePhysics(), this.positionSlider(), this.settle(e), this.isAnimating)) {
                            var t = this;
                            requestAnimationFrame(function () {
                                t.animate();
                            });
                        }
                    },
                    positionSlider: function () {
                        var e = this.x;
                        this.options.wrapAround && this.cells.length > 1 && ((e = t.modulo(e, this.slideableWidth)), (e -= this.slideableWidth), this.shiftWrapCells(e)), this.setTranslateX(e, this.isAnimating), this.dispatchScrollEvent();
                    },
                    setTranslateX: function (e, t) {
                        (e += this.cursorPosition), (e = this.options.rightToLeft ? -e : e);
                        var i = this.getPositionValue(e);
                        this.slider.style.transform = t ? "translate3d(" + i + ",0,0)" : "translateX(" + i + ")";
                    },
                    dispatchScrollEvent: function () {
                        var e = this.slides[0];
                        if (e) {
                            var t = -this.x - e.target,
                                i = t / this.slidesWidth;
                            this.dispatchEvent("scroll", null, [i, t]);
                        }
                    },
                    positionSliderAtSelected: function () {
                        this.cells.length && ((this.x = -this.selectedSlide.target), (this.velocity = 0), this.positionSlider());
                    },
                    getPositionValue: function (e) {
                        return this.options.percentPosition ? 0.01 * Math.round((e / this.size.innerWidth) * 1e4) + "%" : Math.round(e) + "px";
                    },
                    settle: function (e) {
                        this.isPointerDown || Math.round(100 * this.x) != Math.round(100 * e) || this.restingFrames++,
                            this.restingFrames > 2 && ((this.isAnimating = !1), delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent("settle", null, [this.selectedIndex]));
                    },
                    shiftWrapCells: function (e) {
                        var t = this.cursorPosition + e;
                        this._shiftCells(this.beforeShiftCells, t, -1);
                        var i = this.size.innerWidth - (e + this.slideableWidth + this.cursorPosition);
                        this._shiftCells(this.afterShiftCells, i, 1);
                    },
                    _shiftCells: function (e, t, i) {
                        for (var n = 0; n < e.length; n++) {
                            var o = e[n],
                                a = t > 0 ? i : 0;
                            o.wrapShift(a), (t -= o.size.outerWidth);
                        }
                    },
                    _unshiftCells: function (e) {
                        if (e && e.length) for (var t = 0; t < e.length; t++) e[t].wrapShift(0);
                    },
                    integratePhysics: function () {
                        (this.x += this.velocity), (this.velocity *= this.getFrictionFactor());
                    },
                    applyForce: function (e) {
                        this.velocity += e;
                    },
                    getFrictionFactor: function () {
                        return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
                    },
                    getRestingPosition: function () {
                        return this.x + this.velocity / (1 - this.getFrictionFactor());
                    },
                    applyDragForce: function () {
                        if (this.isDraggable && this.isPointerDown) {
                            var e = this.dragX - this.x - this.velocity;
                            this.applyForce(e);
                        }
                    },
                    applySelectedAttraction: function () {
                        if (!(this.isDraggable && this.isPointerDown) && !this.isFreeScrolling && this.slides.length) {
                            var e = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction;
                            this.applyForce(e);
                        }
                    },
                };
                return i;
            });
        }),
        ee = y(function (e) {
            !(function (t, i) {
                if (e.exports) e.exports = i(t, X, G, Z, Q, J, K);
                else {
                    var n = t.Flickity;
                    t.Flickity = i(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, n.Cell, n.Slide, n.animatePrototype);
                }
            })(window, function (e, t, i, n, o, a, s) {
                var r = e.jQuery,
                    l = e.getComputedStyle,
                    c = e.console;
                function d(e, t) {
                    for (e = n.makeArray(e); e.length; ) t.appendChild(e.shift());
                }
                var u = 0,
                    h = {};
                function p(e, t) {
                    var i = n.getQueryElement(e);
                    if (i) {
                        if (((this.element = i), this.element.flickityGUID)) {
                            var o = h[this.element.flickityGUID];
                            return o.option(t), o;
                        }
                        r && (this.$element = r(this.element)), (this.options = n.extend({}, this.constructor.defaults)), this.option(t), this._create();
                    } else c && c.error("Bad element for Flickity: " + (i || e));
                }
                (p.defaults = { accessibility: !0, cellAlign: "center", freeScrollFriction: 0.075, friction: 0.28, namespaceJQueryEvents: !0, percentPosition: !0, resize: !0, selectedAttraction: 0.025, setGallerySize: !0 }),
                    (p.createMethods = []);
                var m = p.prototype;
                n.extend(m, t.prototype),
                    (m._create = function () {
                        var t = (this.guid = ++u);
                        for (var i in ((this.element.flickityGUID = t),
                        (h[t] = this),
                        (this.selectedIndex = 0),
                        (this.restingFrames = 0),
                        (this.x = 0),
                        (this.velocity = 0),
                        (this.originSide = this.options.rightToLeft ? "right" : "left"),
                        (this.viewport = document.createElement("div")),
                        (this.viewport.className = "flickity-viewport"),
                        this._createSlider(),
                        (this.options.resize || this.options.watchCSS) && e.addEventListener("resize", this),
                        this.options.on)) {
                            var n = this.options.on[i];
                            this.on(i, n);
                        }
                        p.createMethods.forEach(function (e) {
                            this[e]();
                        }, this),
                            this.options.watchCSS ? this.watchCSS() : this.activate();
                    }),
                    (m.option = function (e) {
                        n.extend(this.options, e);
                    }),
                    (m.activate = function () {
                        this.isActive ||
                            ((this.isActive = !0),
                            this.element.classList.add("flickity-enabled"),
                            this.options.rightToLeft && this.element.classList.add("flickity-rtl"),
                            this.getSize(),
                            d(this._filterFindCellElements(this.element.children), this.slider),
                            this.viewport.appendChild(this.slider),
                            this.element.appendChild(this.viewport),
                            this.reloadCells(),
                            this.options.accessibility && ((this.element.tabIndex = 0), this.element.addEventListener("keydown", this)),
                            this.emitEvent("activate"),
                            this.selectInitialIndex(),
                            (this.isInitActivated = !0),
                            this.dispatchEvent("ready"));
                    }),
                    (m._createSlider = function () {
                        var e = document.createElement("div");
                        (e.className = "flickity-slider"), (e.style[this.originSide] = 0), (this.slider = e);
                    }),
                    (m._filterFindCellElements = function (e) {
                        return n.filterFindElements(e, this.options.cellSelector);
                    }),
                    (m.reloadCells = function () {
                        (this.cells = this._makeCells(this.slider.children)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize();
                    }),
                    (m._makeCells = function (e) {
                        return this._filterFindCellElements(e).map(function (e) {
                            return new o(e, this);
                        }, this);
                    }),
                    (m.getLastCell = function () {
                        return this.cells[this.cells.length - 1];
                    }),
                    (m.getLastSlide = function () {
                        return this.slides[this.slides.length - 1];
                    }),
                    (m.positionCells = function () {
                        this._sizeCells(this.cells), this._positionCells(0);
                    }),
                    (m._positionCells = function (e) {
                        (e = e || 0), (this.maxCellHeight = (e && this.maxCellHeight) || 0);
                        var t = 0;
                        if (e > 0) {
                            var i = this.cells[e - 1];
                            t = i.x + i.size.outerWidth;
                        }
                        for (var n = this.cells.length, o = e; o < n; o++) {
                            var a = this.cells[o];
                            a.setPosition(t), (t += a.size.outerWidth), (this.maxCellHeight = Math.max(a.size.outerHeight, this.maxCellHeight));
                        }
                        (this.slideableWidth = t), this.updateSlides(), this._containSlides(), (this.slidesWidth = n ? this.getLastSlide().target - this.slides[0].target : 0);
                    }),
                    (m._sizeCells = function (e) {
                        e.forEach(function (e) {
                            e.getSize();
                        });
                    }),
                    (m.updateSlides = function () {
                        if (((this.slides = []), this.cells.length)) {
                            var e = new a(this);
                            this.slides.push(e);
                            var t = "left" == this.originSide ? "marginRight" : "marginLeft",
                                i = this._getCanCellFit();
                            this.cells.forEach(function (n, o) {
                                if (e.cells.length) {
                                    var s = e.outerWidth - e.firstMargin + (n.size.outerWidth - n.size[t]);
                                    i.call(this, o, s) || (e.updateTarget(), (e = new a(this)), this.slides.push(e)), e.addCell(n);
                                } else e.addCell(n);
                            }, this),
                                e.updateTarget(),
                                this.updateSelectedSlide();
                        }
                    }),
                    (m._getCanCellFit = function () {
                        var e = this.options.groupCells;
                        if (!e)
                            return function () {
                                return !1;
                            };
                        if ("number" == typeof e) {
                            var t = parseInt(e, 10);
                            return function (e) {
                                return e % t != 0;
                            };
                        }
                        var i = "string" == typeof e && e.match(/^(\d+)%$/),
                            n = i ? parseInt(i[1], 10) / 100 : 1;
                        return function (e, t) {
                            return t <= (this.size.innerWidth + 1) * n;
                        };
                    }),
                    (m._init = m.reposition = function () {
                        this.positionCells(), this.positionSliderAtSelected();
                    }),
                    (m.getSize = function () {
                        (this.size = i(this.element)), this.setCellAlign(), (this.cursorPosition = this.size.innerWidth * this.cellAlign);
                    });
                var f = { center: { left: 0.5, right: 0.5 }, left: { left: 0, right: 1 }, right: { right: 0, left: 1 } };
                return (
                    (m.setCellAlign = function () {
                        var e = f[this.options.cellAlign];
                        this.cellAlign = e ? e[this.originSide] : this.options.cellAlign;
                    }),
                    (m.setGallerySize = function () {
                        if (this.options.setGallerySize) {
                            var e = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
                            this.viewport.style.height = e + "px";
                        }
                    }),
                    (m._getWrapShiftCells = function () {
                        if (this.options.wrapAround) {
                            this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
                            var e = this.cursorPosition,
                                t = this.cells.length - 1;
                            (this.beforeShiftCells = this._getGapCells(e, t, -1)), (e = this.size.innerWidth - this.cursorPosition), (this.afterShiftCells = this._getGapCells(e, 0, 1));
                        }
                    }),
                    (m._getGapCells = function (e, t, i) {
                        for (var n = []; e > 0; ) {
                            var o = this.cells[t];
                            if (!o) break;
                            n.push(o), (t += i), (e -= o.size.outerWidth);
                        }
                        return n;
                    }),
                    (m._containSlides = function () {
                        if (this.options.contain && !this.options.wrapAround && this.cells.length) {
                            var e = this.options.rightToLeft,
                                t = e ? "marginRight" : "marginLeft",
                                i = e ? "marginLeft" : "marginRight",
                                n = this.slideableWidth - this.getLastCell().size[i],
                                o = n < this.size.innerWidth,
                                a = this.cursorPosition + this.cells[0].size[t],
                                s = n - this.size.innerWidth * (1 - this.cellAlign);
                            this.slides.forEach(function (e) {
                                o ? (e.target = n * this.cellAlign) : ((e.target = Math.max(e.target, a)), (e.target = Math.min(e.target, s)));
                            }, this);
                        }
                    }),
                    (m.dispatchEvent = function (e, t, i) {
                        var n = t ? [t].concat(i) : i;
                        if ((this.emitEvent(e, n), r && this.$element)) {
                            var o = (e += this.options.namespaceJQueryEvents ? ".flickity" : "");
                            if (t) {
                                var a = r.Event(t);
                                (a.type = e), (o = a);
                            }
                            this.$element.trigger(o, i);
                        }
                    }),
                    (m.select = function (e, t, i) {
                        if (this.isActive && ((e = parseInt(e, 10)), this._wrapSelect(e), (this.options.wrapAround || t) && (e = n.modulo(e, this.slides.length)), this.slides[e])) {
                            var o = this.selectedIndex;
                            (this.selectedIndex = e),
                                this.updateSelectedSlide(),
                                i ? this.positionSliderAtSelected() : this.startAnimation(),
                                this.options.adaptiveHeight && this.setGallerySize(),
                                this.dispatchEvent("select", null, [e]),
                                e != o && this.dispatchEvent("change", null, [e]),
                                this.dispatchEvent("cellSelect");
                        }
                    }),
                    (m._wrapSelect = function (e) {
                        var t = this.slides.length;
                        if (!(this.options.wrapAround && t > 1)) return e;
                        var i = n.modulo(e, t),
                            o = Math.abs(i - this.selectedIndex),
                            a = Math.abs(i + t - this.selectedIndex),
                            s = Math.abs(i - t - this.selectedIndex);
                        !this.isDragSelect && a < o ? (e += t) : !this.isDragSelect && s < o && (e -= t), e < 0 ? (this.x -= this.slideableWidth) : e >= t && (this.x += this.slideableWidth);
                    }),
                    (m.previous = function (e, t) {
                        this.select(this.selectedIndex - 1, e, t);
                    }),
                    (m.next = function (e, t) {
                        this.select(this.selectedIndex + 1, e, t);
                    }),
                    (m.updateSelectedSlide = function () {
                        var e = this.slides[this.selectedIndex];
                        e &&
                            (this.unselectSelectedSlide(),
                            (this.selectedSlide = e),
                            e.select(),
                            (this.selectedCells = e.cells),
                            (this.selectedElements = e.getCellElements()),
                            (this.selectedCell = e.cells[0]),
                            (this.selectedElement = this.selectedElements[0]));
                    }),
                    (m.unselectSelectedSlide = function () {
                        this.selectedSlide && this.selectedSlide.unselect();
                    }),
                    (m.selectInitialIndex = function () {
                        var e = this.options.initialIndex;
                        if (this.isInitActivated) this.select(this.selectedIndex, !1, !0);
                        else {
                            if (e && "string" == typeof e) if (this.queryCell(e)) return void this.selectCell(e, !1, !0);
                            var t = 0;
                            e && this.slides[e] && (t = e), this.select(t, !1, !0);
                        }
                    }),
                    (m.selectCell = function (e, t, i) {
                        var n = this.queryCell(e);
                        if (n) {
                            var o = this.getCellSlideIndex(n);
                            this.select(o, t, i);
                        }
                    }),
                    (m.getCellSlideIndex = function (e) {
                        for (var t = 0; t < this.slides.length; t++) {
                            if (-1 != this.slides[t].cells.indexOf(e)) return t;
                        }
                    }),
                    (m.getCell = function (e) {
                        for (var t = 0; t < this.cells.length; t++) {
                            var i = this.cells[t];
                            if (i.element == e) return i;
                        }
                    }),
                    (m.getCells = function (e) {
                        e = n.makeArray(e);
                        var t = [];
                        return (
                            e.forEach(function (e) {
                                var i = this.getCell(e);
                                i && t.push(i);
                            }, this),
                            t
                        );
                    }),
                    (m.getCellElements = function () {
                        return this.cells.map(function (e) {
                            return e.element;
                        });
                    }),
                    (m.getParentCell = function (e) {
                        var t = this.getCell(e);
                        return t || ((e = n.getParent(e, ".flickity-slider > *")), this.getCell(e));
                    }),
                    (m.getAdjacentCellElements = function (e, t) {
                        if (!e) return this.selectedSlide.getCellElements();
                        t = void 0 === t ? this.selectedIndex : t;
                        var i = this.slides.length;
                        if (1 + 2 * e >= i) return this.getCellElements();
                        for (var o = [], a = t - e; a <= t + e; a++) {
                            var s = this.options.wrapAround ? n.modulo(a, i) : a,
                                r = this.slides[s];
                            r && (o = o.concat(r.getCellElements()));
                        }
                        return o;
                    }),
                    (m.queryCell = function (e) {
                        if ("number" == typeof e) return this.cells[e];
                        if ("string" == typeof e) {
                            if (e.match(/^[#\.]?[\d\/]/)) return;
                            e = this.element.querySelector(e);
                        }
                        return this.getCell(e);
                    }),
                    (m.uiChange = function () {
                        this.emitEvent("uiChange");
                    }),
                    (m.childUIPointerDown = function (e) {
                        "touchstart" != e.type && e.preventDefault(), this.focus();
                    }),
                    (m.onresize = function () {
                        this.watchCSS(), this.resize();
                    }),
                    n.debounceMethod(p, "onresize", 150),
                    (m.resize = function () {
                        if (this.isActive) {
                            this.getSize(), this.options.wrapAround && (this.x = n.modulo(this.x, this.slideableWidth)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent("resize");
                            var e = this.selectedElements && this.selectedElements[0];
                            this.selectCell(e, !1, !0);
                        }
                    }),
                    (m.watchCSS = function () {
                        this.options.watchCSS && (-1 != l(this.element, ":after").content.indexOf("flickity") ? this.activate() : this.deactivate());
                    }),
                    (m.onkeydown = function (e) {
                        var t = document.activeElement && document.activeElement != this.element;
                        if (this.options.accessibility && !t) {
                            var i = p.keyboardHandlers[e.keyCode];
                            i && i.call(this);
                        }
                    }),
                    (p.keyboardHandlers = {
                        37: function () {
                            var e = this.options.rightToLeft ? "next" : "previous";
                            this.uiChange(), this[e]();
                        },
                        39: function () {
                            var e = this.options.rightToLeft ? "previous" : "next";
                            this.uiChange(), this[e]();
                        },
                    }),
                    (m.focus = function () {
                        var t = e.pageYOffset;
                        this.element.focus({ preventScroll: !0 }), e.pageYOffset != t && e.scrollTo(e.pageXOffset, t);
                    }),
                    (m.deactivate = function () {
                        this.isActive &&
                            (this.element.classList.remove("flickity-enabled"),
                            this.element.classList.remove("flickity-rtl"),
                            this.unselectSelectedSlide(),
                            this.cells.forEach(function (e) {
                                e.destroy();
                            }),
                            this.element.removeChild(this.viewport),
                            d(this.slider.children, this.element),
                            this.options.accessibility && (this.element.removeAttribute("tabIndex"), this.element.removeEventListener("keydown", this)),
                            (this.isActive = !1),
                            this.emitEvent("deactivate"));
                    }),
                    (m.destroy = function () {
                        this.deactivate(), e.removeEventListener("resize", this), this.allOff(), this.emitEvent("destroy"), r && this.$element && r.removeData(this.element, "flickity"), delete this.element.flickityGUID, delete h[this.guid];
                    }),
                    n.extend(m, s),
                    (p.data = function (e) {
                        var t = (e = n.getQueryElement(e)) && e.flickityGUID;
                        return t && h[t];
                    }),
                    n.htmlInit(p, "flickity"),
                    r && r.bridget && r.bridget("flickity", p),
                    (p.setJQuery = function (e) {
                        r = e;
                    }),
                    (p.Cell = o),
                    (p.Slide = a),
                    p
                );
            });
        }),
        te = y(function (e) {
            /*!
             * Unipointer v2.3.0
             * base class for doing one thing with pointer event
             * MIT license
             */
            !(function (t, i) {
                e.exports ? (e.exports = i(t, X)) : (t.Unipointer = i(t, t.EvEmitter));
            })(window, function (e, t) {
                function i() {}
                var n = (i.prototype = Object.create(t.prototype));
                (n.bindStartEvent = function (e) {
                    this._bindStartEvent(e, !0);
                }),
                    (n.unbindStartEvent = function (e) {
                        this._bindStartEvent(e, !1);
                    }),
                    (n._bindStartEvent = function (t, i) {
                        var n = (i = void 0 === i || i) ? "addEventListener" : "removeEventListener",
                            o = "mousedown";
                        e.PointerEvent ? (o = "pointerdown") : "ontouchstart" in e && (o = "touchstart"), t[n](o, this);
                    }),
                    (n.handleEvent = function (e) {
                        var t = "on" + e.type;
                        this[t] && this[t](e);
                    }),
                    (n.getTouch = function (e) {
                        for (var t = 0; t < e.length; t++) {
                            var i = e[t];
                            if (i.identifier == this.pointerIdentifier) return i;
                        }
                    }),
                    (n.onmousedown = function (e) {
                        var t = e.button;
                        (t && 0 !== t && 1 !== t) || this._pointerDown(e, e);
                    }),
                    (n.ontouchstart = function (e) {
                        this._pointerDown(e, e.changedTouches[0]);
                    }),
                    (n.onpointerdown = function (e) {
                        this._pointerDown(e, e);
                    }),
                    (n._pointerDown = function (e, t) {
                        e.button || this.isPointerDown || ((this.isPointerDown = !0), (this.pointerIdentifier = void 0 !== t.pointerId ? t.pointerId : t.identifier), this.pointerDown(e, t));
                    }),
                    (n.pointerDown = function (e, t) {
                        this._bindPostStartEvents(e), this.emitEvent("pointerDown", [e, t]);
                    });
                var o = { mousedown: ["mousemove", "mouseup"], touchstart: ["touchmove", "touchend", "touchcancel"], pointerdown: ["pointermove", "pointerup", "pointercancel"] };
                return (
                    (n._bindPostStartEvents = function (t) {
                        if (t) {
                            var i = o[t.type];
                            i.forEach(function (t) {
                                e.addEventListener(t, this);
                            }, this),
                                (this._boundPointerEvents = i);
                        }
                    }),
                    (n._unbindPostStartEvents = function () {
                        this._boundPointerEvents &&
                            (this._boundPointerEvents.forEach(function (t) {
                                e.removeEventListener(t, this);
                            }, this),
                            delete this._boundPointerEvents);
                    }),
                    (n.onmousemove = function (e) {
                        this._pointerMove(e, e);
                    }),
                    (n.onpointermove = function (e) {
                        e.pointerId == this.pointerIdentifier && this._pointerMove(e, e);
                    }),
                    (n.ontouchmove = function (e) {
                        var t = this.getTouch(e.changedTouches);
                        t && this._pointerMove(e, t);
                    }),
                    (n._pointerMove = function (e, t) {
                        this.pointerMove(e, t);
                    }),
                    (n.pointerMove = function (e, t) {
                        this.emitEvent("pointerMove", [e, t]);
                    }),
                    (n.onmouseup = function (e) {
                        this._pointerUp(e, e);
                    }),
                    (n.onpointerup = function (e) {
                        e.pointerId == this.pointerIdentifier && this._pointerUp(e, e);
                    }),
                    (n.ontouchend = function (e) {
                        var t = this.getTouch(e.changedTouches);
                        t && this._pointerUp(e, t);
                    }),
                    (n._pointerUp = function (e, t) {
                        this._pointerDone(), this.pointerUp(e, t);
                    }),
                    (n.pointerUp = function (e, t) {
                        this.emitEvent("pointerUp", [e, t]);
                    }),
                    (n._pointerDone = function () {
                        this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone();
                    }),
                    (n._pointerReset = function () {
                        (this.isPointerDown = !1), delete this.pointerIdentifier;
                    }),
                    (n.pointerDone = function () {}),
                    (n.onpointercancel = function (e) {
                        e.pointerId == this.pointerIdentifier && this._pointerCancel(e, e);
                    }),
                    (n.ontouchcancel = function (e) {
                        var t = this.getTouch(e.changedTouches);
                        t && this._pointerCancel(e, t);
                    }),
                    (n._pointerCancel = function (e, t) {
                        this._pointerDone(), this.pointerCancel(e, t);
                    }),
                    (n.pointerCancel = function (e, t) {
                        this.emitEvent("pointerCancel", [e, t]);
                    }),
                    (i.getPointerPoint = function (e) {
                        return { x: e.pageX, y: e.pageY };
                    }),
                    i
                );
            });
        }),
        ie = y(function (e) {
            /*!
             * Unidragger v2.3.1
             * Draggable base class
             * MIT license
             */
            !(function (t, i) {
                e.exports ? (e.exports = i(t, te)) : (t.Unidragger = i(t, t.Unipointer));
            })(window, function (e, t) {
                function i() {}
                var n = (i.prototype = Object.create(t.prototype));
                (n.bindHandles = function () {
                    this._bindHandles(!0);
                }),
                    (n.unbindHandles = function () {
                        this._bindHandles(!1);
                    }),
                    (n._bindHandles = function (t) {
                        for (var i = (t = void 0 === t || t) ? "addEventListener" : "removeEventListener", n = t ? this._touchActionValue : "", o = 0; o < this.handles.length; o++) {
                            var a = this.handles[o];
                            this._bindStartEvent(a, t), a[i]("click", this), e.PointerEvent && (a.style.touchAction = n);
                        }
                    }),
                    (n._touchActionValue = "none"),
                    (n.pointerDown = function (e, t) {
                        this.okayPointerDown(e) && ((this.pointerDownPointer = { pageX: t.pageX, pageY: t.pageY }), e.preventDefault(), this.pointerDownBlur(), this._bindPostStartEvents(e), this.emitEvent("pointerDown", [e, t]));
                    });
                var o = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
                    a = { radio: !0, checkbox: !0, button: !0, submit: !0, image: !0, file: !0 };
                return (
                    (n.okayPointerDown = function (e) {
                        var t = o[e.target.nodeName],
                            i = a[e.target.type],
                            n = !t || i;
                        return n || this._pointerReset(), n;
                    }),
                    (n.pointerDownBlur = function () {
                        var e = document.activeElement;
                        e && e.blur && e != document.body && e.blur();
                    }),
                    (n.pointerMove = function (e, t) {
                        var i = this._dragPointerMove(e, t);
                        this.emitEvent("pointerMove", [e, t, i]), this._dragMove(e, t, i);
                    }),
                    (n._dragPointerMove = function (e, t) {
                        var i = { x: t.pageX - this.pointerDownPointer.pageX, y: t.pageY - this.pointerDownPointer.pageY };
                        return !this.isDragging && this.hasDragStarted(i) && this._dragStart(e, t), i;
                    }),
                    (n.hasDragStarted = function (e) {
                        return Math.abs(e.x) > 3 || Math.abs(e.y) > 3;
                    }),
                    (n.pointerUp = function (e, t) {
                        this.emitEvent("pointerUp", [e, t]), this._dragPointerUp(e, t);
                    }),
                    (n._dragPointerUp = function (e, t) {
                        this.isDragging ? this._dragEnd(e, t) : this._staticClick(e, t);
                    }),
                    (n._dragStart = function (e, t) {
                        (this.isDragging = !0), (this.isPreventingClicks = !0), this.dragStart(e, t);
                    }),
                    (n.dragStart = function (e, t) {
                        this.emitEvent("dragStart", [e, t]);
                    }),
                    (n._dragMove = function (e, t, i) {
                        this.isDragging && this.dragMove(e, t, i);
                    }),
                    (n.dragMove = function (e, t, i) {
                        e.preventDefault(), this.emitEvent("dragMove", [e, t, i]);
                    }),
                    (n._dragEnd = function (e, t) {
                        (this.isDragging = !1),
                            setTimeout(
                                function () {
                                    delete this.isPreventingClicks;
                                }.bind(this)
                            ),
                            this.dragEnd(e, t);
                    }),
                    (n.dragEnd = function (e, t) {
                        this.emitEvent("dragEnd", [e, t]);
                    }),
                    (n.onclick = function (e) {
                        this.isPreventingClicks && e.preventDefault();
                    }),
                    (n._staticClick = function (e, t) {
                        (this.isIgnoringMouseUp && "mouseup" == e.type) ||
                            (this.staticClick(e, t),
                            "mouseup" != e.type &&
                                ((this.isIgnoringMouseUp = !0),
                                setTimeout(
                                    function () {
                                        delete this.isIgnoringMouseUp;
                                    }.bind(this),
                                    400
                                )));
                    }),
                    (n.staticClick = function (e, t) {
                        this.emitEvent("staticClick", [e, t]);
                    }),
                    (i.getPointerPoint = t.getPointerPoint),
                    i
                );
            });
        }),
        ne =
            (y(function (e) {
                !(function (t, i) {
                    e.exports ? (e.exports = i(t, ee, ie, Z)) : (t.Flickity = i(t, t.Flickity, t.Unidragger, t.fizzyUIUtils));
                })(window, function (e, t, i, n) {
                    n.extend(t.defaults, { draggable: ">1", dragThreshold: 3 }), t.createMethods.push("_createDrag");
                    var o = t.prototype;
                    n.extend(o, i.prototype), (o._touchActionValue = "pan-y");
                    var a = "createTouch" in document,
                        s = !1;
                    (o._createDrag = function () {
                        this.on("activate", this.onActivateDrag),
                            this.on("uiChange", this._uiChangeDrag),
                            this.on("deactivate", this.onDeactivateDrag),
                            this.on("cellChange", this.updateDraggable),
                            a && !s && (e.addEventListener("touchmove", function () {}), (s = !0));
                    }),
                        (o.onActivateDrag = function () {
                            (this.handles = [this.viewport]), this.bindHandles(), this.updateDraggable();
                        }),
                        (o.onDeactivateDrag = function () {
                            this.unbindHandles(), this.element.classList.remove("is-draggable");
                        }),
                        (o.updateDraggable = function () {
                            ">1" == this.options.draggable ? (this.isDraggable = this.slides.length > 1) : (this.isDraggable = this.options.draggable),
                                this.isDraggable ? this.element.classList.add("is-draggable") : this.element.classList.remove("is-draggable");
                        }),
                        (o.bindDrag = function () {
                            (this.options.draggable = !0), this.updateDraggable();
                        }),
                        (o.unbindDrag = function () {
                            (this.options.draggable = !1), this.updateDraggable();
                        }),
                        (o._uiChangeDrag = function () {
                            delete this.isFreeScrolling;
                        }),
                        (o.pointerDown = function (t, i) {
                            this.isDraggable
                                ? this.okayPointerDown(t) &&
                                  (this._pointerDownPreventDefault(t),
                                  this.pointerDownFocus(t),
                                  document.activeElement != this.element && this.pointerDownBlur(),
                                  (this.dragX = this.x),
                                  this.viewport.classList.add("is-pointer-down"),
                                  (this.pointerDownScroll = l()),
                                  e.addEventListener("scroll", this),
                                  this._pointerDownDefault(t, i))
                                : this._pointerDownDefault(t, i);
                        }),
                        (o._pointerDownDefault = function (e, t) {
                            (this.pointerDownPointer = { pageX: t.pageX, pageY: t.pageY }), this._bindPostStartEvents(e), this.dispatchEvent("pointerDown", e, [t]);
                        });
                    var r = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
                    function l() {
                        return { x: e.pageXOffset, y: e.pageYOffset };
                    }
                    return (
                        (o.pointerDownFocus = function (e) {
                            r[e.target.nodeName] || this.focus();
                        }),
                        (o._pointerDownPreventDefault = function (e) {
                            var t = "touchstart" == e.type,
                                i = "touch" == e.pointerType,
                                n = r[e.target.nodeName];
                            t || i || n || e.preventDefault();
                        }),
                        (o.hasDragStarted = function (e) {
                            return Math.abs(e.x) > this.options.dragThreshold;
                        }),
                        (o.pointerUp = function (e, t) {
                            delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down"), this.dispatchEvent("pointerUp", e, [t]), this._dragPointerUp(e, t);
                        }),
                        (o.pointerDone = function () {
                            e.removeEventListener("scroll", this), delete this.pointerDownScroll;
                        }),
                        (o.dragStart = function (t, i) {
                            this.isDraggable && ((this.dragStartPosition = this.x), this.startAnimation(), e.removeEventListener("scroll", this), this.dispatchEvent("dragStart", t, [i]));
                        }),
                        (o.pointerMove = function (e, t) {
                            var i = this._dragPointerMove(e, t);
                            this.dispatchEvent("pointerMove", e, [t, i]), this._dragMove(e, t, i);
                        }),
                        (o.dragMove = function (e, t, i) {
                            if (this.isDraggable) {
                                e.preventDefault(), (this.previousDragX = this.dragX);
                                var n = this.options.rightToLeft ? -1 : 1;
                                this.options.wrapAround && (i.x = i.x % this.slideableWidth);
                                var o = this.dragStartPosition + i.x * n;
                                if (!this.options.wrapAround && this.slides.length) {
                                    var a = Math.max(-this.slides[0].target, this.dragStartPosition);
                                    o = o > a ? 0.5 * (o + a) : o;
                                    var s = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                                    o = o < s ? 0.5 * (o + s) : o;
                                }
                                (this.dragX = o), (this.dragMoveTime = new Date()), this.dispatchEvent("dragMove", e, [t, i]);
                            }
                        }),
                        (o.dragEnd = function (e, t) {
                            if (this.isDraggable) {
                                this.options.freeScroll && (this.isFreeScrolling = !0);
                                var i = this.dragEndRestingSelect();
                                if (this.options.freeScroll && !this.options.wrapAround) {
                                    var n = this.getRestingPosition();
                                    this.isFreeScrolling = -n > this.slides[0].target && -n < this.getLastSlide().target;
                                } else this.options.freeScroll || i != this.selectedIndex || (i += this.dragEndBoostSelect());
                                delete this.previousDragX, (this.isDragSelect = this.options.wrapAround), this.select(i), delete this.isDragSelect, this.dispatchEvent("dragEnd", e, [t]);
                            }
                        }),
                        (o.dragEndRestingSelect = function () {
                            var e = this.getRestingPosition(),
                                t = Math.abs(this.getSlideDistance(-e, this.selectedIndex)),
                                i = this._getClosestResting(e, t, 1),
                                n = this._getClosestResting(e, t, -1);
                            return i.distance < n.distance ? i.index : n.index;
                        }),
                        (o._getClosestResting = function (e, t, i) {
                            for (
                                var n = this.selectedIndex,
                                    o = 1 / 0,
                                    a =
                                        this.options.contain && !this.options.wrapAround
                                            ? function (e, t) {
                                                  return e <= t;
                                              }
                                            : function (e, t) {
                                                  return e < t;
                                              };
                                a(t, o) && ((n += i), (o = t), null !== (t = this.getSlideDistance(-e, n)));

                            )
                                t = Math.abs(t);
                            return { distance: o, index: n - i };
                        }),
                        (o.getSlideDistance = function (e, t) {
                            var i = this.slides.length,
                                o = this.options.wrapAround && i > 1,
                                a = o ? n.modulo(t, i) : t,
                                s = this.slides[a];
                            if (!s) return null;
                            var r = o ? this.slideableWidth * Math.floor(t / i) : 0;
                            return e - (s.target + r);
                        }),
                        (o.dragEndBoostSelect = function () {
                            if (void 0 === this.previousDragX || !this.dragMoveTime || new Date() - this.dragMoveTime > 100) return 0;
                            var e = this.getSlideDistance(-this.dragX, this.selectedIndex),
                                t = this.previousDragX - this.dragX;
                            return e > 0 && t > 0 ? 1 : e < 0 && t < 0 ? -1 : 0;
                        }),
                        (o.staticClick = function (e, t) {
                            var i = this.getParentCell(e.target),
                                n = i && i.element,
                                o = i && this.cells.indexOf(i);
                            this.dispatchEvent("staticClick", e, [t, n, o]);
                        }),
                        (o.onscroll = function () {
                            var e = l(),
                                t = this.pointerDownScroll.x - e.x,
                                i = this.pointerDownScroll.y - e.y;
                            (Math.abs(t) > 3 || Math.abs(i) > 3) && this._pointerDone();
                        }),
                        t
                    );
                });
            }),
            y(function (e) {
                !(function (t, i) {
                    e.exports ? (e.exports = i(t, ee, te, Z)) : i(t, t.Flickity, t.Unipointer, t.fizzyUIUtils);
                })(window, function (e, t, i, n) {
                    var o = "http://www.w3.org/2000/svg";
                    function a(e, t) {
                        (this.direction = e), (this.parent = t), this._create();
                    }
                    (a.prototype = Object.create(i.prototype)),
                        (a.prototype._create = function () {
                            (this.isEnabled = !0), (this.isPrevious = -1 == this.direction);
                            var e = this.parent.options.rightToLeft ? 1 : -1;
                            this.isLeft = this.direction == e;
                            var t = (this.element = document.createElement("button"));
                            (t.className = "flickity-button flickity-prev-next-button"),
                                (t.className += this.isPrevious ? " previous" : " next"),
                                t.setAttribute("type", "button"),
                                this.disable(),
                                t.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
                            var i = this.createSVG();
                            t.appendChild(i), this.parent.on("select", this.update.bind(this)), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
                        }),
                        (a.prototype.activate = function () {
                            this.bindStartEvent(this.element), this.element.addEventListener("click", this), this.parent.element.appendChild(this.element);
                        }),
                        (a.prototype.deactivate = function () {
                            this.parent.element.removeChild(this.element), this.unbindStartEvent(this.element), this.element.removeEventListener("click", this);
                        }),
                        (a.prototype.createSVG = function () {
                            var e = document.createElementNS(o, "svg");
                            e.setAttribute("class", "flickity-button-icon"), e.setAttribute("viewBox", "0 0 100 100");
                            var t = document.createElementNS(o, "path"),
                                i = (function (e) {
                                    if ("string" == typeof e) return e;
                                    return "M " + e.x0 + ",50 L " + e.x1 + "," + (e.y1 + 50) + " L " + e.x2 + "," + (e.y2 + 50) + " L " + e.x3 + ",50  L " + e.x2 + "," + (50 - e.y2) + " L " + e.x1 + "," + (50 - e.y1) + " Z";
                                })(this.parent.options.arrowShape);
                            return t.setAttribute("d", i), t.setAttribute("class", "arrow"), this.isLeft || t.setAttribute("transform", "translate(100, 100) rotate(180) "), e.appendChild(t), e;
                        }),
                        (a.prototype.handleEvent = n.handleEvent),
                        (a.prototype.onclick = function () {
                            if (this.isEnabled) {
                                this.parent.uiChange();
                                var e = this.isPrevious ? "previous" : "next";
                                this.parent[e]();
                            }
                        }),
                        (a.prototype.enable = function () {
                            this.isEnabled || ((this.element.disabled = !1), (this.isEnabled = !0));
                        }),
                        (a.prototype.disable = function () {
                            this.isEnabled && ((this.element.disabled = !0), (this.isEnabled = !1));
                        }),
                        (a.prototype.update = function () {
                            var e = this.parent.slides;
                            if (this.parent.options.wrapAround && e.length > 1) this.enable();
                            else {
                                var t = e.length ? e.length - 1 : 0,
                                    i = this.isPrevious ? 0 : t;
                                this[this.parent.selectedIndex == i ? "disable" : "enable"]();
                            }
                        }),
                        (a.prototype.destroy = function () {
                            this.deactivate(), this.allOff();
                        }),
                        n.extend(t.defaults, { prevNextButtons: !0, arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 } }),
                        t.createMethods.push("_createPrevNextButtons");
                    var s = t.prototype;
                    return (
                        (s._createPrevNextButtons = function () {
                            this.options.prevNextButtons && ((this.prevButton = new a(-1, this)), (this.nextButton = new a(1, this)), this.on("activate", this.activatePrevNextButtons));
                        }),
                        (s.activatePrevNextButtons = function () {
                            this.prevButton.activate(), this.nextButton.activate(), this.on("deactivate", this.deactivatePrevNextButtons);
                        }),
                        (s.deactivatePrevNextButtons = function () {
                            this.prevButton.deactivate(), this.nextButton.deactivate(), this.off("deactivate", this.deactivatePrevNextButtons);
                        }),
                        (t.PrevNextButton = a),
                        t
                    );
                });
            }),
            y(function (e) {
                !(function (t, i) {
                    e.exports ? (e.exports = i(t, ee, te, Z)) : i(t, t.Flickity, t.Unipointer, t.fizzyUIUtils);
                })(window, function (e, t, i, n) {
                    function o(e) {
                        (this.parent = e), this._create();
                    }
                    (o.prototype = Object.create(i.prototype)),
                        (o.prototype._create = function () {
                            (this.holder = document.createElement("ol")),
                                (this.holder.className = "flickity-page-dots"),
                                (this.dots = []),
                                (this.handleClick = this.onClick.bind(this)),
                                this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
                        }),
                        (o.prototype.activate = function () {
                            this.setDots(), this.holder.addEventListener("click", this.handleClick), this.bindStartEvent(this.holder), this.parent.element.appendChild(this.holder);
                        }),
                        (o.prototype.deactivate = function () {
                            this.holder.removeEventListener("click", this.handleClick), this.unbindStartEvent(this.holder), this.parent.element.removeChild(this.holder);
                        }),
                        (o.prototype.setDots = function () {
                            var e = this.parent.slides.length - this.dots.length;
                            e > 0 ? this.addDots(e) : e < 0 && this.removeDots(-e);
                        }),
                        (o.prototype.addDots = function (e) {
                            for (var t = document.createDocumentFragment(), i = [], n = this.dots.length, o = n + e, a = n; a < o; a++) {
                                var s = document.createElement("li");
                                (s.className = "dot"), s.setAttribute("aria-label", "Page dot " + (a + 1)), t.appendChild(s), i.push(s);
                            }
                            this.holder.appendChild(t), (this.dots = this.dots.concat(i));
                        }),
                        (o.prototype.removeDots = function (e) {
                            this.dots.splice(this.dots.length - e, e).forEach(function (e) {
                                this.holder.removeChild(e);
                            }, this);
                        }),
                        (o.prototype.updateSelected = function () {
                            this.selectedDot && ((this.selectedDot.className = "dot"), this.selectedDot.removeAttribute("aria-current")),
                                this.dots.length && ((this.selectedDot = this.dots[this.parent.selectedIndex]), (this.selectedDot.className = "dot is-selected"), this.selectedDot.setAttribute("aria-current", "step"));
                        }),
                        (o.prototype.onTap = o.prototype.onClick = function (e) {
                            var t = e.target;
                            if ("LI" == t.nodeName) {
                                this.parent.uiChange();
                                var i = this.dots.indexOf(t);
                                this.parent.select(i);
                            }
                        }),
                        (o.prototype.destroy = function () {
                            this.deactivate(), this.allOff();
                        }),
                        (t.PageDots = o),
                        n.extend(t.defaults, { pageDots: !0 }),
                        t.createMethods.push("_createPageDots");
                    var a = t.prototype;
                    return (
                        (a._createPageDots = function () {
                            this.options.pageDots &&
                                ((this.pageDots = new o(this)),
                                this.on("activate", this.activatePageDots),
                                this.on("select", this.updateSelectedPageDots),
                                this.on("cellChange", this.updatePageDots),
                                this.on("resize", this.updatePageDots),
                                this.on("deactivate", this.deactivatePageDots));
                        }),
                        (a.activatePageDots = function () {
                            this.pageDots.activate();
                        }),
                        (a.updateSelectedPageDots = function () {
                            this.pageDots.updateSelected();
                        }),
                        (a.updatePageDots = function () {
                            this.pageDots.setDots();
                        }),
                        (a.deactivatePageDots = function () {
                            this.pageDots.deactivate();
                        }),
                        (t.PageDots = o),
                        t
                    );
                });
            }),
            y(function (e) {
                !(function (t, i) {
                    e.exports ? (e.exports = i(X, Z, ee)) : i(t.EvEmitter, t.fizzyUIUtils, t.Flickity);
                })(window, function (e, t, i) {
                    function n(e) {
                        (this.parent = e), (this.state = "stopped"), (this.onVisibilityChange = this.visibilityChange.bind(this)), (this.onVisibilityPlay = this.visibilityPlay.bind(this));
                    }
                    (n.prototype = Object.create(e.prototype)),
                        (n.prototype.play = function () {
                            "playing" != this.state &&
                                (document.hidden ? document.addEventListener("visibilitychange", this.onVisibilityPlay) : ((this.state = "playing"), document.addEventListener("visibilitychange", this.onVisibilityChange), this.tick()));
                        }),
                        (n.prototype.tick = function () {
                            if ("playing" == this.state) {
                                var e = this.parent.options.autoPlay;
                                e = "number" == typeof e ? e : 3e3;
                                var t = this;
                                this.clear(),
                                    (this.timeout = setTimeout(function () {
                                        t.parent.next(!0), t.tick();
                                    }, e));
                            }
                        }),
                        (n.prototype.stop = function () {
                            (this.state = "stopped"), this.clear(), document.removeEventListener("visibilitychange", this.onVisibilityChange);
                        }),
                        (n.prototype.clear = function () {
                            clearTimeout(this.timeout);
                        }),
                        (n.prototype.pause = function () {
                            "playing" == this.state && ((this.state = "paused"), this.clear());
                        }),
                        (n.prototype.unpause = function () {
                            "paused" == this.state && this.play();
                        }),
                        (n.prototype.visibilityChange = function () {
                            this[document.hidden ? "pause" : "unpause"]();
                        }),
                        (n.prototype.visibilityPlay = function () {
                            this.play(), document.removeEventListener("visibilitychange", this.onVisibilityPlay);
                        }),
                        t.extend(i.defaults, { pauseAutoPlayOnHover: !0 }),
                        i.createMethods.push("_createPlayer");
                    var o = i.prototype;
                    return (
                        (o._createPlayer = function () {
                            (this.player = new n(this)), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer);
                        }),
                        (o.activatePlayer = function () {
                            this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this));
                        }),
                        (o.playPlayer = function () {
                            this.player.play();
                        }),
                        (o.stopPlayer = function () {
                            this.player.stop();
                        }),
                        (o.pausePlayer = function () {
                            this.player.pause();
                        }),
                        (o.unpausePlayer = function () {
                            this.player.unpause();
                        }),
                        (o.deactivatePlayer = function () {
                            this.player.stop(), this.element.removeEventListener("mouseenter", this);
                        }),
                        (o.onmouseenter = function () {
                            this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener("mouseleave", this));
                        }),
                        (o.onmouseleave = function () {
                            this.player.unpause(), this.element.removeEventListener("mouseleave", this);
                        }),
                        (i.Player = n),
                        i
                    );
                });
            }),
            y(function (e) {
                !(function (t, i) {
                    e.exports ? (e.exports = i(t, ee, Z)) : i(t, t.Flickity, t.fizzyUIUtils);
                })(window, function (e, t, i) {
                    var n = t.prototype;
                    return (
                        (n.insert = function (e, t) {
                            var i = this._makeCells(e);
                            if (i && i.length) {
                                var n = this.cells.length;
                                t = void 0 === t ? n : t;
                                var o = (function (e) {
                                        var t = document.createDocumentFragment();
                                        return (
                                            e.forEach(function (e) {
                                                t.appendChild(e.element);
                                            }),
                                            t
                                        );
                                    })(i),
                                    a = t == n;
                                if (a) this.slider.appendChild(o);
                                else {
                                    var s = this.cells[t].element;
                                    this.slider.insertBefore(o, s);
                                }
                                if (0 === t) this.cells = i.concat(this.cells);
                                else if (a) this.cells = this.cells.concat(i);
                                else {
                                    var r = this.cells.splice(t, n - t);
                                    this.cells = this.cells.concat(i).concat(r);
                                }
                                this._sizeCells(i), this.cellChange(t, !0);
                            }
                        }),
                        (n.append = function (e) {
                            this.insert(e, this.cells.length);
                        }),
                        (n.prepend = function (e) {
                            this.insert(e, 0);
                        }),
                        (n.remove = function (e) {
                            var t = this.getCells(e);
                            if (t && t.length) {
                                var n = this.cells.length - 1;
                                t.forEach(function (e) {
                                    e.remove();
                                    var t = this.cells.indexOf(e);
                                    (n = Math.min(t, n)), i.removeFrom(this.cells, e);
                                }, this),
                                    this.cellChange(n, !0);
                            }
                        }),
                        (n.cellSizeChange = function (e) {
                            var t = this.getCell(e);
                            if (t) {
                                t.getSize();
                                var i = this.cells.indexOf(t);
                                this.cellChange(i);
                            }
                        }),
                        (n.cellChange = function (e, t) {
                            var i = this.selectedElement;
                            this._positionCells(e), this._getWrapShiftCells(), this.setGallerySize();
                            var n = this.getCell(i);
                            n && (this.selectedIndex = this.getCellSlideIndex(n)),
                                (this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex)),
                                this.emitEvent("cellChange", [e]),
                                this.select(this.selectedIndex),
                                t && this.positionSliderAtSelected();
                        }),
                        t
                    );
                });
            }),
            y(function (e) {
                !(function (t, i) {
                    e.exports ? (e.exports = i(t, ee, Z)) : i(t, t.Flickity, t.fizzyUIUtils);
                })(window, function (e, t, i) {
                    t.createMethods.push("_createLazyload");
                    var n = t.prototype;
                    function o(e, t) {
                        (this.img = e), (this.flickity = t), this.load();
                    }
                    return (
                        (n._createLazyload = function () {
                            this.on("select", this.lazyLoad);
                        }),
                        (n.lazyLoad = function () {
                            var e = this.options.lazyLoad;
                            if (e) {
                                var t = "number" == typeof e ? e : 0,
                                    n = this.getAdjacentCellElements(t),
                                    a = [];
                                n.forEach(function (e) {
                                    var t = (function (e) {
                                        if ("IMG" == e.nodeName) {
                                            var t = e.getAttribute("data-flickity-lazyload"),
                                                n = e.getAttribute("data-flickity-lazyload-src"),
                                                o = e.getAttribute("data-flickity-lazyload-srcset");
                                            if (t || n || o) return [e];
                                        }
                                        var a = "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]",
                                            s = e.querySelectorAll(a);
                                        return i.makeArray(s);
                                    })(e);
                                    a = a.concat(t);
                                }),
                                    a.forEach(function (e) {
                                        new o(e, this);
                                    }, this);
                            }
                        }),
                        (o.prototype.handleEvent = i.handleEvent),
                        (o.prototype.load = function () {
                            this.img.addEventListener("load", this), this.img.addEventListener("error", this);
                            var e = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src"),
                                t = this.img.getAttribute("data-flickity-lazyload-srcset");
                            (this.img.src = e),
                                t && this.img.setAttribute("srcset", t),
                                this.img.removeAttribute("data-flickity-lazyload"),
                                this.img.removeAttribute("data-flickity-lazyload-src"),
                                this.img.removeAttribute("data-flickity-lazyload-srcset");
                        }),
                        (o.prototype.onload = function (e) {
                            this.complete(e, "flickity-lazyloaded");
                        }),
                        (o.prototype.onerror = function (e) {
                            this.complete(e, "flickity-lazyerror");
                        }),
                        (o.prototype.complete = function (e, t) {
                            this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
                            var i = this.flickity.getParentCell(this.img),
                                n = i && i.element;
                            this.flickity.cellSizeChange(n), this.img.classList.add(t), this.flickity.dispatchEvent("lazyLoad", e, n);
                        }),
                        (t.LazyLoader = o),
                        t
                    );
                });
            }),
            y(function (e) {
                /*!
                 * Flickity v2.2.1
                 * Touch, responsive, flickable carousels
                 *
                 * Licensed GPLv3 for open source use
                 * or Flickity Commercial License for commercial use
                 *
                 * https://flickity.metafizzy.co
                 * Copyright 2015-2019 Metafizzy
                 */
                window, e.exports && (e.exports = ee);
            })),
        oe = y(function (e) {
            !(function (t, i) {
                e.exports ? (e.exports = i(ne, Z)) : i(t.Flickity, t.fizzyUIUtils);
            })(v, function (e, t) {
                var i = e.Slide,
                    n = i.prototype.updateTarget;
                (i.prototype.updateTarget = function () {
                    if ((n.apply(this, arguments), this.parent.options.fade)) {
                        var e = this.target - this.x,
                            t = this.cells[0].x;
                        this.cells.forEach(function (i) {
                            var n = i.x - t - e;
                            i.renderPosition(n);
                        });
                    }
                }),
                    (i.prototype.setOpacity = function (e) {
                        this.cells.forEach(function (t) {
                            t.element.style.opacity = e;
                        });
                    });
                var o = e.prototype;
                e.createMethods.push("_createFade"),
                    (o._createFade = function () {
                        (this.fadeIndex = this.selectedIndex),
                            (this.prevSelectedIndex = this.selectedIndex),
                            this.on("select", this.onSelectFade),
                            this.on("dragEnd", this.onDragEndFade),
                            this.on("settle", this.onSettleFade),
                            this.on("activate", this.onActivateFade),
                            this.on("deactivate", this.onDeactivateFade);
                    });
                var a = o.updateSlides;
                (o.updateSlides = function () {
                    a.apply(this, arguments),
                        this.options.fade &&
                            this.slides.forEach(function (e, t) {
                                var i = t == this.selectedIndex ? 1 : 0;
                                e.setOpacity(i);
                            }, this);
                }),
                    (o.onSelectFade = function () {
                        (this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1)), (this.prevSelectedIndex = this.selectedIndex);
                    }),
                    (o.onSettleFade = function () {
                        (delete this.didDragEnd, this.options.fade) && (this.selectedSlide.setOpacity(1), this.slides[this.fadeIndex] && this.fadeIndex != this.selectedIndex && this.slides[this.fadeIndex].setOpacity(0));
                    }),
                    (o.onDragEndFade = function () {
                        this.didDragEnd = !0;
                    }),
                    (o.onActivateFade = function () {
                        this.options.fade && this.element.classList.add("is-fade");
                    }),
                    (o.onDeactivateFade = function () {
                        this.options.fade &&
                            (this.element.classList.remove("is-fade"),
                            this.slides.forEach(function (e) {
                                e.setOpacity("");
                            }));
                    });
                var s = o.positionSlider;
                o.positionSlider = function () {
                    this.options.fade ? (this.fadeSlides(), this.dispatchScrollEvent()) : s.apply(this, arguments);
                };
                var r = o.positionSliderAtSelected;
                (o.positionSliderAtSelected = function () {
                    this.options.fade && this.setTranslateX(0), r.apply(this, arguments);
                }),
                    (o.fadeSlides = function () {
                        if (!(this.slides.length < 2)) {
                            var e = this.getFadeIndexes(),
                                t = this.slides[e.a],
                                i = this.slides[e.b],
                                n = this.wrapDifference(t.target, i.target),
                                o = this.wrapDifference(t.target, -this.x);
                            (o /= n), t.setOpacity(1 - o), i.setOpacity(o);
                            var a = e.a;
                            this.isDragging && (a = o > 0.5 ? e.a : e.b),
                                null != this.fadeHideIndex && this.fadeHideIndex != a && this.fadeHideIndex != e.a && this.fadeHideIndex != e.b && this.slides[this.fadeHideIndex].setOpacity(0),
                                (this.fadeHideIndex = a);
                        }
                    }),
                    (o.getFadeIndexes = function () {
                        return this.isDragging || this.didDragEnd ? (this.options.wrapAround ? this.getFadeDragWrapIndexes() : this.getFadeDragLimitIndexes()) : { a: this.fadeIndex, b: this.selectedIndex };
                    }),
                    (o.getFadeDragWrapIndexes = function () {
                        var e = this.slides.map(function (e, t) {
                                return this.getSlideDistance(-this.x, t);
                            }, this),
                            i = e.map(function (e) {
                                return Math.abs(e);
                            }),
                            n = Math.min.apply(Math, i),
                            o = i.indexOf(n),
                            a = e[o],
                            s = this.slides.length,
                            r = a >= 0 ? 1 : -1;
                        return { a: o, b: t.modulo(o + r, s) };
                    }),
                    (o.getFadeDragLimitIndexes = function () {
                        for (var e = 0, t = 0; t < this.slides.length - 1; t++) {
                            var i = this.slides[t];
                            if (-this.x < i.target) break;
                            e = t;
                        }
                        return { a: e, b: e + 1 };
                    }),
                    (o.wrapDifference = function (e, t) {
                        var i = t - e;
                        if (!this.options.wrapAround) return i;
                        var n = i + this.slideableWidth,
                            o = i - this.slideableWidth;
                        return Math.abs(n) < Math.abs(i) && (i = n), Math.abs(o) < Math.abs(i) && (i = o), i;
                    });
                var l = o._getWrapShiftCells;
                o._getWrapShiftCells = function () {
                    this.options.fade || l.apply(this, arguments);
                };
                var c = o.shiftWrapCells;
                return (
                    (o.shiftWrapCells = function () {
                        this.options.fade || c.apply(this, arguments);
                    }),
                    e
                );
            });
        }),
        ae = y(function (t, i) {
            /*! PhotoSwipe - v4.1.3 - 2019-01-08
             * http://photoswipe.com
             * Copyright (c) 2019 Dmitry Semenov; */
            var n;
            t.exports =
                ((n = function (t, i, n, o) {
                    var a = {
                        features: null,
                        bind: function (e, t, i, n) {
                            var o = (n ? "remove" : "add") + "EventListener";
                            t = t.split(" ");
                            for (var a = 0; a < t.length; a++) t[a] && e[o](t[a], i, !1);
                        },
                        isArray: function (e) {
                            return e instanceof Array;
                        },
                        createEl: function (e, t) {
                            var i = document.createElement(t || "div");
                            return e && (i.className = e), i;
                        },
                        getScrollY: function () {
                            var e = window.pageYOffset;
                            return void 0 !== e ? e : document.documentElement.scrollTop;
                        },
                        unbind: function (e, t, i) {
                            a.bind(e, t, i, !0);
                        },
                        removeClass: function (e, t) {
                            var i = new RegExp("(\\s|^)" + t + "(\\s|$)");
                            e.className = e.className
                                .replace(i, " ")
                                .replace(/^\s\s*/, "")
                                .replace(/\s\s*$/, "");
                        },
                        addClass: function (e, t) {
                            a.hasClass(e, t) || (e.className += (e.className ? " " : "") + t);
                        },
                        hasClass: function (e, t) {
                            return e.className && new RegExp("(^|\\s)" + t + "(\\s|$)").test(e.className);
                        },
                        getChildByClass: function (e, t) {
                            for (var i = e.firstChild; i; ) {
                                if (a.hasClass(i, t)) return i;
                                i = i.nextSibling;
                            }
                        },
                        arraySearch: function (e, t, i) {
                            for (var n = e.length; n--; ) if (e[n][i] === t) return n;
                            return -1;
                        },
                        extend: function (e, t, i) {
                            for (var n in t)
                                if (t.hasOwnProperty(n)) {
                                    if (i && e.hasOwnProperty(n)) continue;
                                    e[n] = t[n];
                                }
                        },
                        easing: {
                            sine: {
                                out: function (e) {
                                    return Math.sin(e * (Math.PI / 2));
                                },
                                inOut: function (e) {
                                    return -(Math.cos(Math.PI * e) - 1) / 2;
                                },
                            },
                            cubic: {
                                out: function (e) {
                                    return --e * e * e + 1;
                                },
                            },
                        },
                        detectFeatures: function () {
                            if (a.features) return a.features;
                            var e = a.createEl().style,
                                t = "",
                                i = {};
                            if (
                                ((i.oldIE = document.all && !document.addEventListener),
                                (i.touch = "ontouchstart" in window),
                                window.requestAnimationFrame && ((i.raf = window.requestAnimationFrame), (i.caf = window.cancelAnimationFrame)),
                                (i.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled),
                                !i.pointerEvent)
                            ) {
                                var n = navigator.userAgent;
                                if (/iP(hone|od)/.test(navigator.platform)) {
                                    var o = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                                    o && o.length > 0 && (o = parseInt(o[1], 10)) >= 1 && o < 8 && (i.isOldIOSPhone = !0);
                                }
                                var s = n.match(/Android\s([0-9\.]*)/),
                                    r = s ? s[1] : 0;
                                (r = parseFloat(r)) >= 1 && (r < 4.4 && (i.isOldAndroid = !0), (i.androidVersion = r)), (i.isMobileOpera = /opera mini|opera mobi/i.test(n));
                            }
                            for (var l, c, d = ["transform", "perspective", "animationName"], u = ["", "webkit", "Moz", "ms", "O"], h = 0; h < 4; h++) {
                                t = u[h];
                                for (var p = 0; p < 3; p++) (l = d[p]), (c = t + (t ? l.charAt(0).toUpperCase() + l.slice(1) : l)), !i[l] && c in e && (i[l] = c);
                                t && !i.raf && ((t = t.toLowerCase()), (i.raf = window[t + "RequestAnimationFrame"]), i.raf && (i.caf = window[t + "CancelAnimationFrame"] || window[t + "CancelRequestAnimationFrame"]));
                            }
                            if (!i.raf) {
                                var m = 0;
                                (i.raf = function (e) {
                                    var t = new Date().getTime(),
                                        i = Math.max(0, 16 - (t - m)),
                                        n = window.setTimeout(function () {
                                            e(t + i);
                                        }, i);
                                    return (m = t + i), n;
                                }),
                                    (i.caf = function (e) {
                                        clearTimeout(e);
                                    });
                            }
                            return (i.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect), (a.features = i), i;
                        },
                    };
                    a.detectFeatures(),
                        a.features.oldIE &&
                            (a.bind = function (t, i, n, o) {
                                i = i.split(" ");
                                for (
                                    var a,
                                        s = (o ? "detach" : "attach") + "Event",
                                        r = function () {
                                            n.handleEvent.call(n);
                                        },
                                        l = 0;
                                    l < i.length;
                                    l++
                                )
                                    if ((a = i[l]))
                                        if ("object" === e(n) && n.handleEvent) {
                                            if (o) {
                                                if (!n["oldIE" + a]) return !1;
                                            } else n["oldIE" + a] = r;
                                            t[s]("on" + a, n["oldIE" + a]);
                                        } else t[s]("on" + a, n);
                            });
                    var s = this,
                        r = 25,
                        l = 3,
                        c = {
                            allowPanToNext: !0,
                            spacing: 0.12,
                            bgOpacity: 1,
                            mouseUsed: !1,
                            loop: !0,
                            pinchToClose: !0,
                            closeOnScroll: !0,
                            closeOnVerticalDrag: !0,
                            verticalDragRange: 0.75,
                            hideAnimationDuration: 333,
                            showAnimationDuration: 333,
                            showHideOpacity: !1,
                            focus: !0,
                            escKey: !0,
                            arrowKeys: !0,
                            mainScrollEndFriction: 0.35,
                            panEndFriction: 0.35,
                            isClickableElement: function (e) {
                                return "A" === e.tagName;
                            },
                            getDoubleTapZoom: function (e, t) {
                                return e || t.initialZoomLevel < 0.7 ? 1 : 1.33;
                            },
                            maxSpreadZoom: 1.33,
                            modal: !0,
                            scaleMode: "fit",
                        };
                    a.extend(c, o);
                    var d,
                        u,
                        h,
                        p,
                        m,
                        f,
                        v,
                        g,
                        y,
                        w,
                        b,
                        _,
                        E,
                        S,
                        k,
                        x,
                        C,
                        L,
                        A,
                        T,
                        I,
                        q,
                        P,
                        M,
                        z,
                        D,
                        O,
                        B,
                        H,
                        N,
                        R,
                        F,
                        U,
                        j,
                        W,
                        V,
                        $,
                        X,
                        G,
                        Y,
                        Z,
                        Q,
                        J,
                        K,
                        ee,
                        te,
                        ie,
                        ne,
                        oe,
                        ae,
                        se,
                        re,
                        le,
                        ce,
                        de,
                        ue,
                        he = function () {
                            return { x: 0, y: 0 };
                        },
                        pe = he(),
                        me = he(),
                        fe = he(),
                        ve = {},
                        ge = 0,
                        ye = {},
                        we = he(),
                        be = 0,
                        _e = !0,
                        Ee = [],
                        Se = {},
                        ke = !1,
                        xe = function (e, t) {
                            a.extend(s, t.publicMethods), Ee.push(e);
                        },
                        Ce = function (e) {
                            var t = ei();
                            return e > t - 1 ? e - t : e < 0 ? t + e : e;
                        },
                        Le = {},
                        Ae = function (e, t) {
                            return Le[e] || (Le[e] = []), Le[e].push(t);
                        },
                        Te = function (e) {
                            var t = Le[e];
                            if (t) {
                                var i = Array.prototype.slice.call(arguments);
                                i.shift();
                                for (var n = 0; n < t.length; n++) t[n].apply(s, i);
                            }
                        },
                        Ie = function () {
                            return new Date().getTime();
                        },
                        qe = function (e) {
                            (ce = e), (s.bg.style.opacity = e * c.bgOpacity);
                        },
                        Pe = function (e, t, i, n, o) {
                            (!ke || (o && o !== s.currItem)) && (n /= o ? o.fitRatio : s.currItem.fitRatio), (e[q] = _ + t + "px, " + i + "px" + E + " scale(" + n + ")");
                        },
                        Me = function (e) {
                            oe && (e && (w > s.currItem.fitRatio ? ke || (ui(s.currItem, !1, !0), (ke = !0)) : ke && (ui(s.currItem), (ke = !1))), Pe(oe, fe.x, fe.y, w));
                        },
                        ze = function (e) {
                            e.container && Pe(e.container.style, e.initialPosition.x, e.initialPosition.y, e.initialZoomLevel, e);
                        },
                        De = function (e, t) {
                            t[q] = _ + e + "px, 0px" + E;
                        },
                        Oe = function (e, t) {
                            if (!c.loop && t) {
                                var i = p + (we.x * ge - e) / we.x,
                                    n = Math.round(e - wt.x);
                                ((i < 0 && n > 0) || (i >= ei() - 1 && n < 0)) && (e = wt.x + n * c.mainScrollEndFriction);
                            }
                            (wt.x = e), De(e, m);
                        },
                        Be = function (e, t) {
                            var i = bt[e] - ye[e];
                            return me[e] + pe[e] + i - i * (t / b);
                        },
                        He = function (e, t) {
                            (e.x = t.x), (e.y = t.y), t.id && (e.id = t.id);
                        },
                        Ne = function (e) {
                            (e.x = Math.round(e.x)), (e.y = Math.round(e.y));
                        },
                        Re = null,
                        Fe = function e() {
                            Re && (a.unbind(document, "mousemove", e), a.addClass(t, "pswp--has_mouse"), (c.mouseUsed = !0), Te("mouseUsed")),
                                (Re = setTimeout(function () {
                                    Re = null;
                                }, 100));
                        },
                        Ue = function () {
                            a.bind(document, "keydown", s), R.transform && a.bind(s.scrollWrap, "click", s), c.mouseUsed || a.bind(document, "mousemove", Fe), a.bind(window, "resize scroll orientationchange", s), Te("bindEvents");
                        },
                        je = function () {
                            a.unbind(window, "resize scroll orientationchange", s),
                                a.unbind(window, "scroll", y.scroll),
                                a.unbind(document, "keydown", s),
                                a.unbind(document, "mousemove", Fe),
                                R.transform && a.unbind(s.scrollWrap, "click", s),
                                G && a.unbind(window, v, s),
                                clearTimeout(F),
                                Te("unbindEvents");
                        },
                        We = function (e, t) {
                            var i = ri(s.currItem, ve, e);
                            return t && (ne = i), i;
                        },
                        Ve = function (e) {
                            return e || (e = s.currItem), e.initialZoomLevel;
                        },
                        $e = function (e) {
                            return e || (e = s.currItem), e.w > 0 ? c.maxSpreadZoom : 1;
                        },
                        Xe = function (e, t, i, n) {
                            return n === s.currItem.initialZoomLevel ? ((i[e] = s.currItem.initialPosition[e]), !0) : ((i[e] = Be(e, n)), i[e] > t.min[e] ? ((i[e] = t.min[e]), !0) : i[e] < t.max[e] && ((i[e] = t.max[e]), !0));
                        },
                        Ge = function () {
                            if (q) {
                                var e = R.perspective && !M;
                                return (_ = "translate" + (e ? "3d(" : "(")), void (E = R.perspective ? ", 0px)" : ")");
                            }
                            (q = "left"),
                                a.addClass(t, "pswp--ie"),
                                (De = function (e, t) {
                                    t.left = e + "px";
                                }),
                                (ze = function (e) {
                                    var t = e.fitRatio > 1 ? 1 : e.fitRatio,
                                        i = e.container.style,
                                        n = t * e.w,
                                        o = t * e.h;
                                    (i.width = n + "px"), (i.height = o + "px"), (i.left = e.initialPosition.x + "px"), (i.top = e.initialPosition.y + "px");
                                }),
                                (Me = function () {
                                    if (oe) {
                                        var e = oe,
                                            t = s.currItem,
                                            i = t.fitRatio > 1 ? 1 : t.fitRatio,
                                            n = i * t.w,
                                            o = i * t.h;
                                        (e.width = n + "px"), (e.height = o + "px"), (e.left = fe.x + "px"), (e.top = fe.y + "px");
                                    }
                                });
                        },
                        Ye = function (e) {
                            var t = "";
                            c.escKey && 27 === e.keyCode ? (t = "close") : c.arrowKeys && (37 === e.keyCode ? (t = "prev") : 39 === e.keyCode && (t = "next")),
                                t && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey || (e.preventDefault ? e.preventDefault() : (e.returnValue = !1), s[t]()));
                        },
                        Ze = function (e) {
                            e && (Q || Z || ae || $) && (e.preventDefault(), e.stopPropagation());
                        },
                        Qe = function () {
                            s.setScrollOffset(0, a.getScrollY());
                        },
                        Je = {},
                        Ke = 0,
                        et = function (e) {
                            Je[e] && (Je[e].raf && D(Je[e].raf), Ke--, delete Je[e]);
                        },
                        tt = function (e) {
                            Je[e] && et(e), Je[e] || (Ke++, (Je[e] = {}));
                        },
                        it = function () {
                            for (var e in Je) Je.hasOwnProperty(e) && et(e);
                        },
                        nt = function (e, t, i, n, o, a, s) {
                            var r,
                                l = Ie();
                            tt(e),
                                (function c() {
                                    if (Je[e]) {
                                        if ((r = Ie() - l) >= n) return et(e), a(i), void (s && s());
                                        a((i - t) * o(r / n) + t), (Je[e].raf = z(c));
                                    }
                                })();
                        },
                        ot = {
                            shout: Te,
                            listen: Ae,
                            viewportSize: ve,
                            options: c,
                            isMainScrollAnimating: function () {
                                return ae;
                            },
                            getZoomLevel: function () {
                                return w;
                            },
                            getCurrentIndex: function () {
                                return p;
                            },
                            isDragging: function () {
                                return G;
                            },
                            isZooming: function () {
                                return te;
                            },
                            setScrollOffset: function (e, t) {
                                (ye.x = e), (N = ye.y = t), Te("updateScrollOffset", ye);
                            },
                            applyZoomPan: function (e, t, i, n) {
                                (fe.x = t), (fe.y = i), (w = e), Me(n);
                            },
                            init: function () {
                                if (!d && !u) {
                                    var e;
                                    (s.framework = a),
                                        (s.template = t),
                                        (s.bg = a.getChildByClass(t, "pswp__bg")),
                                        (O = t.className),
                                        (d = !0),
                                        (R = a.detectFeatures()),
                                        (z = R.raf),
                                        (D = R.caf),
                                        (q = R.transform),
                                        (H = R.oldIE),
                                        (s.scrollWrap = a.getChildByClass(t, "pswp__scroll-wrap")),
                                        (s.container = a.getChildByClass(s.scrollWrap, "pswp__container")),
                                        (m = s.container.style),
                                        (s.itemHolders = x = [
                                            { el: s.container.children[0], wrap: 0, index: -1 },
                                            { el: s.container.children[1], wrap: 0, index: -1 },
                                            { el: s.container.children[2], wrap: 0, index: -1 },
                                        ]),
                                        (x[0].el.style.display = x[2].el.style.display = "none"),
                                        Ge(),
                                        (y = {
                                            resize: s.updateSize,
                                            orientationchange: function () {
                                                clearTimeout(F),
                                                    (F = setTimeout(function () {
                                                        ve.x !== s.scrollWrap.clientWidth && s.updateSize();
                                                    }, 500));
                                            },
                                            scroll: Qe,
                                            keydown: Ye,
                                            click: Ze,
                                        });
                                    var n = R.isOldIOSPhone || R.isOldAndroid || R.isMobileOpera;
                                    for ((R.animationName && R.transform && !n) || (c.showAnimationDuration = c.hideAnimationDuration = 0), e = 0; e < Ee.length; e++) s["init" + Ee[e]]();
                                    i && (s.ui = new i(s, a)).init(),
                                        Te("firstUpdate"),
                                        (p = p || c.index || 0),
                                        (isNaN(p) || p < 0 || p >= ei()) && (p = 0),
                                        (s.currItem = Kt(p)),
                                        (R.isOldIOSPhone || R.isOldAndroid) && (_e = !1),
                                        t.setAttribute("aria-hidden", "false"),
                                        c.modal && (_e ? (t.style.position = "fixed") : ((t.style.position = "absolute"), (t.style.top = a.getScrollY() + "px"))),
                                        void 0 === N && (Te("initialLayout"), (N = B = a.getScrollY()));
                                    var o = "pswp--open ";
                                    for (
                                        c.mainClass && (o += c.mainClass + " "),
                                            c.showHideOpacity && (o += "pswp--animate_opacity "),
                                            o += M ? "pswp--touch" : "pswp--notouch",
                                            o += R.animationName ? " pswp--css_animation" : "",
                                            o += R.svg ? " pswp--svg" : "",
                                            a.addClass(t, o),
                                            s.updateSize(),
                                            f = -1,
                                            be = null,
                                            e = 0;
                                        e < l;
                                        e++
                                    )
                                        De((e + f) * we.x, x[e].el.style);
                                    H || a.bind(s.scrollWrap, g, s),
                                        Ae("initialZoomInEnd", function () {
                                            s.setContent(x[0], p - 1), s.setContent(x[2], p + 1), (x[0].el.style.display = x[2].el.style.display = "block"), c.focus && t.focus(), Ue();
                                        }),
                                        s.setContent(x[1], p),
                                        s.updateCurrItem(),
                                        Te("afterInit"),
                                        _e ||
                                            (S = setInterval(function () {
                                                Ke || G || te || w !== s.currItem.initialZoomLevel || s.updateSize();
                                            }, 1e3)),
                                        a.addClass(t, "pswp--visible");
                                }
                            },
                            close: function () {
                                d && ((d = !1), (u = !0), Te("close"), je(), ti(s.currItem, null, !0, s.destroy));
                            },
                            destroy: function () {
                                Te("destroy"), Yt && clearTimeout(Yt), t.setAttribute("aria-hidden", "true"), (t.className = O), S && clearInterval(S), a.unbind(s.scrollWrap, g, s), a.unbind(window, "scroll", s), xt(), it(), (Le = null);
                            },
                            panTo: function (e, t, i) {
                                i || (e > ne.min.x ? (e = ne.min.x) : e < ne.max.x && (e = ne.max.x), t > ne.min.y ? (t = ne.min.y) : t < ne.max.y && (t = ne.max.y)), (fe.x = e), (fe.y = t), Me();
                            },
                            handleEvent: function (e) {
                                (e = e || window.event), y[e.type] && y[e.type](e);
                            },
                            goTo: function (e) {
                                var t = (e = Ce(e)) - p;
                                (be = t), (p = e), (s.currItem = Kt(p)), (ge -= t), Oe(we.x * ge), it(), (ae = !1), s.updateCurrItem();
                            },
                            next: function () {
                                s.goTo(p + 1);
                            },
                            prev: function () {
                                s.goTo(p - 1);
                            },
                            updateCurrZoomItem: function (e) {
                                if ((e && Te("beforeChange", 0), x[1].el.children.length)) {
                                    var t = x[1].el.children[0];
                                    oe = a.hasClass(t, "pswp__zoom-wrap") ? t.style : null;
                                } else oe = null;
                                (ne = s.currItem.bounds), (b = w = s.currItem.initialZoomLevel), (fe.x = ne.center.x), (fe.y = ne.center.y), e && Te("afterChange");
                            },
                            invalidateCurrItems: function () {
                                k = !0;
                                for (var e = 0; e < l; e++) x[e].item && (x[e].item.needsUpdate = !0);
                            },
                            updateCurrItem: function (e) {
                                if (0 !== be) {
                                    var t,
                                        i = Math.abs(be);
                                    if (!(e && i < 2)) {
                                        (s.currItem = Kt(p)), (ke = !1), Te("beforeChange", be), i >= l && ((f += be + (be > 0 ? -l : l)), (i = l));
                                        for (var n = 0; n < i; n++)
                                            be > 0
                                                ? ((t = x.shift()), (x[l - 1] = t), f++, De((f + 2) * we.x, t.el.style), s.setContent(t, p - i + n + 1 + 1))
                                                : ((t = x.pop()), x.unshift(t), f--, De(f * we.x, t.el.style), s.setContent(t, p + i - n - 1 - 1));
                                        if (oe && 1 === Math.abs(be)) {
                                            var o = Kt(C);
                                            o.initialZoomLevel !== w && (ri(o, ve), ui(o), ze(o));
                                        }
                                        (be = 0), s.updateCurrZoomItem(), (C = p), Te("afterChange");
                                    }
                                }
                            },
                            updateSize: function (e) {
                                if (!_e && c.modal) {
                                    var i = a.getScrollY();
                                    if ((N !== i && ((t.style.top = i + "px"), (N = i)), !e && Se.x === window.innerWidth && Se.y === window.innerHeight)) return;
                                    (Se.x = window.innerWidth), (Se.y = window.innerHeight), (t.style.height = Se.y + "px");
                                }
                                if (((ve.x = s.scrollWrap.clientWidth), (ve.y = s.scrollWrap.clientHeight), Qe(), (we.x = ve.x + Math.round(ve.x * c.spacing)), (we.y = ve.y), Oe(we.x * ge), Te("beforeResize"), void 0 !== f)) {
                                    for (var n, o, r, d = 0; d < l; d++)
                                        (n = x[d]),
                                            De((d + f) * we.x, n.el.style),
                                            (r = p + d - 1),
                                            c.loop && ei() > 2 && (r = Ce(r)),
                                            (o = Kt(r)) && (k || o.needsUpdate || !o.bounds)
                                                ? (s.cleanSlide(o), s.setContent(n, r), 1 === d && ((s.currItem = o), s.updateCurrZoomItem(!0)), (o.needsUpdate = !1))
                                                : -1 === n.index && r >= 0 && s.setContent(n, r),
                                            o && o.container && (ri(o, ve), ui(o), ze(o));
                                    k = !1;
                                }
                                (b = w = s.currItem.initialZoomLevel), (ne = s.currItem.bounds) && ((fe.x = ne.center.x), (fe.y = ne.center.y), Me(!0)), Te("resize");
                            },
                            zoomTo: function (e, t, i, n, o) {
                                t && ((b = w), (bt.x = Math.abs(t.x) - fe.x), (bt.y = Math.abs(t.y) - fe.y), He(me, fe));
                                var s = We(e, !1),
                                    r = {};
                                Xe("x", s, r, e), Xe("y", s, r, e);
                                var l = w,
                                    c = { x: fe.x, y: fe.y };
                                Ne(r);
                                var d = function (t) {
                                    1 === t ? ((w = e), (fe.x = r.x), (fe.y = r.y)) : ((w = (e - l) * t + l), (fe.x = (r.x - c.x) * t + c.x), (fe.y = (r.y - c.y) * t + c.y)), o && o(t), Me(1 === t);
                                };
                                i ? nt("customZoomTo", 0, 1, i, n || a.easing.sine.inOut, d) : d(1);
                            },
                        },
                        at = 30,
                        st = 10,
                        rt = {},
                        lt = {},
                        ct = {},
                        dt = {},
                        ut = {},
                        ht = [],
                        pt = {},
                        mt = [],
                        ft = {},
                        vt = 0,
                        gt = he(),
                        yt = 0,
                        wt = he(),
                        bt = he(),
                        _t = he(),
                        Et = function (e, t) {
                            return e.x === t.x && e.y === t.y;
                        },
                        St = function (e, t) {
                            return Math.abs(e.x - t.x) < r && Math.abs(e.y - t.y) < r;
                        },
                        kt = function (e, t) {
                            return (ft.x = Math.abs(e.x - t.x)), (ft.y = Math.abs(e.y - t.y)), Math.sqrt(ft.x * ft.x + ft.y * ft.y);
                        },
                        xt = function () {
                            J && (D(J), (J = null));
                        },
                        Ct = function e() {
                            G && ((J = z(e)), Ut());
                        },
                        Lt = function () {
                            return !("fit" === c.scaleMode && w === s.currItem.initialZoomLevel);
                        },
                        At = function e(t, i) {
                            return !(!t || t === document) && !(t.getAttribute("class") && t.getAttribute("class").indexOf("pswp__scroll-wrap") > -1) && (i(t) ? t : e(t.parentNode, i));
                        },
                        Tt = {},
                        It = function (e, t) {
                            return (Tt.prevent = !At(e.target, c.isClickableElement)), Te("preventDragEvent", e, t, Tt), Tt.prevent;
                        },
                        qt = function (e, t) {
                            return (t.x = e.pageX), (t.y = e.pageY), (t.id = e.identifier), t;
                        },
                        Pt = function (e, t, i) {
                            (i.x = 0.5 * (e.x + t.x)), (i.y = 0.5 * (e.y + t.y));
                        },
                        Mt = function (e, t, i) {
                            if (e - j > 50) {
                                var n = mt.length > 2 ? mt.shift() : {};
                                (n.x = t), (n.y = i), mt.push(n), (j = e);
                            }
                        },
                        zt = function () {
                            var e = fe.y - s.currItem.initialPosition.y;
                            return 1 - Math.abs(e / (ve.y / 2));
                        },
                        Dt = {},
                        Ot = {},
                        Bt = [],
                        Ht = function (e) {
                            for (; Bt.length > 0; ) Bt.pop();
                            return (
                                P
                                    ? ((ue = 0),
                                      ht.forEach(function (e) {
                                          0 === ue ? (Bt[0] = e) : 1 === ue && (Bt[1] = e), ue++;
                                      }))
                                    : e.type.indexOf("touch") > -1
                                    ? e.touches && e.touches.length > 0 && ((Bt[0] = qt(e.touches[0], Dt)), e.touches.length > 1 && (Bt[1] = qt(e.touches[1], Ot)))
                                    : ((Dt.x = e.pageX), (Dt.y = e.pageY), (Dt.id = ""), (Bt[0] = Dt)),
                                Bt
                            );
                        },
                        Nt = function (e, t) {
                            var i,
                                n,
                                o,
                                a,
                                r = fe[e] + t[e],
                                l = t[e] > 0,
                                d = wt.x + t.x,
                                u = wt.x - pt.x;
                            if (
                                ((i = r > ne.min[e] || r < ne.max[e] ? c.panEndFriction : 1),
                                (r = fe[e] + t[e] * i),
                                (c.allowPanToNext || w === s.currItem.initialZoomLevel) &&
                                    (oe
                                        ? "h" !== se ||
                                          "x" !== e ||
                                          Z ||
                                          (l
                                              ? (r > ne.min[e] && ((i = c.panEndFriction), ne.min[e], (n = ne.min[e] - me[e])), (n <= 0 || u < 0) && ei() > 1 ? ((a = d), u < 0 && d > pt.x && (a = pt.x)) : ne.min.x !== ne.max.x && (o = r))
                                              : (r < ne.max[e] && ((i = c.panEndFriction), ne.max[e], (n = me[e] - ne.max[e])), (n <= 0 || u > 0) && ei() > 1 ? ((a = d), u > 0 && d < pt.x && (a = pt.x)) : ne.min.x !== ne.max.x && (o = r)))
                                        : (a = d),
                                    "x" === e))
                            )
                                return void 0 !== a && (Oe(a, !0), (K = a !== pt.x)), ne.min.x !== ne.max.x && (void 0 !== o ? (fe.x = o) : K || (fe.x += t.x * i)), void 0 !== a;
                            ae || K || (w > s.currItem.fitRatio && (fe[e] += t[e] * i));
                        },
                        Rt = function (e) {
                            if (!("mousedown" === e.type && e.button > 0))
                                if (Jt) e.preventDefault();
                                else if (!X || "mousedown" !== e.type) {
                                    if ((It(e, !0) && e.preventDefault(), Te("pointerDown"), P)) {
                                        var t = a.arraySearch(ht, e.pointerId, "id");
                                        t < 0 && (t = ht.length), (ht[t] = { x: e.pageX, y: e.pageY, id: e.pointerId });
                                    }
                                    var i = Ht(e),
                                        n = i.length;
                                    (ee = null),
                                        it(),
                                        (G && 1 !== n) ||
                                            ((G = re = !0),
                                            a.bind(window, v, s),
                                            (V = de = le = $ = K = Q = Y = Z = !1),
                                            (se = null),
                                            Te("firstTouchStart", i),
                                            He(me, fe),
                                            (pe.x = pe.y = 0),
                                            He(dt, i[0]),
                                            He(ut, dt),
                                            (pt.x = we.x * ge),
                                            (mt = [{ x: dt.x, y: dt.y }]),
                                            (j = U = Ie()),
                                            We(w, !0),
                                            xt(),
                                            Ct()),
                                        !te &&
                                            n > 1 &&
                                            !ae &&
                                            !K &&
                                            ((b = w), (Z = !1), (te = Y = !0), (pe.y = pe.x = 0), He(me, fe), He(rt, i[0]), He(lt, i[1]), Pt(rt, lt, _t), (bt.x = Math.abs(_t.x) - fe.x), (bt.y = Math.abs(_t.y) - fe.y), (ie = kt(rt, lt)));
                                }
                        },
                        Ft = function (e) {
                            if ((e.preventDefault(), P)) {
                                var t = a.arraySearch(ht, e.pointerId, "id");
                                if (t > -1) {
                                    var i = ht[t];
                                    (i.x = e.pageX), (i.y = e.pageY);
                                }
                            }
                            if (G) {
                                var n = Ht(e);
                                if (se || Q || te) ee = n;
                                else if (wt.x !== we.x * ge) se = "h";
                                else {
                                    var o = Math.abs(n[0].x - dt.x) - Math.abs(n[0].y - dt.y);
                                    Math.abs(o) >= st && ((se = o > 0 ? "h" : "v"), (ee = n));
                                }
                            }
                        },
                        Ut = function () {
                            if (ee) {
                                var e = ee.length;
                                if (0 !== e)
                                    if ((He(rt, ee[0]), (ct.x = rt.x - dt.x), (ct.y = rt.y - dt.y), te && e > 1)) {
                                        if (((dt.x = rt.x), (dt.y = rt.y), !ct.x && !ct.y && Et(ee[1], lt))) return;
                                        He(lt, ee[1]), Z || ((Z = !0), Te("zoomGestureStarted"));
                                        var t = kt(rt, lt),
                                            i = Xt(t);
                                        i > s.currItem.initialZoomLevel + s.currItem.initialZoomLevel / 15 && (de = !0);
                                        var n = 1,
                                            o = Ve(),
                                            a = $e();
                                        if (i < o)
                                            if (c.pinchToClose && !de && b <= s.currItem.initialZoomLevel) {
                                                var r = 1 - (o - i) / (o / 1.2);
                                                qe(r), Te("onPinchClose", r), (le = !0);
                                            } else (n = (o - i) / o) > 1 && (n = 1), (i = o - n * (o / 3));
                                        else i > a && ((n = (i - a) / (6 * o)) > 1 && (n = 1), (i = a + n * o));
                                        n < 0 && (n = 0), Pt(rt, lt, gt), (pe.x += gt.x - _t.x), (pe.y += gt.y - _t.y), He(_t, gt), (fe.x = Be("x", i)), (fe.y = Be("y", i)), (V = i > w), (w = i), Me();
                                    } else {
                                        if (!se) return;
                                        if ((re && ((re = !1), Math.abs(ct.x) >= st && (ct.x -= ee[0].x - ut.x), Math.abs(ct.y) >= st && (ct.y -= ee[0].y - ut.y)), (dt.x = rt.x), (dt.y = rt.y), 0 === ct.x && 0 === ct.y)) return;
                                        if ("v" === se && c.closeOnVerticalDrag && !Lt()) {
                                            (pe.y += ct.y), (fe.y += ct.y);
                                            var l = zt();
                                            return ($ = !0), Te("onVerticalDrag", l), qe(l), void Me();
                                        }
                                        Mt(Ie(), rt.x, rt.y), (Q = !0), (ne = s.currItem.bounds), Nt("x", ct) || (Nt("y", ct), Ne(fe), Me());
                                    }
                            }
                        },
                        jt = function (e) {
                            if (R.isOldAndroid) {
                                if (X && "mouseup" === e.type) return;
                                e.type.indexOf("touch") > -1 &&
                                    (clearTimeout(X),
                                    (X = setTimeout(function () {
                                        X = 0;
                                    }, 600)));
                            }
                            var t;
                            if ((Te("pointerUp"), It(e, !1) && e.preventDefault(), P)) {
                                var i = a.arraySearch(ht, e.pointerId, "id");
                                if (i > -1)
                                    if (((t = ht.splice(i, 1)[0]), navigator.msPointerEnabled)) {
                                        var n = { 4: "mouse", 2: "touch", 3: "pen" };
                                        (t.type = n[e.pointerType]), t.type || (t.type = e.pointerType || "mouse");
                                    } else t.type = e.pointerType || "mouse";
                            }
                            var o,
                                r = Ht(e),
                                l = r.length;
                            if (("mouseup" === e.type && (l = 0), 2 === l)) return (ee = null), !0;
                            1 === l && He(ut, r[0]),
                                0 !== l ||
                                    se ||
                                    ae ||
                                    (t ||
                                        ("mouseup" === e.type
                                            ? (t = { x: e.pageX, y: e.pageY, type: "mouse" })
                                            : e.changedTouches && e.changedTouches[0] && (t = { x: e.changedTouches[0].pageX, y: e.changedTouches[0].pageY, type: "touch" })),
                                    Te("touchRelease", e, t));
                            var d = -1;
                            if (
                                (0 === l && ((G = !1), a.unbind(window, v, s), xt(), te ? (d = 0) : -1 !== yt && (d = Ie() - yt)),
                                (yt = 1 === l ? Ie() : -1),
                                (o = -1 !== d && d < 150 ? "zoom" : "swipe"),
                                te && l < 2 && ((te = !1), 1 === l && (o = "zoomPointerUp"), Te("zoomGestureEnded")),
                                (ee = null),
                                Q || Z || ae || $)
                            )
                                if ((it(), W || (W = Wt()), W.calculateSwipeSpeed("x"), $))
                                    if (zt() < c.verticalDragRange) s.close();
                                    else {
                                        var u = fe.y,
                                            h = ce;
                                        nt("verticalDrag", 0, 1, 300, a.easing.cubic.out, function (e) {
                                            (fe.y = (s.currItem.initialPosition.y - u) * e + u), qe((1 - h) * e + h), Me();
                                        }),
                                            Te("onVerticalDrag", 1);
                                    }
                                else {
                                    if ((K || ae) && 0 === l) {
                                        if ($t(o, W)) return;
                                        o = "zoomPointerUp";
                                    }
                                    ae || ("swipe" === o ? !K && w > s.currItem.fitRatio && Vt(W) : Gt());
                                }
                        },
                        Wt = function () {
                            var e,
                                t,
                                i = {
                                    lastFlickOffset: {},
                                    lastFlickDist: {},
                                    lastFlickSpeed: {},
                                    slowDownRatio: {},
                                    slowDownRatioReverse: {},
                                    speedDecelerationRatio: {},
                                    speedDecelerationRatioAbs: {},
                                    distanceOffset: {},
                                    backAnimDestination: {},
                                    backAnimStarted: {},
                                    calculateSwipeSpeed: function (n) {
                                        mt.length > 1 ? ((e = Ie() - j + 50), (t = mt[mt.length - 2][n])) : ((e = Ie() - U), (t = ut[n])),
                                            (i.lastFlickOffset[n] = dt[n] - t),
                                            (i.lastFlickDist[n] = Math.abs(i.lastFlickOffset[n])),
                                            i.lastFlickDist[n] > 20 ? (i.lastFlickSpeed[n] = i.lastFlickOffset[n] / e) : (i.lastFlickSpeed[n] = 0),
                                            Math.abs(i.lastFlickSpeed[n]) < 0.1 && (i.lastFlickSpeed[n] = 0),
                                            (i.slowDownRatio[n] = 0.95),
                                            (i.slowDownRatioReverse[n] = 1 - i.slowDownRatio[n]),
                                            (i.speedDecelerationRatio[n] = 1);
                                    },
                                    calculateOverBoundsAnimOffset: function (e, t) {
                                        i.backAnimStarted[e] ||
                                            (fe[e] > ne.min[e] ? (i.backAnimDestination[e] = ne.min[e]) : fe[e] < ne.max[e] && (i.backAnimDestination[e] = ne.max[e]),
                                            void 0 !== i.backAnimDestination[e] &&
                                                ((i.slowDownRatio[e] = 0.7),
                                                (i.slowDownRatioReverse[e] = 1 - i.slowDownRatio[e]),
                                                i.speedDecelerationRatioAbs[e] < 0.05 &&
                                                    ((i.lastFlickSpeed[e] = 0),
                                                    (i.backAnimStarted[e] = !0),
                                                    nt("bounceZoomPan" + e, fe[e], i.backAnimDestination[e], t || 300, a.easing.sine.out, function (t) {
                                                        (fe[e] = t), Me();
                                                    }))));
                                    },
                                    calculateAnimOffset: function (e) {
                                        i.backAnimStarted[e] ||
                                            ((i.speedDecelerationRatio[e] = i.speedDecelerationRatio[e] * (i.slowDownRatio[e] + i.slowDownRatioReverse[e] - (i.slowDownRatioReverse[e] * i.timeDiff) / 10)),
                                            (i.speedDecelerationRatioAbs[e] = Math.abs(i.lastFlickSpeed[e] * i.speedDecelerationRatio[e])),
                                            (i.distanceOffset[e] = i.lastFlickSpeed[e] * i.speedDecelerationRatio[e] * i.timeDiff),
                                            (fe[e] += i.distanceOffset[e]));
                                    },
                                    panAnimLoop: function () {
                                        if (
                                            Je.zoomPan &&
                                            ((Je.zoomPan.raf = z(i.panAnimLoop)),
                                            (i.now = Ie()),
                                            (i.timeDiff = i.now - i.lastNow),
                                            (i.lastNow = i.now),
                                            i.calculateAnimOffset("x"),
                                            i.calculateAnimOffset("y"),
                                            Me(),
                                            i.calculateOverBoundsAnimOffset("x"),
                                            i.calculateOverBoundsAnimOffset("y"),
                                            i.speedDecelerationRatioAbs.x < 0.05 && i.speedDecelerationRatioAbs.y < 0.05)
                                        )
                                            return (fe.x = Math.round(fe.x)), (fe.y = Math.round(fe.y)), Me(), void et("zoomPan");
                                    },
                                };
                            return i;
                        },
                        Vt = function (e) {
                            if ((e.calculateSwipeSpeed("y"), (ne = s.currItem.bounds), (e.backAnimDestination = {}), (e.backAnimStarted = {}), Math.abs(e.lastFlickSpeed.x) <= 0.05 && Math.abs(e.lastFlickSpeed.y) <= 0.05))
                                return (e.speedDecelerationRatioAbs.x = e.speedDecelerationRatioAbs.y = 0), e.calculateOverBoundsAnimOffset("x"), e.calculateOverBoundsAnimOffset("y"), !0;
                            tt("zoomPan"), (e.lastNow = Ie()), e.panAnimLoop();
                        },
                        $t = function (e, t) {
                            var i, n, o;
                            if ((ae || (vt = p), "swipe" === e)) {
                                var r = dt.x - ut.x,
                                    l = t.lastFlickDist.x < 10;
                                r > at && (l || t.lastFlickOffset.x > 20) ? (n = -1) : r < -at && (l || t.lastFlickOffset.x < -20) && (n = 1);
                            }
                            n && ((p += n) < 0 ? ((p = c.loop ? ei() - 1 : 0), (o = !0)) : p >= ei() && ((p = c.loop ? 0 : ei() - 1), (o = !0)), (o && !c.loop) || ((be += n), (ge -= n), (i = !0)));
                            var d,
                                u = we.x * ge,
                                h = Math.abs(u - wt.x);
                            return (
                                i || u > wt.x == t.lastFlickSpeed.x > 0 ? ((d = Math.abs(t.lastFlickSpeed.x) > 0 ? h / Math.abs(t.lastFlickSpeed.x) : 333), (d = Math.min(d, 400)), (d = Math.max(d, 250))) : (d = 333),
                                vt === p && (i = !1),
                                (ae = !0),
                                Te("mainScrollAnimStart"),
                                nt("mainScroll", wt.x, u, d, a.easing.cubic.out, Oe, function () {
                                    it(), (ae = !1), (vt = -1), (i || vt !== p) && s.updateCurrItem(), Te("mainScrollAnimComplete");
                                }),
                                i && s.updateCurrItem(!0),
                                i
                            );
                        },
                        Xt = function (e) {
                            return (1 / ie) * e * b;
                        },
                        Gt = function () {
                            var e = w,
                                t = Ve(),
                                i = $e();
                            w < t ? (e = t) : w > i && (e = i);
                            var n,
                                o = 1,
                                r = ce;
                            return le && !V && !de && w < t
                                ? (s.close(), !0)
                                : (le &&
                                      (n = function (e) {
                                          qe((o - r) * e + r);
                                      }),
                                  s.zoomTo(e, 0, 200, a.easing.cubic.out, n),
                                  !0);
                        };
                    xe("Gestures", {
                        publicMethods: {
                            initGestures: function () {
                                var e = function (e, t, i, n, o) {
                                    (L = e + t), (A = e + i), (T = e + n), (I = o ? e + o : "");
                                };
                                (P = R.pointerEvent) && R.touch && (R.touch = !1),
                                    P
                                        ? navigator.msPointerEnabled
                                            ? e("MSPointer", "Down", "Move", "Up", "Cancel")
                                            : e("pointer", "down", "move", "up", "cancel")
                                        : R.touch
                                        ? (e("touch", "start", "move", "end", "cancel"), (M = !0))
                                        : e("mouse", "down", "move", "up"),
                                    (v = A + " " + T + " " + I),
                                    (g = L),
                                    P && !M && (M = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1),
                                    (s.likelyTouchDevice = M),
                                    (y[L] = Rt),
                                    (y[A] = Ft),
                                    (y[T] = jt),
                                    I && (y[I] = y[T]),
                                    R.touch && ((g += " mousedown"), (v += " mousemove mouseup"), (y.mousedown = y[L]), (y.mousemove = y[A]), (y.mouseup = y[T])),
                                    M || (c.allowPanToNext = !1);
                            },
                        },
                    });
                    var Yt,
                        Zt,
                        Qt,
                        Jt,
                        Kt,
                        ei,
                        ti = function (e, i, n, o) {
                            var r;
                            Yt && clearTimeout(Yt), (Jt = !0), (Qt = !0), e.initialLayout ? ((r = e.initialLayout), (e.initialLayout = null)) : (r = c.getThumbBoundsFn && c.getThumbBoundsFn(p));
                            var l,
                                d,
                                u = n ? c.hideAnimationDuration : c.showAnimationDuration,
                                m = function () {
                                    et("initialZoom"),
                                        n ? (s.template.removeAttribute("style"), s.bg.removeAttribute("style")) : (qe(1), i && (i.style.display = "block"), a.addClass(t, "pswp--animated-in"), Te("initialZoom" + (n ? "OutEnd" : "InEnd"))),
                                        o && o(),
                                        (Jt = !1);
                                };
                            if (!u || !r || void 0 === r.x)
                                return (
                                    Te("initialZoom" + (n ? "Out" : "In")),
                                    (w = e.initialZoomLevel),
                                    He(fe, e.initialPosition),
                                    Me(),
                                    (t.style.opacity = n ? 0 : 1),
                                    qe(1),
                                    void (u
                                        ? setTimeout(function () {
                                              m();
                                          }, u)
                                        : m())
                                );
                            (l = h),
                                (d = !s.currItem.src || s.currItem.loadError || c.showHideOpacity),
                                e.miniImg && (e.miniImg.style.webkitBackfaceVisibility = "hidden"),
                                n || ((w = r.w / e.w), (fe.x = r.x), (fe.y = r.y - B), (s[d ? "template" : "bg"].style.opacity = 0.001), Me()),
                                tt("initialZoom"),
                                n && !l && a.removeClass(t, "pswp--animated-in"),
                                d &&
                                    (n
                                        ? a[(l ? "remove" : "add") + "Class"](t, "pswp--animate_opacity")
                                        : setTimeout(function () {
                                              a.addClass(t, "pswp--animate_opacity");
                                          }, 30)),
                                (Yt = setTimeout(
                                    function () {
                                        if ((Te("initialZoom" + (n ? "Out" : "In")), n)) {
                                            var i = r.w / e.w,
                                                o = { x: fe.x, y: fe.y },
                                                s = w,
                                                c = ce,
                                                h = function (e) {
                                                    1 === e ? ((w = i), (fe.x = r.x), (fe.y = r.y - N)) : ((w = (i - s) * e + s), (fe.x = (r.x - o.x) * e + o.x), (fe.y = (r.y - N - o.y) * e + o.y)),
                                                        Me(),
                                                        d ? (t.style.opacity = 1 - e) : qe(c - e * c);
                                                };
                                            l ? nt("initialZoom", 0, 1, u, a.easing.cubic.out, h, m) : (h(1), (Yt = setTimeout(m, u + 20)));
                                        } else (w = e.initialZoomLevel), He(fe, e.initialPosition), Me(), qe(1), d ? (t.style.opacity = 1) : qe(1), (Yt = setTimeout(m, u + 20));
                                    },
                                    n ? 25 : 90
                                ));
                        },
                        ii = {},
                        ni = [],
                        oi = {
                            index: 0,
                            errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
                            forceProgressiveLoading: !1,
                            preload: [1, 1],
                            getNumItemsFn: function () {
                                return Zt.length;
                            },
                        },
                        ai = function () {
                            return { center: { x: 0, y: 0 }, max: { x: 0, y: 0 }, min: { x: 0, y: 0 } };
                        },
                        si = function (e, t, i) {
                            var n = e.bounds;
                            (n.center.x = Math.round((ii.x - t) / 2)),
                                (n.center.y = Math.round((ii.y - i) / 2) + e.vGap.top),
                                (n.max.x = t > ii.x ? Math.round(ii.x - t) : n.center.x),
                                (n.max.y = i > ii.y ? Math.round(ii.y - i) + e.vGap.top : n.center.y),
                                (n.min.x = t > ii.x ? 0 : n.center.x),
                                (n.min.y = i > ii.y ? e.vGap.top : n.center.y);
                        },
                        ri = function (e, t, i) {
                            if (e.src && !e.loadError) {
                                var n = !i;
                                if ((n && (e.vGap || (e.vGap = { top: 0, bottom: 0 }), Te("parseVerticalMargin", e)), (ii.x = t.x), (ii.y = t.y - e.vGap.top - e.vGap.bottom), n)) {
                                    var o = ii.x / e.w,
                                        a = ii.y / e.h;
                                    e.fitRatio = o < a ? o : a;
                                    var s = c.scaleMode;
                                    "orig" === s ? (i = 1) : "fit" === s && (i = e.fitRatio), i > 1 && (i = 1), (e.initialZoomLevel = i), e.bounds || (e.bounds = ai());
                                }
                                if (!i) return;
                                return si(e, e.w * i, e.h * i), n && i === e.initialZoomLevel && (e.initialPosition = e.bounds.center), e.bounds;
                            }
                            return (e.w = e.h = 0), (e.initialZoomLevel = e.fitRatio = 1), (e.bounds = ai()), (e.initialPosition = e.bounds.center), e.bounds;
                        },
                        li = function (e, t, i, n, o, a) {
                            t.loadError ||
                                (n &&
                                    ((t.imageAppended = !0),
                                    ui(t, n, t === s.currItem && ke),
                                    i.appendChild(n),
                                    a &&
                                        setTimeout(function () {
                                            t && t.loaded && t.placeholder && ((t.placeholder.style.display = "none"), (t.placeholder = null));
                                        }, 500)));
                        },
                        ci = function (e) {
                            (e.loading = !0), (e.loaded = !1);
                            var t = (e.img = a.createEl("pswp__img", "img")),
                                i = function () {
                                    (e.loading = !1), (e.loaded = !0), e.loadComplete ? e.loadComplete(e) : (e.img = null), (t.onload = t.onerror = null), (t = null);
                                };
                            return (
                                (t.onload = i),
                                (t.onerror = function () {
                                    (e.loadError = !0), i();
                                }),
                                (t.src = e.src),
                                t
                            );
                        },
                        di = function (e, t) {
                            if (e.src && e.loadError && e.container) return t && (e.container.innerHTML = ""), (e.container.innerHTML = c.errorMsg.replace("%url%", e.src)), !0;
                        },
                        ui = function (e, t, i) {
                            if (e.src) {
                                t || (t = e.container.lastChild);
                                var n = i ? e.w : Math.round(e.w * e.fitRatio),
                                    o = i ? e.h : Math.round(e.h * e.fitRatio);
                                e.placeholder && !e.loaded && ((e.placeholder.style.width = n + "px"), (e.placeholder.style.height = o + "px")), (t.style.width = n + "px"), (t.style.height = o + "px");
                            }
                        },
                        hi = function () {
                            if (ni.length) {
                                for (var e, t = 0; t < ni.length; t++) (e = ni[t]).holder.index === e.index && li(e.index, e.item, e.baseDiv, e.img, !1, e.clearPlaceholder);
                                ni = [];
                            }
                        };
                    xe("Controller", {
                        publicMethods: {
                            lazyLoadItem: function (e) {
                                e = Ce(e);
                                var t = Kt(e);
                                t && ((!t.loaded && !t.loading) || k) && (Te("gettingData", e, t), t.src && ci(t));
                            },
                            initController: function () {
                                a.extend(c, oi, !0),
                                    (s.items = Zt = n),
                                    (Kt = s.getItemAt),
                                    (ei = c.getNumItemsFn)() < 3 && (c.loop = !1),
                                    Ae("beforeChange", function (e) {
                                        var t,
                                            i = c.preload,
                                            n = null === e || e >= 0,
                                            o = Math.min(i[0], ei()),
                                            a = Math.min(i[1], ei());
                                        for (t = 1; t <= (n ? a : o); t++) s.lazyLoadItem(p + t);
                                        for (t = 1; t <= (n ? o : a); t++) s.lazyLoadItem(p - t);
                                    }),
                                    Ae("initialLayout", function () {
                                        s.currItem.initialLayout = c.getThumbBoundsFn && c.getThumbBoundsFn(p);
                                    }),
                                    Ae("mainScrollAnimComplete", hi),
                                    Ae("initialZoomInEnd", hi),
                                    Ae("destroy", function () {
                                        for (var e, t = 0; t < Zt.length; t++)
                                            (e = Zt[t]).container && (e.container = null), e.placeholder && (e.placeholder = null), e.img && (e.img = null), e.preloader && (e.preloader = null), e.loadError && (e.loaded = e.loadError = !1);
                                        ni = null;
                                    });
                            },
                            getItemAt: function (e) {
                                return e >= 0 && void 0 !== Zt[e] && Zt[e];
                            },
                            allowProgressiveImg: function () {
                                return c.forceProgressiveLoading || !M || c.mouseUsed || screen.width > 1200;
                            },
                            setContent: function (e, t) {
                                c.loop && (t = Ce(t));
                                var i = s.getItemAt(e.index);
                                i && (i.container = null);
                                var n,
                                    o = s.getItemAt(t);
                                if (o) {
                                    Te("gettingData", t, o), (e.index = t), (e.item = o);
                                    var r = (o.container = a.createEl("pswp__zoom-wrap"));
                                    if ((!o.src && o.html && (o.html.tagName ? r.appendChild(o.html) : (r.innerHTML = o.html)), di(o), ri(o, ve), !o.src || o.loadError || o.loaded))
                                        o.src && !o.loadError && (((n = a.createEl("pswp__img", "img")).style.opacity = 1), (n.src = o.src), ui(o, n), li(t, o, r, n));
                                    else {
                                        if (
                                            ((o.loadComplete = function (i) {
                                                if (d) {
                                                    if (e && e.index === t) {
                                                        if (di(i, !0)) return (i.loadComplete = i.img = null), ri(i, ve), ze(i), void (e.index === p && s.updateCurrZoomItem());
                                                        i.imageAppended
                                                            ? !Jt && i.placeholder && ((i.placeholder.style.display = "none"), (i.placeholder = null))
                                                            : R.transform && (ae || Jt)
                                                            ? ni.push({ item: i, baseDiv: r, img: i.img, index: t, holder: e, clearPlaceholder: !0 })
                                                            : li(t, i, r, i.img, ae || Jt, !0);
                                                    }
                                                    (i.loadComplete = null), (i.img = null), Te("imageLoadComplete", t, i);
                                                }
                                            }),
                                            a.features.transform)
                                        ) {
                                            var l = "pswp__img pswp__img--placeholder";
                                            l += o.msrc ? "" : " pswp__img--placeholder--blank";
                                            var u = a.createEl(l, o.msrc ? "img" : "");
                                            o.msrc && (u.src = o.msrc), ui(o, u), r.appendChild(u), (o.placeholder = u);
                                        }
                                        o.loading || ci(o), s.allowProgressiveImg() && (!Qt && R.transform ? ni.push({ item: o, baseDiv: r, img: o.img, index: t, holder: e }) : li(t, o, r, o.img, !0, !0));
                                    }
                                    Qt || t !== p ? ze(o) : ((oe = r.style), ti(o, n || o.img)), (e.el.innerHTML = ""), e.el.appendChild(r);
                                } else e.el.innerHTML = "";
                            },
                            cleanSlide: function (e) {
                                e.img && (e.img.onload = e.img.onerror = null), (e.loaded = e.loading = e.img = e.imageAppended = !1);
                            },
                        },
                    });
                    var pi,
                        mi,
                        fi = {},
                        vi = function (e, t, i) {
                            var n = document.createEvent("CustomEvent"),
                                o = { origEvent: e, target: e.target, releasePoint: t, pointerType: i || "touch" };
                            n.initCustomEvent("pswpTap", !0, !0, o), e.target.dispatchEvent(n);
                        };
                    xe("Tap", {
                        publicMethods: {
                            initTap: function () {
                                Ae("firstTouchStart", s.onTapStart),
                                    Ae("touchRelease", s.onTapRelease),
                                    Ae("destroy", function () {
                                        (fi = {}), (pi = null);
                                    });
                            },
                            onTapStart: function (e) {
                                e.length > 1 && (clearTimeout(pi), (pi = null));
                            },
                            onTapRelease: function (e, t) {
                                if (t && !Q && !Y && !Ke) {
                                    var i = t;
                                    if (pi && (clearTimeout(pi), (pi = null), St(i, fi))) return void Te("doubleTap", i);
                                    if ("mouse" === t.type) return void vi(e, t, "mouse");
                                    if ("BUTTON" === e.target.tagName.toUpperCase() || a.hasClass(e.target, "pswp__single-tap")) return void vi(e, t);
                                    He(fi, i),
                                        (pi = setTimeout(function () {
                                            vi(e, t), (pi = null);
                                        }, 300));
                                }
                            },
                        },
                    }),
                        xe("DesktopZoom", {
                            publicMethods: {
                                initDesktopZoom: function () {
                                    H ||
                                        (M
                                            ? Ae("mouseUsed", function () {
                                                  s.setupDesktopZoom();
                                              })
                                            : s.setupDesktopZoom(!0));
                                },
                                setupDesktopZoom: function (e) {
                                    mi = {};
                                    var i = "wheel mousewheel DOMMouseScroll";
                                    Ae("bindEvents", function () {
                                        a.bind(t, i, s.handleMouseWheel);
                                    }),
                                        Ae("unbindEvents", function () {
                                            mi && a.unbind(t, i, s.handleMouseWheel);
                                        }),
                                        (s.mouseZoomedIn = !1);
                                    var n,
                                        o = function () {
                                            s.mouseZoomedIn && (a.removeClass(t, "pswp--zoomed-in"), (s.mouseZoomedIn = !1)), w < 1 ? a.addClass(t, "pswp--zoom-allowed") : a.removeClass(t, "pswp--zoom-allowed"), r();
                                        },
                                        r = function () {
                                            n && (a.removeClass(t, "pswp--dragging"), (n = !1));
                                        };
                                    Ae("resize", o),
                                        Ae("afterChange", o),
                                        Ae("pointerDown", function () {
                                            s.mouseZoomedIn && ((n = !0), a.addClass(t, "pswp--dragging"));
                                        }),
                                        Ae("pointerUp", r),
                                        e || o();
                                },
                                handleMouseWheel: function (e) {
                                    if (w <= s.currItem.fitRatio) return c.modal && (!c.closeOnScroll || Ke || G ? e.preventDefault() : q && Math.abs(e.deltaY) > 2 && ((h = !0), s.close())), !0;
                                    if ((e.stopPropagation(), (mi.x = 0), "deltaX" in e)) 1 === e.deltaMode ? ((mi.x = 18 * e.deltaX), (mi.y = 18 * e.deltaY)) : ((mi.x = e.deltaX), (mi.y = e.deltaY));
                                    else if ("wheelDelta" in e) e.wheelDeltaX && (mi.x = -0.16 * e.wheelDeltaX), e.wheelDeltaY ? (mi.y = -0.16 * e.wheelDeltaY) : (mi.y = -0.16 * e.wheelDelta);
                                    else {
                                        if (!("detail" in e)) return;
                                        mi.y = e.detail;
                                    }
                                    We(w, !0);
                                    var t = fe.x - mi.x,
                                        i = fe.y - mi.y;
                                    (c.modal || (t <= ne.min.x && t >= ne.max.x && i <= ne.min.y && i >= ne.max.y)) && e.preventDefault(), s.panTo(t, i);
                                },
                                toggleDesktopZoom: function (e) {
                                    e = e || { x: ve.x / 2 + ye.x, y: ve.y / 2 + ye.y };
                                    var i = c.getDoubleTapZoom(!0, s.currItem),
                                        n = w === i;
                                    (s.mouseZoomedIn = !n), s.zoomTo(n ? s.currItem.initialZoomLevel : i, e, 333), a[(n ? "remove" : "add") + "Class"](t, "pswp--zoomed-in");
                                },
                            },
                        });
                    var gi,
                        yi,
                        wi,
                        bi,
                        _i,
                        Ei,
                        Si,
                        ki,
                        xi,
                        Ci,
                        Li,
                        Ai,
                        Ti = { history: !0, galleryUID: 1 },
                        Ii = function () {
                            return Li.hash.substring(1);
                        },
                        qi = function () {
                            gi && clearTimeout(gi), wi && clearTimeout(wi);
                        },
                        Pi = function () {
                            var e = Ii(),
                                t = {};
                            if (e.length < 5) return t;
                            var i,
                                n = e.split("&");
                            for (i = 0; i < n.length; i++)
                                if (n[i]) {
                                    var o = n[i].split("=");
                                    o.length < 2 || (t[o[0]] = o[1]);
                                }
                            if (c.galleryPIDs) {
                                var a = t.pid;
                                for (t.pid = 0, i = 0; i < Zt.length; i++)
                                    if (Zt[i].pid === a) {
                                        t.pid = i;
                                        break;
                                    }
                            } else t.pid = parseInt(t.pid, 10) - 1;
                            return t.pid < 0 && (t.pid = 0), t;
                        },
                        Mi = function e() {
                            if ((wi && clearTimeout(wi), Ke || G)) wi = setTimeout(e, 500);
                            else {
                                bi ? clearTimeout(yi) : (bi = !0);
                                var t = p + 1,
                                    i = Kt(p);
                                i.hasOwnProperty("pid") && (t = i.pid);
                                var n = Si + "&gid=" + c.galleryUID + "&pid=" + t;
                                ki || (-1 === Li.hash.indexOf(n) && (Ci = !0));
                                var o = Li.href.split("#")[0] + "#" + n;
                                Ai ? "#" + n !== window.location.hash && history[ki ? "replaceState" : "pushState"]("", document.title, o) : ki ? Li.replace(o) : (Li.hash = n),
                                    (ki = !0),
                                    (yi = setTimeout(function () {
                                        bi = !1;
                                    }, 60));
                            }
                        };
                    xe("History", {
                        publicMethods: {
                            initHistory: function () {
                                if ((a.extend(c, Ti, !0), c.history)) {
                                    (Li = window.location),
                                        (Ci = !1),
                                        (xi = !1),
                                        (ki = !1),
                                        (Si = Ii()),
                                        (Ai = "pushState" in history),
                                        Si.indexOf("gid=") > -1 && (Si = (Si = Si.split("&gid=")[0]).split("?gid=")[0]),
                                        Ae("afterChange", s.updateURL),
                                        Ae("unbindEvents", function () {
                                            a.unbind(window, "hashchange", s.onHashChange);
                                        });
                                    var e = function () {
                                        (Ei = !0), xi || (Ci ? history.back() : Si ? (Li.hash = Si) : Ai ? history.pushState("", document.title, Li.pathname + Li.search) : (Li.hash = "")), qi();
                                    };
                                    Ae("unbindEvents", function () {
                                        h && e();
                                    }),
                                        Ae("destroy", function () {
                                            Ei || e();
                                        }),
                                        Ae("firstUpdate", function () {
                                            p = Pi().pid;
                                        });
                                    var t = Si.indexOf("pid=");
                                    t > -1 && "&" === (Si = Si.substring(0, t)).slice(-1) && (Si = Si.slice(0, -1)),
                                        setTimeout(function () {
                                            d && a.bind(window, "hashchange", s.onHashChange);
                                        }, 40);
                                }
                            },
                            onHashChange: function () {
                                if (Ii() === Si) return (xi = !0), void s.close();
                                bi || ((_i = !0), s.goTo(Pi().pid), (_i = !1));
                            },
                            updateURL: function () {
                                qi(), _i || (ki ? (gi = setTimeout(Mi, 800)) : Mi());
                            },
                        },
                    }),
                        a.extend(s, ot);
                }),
                n);
        });
    function se(t) {
        return (
            (se =
                "function" == typeof Symbol && "symbol" === e(Symbol.iterator)
                    ? function (t) {
                          return e(t);
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : e(t);
                      }),
            se(t)
        );
    }
    var re = "object" === ("undefined" == typeof HTMLElement ? "undefined" : se(HTMLElement));
    function le(e) {
        return re ? e instanceof HTMLElement : e && "object" === se(e) && null !== e && 1 === e.nodeType && "string" == typeof e.nodeName;
    }
    function ce(e, t) {
        t.forEach(function (t) {
            e.classList.add(t);
        });
    }
    function de(e, t) {
        t.forEach(function (t) {
            e.classList.remove(t);
        });
    }
    function ue() {
        throw new Error("Missing parameter");
    }
    function he(e, t) {
        for (var i = 0; i < t.length; i++) {
            var n = t[i];
            (n.enumerable = n.enumerable || !1), (n.configurable = !0), "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
    }
    var pe = (function () {
        function e(t) {
            !(function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            })(this, e),
                (this.isShowing = !1);
            var i = t.namespace,
                n = void 0 === i ? null : i,
                o = t.zoomFactor,
                a = void 0 === o ? ue() : o,
                s = t.containerEl,
                r = void 0 === s ? ue() : s;
            (this.settings = { namespace: n, zoomFactor: a, containerEl: r }), (this.openClasses = this._buildClasses("open")), this._buildElement();
        }
        var t, i, n;
        return (
            (t = e),
            (i = [
                {
                    key: "_buildClasses",
                    value: function (e) {
                        var t = ["drift-".concat(e)],
                            i = this.settings.namespace;
                        return i && t.push("".concat(i, "-").concat(e)), t;
                    },
                },
                {
                    key: "_buildElement",
                    value: function () {
                        (this.el = document.createElement("div")), ce(this.el, this._buildClasses("bounding-box"));
                    },
                },
                {
                    key: "show",
                    value: function (e, t) {
                        (this.isShowing = !0), this.settings.containerEl.appendChild(this.el);
                        var i = this.el.style;
                        (i.width = "".concat(Math.round(e / this.settings.zoomFactor), "px")), (i.height = "".concat(Math.round(t / this.settings.zoomFactor), "px")), ce(this.el, this.openClasses);
                    },
                },
                {
                    key: "hide",
                    value: function () {
                        this.isShowing && this.settings.containerEl.removeChild(this.el), (this.isShowing = !1), de(this.el, this.openClasses);
                    },
                },
                {
                    key: "setPosition",
                    value: function (e, t, i) {
                        var n = window.pageXOffset,
                            o = window.pageYOffset,
                            a = i.left + e * i.width - this.el.clientWidth / 2 + n,
                            s = i.top + t * i.height - this.el.clientHeight / 2 + o;
                        a < i.left + n ? (a = i.left + n) : a + this.el.clientWidth > i.left + i.width + n && (a = i.left + i.width - this.el.clientWidth + n),
                            s < i.top + o ? (s = i.top + o) : s + this.el.clientHeight > i.top + i.height + o && (s = i.top + i.height - this.el.clientHeight + o),
                            (this.el.style.left = "".concat(a, "px")),
                            (this.el.style.top = "".concat(s, "px"));
                    },
                },
            ]) && he(t.prototype, i),
            n && he(t, n),
            e
        );
    })();
    function me(e, t) {
        for (var i = 0; i < t.length; i++) {
            var n = t[i];
            (n.enumerable = n.enumerable || !1), (n.configurable = !0), "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
    }
    var fe = (function () {
        function e() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            !(function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            })(this, e),
                (this._show = this._show.bind(this)),
                (this._hide = this._hide.bind(this)),
                (this._handleEntry = this._handleEntry.bind(this)),
                (this._handleMovement = this._handleMovement.bind(this));
            var i = t.el,
                n = void 0 === i ? ue() : i,
                o = t.zoomPane,
                a = void 0 === o ? ue() : o,
                s = t.sourceAttribute,
                r = void 0 === s ? ue() : s,
                l = t.handleTouch,
                c = void 0 === l ? ue() : l,
                d = t.onShow,
                u = void 0 === d ? null : d,
                h = t.onHide,
                p = void 0 === h ? null : h,
                m = t.hoverDelay,
                f = void 0 === m ? 0 : m,
                v = t.touchDelay,
                g = void 0 === v ? 0 : v,
                y = t.hoverBoundingBox,
                w = void 0 === y ? ue() : y,
                b = t.touchBoundingBox,
                _ = void 0 === b ? ue() : b,
                E = t.namespace,
                S = void 0 === E ? null : E,
                k = t.zoomFactor,
                x = void 0 === k ? ue() : k,
                C = t.boundingBoxContainer,
                L = void 0 === C ? ue() : C;
            (this.settings = { el: n, zoomPane: a, sourceAttribute: r, handleTouch: c, onShow: u, onHide: p, hoverDelay: f, touchDelay: g, hoverBoundingBox: w, touchBoundingBox: _, namespace: S, zoomFactor: x, boundingBoxContainer: L }),
                (this.settings.hoverBoundingBox || this.settings.touchBoundingBox) &&
                    (this.boundingBox = new pe({ namespace: this.settings.namespace, zoomFactor: this.settings.zoomFactor, containerEl: this.settings.boundingBoxContainer })),
                (this.enabled = !0),
                this._bindEvents();
        }
        var t, i, n;
        return (
            (t = e),
            (i = [
                {
                    key: "_preventDefault",
                    value: function (e) {
                        e.preventDefault();
                    },
                },
                {
                    key: "_preventDefaultAllowTouchScroll",
                    value: function (e) {
                        (this.settings.touchDelay && this._isTouchEvent(e) && !this.isShowing) || e.preventDefault();
                    },
                },
                {
                    key: "_isTouchEvent",
                    value: function (e) {
                        return !!e.touches;
                    },
                },
                {
                    key: "_bindEvents",
                    value: function () {
                        this.settings.el.addEventListener("mouseenter", this._handleEntry, !1),
                            this.settings.el.addEventListener("mouseleave", this._hide, !1),
                            this.settings.el.addEventListener("mousemove", this._handleMovement, !1),
                            this.settings.handleTouch
                                ? (this.settings.el.addEventListener("touchstart", this._handleEntry, !1),
                                  this.settings.el.addEventListener("touchend", this._hide, !1),
                                  this.settings.el.addEventListener("touchmove", this._handleMovement, !1))
                                : (this.settings.el.addEventListener("touchstart", this._preventDefault, !1),
                                  this.settings.el.addEventListener("touchend", this._preventDefault, !1),
                                  this.settings.el.addEventListener("touchmove", this._preventDefault, !1));
                    },
                },
                {
                    key: "_unbindEvents",
                    value: function () {
                        this.settings.el.removeEventListener("mouseenter", this._handleEntry, !1),
                            this.settings.el.removeEventListener("mouseleave", this._hide, !1),
                            this.settings.el.removeEventListener("mousemove", this._handleMovement, !1),
                            this.settings.handleTouch
                                ? (this.settings.el.removeEventListener("touchstart", this._handleEntry, !1),
                                  this.settings.el.removeEventListener("touchend", this._hide, !1),
                                  this.settings.el.removeEventListener("touchmove", this._handleMovement, !1))
                                : (this.settings.el.removeEventListener("touchstart", this._preventDefault, !1),
                                  this.settings.el.removeEventListener("touchend", this._preventDefault, !1),
                                  this.settings.el.removeEventListener("touchmove", this._preventDefault, !1));
                    },
                },
                {
                    key: "_handleEntry",
                    value: function (e) {
                        this._preventDefaultAllowTouchScroll(e),
                            (this._lastMovement = e),
                            "mouseenter" == e.type && this.settings.hoverDelay
                                ? (this.entryTimeout = setTimeout(this._show, this.settings.hoverDelay))
                                : this.settings.touchDelay
                                ? (this.entryTimeout = setTimeout(this._show, this.settings.touchDelay))
                                : this._show();
                    },
                },
                {
                    key: "_show",
                    value: function () {
                        if (this.enabled) {
                            var e = this.settings.onShow;
                            if (
                                (e && "function" == typeof e && e(), this.settings.zoomPane.show(this.settings.el.getAttribute(this.settings.sourceAttribute), this.settings.el.clientWidth, this.settings.el.clientHeight), this._lastMovement)
                            ) {
                                var t = this._lastMovement.touches;
                                ((t && this.settings.touchBoundingBox) || (!t && this.settings.hoverBoundingBox)) && this.boundingBox.show(this.settings.zoomPane.el.clientWidth, this.settings.zoomPane.el.clientHeight);
                            }
                            this._handleMovement();
                        }
                    },
                },
                {
                    key: "_hide",
                    value: function (e) {
                        e && this._preventDefaultAllowTouchScroll(e), (this._lastMovement = null), this.entryTimeout && clearTimeout(this.entryTimeout), this.boundingBox && this.boundingBox.hide();
                        var t = this.settings.onHide;
                        t && "function" == typeof t && t(), this.settings.zoomPane.hide();
                    },
                },
                {
                    key: "_handleMovement",
                    value: function (e) {
                        if (e) this._preventDefaultAllowTouchScroll(e), (this._lastMovement = e);
                        else {
                            if (!this._lastMovement) return;
                            e = this._lastMovement;
                        }
                        var t, i;
                        if (e.touches) {
                            var n = e.touches[0];
                            (t = n.clientX), (i = n.clientY);
                        } else (t = e.clientX), (i = e.clientY);
                        var o = this.settings.el.getBoundingClientRect(),
                            a = t - o.left,
                            s = i - o.top,
                            r = a / this.settings.el.clientWidth,
                            l = s / this.settings.el.clientHeight;
                        this.boundingBox && this.boundingBox.setPosition(r, l, o), this.settings.zoomPane.setPosition(r, l, o);
                    },
                },
                {
                    key: "isShowing",
                    get: function () {
                        return this.settings.zoomPane.isShowing;
                    },
                },
            ]) && me(t.prototype, i),
            n && me(t, n),
            e
        );
    })();
    function ve(e, t) {
        for (var i = 0; i < t.length; i++) {
            var n = t[i];
            (n.enumerable = n.enumerable || !1), (n.configurable = !0), "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
    }
    var ge = document.createElement("div").style,
        ye = "undefined" != typeof document && ("animation" in ge || "webkitAnimation" in ge),
        we = (function () {
            function e() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                !(function (e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                })(this, e),
                    (this._completeShow = this._completeShow.bind(this)),
                    (this._completeHide = this._completeHide.bind(this)),
                    (this._handleLoad = this._handleLoad.bind(this)),
                    (this.isShowing = !1);
                var i = t.container,
                    n = void 0 === i ? null : i,
                    o = t.zoomFactor,
                    a = void 0 === o ? ue() : o,
                    s = t.inline,
                    r = void 0 === s ? ue() : s,
                    l = t.namespace,
                    c = void 0 === l ? null : l,
                    d = t.showWhitespaceAtEdges,
                    u = void 0 === d ? ue() : d,
                    h = t.containInline,
                    p = void 0 === h ? ue() : h,
                    m = t.inlineOffsetX,
                    f = void 0 === m ? 0 : m,
                    v = t.inlineOffsetY,
                    g = void 0 === v ? 0 : v,
                    y = t.inlineContainer,
                    w = void 0 === y ? document.body : y;
                (this.settings = { container: n, zoomFactor: a, inline: r, namespace: c, showWhitespaceAtEdges: u, containInline: p, inlineOffsetX: f, inlineOffsetY: g, inlineContainer: w }),
                    (this.openClasses = this._buildClasses("open")),
                    (this.openingClasses = this._buildClasses("opening")),
                    (this.closingClasses = this._buildClasses("closing")),
                    (this.inlineClasses = this._buildClasses("inline")),
                    (this.loadingClasses = this._buildClasses("loading")),
                    this._buildElement();
            }
            var t, i, n;
            return (
                (t = e),
                (i = [
                    {
                        key: "_buildClasses",
                        value: function (e) {
                            var t = ["drift-".concat(e)],
                                i = this.settings.namespace;
                            return i && t.push("".concat(i, "-").concat(e)), t;
                        },
                    },
                    {
                        key: "_buildElement",
                        value: function () {
                            (this.el = document.createElement("div")), ce(this.el, this._buildClasses("zoom-pane"));
                            var e = document.createElement("div");
                            ce(e, this._buildClasses("zoom-pane-loader")), this.el.appendChild(e), (this.imgEl = document.createElement("img")), this.el.appendChild(this.imgEl);
                        },
                    },
                    {
                        key: "_setImageURL",
                        value: function (e) {
                            this.imgEl.setAttribute("src", e);
                        },
                    },
                    {
                        key: "_setImageSize",
                        value: function (e, t) {
                            (this.imgEl.style.width = "".concat(e * this.settings.zoomFactor, "px")), (this.imgEl.style.height = "".concat(t * this.settings.zoomFactor, "px"));
                        },
                    },
                    {
                        key: "setPosition",
                        value: function (e, t, i) {
                            var n = this.imgEl.offsetWidth,
                                o = this.imgEl.offsetHeight,
                                a = this.el.offsetWidth,
                                s = this.el.offsetHeight,
                                r = a / 2 - n * e,
                                l = s / 2 - o * t,
                                c = a - n,
                                d = s - o,
                                u = c > 0,
                                h = d > 0,
                                p = u ? c / 2 : 0,
                                m = h ? d / 2 : 0,
                                f = u ? c / 2 : c,
                                v = h ? d / 2 : d;
                            if (this.el.parentElement === this.settings.inlineContainer) {
                                var g = window.pageXOffset,
                                    y = window.pageYOffset,
                                    w = i.left + e * i.width - a / 2 + this.settings.inlineOffsetX + g,
                                    b = i.top + t * i.height - s / 2 + this.settings.inlineOffsetY + y;
                                this.settings.containInline &&
                                    (w < i.left + g ? (w = i.left + g) : w + a > i.left + i.width + g && (w = i.left + i.width - a + g), b < i.top + y ? (b = i.top + y) : b + s > i.top + i.height + y && (b = i.top + i.height - s + y)),
                                    (this.el.style.left = "".concat(w, "px")),
                                    (this.el.style.top = "".concat(b, "px"));
                            }
                            this.settings.showWhitespaceAtEdges || (r > p ? (r = p) : r < f && (r = f), l > m ? (l = m) : l < v && (l = v)),
                                (this.imgEl.style.transform = "translate(".concat(r, "px, ").concat(l, "px)")),
                                (this.imgEl.style.webkitTransform = "translate(".concat(r, "px, ").concat(l, "px)"));
                        },
                    },
                    {
                        key: "_removeListenersAndResetClasses",
                        value: function () {
                            this.el.removeEventListener("animationend", this._completeShow, !1),
                                this.el.removeEventListener("animationend", this._completeHide, !1),
                                this.el.removeEventListener("webkitAnimationEnd", this._completeShow, !1),
                                this.el.removeEventListener("webkitAnimationEnd", this._completeHide, !1),
                                de(this.el, this.openClasses),
                                de(this.el, this.closingClasses);
                        },
                    },
                    {
                        key: "show",
                        value: function (e, t, i) {
                            this._removeListenersAndResetClasses(),
                                (this.isShowing = !0),
                                ce(this.el, this.openClasses),
                                this.imgEl.getAttribute("src") != e && (ce(this.el, this.loadingClasses), this.imgEl.addEventListener("load", this._handleLoad, !1), this._setImageURL(e)),
                                this._setImageSize(t, i),
                                this._isInline ? this._showInline() : this._showInContainer(),
                                ye && (this.el.addEventListener("animationend", this._completeShow, !1), this.el.addEventListener("webkitAnimationEnd", this._completeShow, !1), ce(this.el, this.openingClasses));
                        },
                    },
                    {
                        key: "_showInline",
                        value: function () {
                            this.settings.inlineContainer.appendChild(this.el), ce(this.el, this.inlineClasses);
                        },
                    },
                    {
                        key: "_showInContainer",
                        value: function () {
                            this.settings.container.appendChild(this.el);
                        },
                    },
                    {
                        key: "hide",
                        value: function () {
                            this._removeListenersAndResetClasses(),
                                (this.isShowing = !1),
                                ye
                                    ? (this.el.addEventListener("animationend", this._completeHide, !1), this.el.addEventListener("webkitAnimationEnd", this._completeHide, !1), ce(this.el, this.closingClasses))
                                    : (de(this.el, this.openClasses), de(this.el, this.inlineClasses));
                        },
                    },
                    {
                        key: "_completeShow",
                        value: function () {
                            this.el.removeEventListener("animationend", this._completeShow, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeShow, !1), de(this.el, this.openingClasses);
                        },
                    },
                    {
                        key: "_completeHide",
                        value: function () {
                            this.el.removeEventListener("animationend", this._completeHide, !1),
                                this.el.removeEventListener("webkitAnimationEnd", this._completeHide, !1),
                                de(this.el, this.openClasses),
                                de(this.el, this.closingClasses),
                                de(this.el, this.inlineClasses),
                                this.el.setAttribute("style", ""),
                                this.el.parentElement === this.settings.container
                                    ? this.settings.container.removeChild(this.el)
                                    : this.el.parentElement === this.settings.inlineContainer && this.settings.inlineContainer.removeChild(this.el);
                        },
                    },
                    {
                        key: "_handleLoad",
                        value: function () {
                            this.imgEl.removeEventListener("load", this._handleLoad, !1), de(this.el, this.loadingClasses);
                        },
                    },
                    {
                        key: "_isInline",
                        get: function () {
                            var e = this.settings.inline;
                            return !0 === e || ("number" == typeof e && window.innerWidth <= e);
                        },
                    },
                ]) && ve(t.prototype, i),
                n && ve(t, n),
                e
            );
        })();
    function be(e, t) {
        for (var i = 0; i < t.length; i++) {
            var n = t[i];
            (n.enumerable = n.enumerable || !1), (n.configurable = !0), "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
    }
    var _e = (function () {
        function e(t) {
            var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (
                ((function (e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                })(this, e),
                (this.VERSION = "1.4.0"),
                (this.triggerEl = t),
                (this.destroy = this.destroy.bind(this)),
                !le(this.triggerEl))
            )
                throw new TypeError("`new Drift` requires a DOM element as its first argument.");
            var n = i.namespace || null,
                o = i.showWhitespaceAtEdges || !1,
                a = i.containInline || !1,
                s = i.inlineOffsetX || 0,
                r = i.inlineOffsetY || 0,
                l = i.inlineContainer || document.body,
                c = i.sourceAttribute || "data-zoom",
                d = i.zoomFactor || 3,
                u = void 0 === i.paneContainer ? document.body : i.paneContainer,
                h = i.inlinePane || 375,
                p = !("handleTouch" in i) || !!i.handleTouch,
                m = i.onShow || null,
                f = i.onHide || null,
                v = !("injectBaseStyles" in i) || !!i.injectBaseStyles,
                g = i.hoverDelay || 0,
                y = i.touchDelay || 0,
                w = i.hoverBoundingBox || !1,
                b = i.touchBoundingBox || !1,
                _ = i.boundingBoxContainer || document.body;
            if (!0 !== h && !le(u)) throw new TypeError("`paneContainer` must be a DOM element when `inlinePane !== true`");
            if (!le(l)) throw new TypeError("`inlineContainer` must be a DOM element");
            (this.settings = {
                namespace: n,
                showWhitespaceAtEdges: o,
                containInline: a,
                inlineOffsetX: s,
                inlineOffsetY: r,
                inlineContainer: l,
                sourceAttribute: c,
                zoomFactor: d,
                paneContainer: u,
                inlinePane: h,
                handleTouch: p,
                onShow: m,
                onHide: f,
                injectBaseStyles: v,
                hoverDelay: g,
                touchDelay: y,
                hoverBoundingBox: w,
                touchBoundingBox: b,
                boundingBoxContainer: _,
            }),
                this.settings.injectBaseStyles &&
                    (function () {
                        if (!document.querySelector(".drift-base-styles")) {
                            var e = document.createElement("style");
                            (e.type = "text/css"),
                                e.classList.add("drift-base-styles"),
                                e.appendChild(
                                    document.createTextNode(
                                        ".drift-bounding-box,.drift-zoom-pane{position:absolute;pointer-events:none}@keyframes noop{0%{zoom:1}}@-webkit-keyframes noop{0%{zoom:1}}.drift-zoom-pane.drift-open{display:block}.drift-zoom-pane.drift-closing,.drift-zoom-pane.drift-opening{animation:noop 1ms;-webkit-animation:noop 1ms}.drift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.drift-zoom-pane-loader{display:none}.drift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}"
                                    )
                                );
                            var t = document.head;
                            t.insertBefore(e, t.firstChild);
                        }
                    })(),
                this._buildZoomPane(),
                this._buildTrigger();
        }
        var t, i, n;
        return (
            (t = e),
            (i = [
                {
                    key: "_buildZoomPane",
                    value: function () {
                        this.zoomPane = new we({
                            container: this.settings.paneContainer,
                            zoomFactor: this.settings.zoomFactor,
                            showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges,
                            containInline: this.settings.containInline,
                            inline: this.settings.inlinePane,
                            namespace: this.settings.namespace,
                            inlineOffsetX: this.settings.inlineOffsetX,
                            inlineOffsetY: this.settings.inlineOffsetY,
                            inlineContainer: this.settings.inlineContainer,
                        });
                    },
                },
                {
                    key: "_buildTrigger",
                    value: function () {
                        this.trigger = new fe({
                            el: this.triggerEl,
                            zoomPane: this.zoomPane,
                            handleTouch: this.settings.handleTouch,
                            onShow: this.settings.onShow,
                            onHide: this.settings.onHide,
                            sourceAttribute: this.settings.sourceAttribute,
                            hoverDelay: this.settings.hoverDelay,
                            touchDelay: this.settings.touchDelay,
                            hoverBoundingBox: this.settings.hoverBoundingBox,
                            touchBoundingBox: this.settings.touchBoundingBox,
                            namespace: this.settings.namespace,
                            zoomFactor: this.settings.zoomFactor,
                            boundingBoxContainer: this.settings.boundingBoxContainer,
                        });
                    },
                },
                {
                    key: "setZoomImageURL",
                    value: function (e) {
                        this.zoomPane._setImageURL(e);
                    },
                },
                {
                    key: "disable",
                    value: function () {
                        this.trigger.enabled = !1;
                    },
                },
                {
                    key: "enable",
                    value: function () {
                        this.trigger.enabled = !0;
                    },
                },
                {
                    key: "destroy",
                    value: function () {
                        this.trigger._hide(), this.trigger._unbindEvents();
                    },
                },
                {
                    key: "isShowing",
                    get: function () {
                        return this.zoomPane.isShowing;
                    },
                },
                {
                    key: "zoomFactor",
                    get: function () {
                        return this.settings.zoomFactor;
                    },
                    set: function (e) {
                        (this.settings.zoomFactor = e), (this.zoomPane.settings.zoomFactor = e), (this.trigger.settings.zoomFactor = e), (this.boundingBox.settings.zoomFactor = e);
                    },
                },
            ]) && be(t.prototype, i),
            n && be(t, n),
            e
        );
    })();
    Object.defineProperty(_e.prototype, "isShowing", {
        get: function () {
            return this.isShowing;
        },
    }),
        Object.defineProperty(_e.prototype, "zoomFactor", {
            get: function () {
                return this.zoomFactor;
            },
            set: function (e) {
                this.zoomFactor = e;
            },
        }),
        (_e.prototype.setZoomImageURL = _e.prototype.setZoomImageURL),
        (_e.prototype.disable = _e.prototype.disable),
        (_e.prototype.enable = _e.prototype.enable),
        (_e.prototype.destroy = _e.prototype.destroy);
    var Ee,
        Se,
        ke = (function () {
            function e(i, n) {
                t(this, e),
                    (this.element = i),
                    (this.delegateElement = new b(this.element)),
                    (this.viewInSpaceElement = this.element.querySelector("[data-shopify-xr]")),
                    (this.options = n),
                    (this.media = {}),
                    (this.previouslySelectedMedia = null),
                    this._createCarousel(),
                    this._createZoom(),
                    this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "destroy",
                        value: function () {
                            for (var e in (this.flickityInstance && this.flickityInstance.destroy(), this.media)) this.media.hasOwnProperty(e) && this.media[e].destroy();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            var e = this;
                            this.delegateElement.on("model:played", this._disableDrag.bind(this)),
                                this.delegateElement.on("video:played", this._disableDrag.bind(this)),
                                this.delegateElement.on("model:paused", this._enableDrag.bind(this)),
                                this.delegateElement.on("video:paused", this._enableDrag.bind(this)),
                                this.options.enableImageZoom &&
                                    (window.addEventListener("resize", this._handleZoomForMediaQuery.bind(this)),
                                    this.delegateElement.on("click", ".product-gallery__image", this._openMobileZoom.bind(this)),
                                    this.delegateElement.on("click", ".pswp__button", this._doPswpAction.bind(this)));
                            var t = window.innerWidth;
                            window.addEventListener("resize", function () {
                                window.innerWidth !== t && e.flickityInstance && (e.flickityInstance.resize(), (t = window.innerWidth));
                            });
                        },
                    },
                    {
                        key: "variantHasChanged",
                        value: function (e) {
                            var t = this,
                                i = !1;
                            M.mutate(function () {
                                (t.productGalleryCellsElements.forEach(function (n, o) {
                                    if (n.hasAttribute("data-group-name")) {
                                        var a = n.getAttribute("data-group-name");
                                        t.options.productOptions.forEach(function (i, s) {
                                            i.toLowerCase() === a &&
                                                (e["option".concat(s + 1)].toLowerCase() === n.getAttribute("data-group-value") || (e.featured_media && e.featured_media.id === parseInt(n.getAttribute("data-media-id")))
                                                    ? (n.classList.remove("is-filtered"), t.productThumbnailsCellsElements[o].classList.remove("is-filtered"))
                                                    : (n.classList.add("is-filtered"), t.productThumbnailsCellsElements[o].classList.add("is-filtered")));
                                        }),
                                            (i = !0);
                                    }
                                }),
                                i && (t.flickityInstance.deactivate(), t.flickityInstance.activate()),
                                S.matchesBreakpoint("lap-and-up")) &&
                                    t.element.querySelectorAll(".product-gallery__carousel-item").forEach(function (e) {
                                        e.classList.remove("product-gallery__carousel-item--hidden");
                                    });
                                t.flickityInstance && e && e.featured_media && t.flickityInstance.selectCell('[data-media-id="'.concat(e.featured_media.id, '"]'));
                            });
                        },
                    },
                    {
                        key: "_createCarousel",
                        value: function () {
                            var e = this;
                            if (
                                ((this.productGalleryElement = this.element.querySelector(".product-gallery__carousel")),
                                (this.productGalleryCellsElements = this.productGalleryElement ? this.productGalleryElement.querySelectorAll(".product-gallery__carousel-item") : []),
                                this.productGalleryElement &&
                                    (this.productGalleryCellsElements.forEach(function (t) {
                                        switch (t.getAttribute("data-media-type")) {
                                            case "external_video":
                                            case "video":
                                                e.media[t.getAttribute("data-media-id")] = new V(t, e.options.enableVideoLooping);
                                                break;
                                            case "model":
                                                e.media[t.getAttribute("data-media-id")] = new W(t);
                                        }
                                    }),
                                    parseInt(this.productGalleryElement.getAttribute("data-media-count")) > 1))
                            ) {
                                var t = [].slice.call(this.productGalleryCellsElements).filter(function (e) {
                                        return !e.classList.contains("is-filtered");
                                    }),
                                    i = 0;
                                t.forEach(function (t, n) {
                                    t.getAttribute("data-media-id") === e.productGalleryElement.getAttribute("data-initial-media-id") && (i = n);
                                });
                                var n = t[i];
                                n.classList.add("is-selected"),
                                    (this.productGalleryElement.style.height = "".concat(n.clientHeight, "px")),
                                    (this.flickityInstance = new oe(this.productGalleryElement, {
                                        accessibility: !1,
                                        prevNextButtons: !1,
                                        pageDots: !1,
                                        resize: !1,
                                        adaptiveHeight: !0,
                                        draggable: !S.matchesBreakpoint("supports-hover"),
                                        fade: "fade" === this.options.galleryTransitionEffect,
                                        cellSelector: ".product-gallery__carousel-item:not(.is-filtered)",
                                        initialIndex: i,
                                        on: {
                                            ready: function () {
                                                setTimeout(function () {
                                                    e.productGalleryElement.style.height = null;
                                                }, 1e3);
                                            },
                                        },
                                    }));
                            }
                            (this.productThumbnailsListElement = this.element.querySelector(".product-gallery__thumbnail-list")),
                                this.delegateElement.on("click", ".product-gallery__thumbnail", this._onThumbnailClicked.bind(this)),
                                this.productThumbnailsListElement &&
                                    this.flickityInstance &&
                                    ((this.productThumbnailsCellsElements = this.productThumbnailsListElement.querySelectorAll(".product-gallery__thumbnail")),
                                    this.flickityInstance.on("select", this._onGallerySlideChanged.bind(this)),
                                    "fade" === this.options.galleryTransitionEffect ? this.flickityInstance.on("select", this._onGallerySlideSettled.bind(this)) : this.flickityInstance.on("settle", this._onGallerySlideSettled.bind(this)),
                                    this._onGallerySlideChanged(!1),
                                    this._onGallerySlideSettled());
                        },
                    },
                    {
                        key: "_createZoom",
                        value: function () {
                            var e = this;
                            if (this.options.enableImageZoom && S.matchesBreakpoint("lap-and-up")) {
                                this.driftObjects = [];
                                var t = this.element.querySelector(".product__zoom-wrapper");
                                this.element.querySelectorAll(".product-gallery__image").forEach(function (i) {
                                    e.driftObjects.push(
                                        new _e(i, {
                                            containInline: "outside" === e.options.zoomEffect,
                                            inlinePane: window.innerWidth < 1024 || "outside" !== e.options.zoomEffect,
                                            hoverBoundingBox: "outside" === e.options.zoomEffect,
                                            handleTouch: !1,
                                            inlineOffsetY: window.innerWidth < 1024 ? -85 : 0,
                                            paneContainer: t,
                                        })
                                    );
                                });
                            }
                        },
                    },
                    {
                        key: "_openMobileZoom",
                        value: function () {
                            var e = this,
                                t = this.element.querySelector(".pswp");
                            if (t && S.matchesBreakpoint("pocket")) {
                                var i = this.element.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered)[data-media-type="image"]'),
                                    n = 0,
                                    o = [];
                                i.forEach(function (e, t) {
                                    var i = e.querySelector(".product-gallery__image");
                                    o.push({ src: i.getAttribute("data-zoom"), w: parseInt(i.getAttribute("data-zoom-width")), h: parseInt(i.getAttribute("data-zoom-width")) * (i.height / i.width), msrc: i.currentSrc }),
                                        e.classList.contains("is-selected") && (n = t);
                                }),
                                    (t.querySelector(".pswp__prev-next").style.display = o.length > 1 ? "flex" : "none"),
                                    (this.photoSwipeInstance = new ae(t, !1, o, {
                                        index: n,
                                        closeOnVerticalDrag: !1,
                                        closeOnScroll: !1,
                                        history: !1,
                                        showHideOpacity: !0,
                                        pinchToClose: !1,
                                        maxSpreadZoom: 1,
                                        showAnimationDuration: !1,
                                        allowPanToNext: !1,
                                    }));
                                var a = this.photoSwipeInstance.updateSize,
                                    s = null;
                                (this.photoSwipeInstance.updateSize = function () {
                                    (null !== s && s === window.innerWidth) || a(this, arguments), (s = window.innerWidth);
                                }),
                                    this.photoSwipeInstance.listen("destroy", function () {
                                        e.photoSwipeInstance = null;
                                    }),
                                    this.photoSwipeInstance.listen("beforeChange", function () {
                                        var t = e.element.querySelector(".pswp__pagination-current"),
                                            i = e.element.querySelector(".pswp__pagination-count");
                                        (t.textContent = e.photoSwipeInstance.getCurrentIndex() + 1), (i.textContent = e.photoSwipeInstance.options.getNumItemsFn());
                                    }),
                                    this.photoSwipeInstance.init();
                            }
                        },
                    },
                    {
                        key: "_doPswpAction",
                        value: function (e, t) {
                            this.photoSwipeInstance &&
                                (t.classList.contains("pswp__button--close")
                                    ? this.photoSwipeInstance.close()
                                    : t.classList.contains("pswp__button--arrow--left")
                                    ? this.photoSwipeInstance.prev()
                                    : t.classList.contains("pswp__button--arrow--right") && this.photoSwipeInstance.next());
                        },
                    },
                    {
                        key: "_handleZoomForMediaQuery",
                        value: function () {
                            S.matchesBreakpoint("lap-and-up") && this.photoSwipeInstance && (this.photoSwipeInstance.close(), (this.photoSwipeInstance = null));
                        },
                    },
                    {
                        key: "_onGallerySlideChanged",
                        value: function () {
                            var e = this,
                                t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
                                i = null,
                                n = null;
                            if (
                                (this.productThumbnailsCellsElements.forEach(function (t) {
                                    t.classList.contains("is-nav-selected") && (i = t), t.getAttribute("data-media-id") === e.flickityInstance.selectedElement.getAttribute("data-media-id") && (n = t);
                                }),
                                i && i.classList.remove("is-nav-selected"),
                                n && n.classList.add("is-nav-selected"),
                                S.matchesBreakpoint("pocket"))
                            ) {
                                var o = n.offsetLeft - (this.productThumbnailsListElement.parentNode.clientWidth - n.clientWidth) / 2;
                                this.productThumbnailsListElement.parentNode.scrollTo({ left: o, behavior: t ? "smooth" : "auto" });
                            } else {
                                var a = n.offsetTop - (this.productThumbnailsListElement.clientHeight - n.clientHeight) / 2;
                                this.productThumbnailsListElement.scrollTo({ top: a, behavior: t ? "smooth" : "auto" });
                            }
                        },
                    },
                    {
                        key: "_onGallerySlideSettled",
                        value: function () {
                            (this._handleMedia(this.flickityInstance.selectedElement), S.matchesBreakpoint("lap-and-up")) &&
                                this.element.querySelectorAll(".product-gallery__carousel-item:not(.is-selected)").forEach(function (e) {
                                    e.classList.add("product-gallery__carousel-item--hidden");
                                });
                        },
                    },
                    {
                        key: "_onThumbnailClicked",
                        value: function (e, t) {
                            (e.preventDefault(), this.flickityInstance) &&
                                (this.flickityInstance.selectCell('[data-media-id="'.concat(t.getAttribute("data-media-id"), '"]')),
                                S.matchesBreakpoint("lap-and-up") &&
                                    this.element.querySelectorAll(".product-gallery__carousel-item").forEach(function (e) {
                                        e.classList.remove("product-gallery__carousel-item--hidden");
                                    }));
                        },
                    },
                    {
                        key: "_disableDrag",
                        value: function () {
                            (this.flickityInstance.options.draggable = !1), this.flickityInstance.updateDraggable();
                        },
                    },
                    {
                        key: "_enableDrag",
                        value: function () {
                            (this.flickityInstance.options.draggable = !S.matchesBreakpoint("supports-hover")), this.flickityInstance.updateDraggable();
                        },
                    },
                    {
                        key: "_handleMedia",
                        value: function (e) {
                            var t = null === this.previouslySelectedMedia;
                            if (this.previouslySelectedMedia && this.previouslySelectedMedia !== e) {
                                switch (this.previouslySelectedMedia.getAttribute("data-media-type")) {
                                    case "video":
                                    case "external_video":
                                    case "model":
                                        this.media[this.previouslySelectedMedia.getAttribute("data-media-id")].hasBeenDeselected();
                                }
                                "model" === this.previouslySelectedMedia.getAttribute("data-media-type") &&
                                    this.viewInSpaceElement &&
                                    this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", this.viewInSpaceElement.getAttribute("data-shopify-model3d-default-id"));
                            }
                            switch (e.getAttribute("data-media-type")) {
                                case "video":
                                case "external_video":
                                case "model":
                                    this.media[e.getAttribute("data-media-id")].hasBeenSelected(t), this.element.querySelector(".product-gallery__carousel").classList.remove("product-gallery__carousel--zoomable");
                                    break;
                                case "image":
                                    this.element.querySelector(".product-gallery__carousel").classList.add("product-gallery__carousel--zoomable");
                            }
                            "model" === e.getAttribute("data-media-type") && this.viewInSpaceElement && this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", e.getAttribute("data-media-id")), (this.previouslySelectedMedia = e);
                        },
                    },
                ]),
                e
            );
        })(),
        xe = (function () {
            function e(i) {
                t(this, e), i && ((this.element = i), (this.inputElement = this.element.querySelector('[name="quantity"]')), (this.delegateElement = new b(this.element)), this._attachListeners());
            }
            return (
                n(e, [
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateElement.on("click", '[data-action="decrease-picker-quantity"]', this._onDecrease.bind(this)),
                                this.delegateElement.on("click", '[data-action="increase-picker-quantity"]', this._onIncrease.bind(this)),
                                this.delegateElement.on("keyup", this._onInputValueChanged.bind(this)),
                                this.delegateElement.on("focusout", this._onInputFocusOut.bind(this));
                        },
                    },
                    {
                        key: "_onDecrease",
                        value: function () {
                            this.inputElement.value = Math.max(1, parseInt(this.inputElement.value) - 1);
                        },
                    },
                    {
                        key: "_onIncrease",
                        value: function () {
                            this.inputElement.value = parseInt(this.inputElement.value) + 1;
                        },
                    },
                    {
                        key: "_onInputValueChanged",
                        value: function (e) {
                            var t = e.target.value;
                            "" !== t && isNaN(t) && (e.target.value = Math.max(1, parseInt(t) || 1));
                        },
                    },
                    {
                        key: "_onInputFocusOut",
                        value: function (e) {
                            e.target.value = Math.max(1, parseInt(e.target.value) || 1);
                        },
                    },
                ]),
                e
            );
        })(),
        Ce = (function () {
            function e(i, n) {
                t(this, e),
                    (this.element = i),
                    (this.delegateElement = new b(this.element)),
                    (this.options = n),
                    (this.countrySelector = new E(this.element.querySelector('[name="country"]'), this.element.querySelector('[name="province"]'))),
                    this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "destroy",
                        value: function () {
                            this.delegateElement.off("click"), this.countrySelector.destroy();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateElement.on("click", '[data-action="estimate-shipping"]', this._fetchRates.bind(this));
                        },
                    },
                    {
                        key: "_fetchRates",
                        value: function () {
                            document.dispatchEvent(new CustomEvent("theme:loading:start")), this.options.singleProduct ? this._fetchRatesForProduct() : this._fetchRatesForCart();
                        },
                    },
                    {
                        key: "_fetchRatesForCart",
                        value: function () {
                            var e = this,
                                t = this.element.querySelector('[name="country"]').value,
                                i = this.element.querySelector('[name="province"]').value,
                                n = this.element.querySelector('[name="zip"]').value;
                            fetch("".concat(window.routes.cartUrl, "/shipping_rates.json?shipping_address[zip]=").concat(n, "&shipping_address[country]=").concat(t, "&shipping_address[province]=").concat(i), {
                                credentials: "same-origin",
                                method: "GET",
                            }).then(function (t) {
                                document.dispatchEvent(new CustomEvent("theme:loading:end")),
                                    t.json().then(function (i) {
                                        e._formatResults(t.ok, i);
                                    });
                            });
                        },
                    },
                    {
                        key: "_fetchRatesForProduct",
                        value: function () {
                            var e = this,
                                t = this._getCookie("cart"),
                                i = "temp-cart-cookie___" + Date.now() + parseInt(1e3 * Math.random()),
                                n = "fake-cart-cookie___" + Date.now() + parseInt(1e3 * Math.random());
                            if ((t || (this._updateCartCookie(i), (t = this._getCookie("cart"))), !(t.length < 32))) {
                                this._updateCartCookie(n);
                                var o = document.querySelector('form[action*="/cart/add"]');
                                fetch("".concat(window.routes.cartAddUrl, ".js"), {
                                    body: JSON.stringify(F.serialize(o)),
                                    credentials: "same-origin",
                                    headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                                    method: "POST",
                                }).then(function (i) {
                                    i.json()
                                        .then(function () {
                                            var i = e.element.querySelector('[name="country"]').value,
                                                n = e.element.querySelector('[name="province"]').value,
                                                o = e.element.querySelector('[name="zip"]').value;
                                            fetch("".concat(window.routes.cartUrl, "/shipping_rates.json?shipping_address[zip]=").concat(o, "&shipping_address[country]=").concat(i, "&shipping_address[province]=").concat(n), {
                                                credentials: "same-origin",
                                                method: "GET",
                                            })
                                                .then(function (i) {
                                                    document.dispatchEvent(new CustomEvent("theme:loading:end")),
                                                        i.json().then(function (t) {
                                                            e._formatResults(i.ok, t);
                                                        }),
                                                        e._updateCartCookie(t);
                                                })
                                                .catch(function () {
                                                    e._updateCartCookie(t);
                                                });
                                        })
                                        .catch(function () {
                                            e._updateCartCookie(t), document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                        });
                                });
                            }
                        },
                    },
                    {
                        key: "_formatResults",
                        value: function (e, t) {
                            var i = this.element.querySelector(".shipping-estimator__results");
                            if (((i.innerHTML = ""), e)) {
                                var n = t.shipping_rates;
                                if (0 === n.length) i.innerHTML = "<p>".concat(window.languages.shippingEstimatorNoResults, "</p>");
                                else {
                                    1 === n.length
                                        ? (i.innerHTML = "<p>".concat(window.languages.shippingEstimatorOneResult, "</p>"))
                                        : (i.innerHTML = "<p>".concat(window.languages.shippingEstimatorMultipleResults.replace("{{count}}", n.length), "</p>"));
                                    var o = "";
                                    n.forEach(function (e) {
                                        o += "<li>".concat(e.name, ": ").concat(B.formatMoney(parseInt(100 * e.price), window.theme.moneyFormat), "</li>");
                                    }),
                                        (i.innerHTML += "<ul>".concat(o, "</ul>"));
                                }
                            } else {
                                i.innerHTML = "<p>".concat(window.languages.shippingEstimatorErrors, "</p>");
                                var a = "";
                                Object.keys(t).forEach(function (e) {
                                    a += '<li class="alert__list-item">'.concat(e, " ").concat(t[e], "</li>");
                                }),
                                    (i.innerHTML += "<ul>".concat(a, "</ul>"));
                            }
                            i.style.display = "block";
                        },
                    },
                    {
                        key: "_getCookie",
                        value: function (e) {
                            var t = "; ".concat(document.cookie).split("; " + e + "=");
                            if (2 === t.length) return t.pop().split(";").shift();
                        },
                    },
                    {
                        key: "_updateCartCookie",
                        value: function (e) {
                            var t = new Date();
                            t.setTime(t.getTime() + 12096e5), (document.cookie = "cart=".concat(e, "; expires=").concat(t.toUTCString(), "; path=/"));
                        },
                    },
                ]),
                e
            );
        })(),
        Le = (function () {
            function e(i) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                t(this, e),
                    (this.id = i),
                    (this.delegateRoot = new b(document.documentElement)),
                    (this.isOpen = !1),
                    (this.togglerElement = document.querySelector('[data-action="open-value-picker"][aria-controls="'.concat(this.id, '"]'))),
                    (this.onSelect = n.onValueSelect || function () {}),
                    this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "destroy",
                        value: function () {
                            this.delegateRoot.off();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateRoot.on("click", '[data-action="open-value-picker"][aria-controls="'.concat(this.id, '"]'), this._toggle.bind(this)),
                                this.delegateRoot.on("click", '[data-action="close-value-picker"][aria-controls="'.concat(this.id, '"]'), this._toggle.bind(this)),
                                this.delegateRoot.on("click", "#".concat(this.id, ' [data-action="select-value"]'), this._selectValue.bind(this)),
                                this.delegateRoot.on("click", this._detectOutsideClick.bind(this), !0),
                                this.delegateRoot.on("focusout", "#".concat(this.id), this._onFocusOut.bind(this));
                        },
                    },
                    {
                        key: "_toggle",
                        value: function (e) {
                            this.isOpen ? this._close(e) : this._open(e);
                        },
                    },
                    {
                        key: "_open",
                        value: function () {
                            (document.querySelector('[data-action="open-value-picker"][aria-controls="'.concat(this.id, '"]')).setAttribute("aria-expanded", "true"),
                            document.getElementById(this.id).setAttribute("aria-hidden", "false"),
                            S.matchesBreakpoint("phone")) && (document.querySelector(".shopify-section__header").style.zIndex = "3");
                            (this.isOpen = !0), document.body.classList.add("no-mobile-scroll");
                        },
                    },
                    {
                        key: "_close",
                        value: function () {
                            document.querySelector('[data-action="open-value-picker"][aria-controls="'.concat(this.id, '"]')).setAttribute("aria-expanded", "false"),
                                document.getElementById(this.id).setAttribute("aria-hidden", "true"),
                                (document.querySelector(".shopify-section__header").style.zIndex = ""),
                                (this.isOpen = !1),
                                document.body.classList.remove("no-mobile-scroll");
                        },
                    },
                    {
                        key: "_selectValue",
                        value: function (e, t) {
                            this.onSelect(t.getAttribute("data-value")), this._close();
                        },
                    },
                    {
                        key: "_onFocusOut",
                        value: function (e) {
                            document.getElementById(this.id).contains(e.relatedTarget) || this._close();
                        },
                    },
                    {
                        key: "_detectOutsideClick",
                        value: function (e) {
                            this.isOpen && this.togglerElement !== e.target && !this.togglerElement.contains(e.target) && !e.target.closest(".value-picker__inner") && this.isOpen && this._close(e);
                        },
                    },
                ]),
                e
            );
        })(),
        Ae = (function () {
            function e(i) {
                t(this, e),
                    (this.element = i),
                    (this.domDelegate = new b(this.element)),
                    this.element.querySelectorAll('[action*="/account/addresses"]').forEach(function (e) {
                        new E(e.querySelector('[name="address[country]"]'), e.querySelector('[name="address[province]"]'));
                    }),
                    (this.pageSelector = new Le("account-selector"));
            }
            return (
                n(e, [
                    {
                        key: "_onUnload",
                        value: function () {
                            this.pageSelector.destroy();
                        },
                    },
                ]),
                e
            );
        })(),
        Te = (function () {
            function e(i) {
                if ((t(this, e), (this.element = i), (this.domDelegate = new b(this.element)), (this.options = JSON.parse(this.element.getAttribute("data-section-settings"))), (this.isOpen = !1), this.options.showNewsletter)) {
                    let e = null == this.element.querySelector(".announcement-bar__button") ? "100%" : this.element.querySelector(".announcement-bar__button").clientWidth + "px";
                    document.documentElement.style.setProperty("--announcement-bar-button-width", e);
                } else document.documentElement.style.removeProperty("--announcement-bar-button-width");
                this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "onSelect",
                        value: function () {
                            this.options.showNewsletter && !this.isOpen && this._toggleNewsletter();
                        },
                    },
                    {
                        key: "onDeselect",
                        value: function () {
                            this.options.showNewsletter && this.isOpen && this._toggleNewsletter();
                        },
                    },
                    {
                        key: "onUnload",
                        value: function () {
                            this.domDelegate.off();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.domDelegate.on("click", '[data-action="toggle-newsletter"]', this._toggleNewsletter.bind(this)), this.domDelegate.on("keyup", this._handleKey.bind(this));
                        },
                    },
                    {
                        key: "_toggleNewsletter",
                        value: function () {
                            var e = this.element.querySelector(".announcement-bar__button"),
                                t = this.element.querySelector(".announcement-bar__newsletter");
                            "false" === e.getAttribute("aria-expanded")
                                ? (e.setAttribute("aria-expanded", "true"),
                                  t.setAttribute("aria-hidden", "false"),
                                  m.slideDown(t, function () {
                                      A.trapFocus(t, "announcement-bar");
                                  }))
                                : (e.setAttribute("aria-expanded", "false"), t.setAttribute("aria-hidden", "true"), m.slideUp(t), A.removeTrapFocus(t, "announcement-bar")),
                                (this.isOpen = !this.isOpen);
                        },
                    },
                    {
                        key: "_handleKey",
                        value: function (e) {
                            "Escape" === e.key && this.isOpen && this._toggleNewsletter();
                        },
                    },
                ]),
                e
            );
        })(),
        Ie = (function () {
            function e(i) {
                if ((t(this, e), (this.element = i), (this.blogTagSelector = new Le("blog-tag-selector")), Shopify.designMode)) {
                    var n = this.element.querySelector(".page__header");
                    n && (document.querySelector(".blog-container").previousElementSibling.remove(), document.querySelector(".blog-container").insertAdjacentElement("beforebegin", n));
                }
            }
            return (
                n(e, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.blogTagSelector.destroy();
                        },
                    },
                ]),
                e
            );
        })(),
        qe = function e(i) {
            if ((t(this, e), (this.element = i), Shopify.designMode)) {
                var n = this.element.querySelector(".page__header");
                n && (document.querySelector(".blog-container").previousElementSibling.remove(), document.querySelector(".blog-container").insertAdjacentElement("beforebegin", n));
            }
        },
        Pe = (function () {
            function e(i) {
                t(this, e), (this.element = i), "blog" === window.theme.pageType && this._fixItemsPerRow();
            }
            return (
                n(e, [
                    {
                        key: "_fixItemsPerRow",
                        value: function () {
                            0 === this.element.querySelectorAll(".blog-sidebar__item").length
                                ? (document.querySelector(".blog-container").classList.add("blog-container--without-sidebar"),
                                  document.querySelectorAll(".shopify-section__blog-posts .block-list__item").forEach(function (e) {
                                      e.classList.contains("1/2--lap-and-up") && (e.classList.remove("1/2--lap-and-up"), e.classList.add("1/3--lap-and-up"));
                                  }))
                                : (document.querySelector(".blog-container").classList.remove("blog-container--without-sidebar"),
                                  document.querySelectorAll(".shopify-section__blog-posts .block-list__item").forEach(function (e) {
                                      e.classList.contains("1/3--lap-and-up") && (e.classList.remove("1/3--lap-and-up"), e.classList.add("1/2--lap-and-up"));
                                  }));
                        },
                    },
                ]),
                e
            );
        })(),
        Me = (function () {
            function e(i) {
                var n = this;
                if (
                    (t(this, e),
                    (this.element = i),
                    (this.delegateElement = new b(this.element)),
                    (this.options = JSON.parse(this.element.getAttribute("data-section-settings"))),
                    (this.productGallery = new ke(this.element, this.options)),
                    (window.product_Gallery = window.product_Gallery || this.productGallery),
                    this._initShopifyReviews(),
                    this.options.isQuickView && this.options.showPaymentButton && window.Shopify.PaymentButton && Shopify.PaymentButton.init(),
                    (this.productVariants = new j(this.element, this.options)),
                    this.options.showShippingEstimator && (this.shippingEstimator = new Ce(this.element.querySelector(".shipping-estimator"), { singleProduct: !0 })),
                    this.options.showQuantitySelector)
                ) {
                    var o = this.element.querySelector(".quantity-selector--product");
                    o && (this.quantityPicker = new xe(o));
                }
                var a = this.element.querySelector(".product-block-list__item--info .card");
                a &&
                    ((this.element.querySelector(".product-block-list__wrapper").style.minHeight = "".concat(a.clientHeight, "px")),
                    window.ResizeObserver &&
                        ((this.productInfoResizeObserver = new ResizeObserver(function (e) {
                            e[0].contentBoxSize
                                ? (n.element.querySelector(".product-block-list__wrapper").style.minHeight = "".concat(e[0].contentBoxSize[0].blockSize, "px"))
                                : (n.element.querySelector(".product-block-list__wrapper").style.minHeight = "".concat(e[0].contentRect.height, "px"));
                        })),
                        this.productInfoResizeObserver.observe(a)),
                    this.options.infoOverflowScroll &&
                        (this.infoOverflowScroller = new z(a, {
                            offsetTop: document.documentElement.style.getPropertyValue("--header-is-sticky") * parseInt(document.documentElement.style.getPropertyValue("--header-height") + 30),
                            offsetBottom: 30,
                        }))),
                    this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.productVariants.destroy(),
                                this.productGallery.destroy(),
                                this.options.showShippingEstimator && this.shippingEstimator.destroy(),
                                this.options.infoOverflowScroll && this.infoOverflowScroller.destroy(),
                                window.ResizeObserver && this.productInfoResizeObserver && this.productInfoResizeObserver.disconnect(),
                                this.delegateElement.off(),
                                this.element.removeEventListener("variant:changed", this._onVariantChangedListener);
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._onVariantChangedListener = this._onVariantChanged.bind(this)), this.element.addEventListener("variant:changed", this._onVariantChangedListener);
                        },
                    },
                    {
                        key: "_initShopifyReviews",
                        value: function () {
                            var e = this;
                            Shopify.designMode && window.SPR && (window.SPR.initDomEls(), window.SPR.loadProducts()),
                                (window.SPRCallbacks = {}),
                                (window.SPRCallbacks.onFormSuccess = function () {
                                    e.element.querySelector("#shopify-product-reviews .spr-form").classList.add("spr-form-submitted");
                                }),
                                this.options.isQuickView && this.options.showPaymentButton && window.Shopify.PaymentButton && Shopify.PaymentButton.init();
                        },
                    },
                    {
                        key: "_onVariantChanged",
                        value: function (e) {
                            this.productGallery.variantHasChanged(e.detail.variant);
                        },
                    },
                ]),
                e
            );
        })(),
        ze = (function () {
            function e(i) {
                t(this, e),
                    (this.element = i),
                    (this.domDelegate = new b(this.element)),
                    (this.delegateRoot = new b(document.documentElement)),
                    (this.options = JSON.parse(this.element.getAttribute("data-section-settings"))),
                    this.options.showShippingEstimator && (this.shippingEstimator = new Ce(this.element.querySelector(".shipping-estimator"), { singleProduct: !1 })),
                    this._attachListeners(),
                    this._enforceMinimumHeight();
            }
            return (
                n(e, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.options.showShippingEstimator && this.shippingEstimator.destroy();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.domDelegate.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)),
                                this.domDelegate.on("click", '[data-action="save-note"]', this._saveNote.bind(this)),
                                this.domDelegate.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this)),
                                this.delegateRoot.on("cart:rerendered", this._onCartRerendered.bind(this));
                        },
                    },
                    {
                        key: "_saveNote",
                        value: function () {
                            var e = this.element.querySelector('[name="note"]').value;
                            fetch("".concat(window.routes.cartUrl, "/update.js"), {
                                body: JSON.stringify({ note: e }),
                                credentials: "same-origin",
                                method: "POST",
                                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                            }),
                                this.element.querySelector(".cart-recap__note-edit").classList.toggle("is-visible", "" !== e),
                                document.dispatchEvent(new CustomEvent("collapsible:toggle", { detail: { id: "order-note" } }));
                        },
                    },
                    {
                        key: "_addToCart",
                        value: function (e, t) {
                            var i = this;
                            if ("page" !== window.theme.cartType) {
                                e.preventDefault(), e.stopPropagation(), t.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                                var n = t.closest('form[action*="/cart/add"]');
                                fetch("".concat(window.routes.cartAddUrl, ".js"), {
                                    body: JSON.stringify(F.serialize(n)),
                                    credentials: "same-origin",
                                    method: "POST",
                                    headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                                }).then(function (e) {
                                    e.ok
                                        ? (t.removeAttribute("disabled"), i.element.dispatchEvent(new CustomEvent("product:added", { bubbles: !0, detail: { variant: null, quantity: parseInt(n.querySelector('[name="quantity"]').value) } })))
                                        : t.removeAttribute("disabled");
                                }),
                                    e.preventDefault();
                            }
                        },
                    },
                    {
                        key: "_openQuickView",
                        value: function (e, t) {
                            var i = document.getElementById(t.getAttribute("aria-controls"));
                            i.classList.add("is-loading"),
                                fetch("".concat(t.getAttribute("data-product-url"), "?view=quick-view"), { credentials: "same-origin", method: "GET" }).then(function (e) {
                                    e.text().then(function (e) {
                                        (i.querySelector(".modal__inner").innerHTML = e), i.classList.remove("is-loading");
                                        var t = new Me(i.querySelector('[data-section-type="product"]'));
                                        i.addEventListener("modal:closed", function e() {
                                            t.onUnload(), i.removeEventListener("modal:closed", e);
                                        });
                                    });
                                });
                        },
                    },
                    {
                        key: "_enforceMinimumHeight",
                        value: function () {
                            var e = this.element.querySelector(".cart-wrapper"),
                                t = this.element.querySelector(".cart-recap__scroller");
                            e &&
                                t &&
                                ((e.style.minHeight = "".concat(t.clientHeight, "px")),
                                window.ResizeObserver &&
                                    new ResizeObserver(function (t) {
                                        var i,
                                            n = u(t);
                                        try {
                                            for (n.s(); !(i = n.n()).done; ) {
                                                var o = i.value;
                                                e.style.minHeight = "".concat(parseInt(o.contentRect.height), "px");
                                            }
                                        } catch (e) {
                                            n.e(e);
                                        } finally {
                                            n.f();
                                        }
                                    }).observe(t));
                        },
                    },
                    {
                        key: "_onCartRerendered",
                        value: function () {
                            this.options.showShippingEstimator && (this.shippingEstimator.destroy(), (this.shippingEstimator = new Ce(this.element.querySelector(".shipping-estimator"), { singleProduct: !1 }))), this._enforceMinimumHeight();
                        },
                    },
                ]),
                e
            );
        })(),
        De = (function () {
            function e(i) {
                var n = this;
                t(this, e), (this.element = i);
                var o = this.element.querySelector(".collection-list");
                this.flickityInstance = new ne(o, {
                    watchCSS: !0,
                    prevNextButtons: !0,
                    draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches,
                    pageDots: !1,
                    resize: !1,
                    cellAlign: o.childElementCount < 6 ? "center" : "left",
                    contain: !0,
                    groupCells: window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches,
                    accessibility: !0,
                });
                var a = window.innerWidth;
                window.addEventListener("resize", function () {
                    window.innerWidth !== a && (n.flickityInstance.resize(), (a = window.innerWidth));
                });
            }
            return (
                n(e, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.flickityInstance.destroy();
                        },
                    },
                    {
                        key: "onBlockSelect",
                        value: function (e) {
                            this.flickityInstance.isActive && this.flickityInstance.selectCell(parseInt(e.target.getAttribute("data-collection-index")), null, e.detail.load);
                        },
                    },
                ]),
                e
            );
        })(),
        Oe = (function () {
            return (
                n(De, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.flickityInstance.destroy();
                        },
                    },
                    {
                        key: "onBlockSelect",
                        value: function (e) {
                            this.flickityInstance.isActive && this.flickityInstance.selectCell(parseInt(e.target.getAttribute("data-collection-index")), null, e.detail.load);
                        },
                    },
                ]),
                De
            );
        })(),
        Be = (function () {
            function e(i) {
                var n = this;
                t(this, e),
                    (this.element = i),
                    (this.delegateElement = new b(this.element)),
                    (this.options = JSON.parse(this.element.getAttribute("data-section-settings"))),
                    (this.collectionFilterTagElements = this.element.querySelectorAll("[data-tag]")),
                    (this.currentTags = this.options.currentTags),
                    (this.currentUrl = new URL(window.location.href)),
                    (this.mobileFilterDrawer = new x(this.options)),
                    (this.displayByValuePicker = new Le("display-by-selector", { onValueSelect: this._showingCountChanged.bind(this) })),
                    (this.sortByValuePicker = new Le("sort-by-selector", { onValueSelect: this._sortByChanged.bind(this) })),
                    (this.productItemColorSwatch = new O(this.element)),
                    "search" === window.theme.pageType && "product" !== window.theme.searchMode && this._loadContentResults(),
                    window.addEventListener("popstate", function () {
                        (n.currentUrl = new URL(window.location.href)), n._reload(!1);
                    }),
                    this._initSlidersubCat(),
                    this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.delegateElement.off(), this.mobileFilterDrawer.destroy(), this.displayByValuePicker.destroy(), this.sortByValuePicker.destroy(), this.productItemColorSwatch.destroy();
                        },
                    },
                    {
                        key: "onSelect",
                        value: function (e) {
                            Shopify.designMode &&
                                e.detail.load &&
                                (this.element.querySelector('.collection__layout-button[data-layout-mode="'.concat(this.options.defaultLayout, '"]')).click(), this._showingCountChanged(this.options.defaultProductsPerPage));
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateElement.on("click", '[data-action="change-layout"]', this._changeLayout.bind(this)),
                                this.delegateElement.on("change", "#mobile-sort-by, #desktop-sort-by", this._sortByChanged.bind(this)),
                                this.delegateElement.on("change", "#showing-count", this._showingCountChanged.bind(this)),
                                this.delegateElement.on("click", ".pagination [data-page]", this._paginationPageChanged.bind(this)),
                                this.delegateElement.on("click", '[data-action="toggle-tag"]', this._tagToggled.bind(this)),
                                this.delegateElement.on("click", '[data-action="clear-tags"]', this._clearTags.bind(this)),
                                this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this)),
                                this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)),
                                this.delegateElement.on("change", '[name^="filter."]', this._onFilterChanged.bind(this)),
                                this.delegateElement.on("click", '[data-action="clear-filters"]', this._onFiltersCleared.bind(this));
                        },
                    },
                    {
                        key: "_openQuickView",
                        value: function (e, t) {
                            var i = new URL("".concat(window.location.origin).concat(t.getAttribute("data-product-url")));
                            if (S.matchesBreakpoint("phone") || S.matchesBreakpoint("tablet")) return (window.location.href = i.href), !1;
                            var n = document.getElementById(t.getAttribute("aria-controls"));
                            n.classList.add("is-loading"),
                                i.searchParams.set("view", "quick-view"),
                                fetch(i.href, { credentials: "same-origin", method: "GET" }).then(function (e) {
                                    e.text().then(function (e) {
                                        (n.querySelector(".modal__inner").innerHTML = e), n.classList.remove("is-loading");
                                        var t = new Me(n.querySelector('[data-section-type="product"]'));
                                        n.addEventListener("modal:closed", function e() {
                                            t.onUnload(), n.removeEventListener("modal:closed", e);
                                        });
                                    });
                                });
                        },
                    },
                    {
                        key: "_initSlidersubCat",
                        value: function () {
                            var e = this;
                            e.flickityInstance = new ne(e.element.querySelector(".sub-col-list"), { pageDots: !1, prevNextButtons: !0, contain: !0, resize: !1, groupCells: !0, cellAlign: "left", draggable: !0 });
                            var t = window.innerWidth;
                            window.addEventListener("resize", function () {
                                window.innerWidth !== t && (e.flickityInstance.resize(), (t = window.innerWidth));
                            });
                        },
                    },
                    {
                        key: "_changeLayout",
                        value: function (e, t) {
                            var i = this;
                            if (!t.classList.contains("is-selected")) {
                                var n = t.getAttribute("data-layout-mode");
                                fetch("".concat(window.routes.cartUrl, "/update.js"), {
                                    body: JSON.stringify({ attributes: { collection_layout: n } }),
                                    credentials: "same-origin",
                                    method: "POST",
                                    headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                                }),
                                    M.mutate(function () {
                                        f.getSiblings(t, ".is-selected").forEach(function (e) {
                                            return e.classList.remove("is-selected");
                                        }),
                                            t.classList.add("is-selected"),
                                            i.element.querySelectorAll(".product-item").forEach(function (e) {
                                                e.className = "grid" === n ? "product-item product-item--vertical ".concat(i.options.gridClasses) : "product-item product-item--list";
                                            }),
                                            i.productItemColorSwatch.recalculateSwatches();
                                    });
                            }
                        },
                    },
                    {
                        key: "_sortByChanged",
                        value: function (e) {
                            this.currentUrl.searchParams.set("sort_by", e), this.currentUrl.searchParams.delete("page"), this._reload(!0);
                        },
                    },
                    {
                        key: "_showingCountChanged",
                        value: function (e) {
                            var t = this;
                            this.currentUrl.searchParams.delete("page"),
                                fetch("".concat(window.routes.cartUrl, "/update.js"), {
                                    body: JSON.stringify({ attributes: { collection_products_per_page: e } }),
                                    credentials: "same-origin",
                                    method: "POST",
                                    headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                                }).then(function () {
                                    t._reload(!0);
                                });
                        },
                    },
                    {
                        key: "_paginationPageChanged",
                        value: function (e, t) {
                            e.preventDefault(), this.currentUrl.searchParams.set("page", parseInt(t.getAttribute("data-page"))), this._reload(!0);
                        },
                    },
                    {
                        key: "_tagToggled",
                        value: function (e, t) {
                            var i = this,
                                n = t.getAttribute("data-tag"),
                                o = this.currentTags.length > 0;
                            if (this.currentTags.includes(n))
                                this.currentTags = this.currentTags.filter(function (e) {
                                    return e !== n;
                                });
                            else if ("tag" === this.options.filterType) this.currentTags = [n];
                            else {
                                var a = n.split("_")[0];
                                this.currentTags.forEach(function (e) {
                                    e.split("_")[0] === a &&
                                        (i.currentTags = i.currentTags.filter(function (t) {
                                            return t !== e;
                                        }));
                                }),
                                    this.currentTags.push(n);
                            }
                            this.currentUrl.searchParams.delete("page"), this._updateTagUrl(o), this._reload(!0);
                        },
                    },
                    {
                        key: "_clearTags",
                        value: function () {
                            var e = this.currentTags.length > 0;
                            (this.currentTags = []),
                                this.currentUrl.searchParams.delete("page"),
                                this._updateTagUrl(e),
                                this._reload(!0).then(function () {
                                    document.dispatchEvent(new CustomEvent("collection-filter:close"));
                                });
                        },
                    },
                    {
                        key: "_updateTagUrl",
                        value: function (e) {
                            var t = this;
                            if (
                                (M.mutate(function () {
                                    t.collectionFilterTagElements.forEach(function (e) {
                                        t.currentTags.includes(e.getAttribute("data-tag"))
                                            ? (e.classList.add("is-selected"), "INPUT" === e.tagName && (e.checked = !0))
                                            : (e.classList.remove("is-selected"), "INPUT" === e.tagName && (e.checked = !1));
                                    });
                                }),
                                this.options.isAutomatic)
                            )
                                0 === this.currentTags.length ? this.currentUrl.searchParams.delete("constraint") : this.currentUrl.searchParams.set("constraint", this.currentTags.join("+"));
                            else {
                                var i = this.currentTags.join("+"),
                                    n = "/" === this.currentUrl.pathname.substr(-1) ? this.currentUrl.pathname.substr(0, this.currentUrl.pathname.length - 1) : this.currentUrl.pathname;
                                if (e) {
                                    var o = n.split("/");
                                    o.pop(), (this.currentUrl.pathname = "".concat(o.join("/"), "/").concat(i));
                                } else this.currentUrl.pathname = "".concat(n, "/").concat(i);
                            }
                        },
                    },
                    {
                        key: "_onFilterChanged",
                        value: function (e, t) {
                            var i = new FormData(t.closest("form")),
                                n = new URLSearchParams(i).toString();
                            (this.currentUrl = new URL("".concat(window.location.pathname, "?").concat(n), window.location.origin)), this._reload(!0);
                        },
                    },
                    {
                        key: "_onFiltersCleared",
                        value: function (e, t) {
                            (this.currentUrl = new URL(t.getAttribute("data-url"), window.location.origin)), this._reload(!0);
                        },
                    },
                    {
                        key: "_reload",
                        value: function (e) {
                            var t = this;
                            this.abortController && this.abortController.abort(),
                                e && window.history.pushState({ path: this.currentUrl.toString() }, "", this.currentUrl.toString()),
                                document.dispatchEvent(new CustomEvent("theme:loading:start"));
                            var i = window.getComputedStyle(document.documentElement),
                                n = "";
                            n = this.currentUrl.search
                                ? "".concat(this.currentUrl.pathname, "/").concat(this.currentUrl.search, "&section_id=").concat(this.element.getAttribute("data-section-id"))
                                : "".concat(this.currentUrl.pathname, "?section_id=").concat(this.element.getAttribute("data-section-id"));
                            try {
                                return (
                                    (this.abortController = new AbortController()),
                                    fetch(n, { credentials: "same-origin", method: "GET", signal: this.abortController.signal }).then(function (e) {
                                        e.text().then(function (e) {
                                            var n = document.createElement("div");
                                            (n.innerHTML = e),
                                                (t.element.querySelector(".collection__dynamic-part").innerHTML = n.querySelector(".collection__dynamic-part").innerHTML),
                                                (t.element.querySelector(".collection__title").innerHTML = n.querySelector(".collection__title").innerHTML),
                                                (document.title = n.getElementsByClassName("new_title")[0].value);
                                            const o = t.element.querySelectorAll(".collection__dynamic-part .product-item-new");
                                            "null" != typeof o &&
                                                o.forEach((e) => {
                                                    new Ke(e);
                                                });
                                            var a = t.element.querySelector(".collection__active-filters");
                                            a && (a.innerHTML = n.querySelector(".collection__active-filters").innerHTML), h();
                                            var s = t.element.querySelector("#desktop-filters-form"),
                                                r = t.element.querySelector("#mobile-collection-filters"),
                                                l = 0;
                                            r && (l = r.querySelector(".collection-drawer__inner").scrollTop),
                                                s &&
                                                    (Array.from(t.element.querySelectorAll(".collection__filter-group-name[aria-controls]")).forEach(function (e) {
                                                        var t = n.querySelector('[aria-controls="'.concat(e.getAttribute("aria-controls"), '"]'));
                                                        "true" === e.getAttribute("aria-expanded")
                                                            ? (t.setAttribute("aria-expanded", "true"),
                                                              t.nextElementSibling.setAttribute("aria-hidden", "false"),
                                                              (t.nextElementSibling.style.height = "auto"),
                                                              (t.nextElementSibling.style.overflow = "visible"))
                                                            : (t.setAttribute("aria-expanded", "false"), t.nextElementSibling.setAttribute("aria-hidden", "true"), (t.nextElementSibling.style = ""));
                                                    }),
                                                    (s.innerHTML = n.querySelector("#desktop-filters-form").innerHTML),
                                                    (r.innerHTML = n.querySelector("#mobile-collection-filters").innerHTML),
                                                    (r.querySelector(".collection-drawer__inner").scrollTop = l),
                                                    t.mobileFilterDrawer._computeDrawerHeight()),
                                                t.productItemColorSwatch.recalculateSwatches();
                                            var c = t.element.querySelector(".collection").getBoundingClientRect().top - 25 - parseInt(i.getPropertyValue("--header-is-sticky")) * parseInt(i.getPropertyValue("--header-height"));
                                            c < 0 && window.scrollBy({ top: c, behavior: "smooth" });
                                            if (null !== n.querySelector("[data-collection-products-count]")) {
                                                var d = JSON.parse(n.querySelector("[data-collection-products-count]").innerHTML),
                                                    u = t.element.querySelector(".collection__products-count-showing");
                                                u && (u.innerHTML = d.showingCount), (t.element.querySelector(".collection__products-count-total").innerHTML = d.productsCount);
                                            }
                                            document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                        });
                                    })
                                );
                            } catch (e) {}
                        },
                    },
                    {
                        key: "_loadContentResults",
                        value: function () {
                            var e = this,
                                t = new URL(window.location.href);
                            fetch("".concat(window.routes.searchUrl, "?section_id=search-content&q=").concat(t.searchParams.get("q"), "&type=").concat(window.theme.searchMode.replace("product,", "")), { credentials: "same-origin" }).then(
                                function (t) {
                                    t.text().then(function (t) {
                                        var i = e.element.querySelector(".link-search-results"),
                                            n = document.createElement("div");
                                        (n.innerHTML = t), i && "" !== t.trim() && ((i.innerHTML = n.firstElementChild.innerHTML), (i.style.display = "block"));
                                    });
                                }
                            );
                        },
                    },
                    {
                        key: "_addToCart",
                        value: function (e, t) {
                            var i = this;
                            if ("page" !== window.theme.cartType) {
                                e.preventDefault(), e.stopPropagation(), t.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                                var n = t.closest('form[action*="/cart/add"]'),
                                    o = n.querySelector('*[name="id"]'),
                                    a = n.querySelector('input[name="quantity"]'),
                                    s = a.size > 0 ? a.value : 1;
                                window.dataLayer.push({
                                    event: "ee_add_to_cart",
                                    name: n.querySelector(".ptitle").value,
                                    id: n.querySelector(".pid").value,
                                    price: n.querySelector(".pprice").value,
                                    brand: n.querySelector(".pbrand").value,
                                    product_type: n.querySelector(".ptype").value,
                                    category: n.querySelector(".pcollection").value,
                                    quantity: s,
                                    variant: o.value,
                                    g_product_id: "shopify_US_" + n.querySelector(".pid").value + "_" + o.value,
                                }),
                                    fetch("".concat(window.routes.cartAddUrl, ".js"), {
                                        body: JSON.stringify(F.serialize(n)),
                                        credentials: "same-origin",
                                        method: "POST",
                                        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                                    }).then(function (e) {
                                        t.removeAttribute("disabled"),
                                            e.ok
                                                ? $.getJSON("/cart.js", function (e) {
                                                      var o = e.total_price,
                                                          a = e.items,
                                                          s = $(document).find("#minimum-order-fee").data("price"),
                                                          r = $(document).find("#minimum-order-fee").data("required-price"),
                                                          l = $(document).find("#minimum-order-fee").data("variant-id"),
                                                          c = !1;
                                                      $.each(a, function (e, t) {
                                                          t.id === l && (c = !0);
                                                      }),
                                                          r > o
                                                              ? 1 != c && a.length > 0
                                                                  ? $.ajax({
                                                                        type: "POST",
                                                                        url: "/cart/add.js",
                                                                        data: { quantity: 1, id: l },
                                                                        dataType: "json",
                                                                        success: function (e) {
                                                                            i.element.dispatchEvent(
                                                                                new CustomEvent("product:added", { bubbles: !0, detail: { button: t, variant: null, quantity: parseInt(n.querySelector('[name="quantity"]').value) + 1 } })
                                                                            );
                                                                        },
                                                                    })
                                                                  : 1 == a.length && r > o
                                                                  ? $.ajax({
                                                                        type: "POST",
                                                                        url: "/cart/change.js",
                                                                        data: { quantity: 0, id: l },
                                                                        dataType: "json",
                                                                        success: function (e) {
                                                                            i.element.dispatchEvent(
                                                                                new CustomEvent("product:added", { bubbles: !0, detail: { button: t, variant: null, quantity: parseInt(n.querySelector('[name="quantity"]').value) - 1 } })
                                                                            );
                                                                        },
                                                                    })
                                                                  : i.element.dispatchEvent(
                                                                        new CustomEvent("product:added", { bubbles: !0, detail: { button: t, variant: null, quantity: parseInt(n.querySelector('[name="quantity"]').value) } })
                                                                    )
                                                              : c && o - s > r
                                                              ? $.ajax({
                                                                    type: "POST",
                                                                    url: "/cart/change.js",
                                                                    data: { quantity: 0, id: l },
                                                                    dataType: "json",
                                                                    success: function (e) {
                                                                        i.element.dispatchEvent(
                                                                            new CustomEvent("product:added", { bubbles: !0, detail: { button: t, variant: null, quantity: parseInt(n.querySelector('[name="quantity"]').value) - 1 } })
                                                                        );
                                                                    },
                                                                })
                                                              : i.element.dispatchEvent(
                                                                    new CustomEvent("product:added", { bubbles: !0, detail: { button: t, variant: null, quantity: parseInt(n.querySelector('[name="quantity"]').value) } })
                                                                );
                                                  })
                                                : document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                    }),
                                    e.preventDefault();
                            }
                        },
                    },
                ]),
                e
            );
        })(),
        He = (function () {
            function e(i) {
                var n = this;
                if ((t(this, e), (this.element = i), (this.delegateElement = new b(this.element)), (this.options = JSON.parse(this.element.getAttribute("data-section-settings"))), !this.options.stackable)) {
                    this.flickityInstance = new ne(this.element.querySelector(".product-list"), {
                        watchCSS: !0,
                        pageDots: !1,
                        prevNextButtons: !0,
                        contain: !0,
                        resize: !1,
                        groupCells: !0,
                        cellAlign: "left",
                        draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches,
                    });
                    var o = window.innerWidth;
                    window.addEventListener("resize", function () {
                        window.innerWidth !== o && (n.flickityInstance.resize(), (o = window.innerWidth));
                    });
                }
                (this.productItemColorSwatch = new O(this.element)), this._fixSafari(), this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.options.stackable || this.flickityInstance.destroy(),
                                window.removeEventListener("resize", this._fixSafariListener),
                                this.delegateElement.off("change"),
                                this.productItemColorSwatch.destroy(),
                                this.resizeObserver && this.resizeObserver.disconnect();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            var e = this;
                            (this._fixSafariListener = this._fixSafari.bind(this)),
                                window.addEventListener("resize", this._fixSafariListener),
                                this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)),
                                this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this)),
                                window.ResizeObserver &&
                                    this.flickityInstance &&
                                    ((this.resizeObserver = new ResizeObserver(function () {
                                        e.flickityInstance.resize();
                                    })),
                                    this.element.querySelectorAll(".product-item").forEach(function (t) {
                                        e.resizeObserver.observe(t);
                                    }));
                        },
                    },
                    {
                        key: "_fixSafari",
                        value: function () {
                            var e = window.navigator.userAgent.toLowerCase();
                            if (e.includes("safari") && (e.includes("version/10.1") || e.includes("version/10.3") || e.includes("version/11.0"))) {
                                var t = S.matchesBreakpoint("phone");
                                this.element.querySelectorAll(".product-item__image-wrapper .aspect-ratio, .product-item__image-wrapper .placeholder-svg").forEach(function (e) {
                                    e.parentNode.style.height = t ? null : "".concat(e.clientHeight, "px");
                                });
                            }
                        },
                    },
                    {
                        key: "_openQuickView",
                        value: function (e, t) {
                            var i = new URL("".concat(window.location.origin).concat(t.getAttribute("data-product-url")));
                            if (S.matchesBreakpoint("phone") || S.matchesBreakpoint("tablet")) return (window.location.href = i.href), !1;
                            var n = document.getElementById(t.getAttribute("aria-controls"));
                            n.classList.add("is-loading"),
                                i.searchParams.set("view", "quick-view"),
                                fetch(i.href, { credentials: "same-origin", method: "GET" }).then(function (e) {
                                    e.text().then(function (e) {
                                        (n.querySelector(".modal__inner").innerHTML = e), n.classList.remove("is-loading");
                                        var t = new Me(n.querySelector('[data-section-type="product"]'));
                                        n.addEventListener("modal:closed", function e() {
                                            t.onUnload(), n.removeEventListener("modal:closed", e);
                                        });
                                    });
                                });
                        },
                    },
                    {
                        key: "_addToCart",
                        value: function (e, t) {
                            var i = this;
                            if ("page" !== window.theme.cartType) {
                                e.preventDefault(), e.stopPropagation(), t.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                                var n = t.closest('form[action*="/cart/add"]');
                                fetch("".concat(window.routes.cartAddUrl, ".js"), {
                                    body: JSON.stringify(F.serialize(n)),
                                    credentials: "same-origin",
                                    method: "POST",
                                    headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                                }).then(function (e) {
                                    t.removeAttribute("disabled"),
                                        e.ok
                                            ? i.element.dispatchEvent(new CustomEvent("product:added", { bubbles: !0, detail: { button: t, variant: null, quantity: parseInt(n.querySelector('[name="quantity"]').value) } }))
                                            : document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                }),
                                    e.preventDefault();
                            }
                        },
                    },
                ]),
                e
            );
        })(),
        Ne = (function () {
            function e(i) {
                t(this, e), (this.element = i), (this.delegateElement = new b(this.element)), this._createQrCode(), this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.delegateElement.off();
                        },
                    },
                    {
                        key: "_createQrCode",
                        value: function () {
                            document.querySelectorAll(".gift-card__qr").forEach(function (e) {
                                new QRCode(e, { text: e.getAttribute("data-identifier"), width: 200, height: 200 });
                            });
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateElement.on("click", '[data-action="print"]', this._print.bind(this)), this.delegateElement.on("click", '[data-action="select-code"]', this._selectCode.bind(this));
                        },
                    },
                    {
                        key: "_print",
                        value: function () {
                            window.print();
                        },
                    },
                    {
                        key: "_selectCode",
                        value: function (e, t) {
                            t.select();
                        },
                    },
                ]),
                e
            );
        })(),
        Re = (function () {
            function e(i) {
                t(this, e),
                    (this.element = i),
                    (this.domDelegate = new b(this.element)),
                    (this.localeValuePicker = new Le("footer-locale-picker")),
                    (this.currencyValuePicker = new Le("footer-currency-picker")),
                    (this.cookieBarElement = this.element.querySelector(".cookie-bar")),
                    this.cookieBarElement && window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1", onLoad: this._setupCookieBar.bind(this) }]),
                    this._setupCollapsibles(),
                    this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "onUnload",
                        value: function () {
                            window.removeEventListener("resize", this._setupCollapsiblesListener), this.domDelegate.off(), this.localeValuePicker.destroy(), this.currencyValuePicker.destroy();
                        },
                    },
                    {
                        key: "onSelect",
                        value: function () {
                            this.cookieBarElement && this.cookieBarElement.setAttribute("aria-hidden", "false");
                        },
                    },
                    {
                        key: "onDeselect",
                        value: function () {
                            this.cookieBarElement && this.cookieBarElement.setAttribute("aria-hidden", "true");
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._setupCollapsiblesListener = this._setupCollapsibles.bind(this)),
                                window.addEventListener("resize", this._setupCollapsiblesListener),
                                this.domDelegate.on("click", '[data-action="accept-terms"]', this._acceptCookieBarTerms.bind(this)),
                                this.domDelegate.on("click", '[data-action="decline-terms"]', this._declineCookieBarTerms.bind(this));
                        },
                    },
                    {
                        key: "_setupCollapsibles",
                        value: function () {
                            var e = this.element.querySelectorAll('[data-action="toggle-collapsible"]'),
                                t = S.matchesBreakpoint("phone");
                            e.forEach(function (e) {
                                t ? e.removeAttribute("disabled") : (e.setAttribute("disabled", "disabled"), (document.getElementById(e.getAttribute("aria-controls")).style.height = ""));
                            });
                        },
                    },
                    {
                        key: "_setupCookieBar",
                        value: function () {
                            try {
                                window.Shopify.customerPrivacy.shouldShowGDPRBanner() && this.cookieBarElement.setAttribute("aria-hidden", "false");
                            } catch (e) {}
                        },
                    },
                    {
                        key: "_acceptCookieBarTerms",
                        value: function () {
                            var e = this;
                            window.Shopify.customerPrivacy.setTrackingConsent(!0, function () {
                                return e.cookieBarElement.setAttribute("aria-hidden", "true");
                            });
                        },
                    },
                    {
                        key: "_declineCookieBarTerms",
                        value: function () {
                            var e = this;
                            window.Shopify.customerPrivacy.setTrackingConsent(!1, function () {
                                return e.cookieBarElement.setAttribute("aria-hidden", "true");
                            });
                        },
                    },
                ]),
                e
            );
        })(),
        Fe = (function () {
            function e(i) {
                t(this, e),
                    (this.element = i),
                    (this.delegateElement = new b(this.element)),
                    (this.headerElement = this.element.closest(".header")),
                    (this.searchBarElement = this.element.querySelector(".search-bar")),
                    (this.inputElement = this.element.querySelector('[name="q"]')),
                    (this.searchMenuElement = this.element.querySelector(".search-bar__menu-wrapper")),
                    (this.searchResultsElement = this.element.querySelector(".search-bar__results")),
                    (this.closeButtonElement = this.element.querySelector(".search-bar__close-button")),
                    (this.productTypeFilter = ""),
                    (this.isSearchOpen = !1),
                    this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "destroy",
                        value: function () {
                            this.delegateElement.off();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateElement.on("click", '[data-action="clear-input"]', this._clearInput.bind(this)),
                                this.delegateElement.on("click", '[data-action="unfix-search"]', this._unfixMobileSearch.bind(this)),
                                this.delegateElement.on("focusin", '[name="q"]', this._onInputFocus.bind(this)),
                                document.addEventListener("click", this._onFocusOut.bind(this)),
                                this.delegateElement.on("keydown", '[name="q"]', this._handleTab.bind(this)),
                                this.delegateElement.on("input", '[name="q"]', this._debounce(this._doSearch.bind(this), 250)),
                                this.delegateElement.on("change", "#search-product-type", this._productTypeChanged.bind(this)),
                                this.delegateElement.on("submit", this._onFormSubmit.bind(this));
                        },
                    },
                    {
                        key: "toggleMobileSearch",
                        value: function () {
                            this.isSearchOpen
                                ? (this.headerElement.classList.remove("header--search-expanded"), this.element.classList.remove("is-visible"))
                                : (this.headerElement.classList.add("header--search-expanded"), this.element.classList.add("is-visible")),
                                (this.isSearchOpen = !this.isSearchOpen);
                        },
                    },
                    {
                        key: "_unfixMobileSearch",
                        value: function () {
                            this.element.classList.remove("is-fixed"),
                                (this.closeButtonElement.style.width = ""),
                                this.searchBarElement.classList.remove("is-expanded"),
                                this.searchResultsElement.setAttribute("aria-hidden", "true"),
                                this.inputElement.classList.remove("is-filled"),
                                document.body.classList.remove("no-mobile-scroll"),
                                this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "true");
                        },
                    },
                    {
                        key: "_clearInput",
                        value: function () {
                            (this.inputElement.value = ""),
                                this.inputElement.classList.remove("is-filled"),
                                this.searchResultsElement.setAttribute("aria-hidden", "true"),
                                this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "false");
                        },
                    },
                    {
                        key: "_onInputFocus",
                        value: function () {
                            this.element.classList.add("is-fixed"),
                                document.body.classList.add("no-mobile-scroll"),
                                "" === this.inputElement.value
                                    ? (this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "false"), this.searchResultsElement.setAttribute("aria-hidden", "true"))
                                    : (this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "true"),
                                      this.searchResultsElement.setAttribute("aria-hidden", "false"),
                                      this.inputElement.classList.add("is-filled"),
                                      this.searchBarElement.classList.add("is-expanded")),
                                this.searchMenuElement && this.searchBarElement.classList.add("is-expanded");
                        },
                    },
                    {
                        key: "_onFocusOut",
                        value: function (e) {
                            var t = this;
                            S.matchesBreakpoint("phone") ||
                                S.matchesBreakpoint("phone") ||
                                e.target.classList.contains("search-bar__input") ||
                                e.target.closest(".search-bar__inner") ||
                                setTimeout(function () {
                                    t.element.classList.remove("is-fixed"),
                                        document.body.classList.remove("no-mobile-scroll"),
                                        t.element.contains(e.relatedTarget) ||
                                            (t.searchMenuElement && t.searchMenuElement.setAttribute("aria-hidden", "true"), t.searchResultsElement.setAttribute("aria-hidden", "true"), t.searchBarElement.classList.remove("is-expanded"));
                                }, 150);
                        },
                    },
                    {
                        key: "_handleTab",
                        value: function (e) {
                            if ("Tab" === e.key) {
                                var t = this.searchResultsElement.querySelector("a");
                                t && (t.focus(), e.preventDefault());
                            }
                        },
                    },
                    {
                        key: "_doSearch",
                        value: function () {
                            var e = this,
                                t = this.inputElement.value;
                            if (((this.lastInputValue = t), "" === t))
                                this.searchMenuElement ? this.searchMenuElement.setAttribute("aria-hidden", "false") : this.searchBarElement.classList.remove("is-expanded"), this.searchResultsElement.setAttribute("aria-hidden", "true");
                            else {
                                this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "true"),
                                    this.searchResultsElement.setAttribute("aria-hidden", "false"),
                                    this.searchBarElement.classList.add("is-expanded", "is-loading");
                                var i = { method: "GET", credentials: "same-origin" },
                                    n = "".concat("" !== this.productTypeFilter ? "product_type:".concat(this.productTypeFilter, " AND ") : "").concat(encodeURIComponent(this.lastInputValue)),
                                    o = [
                                        fetch(
                                            "".concat(window.routes.searchUrl, "?section_id=search-ajax&q=").concat(n, "&options[prefix]=last&options[unavailable_products]=").concat(window.theme.searchUnavailableProducts, "&type=product"),
                                            i
                                        ),
                                    ];
                                "product" !== window.theme.searchMode &&
                                    o.push(
                                        fetch(
                                            ""
                                                .concat(window.routes.searchUrl, "?section_id=search-ajax&q=")
                                                .concat(encodeURIComponent(this.lastInputValue), "&options[prefix]=last&type=")
                                                .concat(window.theme.searchMode.replace("product,", "")),
                                            i
                                        )
                                    ),
                                    Promise.all(o).then(function (i) {
                                        e.lastInputValue === t &&
                                            Promise.all(
                                                i.map(function (e) {
                                                    return e.text().then(function (e) {
                                                        var t = document.createElement("div");
                                                        return (t.innerHTML = e), t.querySelector(".search-ajax").innerHTML;
                                                    });
                                                })
                                            ).then(function (t) {
                                                e.searchBarElement.classList.remove("is-loading");
                                                var i = document.createElement("div");
                                                i.innerHTML = t.join("").trim();
                                                var n = i.querySelector(".search-bar__view-all");
                                                n && i.insertAdjacentElement("beforeend", n),
                                                    (e.searchBarElement.querySelector(".search-bar__results-inner").innerHTML = i.innerHTML),
                                                    window.dispatchEvent(new CustomEvent("theme:search:done"));
                                            });
                                    });
                            }
                        },
                    },
                    {
                        key: "_productTypeChanged",
                        value: function (e, t) {
                            (t.closest(".search-bar__filter").querySelector(".search-bar__filter-active").innerText = t.options[t.selectedIndex].innerText),
                                (this.productTypeFilter = t.value),
                                "" !== this.inputElement.value && this._doSearch();
                        },
                    },
                    {
                        key: "_onFormSubmit",
                        value: function (e) {
                            var t = this.inputElement.cloneNode();
                            t.setAttribute("type", "hidden"),
                                (t.value = ""),
                                "" !== this.productTypeFilter && ((t.value += "product_type:".concat(this.productTypeFilter)), "" !== this.inputElement.value && (t.value += " AND ")),
                                (t.value += this.inputElement.value),
                                this.inputElement.removeAttribute("name"),
                                this.inputElement.insertAdjacentElement("afterend", t);
                        },
                    },
                    {
                        key: "_debounce",
                        value: function (e, t) {
                            var i = this,
                                n = null;
                            return function () {
                                for (var o = arguments.length, a = new Array(o), s = 0; s < o; s++) a[s] = arguments[s];
                                clearTimeout(n),
                                    (n = setTimeout(function () {
                                        e.apply(i, a);
                                    }, t));
                            };
                        },
                    },
                ]),
                e
            );
        })(),
        Ue = (function () {
            function e(i) {
                t(this, e),
                    (this.element = i),
                    (this.delegateElement = new b(this.element)),
                    (this.options = JSON.parse(this.element.getAttribute("data-section-settings"))),
                    (this.searchBar = new Fe(this.element.querySelector(".header__search-bar-wrapper"))),
                    (this.cart = new T(this.element.querySelector(".header__action-item--cart"), { useStickyHeader: this.options.useStickyHeader }));
                var n = this.element.querySelector("inline" === this.options.navigationLayout ? ".nav-bar" : ".header__desktop-nav");
                n && (this.desktopNavigation = new k(n, this.options.navigationLayout, this.options.desktopOpenTrigger));
                var o = this.element.querySelector(".header__mobile-nav");
                o && (this.mobileNavigation = new I(o)), this._setupCssVariables(), this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.searchBar.destroy(),
                                this.cart.destroy(),
                                this.desktopNavigation && this.desktopNavigation.destroy(),
                                this.mobileNavigation && this.mobileNavigation.destroy(),
                                window.removeEventListener("resize", this._setupCssVariablesListener);
                        },
                    },
                    {
                        key: "onBlockSelect",
                        value: function (e) {
                            this.desktopNavigation && this.desktopNavigation.onBlockSelect(e);
                        },
                    },
                    {
                        key: "onBlockDeselect",
                        value: function (e) {
                            this.desktopNavigation && this.desktopNavigation.onBlockDeselect(e);
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._setupCssVariablesListener = this._setupCssVariables.bind(this)),
                                window.addEventListener("resize", this._setupCssVariablesListener),
                                this.delegateElement.on("click", '[data-action="toggle-search"]', this._toggleMobileSearch.bind(this));
                        },
                    },
                    {
                        key: "_setupCssVariables",
                        value: function () {
                            document.documentElement.style.setProperty("--header-height", this.element.parentNode.clientHeight + "px");
                        },
                    },
                    {
                        key: "_toggleMobileSearch",
                        value: function (e) {
                            this.searchBar.toggleMobileSearch(), e.preventDefault();
                        },
                    },
                ]),
                e
            );
        })(),
        je = (function () {
            function e(i) {
                t(this, e),
                    (this.element = i),
                    (this.domDelegate = new b(this.element)),
                    (this.customerLoginForm = this.element.querySelector("#customer_login")),
                    (this.recoverPasswordForm = this.element.querySelector("#recover_customer_password")),
                    this.domDelegate.on("click", '[data-action="toggle-login-form"]', this._showRecoverPassword.bind(this));
            }
            return (
                n(e, [
                    {
                        key: "_showRecoverPassword",
                        value: function () {
                            "block" === this.customerLoginForm.style.display
                                ? ((this.customerLoginForm.style.display = "none"), (this.recoverPasswordForm.style.display = "block"))
                                : ((this.customerLoginForm.style.display = "block"), (this.recoverPasswordForm.style.display = "none"));
                        },
                    },
                ]),
                e
            );
        })(),
        We = (function () {
            function e(i) {
                t(this, e),
                    (this.element = i),
                    (this.delegateElement = new b(this.element)),
                    (this.options = JSON.parse(i.getAttribute("data-section-settings"))),
                    (this.mapPositions = []),
                    (this.desktopMarkers = []),
                    (this.desktopMapElement = null),
                    (this.mobileMarkers = []),
                    (this.mobileMapElements = []),
                    this.options.apiKey && this.options.mapAddresses.length > 0 && this._loadScript().then(this._initMaps.bind(this)),
                    this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.delegateElement.off("click"), this.options.apiKey && this.options.mapAddresses.length > 0 && google.maps.event.clearInstanceListeners(window);
                        },
                    },
                    {
                        key: "onBlockSelect",
                        value: function (e) {
                            this._showStore(e.target);
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            var e = this;
                            this.delegateElement.on("click", '[data-action="toggle-store"]', function (t, i) {
                                e._showStore(i.closest(".map__store-item"));
                            });
                        },
                    },
                    {
                        key: "_showStore",
                        value: function (e) {
                            var t = this,
                                i = e.querySelector('[data-action="toggle-store"]');
                            if ("phone" === S.getCurrentBreakpoint() || "true" !== i.getAttribute("aria-expanded")) {
                                "true" === i.getAttribute("aria-expanded")
                                    ? (i.setAttribute("aria-expanded", "false"), m.slideUp(e.querySelector(".map__store-collapsible")))
                                    : (i.setAttribute("aria-expanded", "true"), m.slideDown(e.querySelector(".map__store-collapsible"))),
                                    f.getSiblings(e).forEach(function (e) {
                                        e.querySelector('[data-action="toggle-store"]').setAttribute("aria-expanded", "false"), m.slideUp(e.querySelector(".map__store-collapsible"));
                                    });
                                var n = parseInt(e.getAttribute("data-store-index"));
                                this.desktopMapElement.panTo(this.mapPositions[n]),
                                    this.desktopMarkers.forEach(function (e, i) {
                                        e.setMap(t.desktopMapElement), (e.icon.fillColor = i === n ? t.options.markerActiveColor : t.options.markerColor);
                                    });
                            }
                        },
                    },
                    {
                        key: "_loadScript",
                        value: function () {
                            var e = this;
                            return new Promise(function (t, i) {
                                var n = document.createElement("script");
                                document.body.appendChild(n), (n.onload = t), (n.onerror = i), (n.async = !0), (n.src = "https://maps.googleapis.com/maps/api/js?key=".concat(e.options.apiKey));
                            });
                        },
                    },
                    {
                        key: "_initMaps",
                        value: function () {
                            var e = this,
                                t = {
                                    zoom: this.options.zoom,
                                    draggable: this.options.draggableMap,
                                    clickableIcons: !1,
                                    scrollwheel: this.options.draggableMap,
                                    disableDoubleClickZoom: !0,
                                    disableDefaultUI: !this.options.showMapControls,
                                    styles: JSON.parse(this.element.querySelector("[data-gmap-style]").innerHTML),
                                };
                            (this.desktopMapElement = new google.maps.Map(this.element.querySelector(".map__map-container--desktop .map__gmap"), t)),
                                (this.mobileMapElements = []),
                                this.element.querySelectorAll(".map__map-container--mobile .map__gmap").forEach(function (i, n) {
                                    e.mobileMapElements[n] = new google.maps.Map(i, t);
                                }),
                                this._geocodeAddresses(),
                                google.maps.event.addDomListener(window, "resize", function () {
                                    var t = e.desktopMapElement.getCenter();
                                    google.maps.event.trigger(e.desktopMapElement, "resize"),
                                        e.desktopMapElement.setCenter(t),
                                        e.mobileMapElements.forEach(function (e) {
                                            var t = e.getCenter();
                                            google.maps.event.trigger(e, "resize"), e.setCenter(t);
                                        });
                                });
                        },
                    },
                    {
                        key: "_onMarkerClicked",
                        value: function (e) {
                            window.open("https://www.google.com/maps/search/?api=1&query=".concat(e), "_blank");
                        },
                    },
                    {
                        key: "_geocodeAddresses",
                        value: function () {
                            var e = this,
                                t = new google.maps.Geocoder();
                            this.options.mapAddresses.forEach(function (i, n) {
                                t.geocode({ address: i }, function (t, o) {
                                    if (o !== google.maps.GeocoderStatus.OK) Shopify.designMode;
                                    else {
                                        var a = t[0].geometry.location;
                                        (e.mapPositions[n] = a),
                                            (e.desktopMarkers[n] = new google.maps.Marker({
                                                map: 0 === n ? e.desktopMapElement : null,
                                                position: a,
                                                icon: {
                                                    path:
                                                        "M12.5,0 C6.388889,0 0,4.7304348 0,12.5217391 C0,19.8956522 11.111111,31.1652174 11.527778,31.5826087 C11.805556,31.8608696 12.083333,32 12.5,32 C12.916667,32 13.194444,31.8608696 13.472222,31.5826087 C13.888889,31.1652174 25,19.8956522 25,12.5217391 C25,4.7304348 18.611111,0 12.5,0 Z M12,16 C9.733333,16 8,14.2666667 8,12 C8,9.7333333 9.733333,8 12,8 C14.266667,8 16,9.7333333 16,12 C16,14.2666667 14.266667,16 12,16 Z",
                                                    fillColor: 0 === n ? e.options.markerActiveColor : e.options.markerColor,
                                                    fillOpacity: 1,
                                                    anchor: new google.maps.Point(12, 30),
                                                    strokeWeight: 0,
                                                },
                                            })),
                                            (e.mobileMarkers[n] = new google.maps.Marker({
                                                map: e.mobileMapElements[n],
                                                position: a,
                                                icon: {
                                                    path:
                                                        "M12.5,0 C6.388889,0 0,4.7304348 0,12.5217391 C0,19.8956522 11.111111,31.1652174 11.527778,31.5826087 C11.805556,31.8608696 12.083333,32 12.5,32 C12.916667,32 13.194444,31.8608696 13.472222,31.5826087 C13.888889,31.1652174 25,19.8956522 25,12.5217391 C25,4.7304348 18.611111,0 12.5,0 Z M12,16 C9.733333,16 8,14.2666667 8,12 C8,9.7333333 9.733333,8 12,8 C14.266667,8 16,9.7333333 16,12 C16,14.2666667 14.266667,16 12,16 Z",
                                                    fillColor: e.options.markerActiveColor,
                                                    fillOpacity: 1,
                                                    anchor: new google.maps.Point(12, 30),
                                                    strokeWeight: 0,
                                                },
                                            })),
                                            e.desktopMarkers[n].addListener("click", e._onMarkerClicked.bind(e, i)),
                                            e.mobileMarkers[n].addListener("click", e._onMarkerClicked.bind(e, i)),
                                            0 === n && e.desktopMapElement.setCenter(a),
                                            e.mobileMapElements[n].setCenter(a);
                                    }
                                });
                            });
                        },
                    },
                ]),
                e
            );
        })(),
        Ve = (function () {
            function e(i) {
                t(this, e), (this.element = i), this._setupCssVariables(), this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "onUnload",
                        value: function () {
                            window.removeEventListener("resize", this._setupCssVariablesListener);
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._setupCssVariablesListener = this._setupCssVariables.bind(this)), window.addEventListener("resize", this._setupCssVariablesListener);
                        },
                    },
                    {
                        key: "_setupCssVariables",
                        value: function () {
                            document.documentElement.style.setProperty("--header-height", this.element.parentNode.clientHeight + "px");
                        },
                    },
                ]),
                e
            );
        })(),
        $e = function e(i) {
            t(this, e), (this.element = i), Shopify.designMode && this.element.classList.remove("hidden-lap-and-up");
        },
        Xe = (function () {
            function e(i) {
                var n = this;
                t(this, e),
                    i.querySelectorAll("[data-popup-type]").forEach(function (e) {
                        "exit" === e.getAttribute("data-popup-type") ? (n.exitPopup = new C(e)) : "newsletter" === e.getAttribute("data-popup-type") && (n.newsletterPopup = new P(e));
                    });
            }
            return (
                n(e, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.exitPopup && this.exitPopup.destroy(), this.newsletterPopup && this.newsletterPopup.destroy();
                        },
                    },
                    {
                        key: "onBlockSelect",
                        value: function (e) {
                            "exit" === e.target.getAttribute("data-popup-type") && this.exitPopup
                                ? this.exitPopup._openPopup()
                                : "newsletter" === e.target.getAttribute("data-popup-type") && this.newsletterPopup && this.newsletterPopup._openPopup();
                        },
                    },
                    {
                        key: "onBlockDeselect",
                        value: function () {
                            this.exitPopup && this.exitPopup._closePopup(), this.newsletterPopup && this.newsletterPopup._closePopup();
                        },
                    },
                ]),
                e
            );
        })(),
        Ge = (function () {
            function e(i) {
                t(this, e),
                    (this.element = i),
                    (this.delegateElement = new b(this.element)),
                    (this.options = JSON.parse(this.element.getAttribute("data-section-settings"))),
                    this.options.useRecommendations ? this._loadRecommendations().then(this._createSlideshow.bind(this)) : this._createSlideshow(),
                    (this.productItemColorSwatch = new O(this.element)),
                    this._fixSafari(),
                    this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.options.stackable || this.flickityInstance.destroy(),
                                window.removeEventListener("resize", this._fixSafariListener),
                                this.delegateElement.off("change"),
                                this.productItemColorSwatch.destroy(),
                                this.resizeObserver && this.resizeObserver.disconnect();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._fixSafariListener = this._fixSafari.bind(this)),
                                window.addEventListener("resize", this._fixSafariListener),
                                this.delegateElement.on("click", '[data-action="add-to-cart"],[data-related-action="add-to-cart"]', this._addToCart.bind(this)),
                                this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this));
                        },
                    },
                    {
                        key: "_fixSafari",
                        value: function () {
                            var e = window.navigator.userAgent.toLowerCase();
                            if (e.includes("safari") && (e.includes("version/10.1") || e.includes("version/10.3") || e.includes("version/11.0"))) {
                                var t = S.matchesBreakpoint("phone");
                                this.element.querySelectorAll(".product-item__image-wrapper .aspect-ratio, .product-item__image-wrapper .placeholder-svg").forEach(function (e) {
                                    e.parentNode.style.height = t ? null : "".concat(e.clientHeight, "px");
                                });
                            }
                        },
                    },
                    {
                        key: "_loadRecommendations",
                        value: function () {
                            var e = this,
                                t = ""
                                    .concat(window.routes.productRecommendationsUrl, "?section_id=")
                                    .concat(this.element.getAttribute("data-section-id"), "&product_id=")
                                    .concat(this.options.productId, "&limit=")
                                    .concat(this.options.recommendationsCount);
                            return fetch(t).then(function (t) {
                                return t.text().then(function (t) {
                                    var i = document.createElement("div");
                                    (i.innerHTML = t), (e.element.querySelector(".product-recommendations").innerHTML = i.querySelector(".product-recommendations").innerHTML), e.productItemColorSwatch.recalculateSwatches();
                                });
                            });
                        },
                    },
                    {
                        key: "_createSlideshow",
                        value: function () {
                            var e = this;
                            if (!this.options.stackable) {
                                this.flickityInstance = new ne(this.element.querySelector(".product-list"), {
                                    watchCSS: !0,
                                    pageDots: !1,
                                    prevNextButtons: !0,
                                    contain: !0,
                                    resize: !1,
                                    groupCells: !0,
                                    cellAlign: "left",
                                    draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches,
                                });
                                var t = window.innerWidth;
                                window.addEventListener("resize", function () {
                                    window.innerWidth !== t && (e.flickityInstance.resize(), (t = window.innerWidth));
                                });
                            }
                            window.ResizeObserver &&
                                this.flickityInstance &&
                                ((this.resizeObserver = new ResizeObserver(function () {
                                    e.flickityInstance.resize();
                                })),
                                this.element.querySelectorAll(".product-item").forEach(function (t) {
                                    e.resizeObserver.observe(t);
                                }));
                        },
                    },
                    {
                        key: "_openQuickView",
                        value: function (e, t) {
                            var i = new URL("".concat(window.location.origin).concat(t.getAttribute("data-product-url")));
                            if (S.matchesBreakpoint("phone") || S.matchesBreakpoint("tablet")) return (window.location.href = i.href), !1;
                            var n = document.getElementById(t.getAttribute("aria-controls"));
                            n.classList.add("is-loading"),
                                i.searchParams.set("view", "quick-view"),
                                fetch(i.href, { credentials: "same-origin", method: "GET" }).then(function (e) {
                                    e.text().then(function (e) {
                                        (n.querySelector(".modal__inner").innerHTML = e), n.classList.remove("is-loading");
                                        var t = new Me(n.querySelector('[data-section-type="product"]'));
                                        n.addEventListener("modal:closed", function e() {
                                            t.onUnload(), n.removeEventListener("modal:closed", e);
                                        });
                                    });
                                });
                        },
                    },
                    {
                        key: "_addToCart",
                        value: function (e, t) {
                            var i = this;
                            if ("page" !== window.theme.cartType) {
                                e.preventDefault(), e.stopPropagation(), t.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                                var n = t.closest('form[action*="/cart/add"]'),
                                    o = n.querySelector('*[name="id"]'),
                                    a = n.querySelector('input[name="quantity"]'),
                                    s = a.size > 0 ? a.value : 1;
                                window.dataLayer.push({
                                    event: "ee_add_to_cart",
                                    name: n.querySelector(".ptitle").value,
                                    id: n.querySelector(".pid").value,
                                    price: n.querySelector(".pprice").value,
                                    brand: n.querySelector(".pbrand").value,
                                    product_type: n.querySelector(".ptype").value,
                                    category: n.querySelector(".pcollection").value,
                                    quantity: s,
                                    variant: o.value,
                                    g_product_id: "shopify_US_" + n.querySelector(".pid").value + "_" + o.value,
                                }),
                                    fetch("".concat(window.routes.cartAddUrl, ".js"), {
                                        body: JSON.stringify(F.serialize(n)),
                                        credentials: "same-origin",
                                        method: "POST",
                                        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                                    }).then(function (e) {
                                        t.removeAttribute("disabled"),
                                            e.ok
                                                ? $.getJSON("/cart.js", function (e) {
                                                      var o = e.total_price,
                                                          a = e.items,
                                                          s = $(document).find("#minimum-order-fee").data("price"),
                                                          r = $(document).find("#minimum-order-fee").data("required-price"),
                                                          l = $(document).find("#minimum-order-fee").data("variant-id"),
                                                          c = !1;
                                                      $.each(a, function (e, t) {
                                                          t.id === l && (c = !0);
                                                      }),
                                                          r > o
                                                              ? 1 != c && a.length > 0
                                                                  ? $.ajax({
                                                                        type: "POST",
                                                                        url: "/cart/add.js",
                                                                        data: { quantity: 1, id: l },
                                                                        dataType: "json",
                                                                        success: function (e) {
                                                                            i.element.dispatchEvent(
                                                                                new CustomEvent("product:added", { bubbles: !0, detail: { button: t, variant: null, quantity: parseInt(n.querySelector('[name="quantity"]').value) + 1 } })
                                                                            );
                                                                        },
                                                                    })
                                                                  : 1 == a.length && r > o
                                                                  ? $.ajax({
                                                                        type: "POST",
                                                                        url: "/cart/change.js",
                                                                        data: { quantity: 0, id: l },
                                                                        dataType: "json",
                                                                        success: function (e) {
                                                                            i.element.dispatchEvent(
                                                                                new CustomEvent("product:added", { bubbles: !0, detail: { button: t, variant: null, quantity: parseInt(n.querySelector('[name="quantity"]').value) - 1 } })
                                                                            );
                                                                        },
                                                                    })
                                                                  : i.element.dispatchEvent(
                                                                        new CustomEvent("product:added", { bubbles: !0, detail: { button: t, variant: null, quantity: parseInt(n.querySelector('[name="quantity"]').value) } })
                                                                    )
                                                              : c && o - s > r
                                                              ? $.ajax({
                                                                    type: "POST",
                                                                    url: "/cart/change.js",
                                                                    data: { quantity: 0, id: l },
                                                                    dataType: "json",
                                                                    success: function (e) {
                                                                        i.element.dispatchEvent(
                                                                            new CustomEvent("product:added", { bubbles: !0, detail: { button: t, variant: null, quantity: parseInt(n.querySelector('[name="quantity"]').value) - 1 } })
                                                                        );
                                                                    },
                                                                })
                                                              : i.element.dispatchEvent(
                                                                    new CustomEvent("product:added", { bubbles: !0, detail: { button: t, variant: null, quantity: parseInt(n.querySelector('[name="quantity"]').value) } })
                                                                );
                                                  })
                                                : document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                    }),
                                    e.preventDefault();
                            }
                        },
                    },
                ]),
                e
            );
        })(),
        Ye = (function () {
            function e(i) {
                t(this, e),
                    (this.element = i),
                    (this.delegateElement = new b(this.element)),
                    (this.options = JSON.parse(this.element.getAttribute("data-section-settings"))),
                    (this.productItemColorSwatch = new O(this.element)),
                    this._fetchProducts(),
                    this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.flickityInstance && this.flickityInstance.destroy(), this.productItemColorSwatch.destroy(), this.resizeObserver && this.resizeObserver.disconnect();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)), this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this));
                        },
                    },
                    {
                        key: "_fetchProducts",
                        value: function () {
                            var e = this,
                                t = this._getSearchQueryString();
                            "" !== t &&
                                fetch("".concat(window.routes.searchUrl, "?section_id=").concat(this.element.getAttribute("data-section-id"), "&type=product&q=").concat(t), { credentials: "same-origin", method: "GET" }).then(function (t) {
                                    t.text().then(function (t) {
                                        var i = document.createElement("div");
                                        (i.innerHTML = t),
                                            (e.element.querySelector(".recently-viewed-products-placeholder").innerHTML = i.querySelector('[data-section-type="recently-viewed-products"] .recently-viewed-products-placeholder').innerHTML),
                                            (e.element.parentNode.style.display = "block"),
                                            e.productItemColorSwatch.recalculateSwatches(),
                                            (e.flickityInstance = new ne(e.element.querySelector(".product-list"), {
                                                watchCSS: !0,
                                                pageDots: !1,
                                                prevNextButtons: !0,
                                                contain: !0,
                                                resize: !1,
                                                groupCells: !0,
                                                cellAlign: "left",
                                                draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches,
                                            }));
                                        var n = window.innerWidth;
                                        window.addEventListener("resize", function () {
                                            window.innerWidth !== n && (e.flickityInstance.resize(), (n = window.innerWidth));
                                        }),
                                            window.ResizeObserver &&
                                                e.flickityInstance &&
                                                ((e.resizeObserver = new ResizeObserver(function () {
                                                    e.flickityInstance.resize();
                                                })),
                                                e.element.querySelectorAll(".product-item").forEach(function (t) {
                                                    e.resizeObserver.observe(t);
                                                }));
                                        const o = e.element.querySelectorAll(".product-item-new");
                                        "null" != typeof o &&
                                            o.forEach((e) => {
                                                new Ke(e);
                                            });
                                    });
                                });
                        },
                    },
                    {
                        key: "_getSearchQueryString",
                        value: function () {
                            var e = JSON.parse(localStorage.getItem("recentlyViewedProducts") || "[]");
                            return (
                                e.includes(this.options.currentProductId) && e.splice(e.indexOf(this.options.currentProductId), 1),
                                e
                                    .map(function (e) {
                                        return "id:" + e;
                                    })
                                    .join(" OR ")
                            );
                        },
                    },
                    {
                        key: "_openQuickView",
                        value: function (e, t) {
                            var i = new URL("".concat(window.location.origin).concat(t.getAttribute("data-product-url")));
                            if (S.matchesBreakpoint("phone") || S.matchesBreakpoint("tablet")) return (window.location.href = i.href), !1;
                            var n = document.getElementById(t.getAttribute("aria-controls"));
                            n.classList.add("is-loading"),
                                i.searchParams.set("view", "quick-view"),
                                fetch(i.href, { credentials: "same-origin", method: "GET" }).then(function (e) {
                                    e.text().then(function (e) {
                                        (n.querySelector(".modal__inner").innerHTML = e), n.classList.remove("is-loading");
                                        var t = new Me(n.querySelector('[data-section-type="product"]'));
                                        n.addEventListener("modal:closed", function e() {
                                            t.onUnload(), n.removeEventListener("modal:closed", e);
                                        });
                                    });
                                });
                        },
                    },
                    {
                        key: "_addToCart",
                        value: function (e, t) {
                            var i = this;
                            if ("page" !== window.theme.cartType) {
                                e.preventDefault(), e.stopPropagation(), t.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                                var n = t.closest('form[action*="/cart/add"]'),
                                    o = n.querySelector('*[name="id"]'),
                                    a = n.querySelector('input[name="quantity"]'),
                                    s = a.size > 0 ? a.value : 1;
                                window.dataLayer.push({
                                    event: "ee_add_to_cart",
                                    name: n.querySelector(".ptitle").value,
                                    id: n.querySelector(".pid").value,
                                    price: n.querySelector(".pprice").value,
                                    brand: n.querySelector(".pbrand").value,
                                    product_type: n.querySelector(".ptype").value,
                                    category: n.querySelector(".pcollection").value,
                                    quantity: s,
                                    variant: o.value,
                                    g_product_id: "shopify_US_" + n.querySelector(".pid").value + "_" + o.value,
                                }),
                                    fetch("".concat(window.routes.cartAddUrl, ".js"), {
                                        body: JSON.stringify(F.serialize(n)),
                                        credentials: "same-origin",
                                        method: "POST",
                                        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                                    }).then(function (e) {
                                        t.removeAttribute("disabled"),
                                            e.ok
                                                ? $.getJSON("/cart.js", function (e) {
                                                      var o = e.total_price,
                                                          a = e.items,
                                                          s = $(document).find("#minimum-order-fee").data("price"),
                                                          r = $(document).find("#minimum-order-fee").data("required-price"),
                                                          l = $(document).find("#minimum-order-fee").data("variant-id"),
                                                          c = !1;
                                                      $.each(a, function (e, t) {
                                                          t.id === l && (c = !0);
                                                      }),
                                                          r > o
                                                              ? 1 != c && a.length > 0
                                                                  ? $.ajax({
                                                                        type: "POST",
                                                                        url: "/cart/add.js",
                                                                        data: { quantity: 1, id: l },
                                                                        dataType: "json",
                                                                        success: function (e) {
                                                                            i.element.dispatchEvent(
                                                                                new CustomEvent("product:added", { bubbles: !0, detail: { button: t, variant: null, quantity: parseInt(n.querySelector('[name="quantity"]').value) + 1 } })
                                                                            );
                                                                        },
                                                                    })
                                                                  : 1 == a.length && r > o
                                                                  ? $.ajax({
                                                                        type: "POST",
                                                                        url: "/cart/change.js",
                                                                        data: { quantity: 0, id: l },
                                                                        dataType: "json",
                                                                        success: function (e) {
                                                                            i.element.dispatchEvent(
                                                                                new CustomEvent("product:added", { bubbles: !0, detail: { button: t, variant: null, quantity: parseInt(n.querySelector('[name="quantity"]').value) - 1 } })
                                                                            );
                                                                        },
                                                                    })
                                                                  : i.element.dispatchEvent(
                                                                        new CustomEvent("product:added", { bubbles: !0, detail: { button: t, variant: null, quantity: parseInt(n.querySelector('[name="quantity"]').value) } })
                                                                    )
                                                              : c && o - s > r
                                                              ? $.ajax({
                                                                    type: "POST",
                                                                    url: "/cart/change.js",
                                                                    data: { quantity: 0, id: l },
                                                                    dataType: "json",
                                                                    success: function (e) {
                                                                        i.element.dispatchEvent(
                                                                            new CustomEvent("product:added", { bubbles: !0, detail: { button: t, variant: null, quantity: parseInt(n.querySelector('[name="quantity"]').value) - 1 } })
                                                                        );
                                                                    },
                                                                })
                                                              : i.element.dispatchEvent(
                                                                    new CustomEvent("product:added", { bubbles: !0, detail: { button: t, variant: null, quantity: parseInt(n.querySelector('[name="quantity"]').value) } })
                                                                );
                                                  })
                                                : document.dispatchEvent(new CustomEvent("theme:loading:end"));
                                    }),
                                    e.preventDefault();
                            }
                        },
                    },
                ]),
                e
            );
        })(),
        Ze = (function () {
            function e(i) {
                t(this, e), (this.element = i), (this.delegateElement = new b(this.element)), this._createSlideshow(), (this.productItemColorSwatch = new O(this.element)), this._fixSafari(), this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "onUnload",
                        value: function () {
                            window.removeEventListener("resize", this._fixSafariListener), this.delegateElement.off("change"), this.productItemColorSwatch.destroy(), this.resizeObserver && this.resizeObserver.disconnect();
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            (this._fixSafariListener = this._fixSafari.bind(this)),
                                window.addEventListener("resize", this._fixSafariListener),
                                this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this));
                        },
                    },
                    {
                        key: "_fixSafari",
                        value: function () {
                            var e = window.navigator.userAgent.toLowerCase();
                            if (e.includes("safari") && (e.includes("version/10.1") || e.includes("version/10.3") || e.includes("version/11.0"))) {
                                var t = S.matchesBreakpoint("phone");
                                this.element.querySelectorAll(".product-item__image-wrapper .aspect-ratio, .product-item__image-wrapper .placeholder-svg").forEach(function (e) {
                                    e.parentNode.style.height = t ? null : "".concat(e.clientHeight, "px");
                                });
                            }
                        },
                    },
                    {
                        key: "_createSlideshow",
                        value: function () {
                            var e = this;
                            this.flickityInstance = new ne(this.element.querySelector(".product-list"), {
                                watchCSS: !0,
                                pageDots: !1,
                                prevNextButtons: !0,
                                contain: !0,
                                resize: !1,
                                groupCells: !0,
                                cellAlign: "left",
                                draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches,
                            });
                            var t = window.innerWidth;
                            window.addEventListener("resize", function () {
                                window.innerWidth !== t && (e.flickityInstance.resize(), (t = window.innerWidth));
                            }),
                                window.ResizeObserver &&
                                    this.flickityInstance &&
                                    ((this.resizeObserver = new ResizeObserver(function () {
                                        e.flickityInstance.resize();
                                    })),
                                    this.element.querySelectorAll(".product-item").forEach(function (t) {
                                        e.resizeObserver.observe(t);
                                    }));
                        },
                    },
                    {
                        key: "_openQuickView",
                        value: function (e, t) {
                            var i = new URL("".concat(window.location.origin).concat(t.getAttribute("data-product-url")));
                            if (S.matchesBreakpoint("phone") || S.matchesBreakpoint("tablet")) return (window.location.href = i.href), !1;
                            var n = document.getElementById(t.getAttribute("aria-controls"));
                            n.classList.add("is-loading"),
                                i.searchParams.set("view", "quick-view"),
                                fetch(i.href, { credentials: "same-origin", method: "GET" }).then(function (e) {
                                    e.text().then(function (e) {
                                        (n.querySelector(".modal__inner").innerHTML = e), n.classList.remove("is-loading");
                                        var t = new Me(n.querySelector('[data-section-type="product"]'));
                                        n.addEventListener("modal:closed", function e() {
                                            t.onUnload(), n.removeEventListener("modal:closed", e);
                                        });
                                    });
                                });
                        },
                    },
                ]),
                e
            );
        })(),
        Qe = (function () {
            function e(i) {
                t(this, e),
                    (this.element = i),
                    (this.delegateElement = new b(this.element)),
                    (this.productItemColorSwatch = new O(this.element)),
                    (this.settings = JSON.parse(this.element.getAttribute("data-section-settings"))),
                    this._attachListeners(),
                    this._checkIfActiveVariant();
            }
            return (
                n(e, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.flickityInstance && this.flickityInstance.destroy(), this.productItemColorSwatch.destroy(), this.resizeObserver && this.resizeObserver.disconnect();
                        },
                    },
                    {
                        key: "_checkIfActiveVariant",
                        value: function () {
                            const e = window.location.search,
                                t = new URLSearchParams(e).get("variant");
                            let i = null;
                            t
                                ? this.settings.products.forEach((e) => {
                                      e.variants.forEach((e) => {
                                          e.id === t && (i = e);
                                      });
                                  })
                                : (i = this.settings.products[0].variants[0]),
                                this.element.dispatchEvent(new CustomEvent("variant:changed", { bubbles: !0, detail: { variant: i } }));
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            document.querySelectorAll('[data-section-type="product"] .product-block-list__item--info [data-option-position]').forEach((e) => {
                                e.addEventListener("change", this._handleVariantChangesForComplementaryProducts.bind(this));
                            }),
                                document.querySelectorAll(".ctrl__button").forEach((e) => {
                                    e.addEventListener("click", this._updateBulkAddToCartPrice.bind(this));
                                }),
                                this.delegateElement.on("change", "[data-option-position]", this._complementaryVariantChange.bind(this)),
                                this.delegateElement.on("change", ".complementary-main-product [data-option-position]", this._handleVariantChangesForComplementaryProducts.bind(this)),
                                this.delegateElement.on("click", "#bulk-add-to-cart", this._bulkAddToCart.bind(this)),
                                this.delegateElement.on("change", ".bulk-add-to-cart", this._updateBulkAddToCartPrice.bind(this)),
                                this.delegateElement.on("keyup", ".quantity-selector__value", this._updateBulkAddToCartPrice.bind(this)),
                                this.element.addEventListener("variant:changed", this._handleVariantChangesForComplementaryProducts.bind(this));
                            const e = this.element.querySelectorAll(".product-item:not(.bulk-add-to-cart-item)");
                            if (null != e) {
                                let t = 0;
                                e.forEach((e) => {
                                    const i = e.querySelectorAll(".product-form__option");
                                    null != i &&
                                        i.forEach((e) => {
                                            const i = setInterval(() => {
                                                (e.style = ""), t++, t > 40 && clearInterval(i);
                                            }, 500);
                                            null != e.querySelector(".product-form__option label") && e.querySelector(".product-form__option label").classList.remove("d-none"),
                                                null != e.querySelector(".product-form__option label span") && e.querySelector(".product-form__option label span").classList.add("d-none");
                                        });
                                });
                            }
                        },
                    },
                    {
                        key: "_loadSlideshow",
                        value: function () {
                            var e = this;
                            (e.flickityInstance = new ne(e.element.querySelector(".product-item__image-wrapper"), {
                                watchCSS: !0,
                                pageDots: !0,
                                prevNextButtons: !0,
                                contain: !0,
                                resize: !1,
                                groupCells: !0,
                                cellAlign: "left",
                                draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches,
                            })),
                                console.log(e.flickityInstance);
                            var t = window.innerWidth;
                            window.addEventListener("resize", function () {
                                window.innerWidth !== t && (e.flickityInstance.resize(), (t = window.innerWidth));
                            }),
                                window.ResizeObserver &&
                                    e.flickityInstance &&
                                    ((e.resizeObserver = new ResizeObserver(function () {
                                        e.flickityInstance.resize();
                                    })),
                                    e.element.querySelectorAll(".product-item").forEach(function (t) {
                                        e.resizeObserver.observe(t);
                                    }));
                        },
                    },
                    {
                        key: "_updateComplementaryProduct",
                        value: function (e, t) {
                            if (null == e.querySelector("a.product-item__title")) return;
                            const i = e.querySelector("a.product-item__title").getAttribute("href").replace("/products/", ""),
                                n = this.settings.products.filter((e) => e.handle === i);
                            let o = !1;
                            if (((o = n[0].variants.filter((e) => (o = JSON.stringify(e.options.toSorted()) === JSON.stringify(t.toSorted())))), !o.length)) {
                                let e = null,
                                    i = 0;
                                n[0].variants.forEach((n) => {
                                    let a = 0;
                                    t.forEach((t, i) => {
                                        n.options.includes(t) && (a++, 0 == i && null == e && (e = [n]));
                                    }),
                                        a > i && ((o = [n]), (i = a));
                                }),
                                    1 === i && (o = e);
                            }
                            if ((o.length || (o = [n[0].variants[0]]), (e.querySelector("input.bulk-add-to-cart").value = o[0].id), null != o[0].featured_image)) {
                                const t = e.querySelector(".product-item__image-wrapper img"),
                                    i = /(.*?)&/i,
                                    n = t.getAttribute("src").match(i);
                                if (n) {
                                    const e = t.getAttribute("src").replace(n[0], o[0].featured_image.src + "&"),
                                        i = t.getAttribute("srcset").replaceAll(n[0], o[0].featured_image.src + "&");
                                    t.setAttribute("src", e), t.setAttribute("srcset", i);
                                }
                            }
                            for (const [t, i] of Object.entries(o[0]))
                                if (-1 !== t.indexOf("option")) {
                                    const a = t.replace("option", ""),
                                        s = e.querySelectorAll(`*[data-option-position="${a}"]`);
                                    if (1 === s.length) {
                                        if ((s[0].querySelector("[selected]").removeAttribute("selected"), s[0].querySelector(`[value=${JSON.stringify(i)}]`).setAttribute("selected", "selected"), (s[0].value = i), 2 == a)) {
                                            const e = n[0].variants.filter((e) => e.option1 == o[0].option1).map((e) => e.option2);
                                            [...s[0].children].forEach((t) => {
                                                t.removeAttribute("disabled"), e.includes(t.value) || t.setAttribute("disabled", "disabled");
                                            });
                                        }
                                    } else
                                        s.forEach((e) => {
                                            e.value === i && e.click();
                                        });
                                }
                            e.querySelector(".product-item__price-list .price").textContent = B.formatMoney(o[0].price);
                        },
                    },
                    {
                        key: "_handleVariantChangesForComplementaryProducts",
                        value: function (e) {
                            let t = this,
                                i = document.querySelector('section[data-section-type="product"] .product-form');
                            null !== e.target.closest(".complementary-main-product") && (i = e.target.closest(".complementary-main-product").querySelector("form"));
                            const n = Array.from(i.elements);
                            let o = [];
                            n.forEach((e) => {
                                e.hasAttribute("data-option-position") && (("radio" !== e.type && "checkbox" !== e.type) || !e.checked || o.push(e.value), -1 !== e.type.indexOf("select") && o.push(e.value));
                            }),
                                t.element.querySelectorAll(".product-item:not(.bulk-add-to-cart-item)").forEach((e) => {
                                    t._updateComplementaryProduct(e, o);
                                }),
                                t._updateBulkAddToCartPrice();
                        },
                    },
                    {
                        key: "_complementaryVariantChange",
                        value: function (e) {
                            const t = e.target.closest("form"),
                                i = Array.from(t.elements);
                            var n = [];
                            i.forEach((e) => {
                                e.hasAttribute("data-option-position") && (("radio" !== e.type && "checkbox" !== e.type) || !e.checked || n.push(e.value), -1 !== e.type.indexOf("select") && n.push(e.value));
                            });
                            const o = e.target.closest(".product-item");
                            this._updateComplementaryProduct(o, n), this._updateBulkAddToCartPrice();
                        },
                    },
                    {
                        key: "_bulkAddToCart",
                        value: async function (e) {
                            const t = { items: [] };
                            if (
                                (this.element.querySelectorAll(".bulk-add-to-cart").forEach((e) => {
                                    e.checked && t.items.push({ id: e.value, quantity: Number(e.closest(".product-item").querySelector(".quantity-selector__value").value) });
                                }),
                                t.items.length)
                            ) {
                                const i = await fetch("/cart/add.js", { method: "POST", body: JSON.stringify(t), headers: { "Content-type": "application/json; charset=UTF-8" } });
                                (await i.json()).items.length && (e.target.dispatchEvent(new CustomEvent("product:added", { bubbles: !0, detail: { button: e.target } })), document.querySelector("a.header__cart-toggle").click());
                            }
                        },
                    },
                    {
                        key: "_updateBulkAddToCartPrice",
                        value: function () {
                            const e = document.getElementById("bulk-add-to-cart-price"),
                                t = document.querySelectorAll('[data-section-type="complementary-products"] input.bulk-add-to-cart');
                            let i = 0;
                            t.forEach((e) => {
                                e.checked &&
                                    this.settings.products.forEach((t) => {
                                        const n = t.variants.filter((t) => t.id === Number(e.value));
                                        if (n[0]) {
                                            const t = Number(e.closest(".product-item").querySelector(".quantity-selector__value").value);
                                            (i += (n[0].price / 100) * t), (e.closest(".product-item").querySelector(".product-item__price-list .price").textContent = B.formatMoney(n[0].price * t));
                                        }
                                    });
                            }),
                                i > 0
                                    ? ((e.querySelector(".bulk-price").textContent = `${e.dataset.symbol}${i.toFixed(2)}`), e.closest(".bulk-add-to-cart-item").classList.remove("hidden"))
                                    : ((e.querySelector(".bulk-price").textContent = ""), e.closest(".bulk-add-to-cart-item").classList.add("hidden"));
                        },
                    },
                ]),
                e
            );
        })(),
        Je = (function () {
            function e(i) {
                t(this, e), (this.element = i), (this.delegateElement = new b(this.element)), this._getProductsCount(), this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "_attachListeners",
                        value: function () {
                            window.addEventListener("DOMContentLoaded", this._setCollectionItemTextWrapperHeight.bind(this)), window.addEventListener("resize", this._setCollectionItemTextWrapperHeight.bind(this));
                        },
                    },
                    {
                        key: "_getProductsCount",
                        value: async function (e) {
                            const t = this.element.querySelectorAll('section[data-section-type="list-brand-collections"] .collection-item');
                            if (null != t) {
                                const e = document.createElement("p"),
                                    n = '<span class="filter-group-loader"></span>';
                                (e.innerHTML = n),
                                    document.querySelector('section[data-section-type="page"] .page__header').append(e),
                                    t.forEach((e) => {
                                        e.querySelector(".collection__products-count").innerHTML = n;
                                    });
                                let o = 0;
                                for (let n = 0; n < t.length; n++) {
                                    const a = t[n].href.replace("https://qualitydoor.com", ""),
                                        s = await fetch(a, { credentials: "same-origin", method: "GET", headers: { "Cache-Control": "no-cache", "Content-Type": "text/html" } }),
                                        r = await s.text();
                                    var i = document.createElement("div");
                                    i.innerHTML = r;
                                    const l = i.querySelector(".collection__toolbar-item--count span");
                                    if (l) {
                                        let e = l.textContent.split(" ");
                                        (e = parseInt(e[e.length - 2])), (t[n].querySelector(".collection__products-count").textContent = `${e} products`), (o += e);
                                    }
                                    n === t.length - 1 && ((e.style.fontWeight = "bold"), (e.textContent = `${t.length} collections | ${o} products`), this._setCollectionItemTextWrapperHeight());
                                }
                            }
                        },
                    },
                    {
                        key: "_setCollectionItemTextWrapperHeight",
                        value: function () {
                            const e = this.element.querySelectorAll(".collection-item__text-wrapper");
                            let t = 0;
                            e.forEach((e) => (e.style = "")),
                                e.forEach((e) => {
                                    t = e.clientHeight >= t ? e.clientHeight : t;
                                }),
                                e.forEach((e) => {
                                    (e.style.flex = `0 0 ${t}px`), (e.style.maxHeight = `${t}px`);
                                });
                        },
                    },
                ]),
                e
            );
        })(),
        Ke = (function () {
            function e(i) {
                t(this, e),
                    (this.element = i),
                    (this.delegateElement = new b(this.element)),
                    (this.data = JSON.parse(this.element.getAttribute("data-product"))),
                    (this.options = this.element.querySelectorAll("[data-option-position]")),
                    this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.delegateElement.on("change", "[data-option-position]", this._updateProductData.bind(this)),
                                this.delegateElement.on("keyup", ".quantity-selector__value", this._updateProductQty.bind(this)),
                                this.delegateElement.on("submit", ".product-item-new-add-to-cart", this._addToCart.bind(this)),
                                window.addEventListener("DOMContentLoaded", (e) => {
                                    let t = !1;
                                    const i = setInterval(() => {
                                        if (t) return void clearInterval(i);
                                        const e = this.element.querySelectorAll(".product-form__option");
                                        let n = 0;
                                        "null" != typeof e
                                            ? e.forEach((o) => {
                                                  if (("null" != typeof o.getAttribute("style") && (o.removeAttribute("style"), n++), n >= e.length - 1)) return clearInterval(i), void (t = !0);
                                              })
                                            : clearInterval(i);
                                    }, 250);
                                });
                        },
                    },
                    {
                        key: "_updateProductData",
                        value: function () {
                            const e = this.data.variants.filter((e) => {
                                let t = !0;
                                return (
                                    "null" != typeof this.options &&
                                        this.options.forEach((i, n) => {
                                            e[`option${n + 1}`] !== i.value && (t = !1);
                                        }),
                                    !!t && e
                                );
                            });
                            e.length &&
                                (void 0 !== e[0].image && (this.element.querySelector(".product-item__image-wrapper .aspect-ratio").innerHTML = e[0].image),
                                (this.element.querySelector(".product-item__price-list-price").innerHTML = e[0].price),
                                (this.element.querySelector('.product-item-new-add-to-cart input[name="id"]').value = e[0].id));
                        },
                    },
                    {
                        key: "_updateProductQty",
                        value: function (e) {
                            this.element.querySelector('.product-item-new-add-to-cart input[name="quantity"]').value = e.target.value;
                        },
                    },
                    {
                        key: "_addToCart",
                        value: async function (e) {
                            e.preventDefault();
                            const t = await fetch("/cart/add.js", {
                                method: "POST",
                                body: JSON.stringify({ items: [{ id: e.target.querySelector('input[name="id"]').value, quantity: e.target.querySelector('input[name="quantity"]').value }] }),
                                headers: { "Content-type": "application/json; charset=UTF-8" },
                            });
                            (await t.json()).items.length &&
                                (e.target.dispatchEvent(new CustomEvent("product:added", { bubbles: !0, detail: { button: e.target.querySelector(".product-item__action-button") } })),
                                document.querySelector("a.header__cart-toggle").click());
                        },
                    },
                ]),
                e
            );
        })(),
        et = (function () {
            function e() {
                t(this, e), (this.constructors = []), (this.instances = []), this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "_attachListeners",
                        value: function () {
                            document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this)),
                                document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this)),
                                document.addEventListener("shopify:section:select", this._onSelect.bind(this)),
                                document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this)),
                                document.addEventListener("shopify:section:reorder", this._onReorder.bind(this)),
                                document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this)),
                                document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this));
                        },
                    },
                    {
                        key: "register",
                        value: function (e, t) {
                            var i = this;
                            (this.constructors[e] = t),
                                document.querySelectorAll("[data-section-type=".concat(e, "]")).forEach(function (e) {
                                    i._createInstance(e, t);
                                });
                        },
                    },
                    {
                        key: "_findInstance",
                        value: function (e, t, i) {
                            for (var n = 0; n < e.length; n++) if (e[n][t] === i) return e[n];
                        },
                    },
                    {
                        key: "_removeInstance",
                        value: function (e, t, i) {
                            for (var n = e.length; n--; )
                                if (e[n][t] === i) {
                                    e.splice(n, 1);
                                    break;
                                }
                            return e;
                        },
                    },
                    {
                        key: "_onSectionLoad",
                        value: function (e) {
                            var t = e.target.querySelector("[data-section-id]");
                            t && this._createInstance(t);
                        },
                    },
                    {
                        key: "_onSectionUnload",
                        value: function (e) {
                            var t = this._findInstance(this.instances, "id", e.detail.sectionId);
                            t && ("function" == typeof t.onUnload && t.onUnload(e), (this.instances = this._removeInstance(this.instances, "id", e.detail.sectionId)));
                        },
                    },
                    {
                        key: "_onSelect",
                        value: function (e) {
                            var t = this._findInstance(this.instances, "id", e.detail.sectionId);
                            t && "function" == typeof t.onSelect && t.onSelect(e);
                        },
                    },
                    {
                        key: "_onDeselect",
                        value: function (e) {
                            var t = this._findInstance(this.instances, "id", e.detail.sectionId);
                            t && "function" == typeof t.onDeselect && t.onDeselect(e);
                        },
                    },
                    {
                        key: "_onReorder",
                        value: function (e) {
                            var t = this._findInstance(this.instances, "id", e.detail.sectionId);
                            t && "function" == typeof t.onReorder && t.onReorder(e);
                        },
                    },
                    {
                        key: "_onBlockSelect",
                        value: function (e) {
                            var t = this._findInstance(this.instances, "id", e.detail.sectionId);
                            t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
                        },
                    },
                    {
                        key: "_onBlockDeselect",
                        value: function (e) {
                            var t = this._findInstance(this.instances, "id", e.detail.sectionId);
                            t && "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
                        },
                    },
                    {
                        key: "_createInstance",
                        value: function (e, t) {
                            var i = e.getAttribute("data-section-id"),
                                n = e.getAttribute("data-section-type");
                            if (void 0 !== (t = t || this.constructors[n]))
                                try {
                                    var o = Object.assign(new t(e), { id: i, type: n, container: e });
                                    this.instances.push(o);
                                } catch (e) {
                                    console.error("Logged exception (this may happen if you have tried to edit the code without properly adjusting the JavaScript): " + e.message);
                                }
                        },
                    },
                ]),
                e
            );
        })(),
        tt = (function () {
            function e(i) {
                var n = this;
                t(this, e),
                    (this.element = i),
                    (this.options = JSON.parse(this.element.getAttribute("data-section-settings"))),
                    (this.flickityInstance = new oe(i.querySelector(".slideshow"), {
                        pageDots: this.options.pageDots,
                        prevNextButtons: this.options.prevNextButtons,
                        wrapAround: !0,
                        dragThreshold: 12,
                        resize: !1,
                        draggable: ">1",
                        fade: "fade" === this.options.transitionEffect,
                        setGallerySize: this.options.setGallerySize,
                        adaptiveHeight: this.options.adaptiveHeight,
                        autoPlay: !!this.options.autoPlay && this.options.cycleSpeed,
                    }));
                var o = window.innerWidth;
                window.addEventListener("resize", function () {
                    window.innerWidth !== o && (n.flickityInstance.resize(), (o = window.innerWidth));
                });
            }
            return (
                n(e, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.flickityInstance.destroy();
                        },
                    },
                    {
                        key: "onBlockSelect",
                        value: function (e) {
                            this.flickityInstance.isActive && (this.flickityInstance.selectCell(parseInt(e.target.getAttribute("data-block-index")), !1, e.detail.load), this.flickityInstance.pausePlayer());
                        },
                    },
                    {
                        key: "onBlockDeselect",
                        value: function () {
                            this.flickityInstance.isActive && this.flickityInstance.unpausePlayer();
                        },
                    },
                ]),
                e
            );
        })(),
        it = (function () {
            function e(i) {
                var n = this;
                t(this, e), (this.flickityInstance = new ne(i.querySelector(".text-with-icons"), { pageDots: !0, prevNextButtons: !1, wrapAround: !0, autoPlay: 5e3, resize: !1, watchCSS: !0 }));
                var o = window.innerWidth;
                window.addEventListener("resize", function () {
                    window.innerWidth !== o && (n.flickityInstance.resize(), (o = window.innerWidth));
                });
            }
            return (
                n(e, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.flickityInstance.destroy();
                        },
                    },
                    {
                        key: "onBlockSelect",
                        value: function (e) {
                            this.flickityInstance.isActive && (this.flickityInstance.selectCell(parseInt(e.target.getAttribute("data-block-index")), !1, e.detail.load), this.flickityInstance.pausePlayer());
                        },
                    },
                    {
                        key: "onBlockDeselect",
                        value: function () {
                            this.flickityInstance.isActive && this.flickityInstance.unpausePlayer();
                        },
                    },
                ]),
                e
            );
        })(),
        nt = (function () {
            function e(i) {
                t(this, e), (this.element = i), (this.domDelegate = new b(this.element)), (this.options = JSON.parse(this.element.getAttribute("data-section-settings"))), this._attachListeners();
            }
            return (
                n(e, [
                    {
                        key: "onUnload",
                        value: function () {
                            this.domDelegate.off("click");
                        },
                    },
                    {
                        key: "_attachListeners",
                        value: function () {
                            this.domDelegate.on("click", '[data-action="play-video"]', this._playVideo.bind(this));
                        },
                    },
                    {
                        key: "_playVideo",
                        value: function (e, t) {
                            var i = t.querySelector("iframe");
                            (i.src = i.getAttribute("data-src")), t.classList.add("is-playing");
                        },
                    },
                ]),
                e
            );
        })(),
        ot = y(function (t, i) {
            t.exports = {
                polyfill: function () {
                    var t = window,
                        i = document;
                    if (!("scrollBehavior" in i.documentElement.style) || !0 === t.__forceSmoothScrollPolyfill__) {
                        var n,
                            o = t.HTMLElement || t.Element,
                            a = 468,
                            s = { scroll: t.scroll || t.scrollTo, scrollBy: t.scrollBy, elementScroll: o.prototype.scroll || c, scrollIntoView: o.prototype.scrollIntoView },
                            r = t.performance && t.performance.now ? t.performance.now.bind(t.performance) : Date.now,
                            l = ((n = t.navigator.userAgent), new RegExp(["MSIE ", "Trident/", "Edge/"].join("|")).test(n) ? 1 : 0);
                        (t.scroll = t.scrollTo = function () {
                            void 0 !== arguments[0] &&
                                (!0 !== d(arguments[0])
                                    ? f.call(t, i.body, void 0 !== arguments[0].left ? ~~arguments[0].left : t.scrollX || t.pageXOffset, void 0 !== arguments[0].top ? ~~arguments[0].top : t.scrollY || t.pageYOffset)
                                    : s.scroll.call(
                                          t,
                                          void 0 !== arguments[0].left ? arguments[0].left : "object" !== e(arguments[0]) ? arguments[0] : t.scrollX || t.pageXOffset,
                                          void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : t.scrollY || t.pageYOffset
                                      ));
                        }),
                            (t.scrollBy = function () {
                                void 0 !== arguments[0] &&
                                    (d(arguments[0])
                                        ? s.scrollBy.call(
                                              t,
                                              void 0 !== arguments[0].left ? arguments[0].left : "object" !== e(arguments[0]) ? arguments[0] : 0,
                                              void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : 0
                                          )
                                        : f.call(t, i.body, ~~arguments[0].left + (t.scrollX || t.pageXOffset), ~~arguments[0].top + (t.scrollY || t.pageYOffset)));
                            }),
                            (o.prototype.scroll = o.prototype.scrollTo = function () {
                                if (void 0 !== arguments[0])
                                    if (!0 !== d(arguments[0])) {
                                        var t = arguments[0].left,
                                            i = arguments[0].top;
                                        f.call(this, this, void 0 === t ? this.scrollLeft : ~~t, void 0 === i ? this.scrollTop : ~~i);
                                    } else {
                                        if ("number" == typeof arguments[0] && void 0 === arguments[1]) throw new SyntaxError("Value could not be converted");
                                        s.elementScroll.call(
                                            this,
                                            void 0 !== arguments[0].left ? ~~arguments[0].left : "object" !== e(arguments[0]) ? ~~arguments[0] : this.scrollLeft,
                                            void 0 !== arguments[0].top ? ~~arguments[0].top : void 0 !== arguments[1] ? ~~arguments[1] : this.scrollTop
                                        );
                                    }
                            }),
                            (o.prototype.scrollBy = function () {
                                void 0 !== arguments[0] &&
                                    (!0 !== d(arguments[0])
                                        ? this.scroll({ left: ~~arguments[0].left + this.scrollLeft, top: ~~arguments[0].top + this.scrollTop, behavior: arguments[0].behavior })
                                        : s.elementScroll.call(
                                              this,
                                              void 0 !== arguments[0].left ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft,
                                              void 0 !== arguments[0].top ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop
                                          ));
                            }),
                            (o.prototype.scrollIntoView = function () {
                                if (!0 !== d(arguments[0])) {
                                    var e = (function (e) {
                                            for (; e !== i.body && !1 === p(e); ) e = e.parentNode || e.host;
                                            return e;
                                        })(this),
                                        n = e.getBoundingClientRect(),
                                        o = this.getBoundingClientRect();
                                    e !== i.body
                                        ? (f.call(this, e, e.scrollLeft + o.left - n.left, e.scrollTop + o.top - n.top), "fixed" !== t.getComputedStyle(e).position && t.scrollBy({ left: n.left, top: n.top, behavior: "smooth" }))
                                        : t.scrollBy({ left: o.left, top: o.top, behavior: "smooth" });
                                } else s.scrollIntoView.call(this, void 0 === arguments[0] || arguments[0]);
                            });
                    }
                    function c(e, t) {
                        (this.scrollLeft = e), (this.scrollTop = t);
                    }
                    function d(t) {
                        if (null === t || "object" !== e(t) || void 0 === t.behavior || "auto" === t.behavior || "instant" === t.behavior) return !0;
                        if ("object" === e(t) && "smooth" === t.behavior) return !1;
                        throw new TypeError("behavior member of ScrollOptions " + t.behavior + " is not a valid value for enumeration ScrollBehavior.");
                    }
                    function u(e, t) {
                        return "Y" === t ? e.clientHeight + l < e.scrollHeight : "X" === t ? e.clientWidth + l < e.scrollWidth : void 0;
                    }
                    function h(e, i) {
                        var n = t.getComputedStyle(e, null)["overflow" + i];
                        return "auto" === n || "scroll" === n;
                    }
                    function p(e) {
                        var t = u(e, "Y") && h(e, "Y"),
                            i = u(e, "X") && h(e, "X");
                        return t || i;
                    }
                    function m(e) {
                        var i,
                            n,
                            o,
                            s,
                            l = (r() - e.startTime) / a;
                        (s = l = l > 1 ? 1 : l),
                            (i = 0.5 * (1 - Math.cos(Math.PI * s))),
                            (n = e.startX + (e.x - e.startX) * i),
                            (o = e.startY + (e.y - e.startY) * i),
                            e.method.call(e.scrollable, n, o),
                            (n === e.x && o === e.y) || t.requestAnimationFrame(m.bind(t, e));
                    }
                    function f(e, n, o) {
                        var a,
                            l,
                            d,
                            u,
                            h = r();
                        e === i.body ? ((a = t), (l = t.scrollX || t.pageXOffset), (d = t.scrollY || t.pageYOffset), (u = s.scroll)) : ((a = e), (l = e.scrollLeft), (d = e.scrollTop), (u = c)),
                            m({ scrollable: a, method: u, startTime: h, startX: l, startY: d, x: n, y: o });
                    }
                },
            };
        }),
        at = new Set(),
        st = document.createElement("link"),
        rt = st.relList && st.relList.supports && st.relList.supports("prefetch") && window.IntersectionObserver && "isIntersecting" in IntersectionObserverEntry.prototype,
        lt = "instantAllowQueryString" in document.body.dataset,
        ct = "instantAllowExternalLinks" in document.body.dataset,
        dt = "instantWhitelist" in document.body.dataset,
        ut = "instantMousedownShortcut" in document.body.dataset,
        ht = 1111,
        pt = 65,
        mt = !1,
        ft = !1,
        vt = !1;
    if ("instantIntensity" in document.body.dataset) {
        var gt = document.body.dataset.instantIntensity;
        if ("mousedown" == gt.substr(0, 9)) (mt = !0), "mousedown-only" == gt && (ft = !0);
        else if ("viewport" == gt.substr(0, 8))
            (navigator.connection && (navigator.connection.saveData || (navigator.connection.effectiveType && navigator.connection.effectiveType.includes("2g")))) ||
                ("viewport" == gt ? document.documentElement.clientWidth * document.documentElement.clientHeight < 45e4 && (vt = !0) : "viewport-all" == gt && (vt = !0));
        else {
            var yt = parseInt(gt);
            isNaN(yt) || (pt = yt);
        }
    }
    if (rt) {
        var wt = { capture: !0, passive: !0 };
        if (
            (ft ||
                document.addEventListener(
                    "touchstart",
                    function (e) {
                        Se = performance.now();
                        var t = e.target.closest("a");
                        if (!_t(t)) return;
                        Et(t.href);
                    },
                    wt
                ),
            mt
                ? ut ||
                  document.addEventListener(
                      "mousedown",
                      function (e) {
                          var t = e.target.closest("a");
                          if (!_t(t)) return;
                          Et(t.href);
                      },
                      wt
                  )
                : document.addEventListener(
                      "mouseover",
                      function (e) {
                          if (performance.now() - Se < ht) return;
                          var t = e.target.closest("a");
                          if (!_t(t)) return;
                          t.addEventListener("mouseout", bt, { passive: !0 }),
                              (Ee = setTimeout(function () {
                                  Et(t.href), (Ee = void 0);
                              }, pt));
                      },
                      wt
                  ),
            ut &&
                document.addEventListener(
                    "mousedown",
                    function (e) {
                        if (performance.now() - Se < ht) return;
                        var t = e.target.closest("a");
                        if (e.which > 1 || e.metaKey || e.ctrlKey) return;
                        if (!t) return;
                        t.addEventListener(
                            "click",
                            function (e) {
                                1337 != e.detail && e.preventDefault();
                            },
                            { capture: !0, passive: !1, once: !0 }
                        );
                        var i = new MouseEvent("click", { view: window, bubbles: !0, cancelable: !1, detail: 1337 });
                        t.dispatchEvent(i);
                    },
                    wt
                ),
            vt)
        )
            (window.requestIdleCallback
                ? function (e) {
                      requestIdleCallback(e, { timeout: 1500 });
                  }
                : function (e) {
                      e();
                  })(function () {
                var e = new IntersectionObserver(function (t) {
                    t.forEach(function (t) {
                        if (t.isIntersecting) {
                            var i = t.target;
                            e.unobserve(i), Et(i.href);
                        }
                    });
                });
                document.querySelectorAll("a").forEach(function (t) {
                    _t(t) && e.observe(t);
                });
            });
    }
    function bt(e) {
        (e.relatedTarget && e.target.closest("a") == e.relatedTarget.closest("a")) || (Ee && (clearTimeout(Ee), (Ee = void 0)));
    }
    function _t(e) {
        if (
            e &&
            e.href &&
            (!dt || "instant" in e.dataset) &&
            (ct || e.origin == location.origin || "instant" in e.dataset) &&
            ["http:", "https:"].includes(e.protocol) &&
            ("http:" != e.protocol || "https:" != location.protocol) &&
            (lt || !e.search || "instant" in e.dataset) &&
            !((e.hash && e.pathname + e.search == location.pathname + location.search) || "noInstant" in e.dataset)
        )
            return !0;
    }
    function Et(e) {
        if (!at.has(e)) {
            var t = document.createElement("link");
            (t.rel = "prefetch"), (t.href = e), document.head.appendChild(t), at.add(e);
        }
    }
    var St = y(function (e) {
            !(function (t, i) {
                var n = (function (e, t, i) {
                    var n, o;
                    if (
                        ((function () {
                            var t,
                                i = {
                                    lazyClass: "lazyload",
                                    loadedClass: "lazyloaded",
                                    loadingClass: "lazyloading",
                                    preloadClass: "lazypreload",
                                    errorClass: "lazyerror",
                                    autosizesClass: "lazyautosizes",
                                    srcAttr: "data-src",
                                    srcsetAttr: "data-srcset",
                                    sizesAttr: "data-sizes",
                                    minSize: 40,
                                    customMedia: {},
                                    init: !0,
                                    expFactor: 1.5,
                                    hFac: 0.8,
                                    loadMode: 2,
                                    loadHidden: !0,
                                    ricTimeout: 0,
                                    throttleDelay: 125,
                                };
                            for (t in ((o = e.lazySizesConfig || e.lazysizesConfig || {}), i)) t in o || (o[t] = i[t]);
                        })(),
                        !t || !t.getElementsByClassName)
                    )
                        return { init: function () {}, cfg: o, noSupport: !0 };
                    var a = t.documentElement,
                        s = e.HTMLPictureElement,
                        r = "addEventListener",
                        l = "getAttribute",
                        c = e[r].bind(e),
                        d = e.setTimeout,
                        u = e.requestAnimationFrame || d,
                        h = e.requestIdleCallback,
                        p = /^picture$/i,
                        m = ["load", "error", "lazyincluded", "_lazyloaded"],
                        f = {},
                        v = Array.prototype.forEach,
                        g = function (e, t) {
                            return f[t] || (f[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")), f[t].test(e[l]("class") || "") && f[t];
                        },
                        y = function (e, t) {
                            g(e, t) || e.setAttribute("class", (e[l]("class") || "").trim() + " " + t);
                        },
                        w = function (e, t) {
                            var i;
                            (i = g(e, t)) && e.setAttribute("class", (e[l]("class") || "").replace(i, " "));
                        },
                        b = function e(t, i, n) {
                            var o = n ? r : "removeEventListener";
                            n && e(t, i),
                                m.forEach(function (e) {
                                    t[o](e, i);
                                });
                        },
                        _ = function (e, i, o, a, s) {
                            var r = t.createEvent("Event");
                            return o || (o = {}), (o.instance = n), r.initEvent(i, !a, !s), (r.detail = o), e.dispatchEvent(r), r;
                        },
                        E = function (t, i) {
                            var n;
                            !s && (n = e.picturefill || o.pf) ? (i && i.src && !t[l]("srcset") && t.setAttribute("srcset", i.src), n({ reevaluate: !0, elements: [t] })) : i && i.src && (t.src = i.src);
                        },
                        S = function (e, t) {
                            return (getComputedStyle(e, null) || {})[t];
                        },
                        k = function (e, t, i) {
                            for (i = i || e.offsetWidth; i < o.minSize && t && !e._lazysizesWidth; ) (i = t.offsetWidth), (t = t.parentNode);
                            return i;
                        },
                        x =
                            ((ye = []),
                            (we = []),
                            (be = ye),
                            (_e = function () {
                                var e = be;
                                for (be = ye.length ? we : ye, ve = !0, ge = !1; e.length; ) e.shift()();
                                ve = !1;
                            }),
                            (Ee = function (e, i) {
                                ve && !i ? e.apply(this, arguments) : (be.push(e), ge || ((ge = !0), (t.hidden ? d : u)(_e)));
                            }),
                            (Ee._lsFlush = _e),
                            Ee),
                        C = function (e, t) {
                            return t
                                ? function () {
                                      x(e);
                                  }
                                : function () {
                                      var t = this,
                                          i = arguments;
                                      x(function () {
                                          e.apply(t, i);
                                      });
                                  };
                        },
                        L = function (e) {
                            var t,
                                n = 0,
                                a = o.throttleDelay,
                                s = o.ricTimeout,
                                r = function () {
                                    (t = !1), (n = i.now()), e();
                                },
                                l =
                                    h && s > 49
                                        ? function () {
                                              h(r, { timeout: s }), s !== o.ricTimeout && (s = o.ricTimeout);
                                          }
                                        : C(function () {
                                              d(r);
                                          }, !0);
                            return function (e) {
                                var o;
                                (e = !0 === e) && (s = 33), t || ((t = !0), (o = a - (i.now() - n)) < 0 && (o = 0), e || o < 9 ? l() : d(l, o));
                            };
                        },
                        A = function (e) {
                            var t,
                                n,
                                o = 99,
                                a = function () {
                                    (t = null), e();
                                },
                                s = function e() {
                                    var t = i.now() - n;
                                    t < o ? d(e, o - t) : (h || a)(a);
                                };
                            return function () {
                                (n = i.now()), t || (t = d(s, o));
                            };
                        },
                        T =
                            ((G = /^img$/i),
                            (Y = /^iframe$/i),
                            (Z = "onscroll" in e && !/(gle|ing)bot/.test(navigator.userAgent)),
                            (Q = 0),
                            (J = 0),
                            (K = 0),
                            (ee = -1),
                            (te = function (e) {
                                K--, (!e || K < 0 || !e.target) && (K = 0);
                            }),
                            (ie = function (e) {
                                return null == X && (X = "hidden" == S(t.body, "visibility")), X || !("hidden" == S(e.parentNode, "visibility") && "hidden" == S(e, "visibility"));
                            }),
                            (ne = function (e, i) {
                                var n,
                                    o = e,
                                    s = ie(e);
                                for (j -= i, $ += i, W -= i, V += i; s && (o = o.offsetParent) && o != t.body && o != a; )
                                    (s = (S(o, "opacity") || 1) > 0) && "visible" != S(o, "overflow") && ((n = o.getBoundingClientRect()), (s = V > n.left && W < n.right && $ > n.top - 1 && j < n.bottom + 1));
                                return s;
                            }),
                            (oe = function () {
                                var e,
                                    i,
                                    s,
                                    r,
                                    c,
                                    d,
                                    u,
                                    h,
                                    p,
                                    m,
                                    f,
                                    v,
                                    g = n.elements;
                                if ((N = o.loadMode) && K < 8 && (e = g.length)) {
                                    for (i = 0, ee++; i < e; i++)
                                        if (g[i] && !g[i]._lazyRace)
                                            if (!Z || (n.prematureUnveil && n.prematureUnveil(g[i]))) he(g[i]);
                                            else if (
                                                (((h = g[i][l]("data-expand")) && (d = 1 * h)) || (d = J),
                                                m ||
                                                    ((m = !o.expand || o.expand < 1 ? (a.clientHeight > 500 && a.clientWidth > 500 ? 500 : 370) : o.expand),
                                                    (n._defEx = m),
                                                    (f = m * o.expFactor),
                                                    (v = o.hFac),
                                                    (X = null),
                                                    J < f && K < 1 && ee > 2 && N > 2 && !t.hidden ? ((J = f), (ee = 0)) : (J = N > 1 && ee > 1 && K < 6 ? m : Q)),
                                                p !== d && ((F = innerWidth + d * v), (U = innerHeight + d), (u = -1 * d), (p = d)),
                                                (s = g[i].getBoundingClientRect()),
                                                ($ = s.bottom) >= u &&
                                                    (j = s.top) <= U &&
                                                    (V = s.right) >= u * v &&
                                                    (W = s.left) <= F &&
                                                    ($ || V || W || j) &&
                                                    (o.loadHidden || ie(g[i])) &&
                                                    ((B && K < 3 && !h && (N < 3 || ee < 4)) || ne(g[i], d)))
                                            ) {
                                                if ((he(g[i]), (c = !0), K > 9)) break;
                                            } else !c && B && !r && K < 4 && ee < 4 && N > 2 && (O[0] || o.preloadAfterLoad) && (O[0] || (!h && ($ || V || W || j || "auto" != g[i][l](o.sizesAttr)))) && (r = O[0] || g[i]);
                                    r && !c && he(r);
                                }
                            }),
                            (ae = L(oe)),
                            (se = function (e) {
                                var t = e.target;
                                t._lazyCache ? delete t._lazyCache : (te(e), y(t, o.loadedClass), w(t, o.loadingClass), b(t, le), _(t, "lazyloaded"));
                            }),
                            (re = C(se)),
                            (le = function (e) {
                                re({ target: e.target });
                            }),
                            (ce = function (e, t) {
                                try {
                                    e.contentWindow.location.replace(t);
                                } catch (i) {
                                    e.src = t;
                                }
                            }),
                            (de = function (e) {
                                var t,
                                    i = e[l](o.srcsetAttr);
                                (t = o.customMedia[e[l]("data-media") || e[l]("media")]) && e.setAttribute("media", t), i && e.setAttribute("srcset", i);
                            }),
                            (ue = C(function (e, t, i, n, a) {
                                var s, r, c, u, h, m;
                                (h = _(e, "lazybeforeunveil", t)).defaultPrevented ||
                                    (n && (i ? y(e, o.autosizesClass) : e.setAttribute("sizes", n)),
                                    (r = e[l](o.srcsetAttr)),
                                    (s = e[l](o.srcAttr)),
                                    a && (u = (c = e.parentNode) && p.test(c.nodeName || "")),
                                    (m = t.firesLoad || ("src" in e && (r || s || u))),
                                    (h = { target: e }),
                                    y(e, o.loadingClass),
                                    m && (clearTimeout(H), (H = d(te, 2500)), b(e, le, !0)),
                                    u && v.call(c.getElementsByTagName("source"), de),
                                    r ? e.setAttribute("srcset", r) : s && !u && (Y.test(e.nodeName) ? ce(e, s) : (e.src = s)),
                                    a && (r || u) && E(e, { src: s })),
                                    e._lazyRace && delete e._lazyRace,
                                    w(e, o.lazyClass),
                                    x(function () {
                                        var t = e.complete && e.naturalWidth > 1;
                                        (m && !t) ||
                                            (t && y(e, "ls-is-cached"),
                                            se(h),
                                            (e._lazyCache = !0),
                                            d(function () {
                                                "_lazyCache" in e && delete e._lazyCache;
                                            }, 9)),
                                            "lazy" == e.loading && K--;
                                    }, !0);
                            })),
                            (he = function (e) {
                                if (!e._lazyRace) {
                                    var t,
                                        i = G.test(e.nodeName),
                                        n = i && (e[l](o.sizesAttr) || e[l]("sizes")),
                                        a = "auto" == n;
                                    ((!a && B) || !i || (!e[l]("src") && !e.srcset) || e.complete || g(e, o.errorClass) || !g(e, o.lazyClass)) &&
                                        ((t = _(e, "lazyunveilread").detail), a && I.updateElem(e, !0, e.offsetWidth), (e._lazyRace = !0), K++, ue(e, t, a, n, i));
                                }
                            }),
                            (pe = A(function () {
                                (o.loadMode = 3), ae();
                            })),
                            (me = function () {
                                3 == o.loadMode && (o.loadMode = 2), pe();
                            }),
                            (fe = function e() {
                                B || (i.now() - R < 999 ? d(e, 999) : ((B = !0), (o.loadMode = 3), ae(), c("scroll", me, !0)));
                            }),
                            {
                                _: function () {
                                    (R = i.now()),
                                        (n.elements = t.getElementsByClassName(o.lazyClass)),
                                        (O = t.getElementsByClassName(o.lazyClass + " " + o.preloadClass)),
                                        c("scroll", ae, !0),
                                        c("resize", ae, !0),
                                        c("pageshow", function (e) {
                                            if (e.persisted) {
                                                var i = t.querySelectorAll("." + o.loadingClass);
                                                i.length &&
                                                    i.forEach &&
                                                    u(function () {
                                                        i.forEach(function (e) {
                                                            e.complete && he(e);
                                                        });
                                                    });
                                            }
                                        }),
                                        e.MutationObserver ? new MutationObserver(ae).observe(a, { childList: !0, subtree: !0, attributes: !0 }) : (a[r]("DOMNodeInserted", ae, !0), a[r]("DOMAttrModified", ae, !0), setInterval(ae, 999)),
                                        c("hashchange", ae, !0),
                                        ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(function (e) {
                                            t[r](e, ae, !0);
                                        }),
                                        /d$|^c/.test(t.readyState) ? fe() : (c("load", fe), t[r]("DOMContentLoaded", ae), d(fe, 2e4)),
                                        n.elements.length ? (oe(), x._lsFlush()) : ae();
                                },
                                checkElems: ae,
                                unveil: he,
                                _aLSL: me,
                            }),
                        I =
                            ((M = C(function (e, t, i, n) {
                                var o, a, s;
                                if (((e._lazysizesWidth = n), (n += "px"), e.setAttribute("sizes", n), p.test(t.nodeName || ""))) for (a = 0, s = (o = t.getElementsByTagName("source")).length; a < s; a++) o[a].setAttribute("sizes", n);
                                i.detail.dataAttr || E(e, i.detail);
                            })),
                            (z = function (e, t, i) {
                                var n,
                                    o = e.parentNode;
                                o && ((i = k(e, o, i)), (n = _(e, "lazybeforesizes", { width: i, dataAttr: !!t })).defaultPrevented || ((i = n.detail.width) && i !== e._lazysizesWidth && M(e, o, n, i)));
                            }),
                            (D = A(function () {
                                var e,
                                    t = P.length;
                                if (t) for (e = 0; e < t; e++) z(P[e]);
                            })),
                            {
                                _: function () {
                                    (P = t.getElementsByClassName(o.autosizesClass)), c("resize", D);
                                },
                                checkElems: D,
                                updateElem: z,
                            }),
                        q = function e() {
                            !e.i && t.getElementsByClassName && ((e.i = !0), I._(), T._());
                        };
                    var P, M, z, D;
                    var O, B, H, N, R, F, U, j, W, V, $, X, G, Y, Z, Q, J, K, ee, te, ie, ne, oe, ae, se, re, le, ce, de, ue, he, pe, me, fe;
                    var ve, ge, ye, we, be, _e, Ee;
                    return (
                        d(function () {
                            o.init && q();
                        }),
                        (n = { cfg: o, autoSizer: I, loader: T, init: q, uP: E, aC: y, rC: w, hC: g, fire: _, gW: k, rAF: x }),
                        n
                    );
                })(t, t.document, Date);
                (t.lazySizes = n), e.exports && (e.exports = n);
            })("undefined" != typeof window ? window : {});
        }),
        kt =
            (y(function (t) {
                !(function (e, i) {
                    var n = function t() {
                        i(e.lazySizes), e.removeEventListener("lazyunveilread", t, !0);
                    };
                    (i = i.bind(null, e, e.document)), t.exports ? i(St) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0);
                })(window, function (t, i, n) {
                    var o,
                        a,
                        s = n.cfg,
                        r = { string: 1, number: 1 },
                        l = /^\-*\+*\d+\.*\d*$/,
                        c = /^picture$/i,
                        d = /\s*\{\s*width\s*\}\s*/i,
                        u = /\s*\{\s*height\s*\}\s*/i,
                        h = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
                        p = /^\[.*\]|\{.*\}$/,
                        m = /^(?:auto|\d+(px)?)$/,
                        f = i.createElement("a"),
                        v = i.createElement("img"),
                        g = "srcset" in v && !("sizes" in v),
                        y = !!t.HTMLPictureElement && !g;
                    function w(t, n, s) {
                        var l = 0,
                            c = 0,
                            p = s;
                        if (t) {
                            if ("container" === n.ratio) {
                                for (l = p.scrollWidth, c = p.scrollHeight; !((l && c) || p === i); ) (l = (p = p.parentNode).scrollWidth), (c = p.scrollHeight);
                                l && c && (n.ratio = n.traditionalRatio ? c / l : l / c);
                            }
                            var m, v, y;
                            (m = t),
                                (v = n),
                                ((y = []).srcset = []),
                                v.absUrl && (f.setAttribute("href", m), (m = f.href)),
                                (m = ((v.prefix || "") + m + (v.postfix || "")).replace(h, function (t, i) {
                                    return r[e(v[i])] ? v[i] : t;
                                })),
                                v.widths.forEach(function (e) {
                                    var t = v.widthmap[e] || e,
                                        i = v.aspectratio || v.ratio,
                                        n = !v.aspectratio && a.traditionalRatio,
                                        o = { u: m.replace(d, t).replace(u, i ? (n ? Math.round(e * i) : Math.round(e / i)) : ""), w: e };
                                    y.push(o), y.srcset.push((o.c = o.u + " " + e + "w"));
                                }),
                                ((t = y).isPicture = n.isPicture),
                                g && "IMG" == s.nodeName.toUpperCase() ? s.removeAttribute(o.srcsetAttr) : s.setAttribute(o.srcsetAttr, t.srcset.join(", ")),
                                Object.defineProperty(s, "_lazyrias", { value: t, writable: !0 });
                        }
                    }
                    function b(e, i) {
                        var o = (function (e, i) {
                            var n,
                                o,
                                s,
                                r,
                                d = t.getComputedStyle(e);
                            for (n in ((o = e.parentNode),
                            (r = { isPicture: !(!o || !c.test(o.nodeName || "")) }),
                            (s = function (t, i) {
                                var n = e.getAttribute("data-" + t);
                                if (!n) {
                                    var o = d.getPropertyValue("--ls-" + t);
                                    o && (n = o.trim());
                                }
                                if (n) {
                                    if ("true" == n) n = !0;
                                    else if ("false" == n) n = !1;
                                    else if (l.test(n)) n = parseFloat(n);
                                    else if ("function" == typeof a[t]) n = a[t](e, n);
                                    else if (p.test(n))
                                        try {
                                            n = JSON.parse(n);
                                        } catch (e) {}
                                    r[t] = n;
                                } else t in a && "function" != typeof a[t] ? (r[t] = a[t]) : i && "function" == typeof a[t] && (r[t] = a[t](e, n));
                            }),
                            a))
                                s(n);
                            return (
                                i.replace(h, function (e, t) {
                                    t in r || s(t, !0);
                                }),
                                r
                            );
                        })(e, i);
                        return a.modifyOptions.call(e, { target: e, details: o, detail: o }), n.fire(e, "lazyriasmodifyoptions", o), o;
                    }
                    function _(e) {
                        return e.getAttribute(e.getAttribute("data-srcattr") || a.srcAttr) || e.getAttribute(o.srcsetAttr) || e.getAttribute(o.srcAttr) || e.getAttribute("data-pfsrcset") || "";
                    }
                    !(function () {
                        var e,
                            t = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: function () {}, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 };
                        for (e in ((o = n && n.cfg).supportsType ||
                            (o.supportsType = function (e) {
                                return !e;
                            }),
                        o.rias || (o.rias = {}),
                        "widths" in (a = o.rias) ||
                            ((a.widths = []),
                            (function (e) {
                                for (var t, i = 0; !t || t < 3e3; ) (i += 5) > 30 && (i += 1), (t = 36 * i), e.push(t);
                            })(a.widths)),
                        t))
                            e in a || (a[e] = t[e]);
                    })(),
                        addEventListener(
                            "lazybeforesizes",
                            function (e) {
                                var t, i, s, r, l, c, u, h, p, f, v, g, E;
                                if (e.detail.instance == n && ((t = e.target), e.detail.dataAttr && !e.defaultPrevented && !a.disabled && (p = t.getAttribute(o.sizesAttr) || t.getAttribute("sizes")) && m.test(p))) {
                                    if (((s = b(t, (i = _(t)))), (v = d.test(s.prefix) || d.test(s.postfix)), s.isPicture && (r = t.parentNode)))
                                        for (c = 0, u = (l = r.getElementsByTagName("source")).length; c < u; c++) (v || d.test((h = _(l[c])))) && (w(h, s, l[c]), (g = !0));
                                    v || d.test(i) ? (w(i, s, t), (g = !0)) : g && (((E = []).srcset = []), (E.isPicture = !0), Object.defineProperty(t, "_lazyrias", { value: E, writable: !0 })),
                                        g && (y ? t.removeAttribute(o.srcAttr) : "auto" != p && ((f = { width: parseInt(p, 10) }), C({ target: t, detail: f })));
                                }
                            },
                            !0
                        );
                    var E,
                        S,
                        k,
                        x,
                        C =
                            ((E = function (e, t) {
                                return e.w - t.w;
                            }),
                            (S = function (e, t) {
                                var i;
                                return (
                                    !e._lazyrias &&
                                        n.pWS &&
                                        (i = n.pWS(e.getAttribute(o.srcsetAttr || ""))).length &&
                                        (Object.defineProperty(e, "_lazyrias", { value: i, writable: !0 }), t && e.parentNode && (i.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase())),
                                    e._lazyrias
                                );
                            }),
                            (k = function (e, i) {
                                var o, a, s, r, l, c;
                                if ((l = e._lazyrias).isPicture && t.matchMedia)
                                    for (a = 0, s = (o = e.parentNode.getElementsByTagName("source")).length; a < s; a++)
                                        if (S(o[a]) && !o[a].getAttribute("type") && (!(r = o[a].getAttribute("media")) || (matchMedia(r) || {}).matches)) {
                                            l = o[a]._lazyrias;
                                            break;
                                        }
                                return (
                                    (!l.w || l.w < i) &&
                                        ((l.w = i),
                                        (l.d = (function (e) {
                                            var i = t.devicePixelRatio || 1,
                                                o = n.getX && n.getX(e);
                                            return Math.min(o || i, 2.4, i);
                                        })(e)),
                                        (c = (function (e) {
                                            for (var t, i, n = e.length, o = e[n - 1], a = 0; a < n; a++)
                                                if ((((o = e[a]).d = o.w / e.w), o.d >= e.d)) {
                                                    !o.cached && (t = e[a - 1]) && t.d > e.d - 0.13 * Math.pow(e.d, 2.2) && ((i = Math.pow(t.d - 0.6, 1.6)), t.cached && (t.d += 0.15 * i), t.d + (o.d - e.d) * i > e.d && (o = t));
                                                    break;
                                                }
                                            return o;
                                        })(l.sort(E)))),
                                    c
                                );
                            }),
                            (x = function (e) {
                                if (e.detail.instance == n) {
                                    var a,
                                        r = e.target;
                                    g || !(t.respimage || t.picturefill || s.pf)
                                        ? ("_lazyrias" in r || (e.detail.dataAttr && S(r, !0))) &&
                                          (a = k(r, e.detail.width)) &&
                                          a.u &&
                                          r._lazyrias.cur != a.u &&
                                          ((r._lazyrias.cur = a.u),
                                          (a.cached = !0),
                                          n.rAF(function () {
                                              r.setAttribute(o.srcAttr, a.u), r.setAttribute("src", a.u);
                                          }))
                                        : i.removeEventListener("lazybeforesizes", x);
                                }
                            }),
                            y ? (x = function () {}) : addEventListener("lazybeforesizes", x),
                            x);
                });
            }),
            y(function (e) {
                !(function (t, i) {
                    var n = function e() {
                        i(t.lazySizes), t.removeEventListener("lazyunveilread", e, !0);
                    };
                    (i = i.bind(null, t, t.document)), e.exports ? i(St) : t.lazySizes ? n() : t.addEventListener("lazyunveilread", n, !0);
                })(window, function (e, t, i) {
                    var n,
                        o,
                        a = {};
                    function s(e, i) {
                        if (!a[e]) {
                            var n = t.createElement(i ? "link" : "script"),
                                o = t.getElementsByTagName("script")[0];
                            i ? ((n.rel = "stylesheet"), (n.href = e)) : (n.src = e), (a[e] = !0), (a[n.src || n.href] = !0), o.parentNode.insertBefore(n, o);
                        }
                    }
                    t.addEventListener &&
                        ((o = /\(|\)|\s|'/),
                        (n = function (e, i) {
                            var n = t.createElement("img");
                            (n.onload = function () {
                                (n.onload = null), (n.onerror = null), (n = null), i();
                            }),
                                (n.onerror = n.onload),
                                (n.src = e),
                                n && n.complete && n.onload && n.onload();
                        }),
                        addEventListener(
                            "lazybeforeunveil",
                            function (e) {
                                var t, a, r;
                                if (e.detail.instance == i && !e.defaultPrevented) {
                                    var l = e.target;
                                    if (("none" == l.preload && (l.preload = l.getAttribute("data-preload") || "auto"), null != l.getAttribute("data-autoplay")))
                                        if (l.getAttribute("data-expand") && !l.autoplay)
                                            try {
                                                l.play();
                                            } catch (e) {}
                                        else
                                            requestAnimationFrame(function () {
                                                l.setAttribute("data-expand", "-10"), i.aC(l, i.cfg.lazyClass);
                                            });
                                    (t = l.getAttribute("data-link")) && s(t, !0),
                                        (t = l.getAttribute("data-script")) && s(t),
                                        (t = l.getAttribute("data-require")) && (i.cfg.requireJs ? i.cfg.requireJs([t]) : s(t)),
                                        (a = l.getAttribute("data-bg")) &&
                                            ((e.detail.firesLoad = !0),
                                            n(a, function () {
                                                (l.style.backgroundImage = "url(" + (o.test(a) ? JSON.stringify(a) : a) + ")"), (e.detail.firesLoad = !1), i.fire(l, "_lazyloaded", {}, !0, !0);
                                            })),
                                        (r = l.getAttribute("data-poster")) &&
                                            ((e.detail.firesLoad = !0),
                                            n(r, function () {
                                                (l.poster = r), (e.detail.firesLoad = !1), i.fire(l, "_lazyloaded", {}, !0, !0);
                                            }));
                                }
                            },
                            !1
                        ));
                });
            }),
            y(function (e) {
                !(function (t, i) {
                    var n = function e() {
                        i(t.lazySizes), t.removeEventListener("lazyunveilread", e, !0);
                    };
                    (i = i.bind(null, t, t.document)), e.exports ? i(St) : t.lazySizes ? n() : t.addEventListener("lazyunveilread", n, !0);
                })(window, function (e, t, i) {
                    if (e.addEventListener) {
                        var n = i.cfg,
                            o = /\s+/g,
                            a = /\s*\|\s+|\s+\|\s*/g,
                            s = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/,
                            r = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/,
                            l = /\(|\)|'/,
                            c = { contain: 1, cover: 1 },
                            d = function (e, t) {
                                if (t) {
                                    var i = t.match(r);
                                    i && i[1] ? e.setAttribute("type", i[1]) : e.setAttribute("media", n.customMedia[t] || t);
                                }
                            },
                            u = function (e) {
                                if (e.target._lazybgset) {
                                    var t = e.target,
                                        n = t._lazybgset,
                                        o = t.currentSrc || t.src;
                                    if (o) {
                                        var a = i.fire(n, "bgsetproxy", { src: o, useSrc: l.test(o) ? JSON.stringify(o) : o });
                                        a.defaultPrevented || (n.style.backgroundImage = "url(" + a.detail.useSrc + ")");
                                    }
                                    t._lazybgsetLoading && (i.fire(n, "_lazyloaded", {}, !1, !0), delete t._lazybgsetLoading);
                                }
                            };
                        addEventListener("lazybeforeunveil", function (e) {
                            var r, l, c;
                            !e.defaultPrevented &&
                                (r = e.target.getAttribute("data-bgset")) &&
                                ((c = e.target),
                                ((l = t.createElement("img")).alt = ""),
                                (l._lazybgsetLoading = !0),
                                (e.detail.firesLoad = !0),
                                (function (e, i, r) {
                                    var l = t.createElement("picture"),
                                        c = i.getAttribute(n.sizesAttr),
                                        u = i.getAttribute("data-ratio"),
                                        h = i.getAttribute("data-optimumx");
                                    i._lazybgset && i._lazybgset.parentNode == i && i.removeChild(i._lazybgset),
                                        Object.defineProperty(r, "_lazybgset", { value: i, writable: !0 }),
                                        Object.defineProperty(i, "_lazybgset", { value: l, writable: !0 }),
                                        (e = e.replace(o, " ").split(a)),
                                        (l.style.display = "none"),
                                        (r.className = n.lazyClass),
                                        1 != e.length || c || (c = "auto"),
                                        e.forEach(function (e) {
                                            var i,
                                                o = t.createElement("source");
                                            c && "auto" != c && o.setAttribute("sizes", c), (i = e.match(s)) ? (o.setAttribute(n.srcsetAttr, i[1]), d(o, i[2]), d(o, i[3])) : o.setAttribute(n.srcsetAttr, e), l.appendChild(o);
                                        }),
                                        c && (r.setAttribute(n.sizesAttr, c), i.removeAttribute(n.sizesAttr), i.removeAttribute("sizes")),
                                        h && r.setAttribute("data-optimumx", h),
                                        u && r.setAttribute("data-ratio", u),
                                        l.appendChild(r),
                                        i.appendChild(l);
                                })(r, c, l),
                                setTimeout(function () {
                                    i.loader.unveil(l),
                                        i.rAF(function () {
                                            i.fire(l, "_lazyloaded", {}, !0, !0), l.complete && u({ target: l });
                                        });
                                }));
                        }),
                            t.addEventListener("load", u, !0),
                            e.addEventListener(
                                "lazybeforesizes",
                                function (e) {
                                    if (e.detail.instance == i && e.target._lazybgset && e.detail.dataAttr) {
                                        var t = (function (e) {
                                            var t;
                                            return (t = (getComputedStyle(e) || { getPropertyValue: function () {} }).getPropertyValue("background-size")), !c[t] && c[e.style.backgroundSize] && (t = e.style.backgroundSize), t;
                                        })(e.target._lazybgset);
                                        c[t] &&
                                            ((e.target._lazysizesParentFit = t),
                                            i.rAF(function () {
                                                e.target.setAttribute("data-parent-fit", t), e.target._lazysizesParentFit && delete e.target._lazysizesParentFit;
                                            }));
                                    }
                                },
                                !0
                            ),
                            t.documentElement.addEventListener("lazybeforesizes", function (e) {
                                var t, n;
                                !e.defaultPrevented &&
                                    e.target._lazybgset &&
                                    e.detail.instance == i &&
                                    (e.detail.width = ((t = e.target._lazybgset), (n = i.gW(t, t.parentNode)), (!t._lazysizesWidth || n > t._lazysizesWidth) && (t._lazysizesWidth = n), t._lazysizesWidth));
                            });
                    }
                });
            }),
            y(function (e) {
                !(function (t, i) {
                    if (t) {
                        var n = function e() {
                            i(t.lazySizes), t.removeEventListener("lazyunveilread", e, !0);
                        };
                        (i = i.bind(null, t, t.document)), e.exports ? i(St) : t.lazySizes ? n() : t.addEventListener("lazyunveilread", n, !0);
                    }
                })("undefined" != typeof window ? window : 0, function (e, t, i) {
                    var n,
                        o,
                        a,
                        s,
                        r,
                        l,
                        c,
                        d,
                        u,
                        h,
                        p,
                        m,
                        f,
                        v,
                        g,
                        y,
                        w = i.cfg,
                        b = t.createElement("img"),
                        _ = "sizes" in b && "srcset" in b,
                        E = /\s+\d+h/g,
                        S =
                            ((o = /\s+(\d+)(w|h)\s+(\d+)(w|h)/),
                            (a = Array.prototype.forEach),
                            function () {
                                var e = t.createElement("img"),
                                    n = function (e) {
                                        var t,
                                            i,
                                            n = e.getAttribute(w.srcsetAttr);
                                        n && (i = n.match(o)) && ((t = "w" == i[2] ? i[1] / i[3] : i[3] / i[1]) && e.setAttribute("data-aspectratio", t), e.setAttribute(w.srcsetAttr, n.replace(E, "")));
                                    },
                                    s = function (e) {
                                        if (e.detail.instance == i) {
                                            var t = e.target.parentNode;
                                            t && "PICTURE" == t.nodeName && a.call(t.getElementsByTagName("source"), n), n(e.target);
                                        }
                                    },
                                    r = function () {
                                        e.currentSrc && t.removeEventListener("lazybeforeunveil", s);
                                    };
                                t.addEventListener("lazybeforeunveil", s), (e.onload = r), (e.onerror = r), (e.srcset = "data:,a 1w 1h"), e.complete && r();
                            });
                    (w.supportsType ||
                        (w.supportsType = function (e) {
                            return !e;
                        }),
                    e.HTMLPictureElement && _)
                        ? !i.hasHDescriptorFix && t.msElementsFromPoint && ((i.hasHDescriptorFix = !0), S())
                        : e.picturefill ||
                          w.pf ||
                          ((w.pf = function (t) {
                              var i, o;
                              if (!e.picturefill) for (i = 0, o = t.elements.length; i < o; i++) n(t.elements[i]);
                          }),
                          (d = function (e, t) {
                              return e.w - t.w;
                          }),
                          (u = /^\s*\d+\.*\d*px\s*$/),
                          (r = /(([^,\s].[^\s]+)\s+(\d+)w)/g),
                          (l = /\s/),
                          (c = function (e, t, i, n) {
                              s.push({ c: t, u: i, w: 1 * n });
                          }),
                          (p = function e() {
                              var i, o, a;
                              e.init ||
                                  ((e.init = !0),
                                  addEventListener(
                                      "resize",
                                      ((o = t.getElementsByClassName("lazymatchmedia")),
                                      (a = function () {
                                          var e, t;
                                          for (e = 0, t = o.length; e < t; e++) n(o[e]);
                                      }),
                                      function () {
                                          clearTimeout(i), (i = setTimeout(a, 66));
                                      })
                                  ));
                          }),
                          (m = function (t, n) {
                              var o,
                                  a = t.getAttribute("srcset") || t.getAttribute(w.srcsetAttr);
                              !a && n && (a = t._lazypolyfill ? t._lazypolyfill._set : t.getAttribute(w.srcAttr) || t.getAttribute("src")),
                                  (t._lazypolyfill && t._lazypolyfill._set == a) ||
                                      ((o = h(a || "")),
                                      n && t.parentNode && ((o.isPicture = "PICTURE" == t.parentNode.nodeName.toUpperCase()), o.isPicture && e.matchMedia && (i.aC(t, "lazymatchmedia"), p())),
                                      (o._set = a),
                                      Object.defineProperty(t, "_lazypolyfill", { value: o, writable: !0 }));
                          }),
                          (f = function (t) {
                              return e.matchMedia
                                  ? ((f = function (e) {
                                        return !e || (matchMedia(e) || {}).matches;
                                    }),
                                    f(t))
                                  : !t;
                          }),
                          (v = function (t) {
                              var n, o, a, s, r, l, c;
                              if ((m((s = t), !0), (r = s._lazypolyfill).isPicture))
                                  for (o = 0, a = (n = t.parentNode.getElementsByTagName("source")).length; o < a; o++)
                                      if (w.supportsType(n[o].getAttribute("type"), t) && f(n[o].getAttribute("media"))) {
                                          (s = n[o]), m(s), (r = s._lazypolyfill);
                                          break;
                                      }
                              return (
                                  r.length > 1
                                      ? ((c = s.getAttribute("sizes") || ""),
                                        (c = (u.test(c) && parseInt(c, 10)) || i.gW(t, t.parentNode)),
                                        (r.d = (function (t) {
                                            var n = e.devicePixelRatio || 1,
                                                o = i.getX && i.getX(t);
                                            return Math.min(o || n, 2.5, n);
                                        })(t)),
                                        !r.src || !r.w || r.w < c
                                            ? ((r.w = c),
                                              (l = (function (e) {
                                                  for (var t, i, n = e.length, o = e[n - 1], a = 0; a < n; a++)
                                                      if ((((o = e[a]).d = o.w / e.w), o.d >= e.d)) {
                                                          !o.cached && (t = e[a - 1]) && t.d > e.d - 0.13 * Math.pow(e.d, 2.2) && ((i = Math.pow(t.d - 0.6, 1.6)), t.cached && (t.d += 0.15 * i), t.d + (o.d - e.d) * i > e.d && (o = t));
                                                          break;
                                                      }
                                                  return o;
                                              })(r.sort(d))),
                                              (r.src = l))
                                            : (l = r.src))
                                      : (l = r[0]),
                                  l
                              );
                          }),
                          ((g = function (e) {
                              if (!_ || !e.parentNode || "PICTURE" == e.parentNode.nodeName.toUpperCase()) {
                                  var t = v(e);
                                  t && t.u && e._lazypolyfill.cur != t.u && ((e._lazypolyfill.cur = t.u), (t.cached = !0), e.setAttribute(w.srcAttr, t.u), e.setAttribute("src", t.u));
                              }
                          }).parse = h = function (e) {
                              return (s = []), (e = e.trim()).replace(E, "").replace(r, c), s.length || !e || l.test(e) || s.push({ c: e, u: e, w: 99 }), s;
                          }),
                          (n = g),
                          w.loadedClass &&
                              w.loadingClass &&
                              ((y = []),
                              ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function (e) {
                                  y.push(e + w.loadedClass), y.push(e + w.loadingClass);
                              }),
                              w.pf({ elements: t.querySelectorAll(y.join(", ")) })));
                });
            }),
            (function (e) {
                !(function (e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    (e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })), t && a(e, t);
                })(d, e);
                var i,
                    r,
                    l =
                        ((i = d),
                        (r = s()),
                        function () {
                            var e,
                                t = o(i);
                            if (r) {
                                var n = o(this).constructor;
                                e = Reflect.construct(t, arguments, n);
                            } else e = t.apply(this, arguments);
                            return c(this, e);
                        });
                function d() {
                    return t(this, d), l.apply(this, arguments);
                }
                return (
                    n(d, [
                        {
                            key: "connectedCallback",
                            value: function () {
                                var e = this;
                                (this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child")),
                                    (this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child")),
                                    (this.textInputLowerBound = this.querySelector(".price-range__input:first-child input")),
                                    (this.textInputHigherBound = this.querySelector(".price-range__input:last-child input")),
                                    this.textInputLowerBound.addEventListener("focus", function () {
                                        return e.textInputLowerBound.select();
                                    }),
                                    this.textInputHigherBound.addEventListener("focus", function () {
                                        return e.textInputHigherBound.select();
                                    }),
                                    this.textInputLowerBound.addEventListener("change", function (t) {
                                        (t.target.value = Math.max(Math.min(parseInt(t.target.value), parseInt(e.textInputHigherBound.value || t.target.max) - 1), t.target.min)),
                                            (e.rangeLowerBound.value = t.target.value),
                                            e.rangeLowerBound.parentElement.style.setProperty("--range-min", "".concat((parseInt(e.rangeLowerBound.value) / parseInt(e.rangeLowerBound.max)) * 100, "%"));
                                    }),
                                    this.textInputHigherBound.addEventListener("change", function (t) {
                                        (t.target.value = Math.min(Math.max(parseInt(t.target.value), parseInt(e.textInputLowerBound.value || t.target.min) + 1), t.target.max)),
                                            (e.rangeHigherBound.value = t.target.value),
                                            e.rangeHigherBound.parentElement.style.setProperty("--range-max", "".concat((parseInt(e.rangeHigherBound.value) / parseInt(e.rangeHigherBound.max)) * 100, "%"));
                                    }),
                                    this.rangeLowerBound.addEventListener("change", function (t) {
                                        (e.textInputLowerBound.value = t.target.value), e.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: !0 }));
                                    }),
                                    this.rangeHigherBound.addEventListener("change", function (t) {
                                        (e.textInputHigherBound.value = t.target.value), e.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: !0 }));
                                    }),
                                    this.rangeLowerBound.addEventListener("input", function (t) {
                                        e.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: !0 })),
                                            (t.target.value = Math.min(parseInt(t.target.value), parseInt(e.textInputHigherBound.value || t.target.max) - 1)),
                                            t.target.parentElement.style.setProperty("--range-min", "".concat((parseInt(t.target.value) / parseInt(t.target.max)) * 100, "%")),
                                            (e.textInputLowerBound.value = t.target.value);
                                    }),
                                    this.rangeHigherBound.addEventListener("input", function (t) {
                                        e.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: !0 })),
                                            (t.target.value = Math.max(parseInt(t.target.value), parseInt(e.textInputLowerBound.value || t.target.min) + 1)),
                                            t.target.parentElement.style.setProperty("--range-max", "".concat((parseInt(t.target.value) / parseInt(t.target.max)) * 100, "%")),
                                            (e.textInputHigherBound.value = t.target.value);
                                    });
                            },
                        },
                    ]),
                    d
                );
            })(l(HTMLElement)));
    window.customElements.define("price-range", kt),
        (function () {
            var e = function () {
                window.NodeList &&
                    !NodeList.prototype.forEach &&
                    (NodeList.prototype.forEach = function (e, t) {
                        t = t || window;
                        for (var i = 0; i < this.length; i++) e.call(t, this[i], i, this);
                    }),
                    ot.polyfill(),
                    new _(),
                    new L(),
                    new q(),
                    new D();
                var e,
                    t,
                    i,
                    n,
                    o = new et();
                o.register("account", Ae),
                    o.register("announcement-bar", Te),
                    o.register("blog", Ie),
                    o.register("blog-sidebar", Pe),
                    o.register("blog-post", qe),
                    o.register("cart", ze),
                    o.register("collection-list", De),
                    o.register("collection-list-promo", Oe),
                    o.register("collection", Be),
                    o.register("featured-collection", He),
                    o.register("footer", Re),
                    o.register("gift-card", Ne),
                    o.register("header", Ue),
                    o.register("login", je),
                    o.register("map", We),
                    o.register("minimal-header", Ve),
                    o.register("popups", Xe),
                    o.register("product-recommendations", Ge),
                    o.register("product", Me),
                    o.register("quick-links", $e),
                    o.register("recently-viewed-products", Ye),
                    o.register("complementary-products", Qe),
                    o.register("list-brand-collections", Je),
                    o.register("single-product-card", Ke),
                    o.register("brand-featured-products", Ze),
                    o.register("slideshow", tt),
                    o.register("text-with-icons", it),
                    o.register("video", nt),
                    document.querySelectorAll(".rte table").forEach(function (e) {
                        e.outerHTML = '<div class="table-wrapper">' + e.outerHTML + "</div>";
                    }),
                    document.querySelectorAll(".rte iframe").forEach(function (e) {
                        (-1 === e.src.indexOf("youtube") && -1 === e.src.indexOf("youtu.be") && -1 === e.src.indexOf("vimeo")) || ((e.outerHTML = '<div class="video-wrapper">' + e.outerHTML + "</div>"), (e.src = e.src));
                    }),
                    (t = !1),
                    document.body.addEventListener("touchstart", function (i) {
                        var n = i.target.closest(".flickity-slider");
                        n && ne.data(n.closest(".flickity-enabled")).isDraggable ? ((t = !0), (e = { x: i.touches[0].pageX, y: i.touches[0].pageY })) : (t = !1);
                    }),
                    document.body.addEventListener(
                        "touchmove",
                        function (i) {
                            if (t && i.cancelable) {
                                var n = { x: i.touches[0].pageX - e.x, y: i.touches[0].pageY - e.y };
                                Math.abs(n.x) > 8 && i.preventDefault();
                            }
                        },
                        { passive: !1 }
                    ),
                    (function () {
                        new b(document.body).on("click", ".expandable-content__toggle", function (e, t) {
                            var i = t.closest(".expandable-content");
                            if ("true" === i.getAttribute("aria-expanded")) {
                                i.setAttribute("aria-expanded", "false"), (i.style["max-height"] = "".concat(i.offsetHeight, "px")), i.offsetHeight, (i.style["max-height"] = null);
                                var n = t.querySelector(".expandable-content__toggle-text");
                                n.innerHTML = n.getAttribute("data-view-more");
                                var o = i.closest(".card");
                                if (o) {
                                    var a = o.getBoundingClientRect().top - 15 - parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height"));
                                    window.scrollBy({ top: a, behavior: "smooth" });
                                }
                            } else {
                                i.setAttribute("aria-expanded", "true"), t.previousElementSibling && (t.previousElementSibling.style["margin-bottom"] = "".concat(parseInt(t.clientHeight), "px")), m.slideDown(i, null, "max-height");
                                var s = t.querySelector(".expandable-content__toggle-text");
                                s.innerHTML = s.getAttribute("data-view-less");
                            }
                        });
                        var e = function () {
                            document.querySelectorAll(".expandable-content[aria-expanded]").forEach(function (e) {
                                e.scrollHeight > e.clientHeight ? e.classList.add("expandable-content--expandable") : e.setAttribute("aria-expanded", "true");
                            });
                        };
                        document.addEventListener("shopify:section:load", function (t) {
                            e();
                        }),
                            e();
                    })(),
                    (function () {
                        if ("phone" === S.getCurrentBreakpoint()) for (var e = document.querySelectorAll("input[autofocus]"), t = 0; t < e.length; t++) e[t].blur(), e[t].removeAttribute("autofocus");
                    })(),
                    new b(document.body).on("click", '[href^="#"], [data-href]', function (e, t) {
                        var i = t.hasAttribute("href") ? t.getAttribute("href") : t.getAttribute("data-href");
                        if ("#" !== i && "#main" !== i) {
                            var n = null;
                            try {
                                n = document.querySelector(i);
                            } catch (e) {
                                return;
                            }
                            for (var o = parseInt(t.getAttribute("data-offset") || 0), a = 0; "BODY" !== n.offsetParent.tagName; ) (a += n.offsetTop), (n = n.offsetParent);
                            (a += n.offsetTop), window.scrollTo({ behavior: "smooth", top: a - o }), e.preventDefault();
                        }
                    }),
                    window.addEventListener("keydown", function e(t) {
                        "Tab" === t.key && (document.body.classList.add("is-tabbing"), window.removeEventListener("keydown", e));
                    }),
                    (i = new b(document.body)).on("keyup", "input, textarea", function (e, t) {
                        t.classList.toggle("is-filled", "" !== t.value);
                    }),
                    i.on("change", "select", function (e, t) {
                        t.parentNode.classList.toggle("is-filled", "" !== t.value);
                    }),
                    (n = document.links),
                    M.mutate(function () {
                        for (var e = 0, t = n.length; e < t; e++) n[e].hostname !== window.location.hostname && ((n[e].target = "_blank"), n[e].relList.add("noopener"), n[e].setAttribute("aria-describedby", "a11y-new-window-message"));
                    });
            };
            if ("fetch" in window && "assign" in Object) e();
            else {
                var t = document.createElement("script");
                (t.src =
                    "//cdn.polyfill.io/v3/polyfill.min.js?unknown=polyfill&features=fetch,Element.prototype.closest,Element.prototype.matches,Element.prototype.remove,Element.prototype.classList,Array.prototype.includes,String.prototype.includes,Object.assign,CustomEvent,URL,DOMTokenList"),
                    (t.async = !1),
                    (t.onload = function () {
                        e();
                    }),
                    document.head.appendChild(t);
            }
        })(),
        document.addEventListener("variant:changed", function (e) {
            if (!window.enable_varaint_multi_images) return !1;
            let t = document.querySelector('section[data-section-id="' + window.product_section + '"]'),
                i = JSON.parse(t.getAttribute("data-section-settings"));
            window.product_Gallery && window.product_Gallery.destroy(), showOnlyCurrentVaraint(e.detail.variant.id), (window.product_Gallery = new ke(t, i)), initLightBoxSwiper();
        });
}),
    $(document).on("click", ".btn-expand-all", function (e) {
        e.preventDefault();
        var t = $(this).attr("value");
        "expand" == t
            ? ($(this).attr("value", "collapsible").text("COLLAPSE ALL"), $('[data-action="toggle-collapsible"]').trigger("click"))
            : "collapsible" == t && ($(this).attr("value", "expand").text("EXPAND ALL"), $('[data-action="toggle-collapsible"]').trigger("click"));
    }),
    $(document).ready(function () {
        let e = document.getElementsByClassName("new_title"),
            t = e.length ? e[0].value : null;
        null != t && (document.title = t),
            $(document).on("change", ".maincategory", function () {
                var e = !1,
                    t = this.selectedOptions[0].dataset.handle;
                $(document)
                    .find(".subcategory")
                    .each(function () {
                        var i = $(this).data("value");
                        t == i ? ($(this).removeClass("itg-hide"), (e = !0)) : $(this).addClass("itg-hide");
                    }),
                    0 == e && (window.location.href = $(this).val());
            }),
            $(document).on("change", ".subcategory", function () {
                var e = $(this).val();
                location.href = e;
            });
    });
